var mc_catalog_modelsxxx =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/mcst/dist/mc-catalog-modelsxxx/e35ca98d05d102ce7696/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(18);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var widget_uuid = 0,
	widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; (elem = elems[i]) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
})( $.cleanData );

$.widget = function( name, base, prototype ) {
	var fullName, existingConstructor, constructor, basePrototype,
		// proxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		proxiedPrototype = {},
		namespace = name.split( "." )[ 0 ];

	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};
	// extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,
		// copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),
		// track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	});

	basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = (function() {
			var _super = function() {
					return base.prototype[ prop ].apply( this, arguments );
				},
				_superApply = function( args ) {
					return base.prototype[ prop ].apply( this, args );
				};
			return function() {
				var __super = this._super,
					__superApply = this._superApply,
					returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		})();
	});
	constructor.prototype = $.widget.extend( basePrototype, {
		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	});

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
		});
		// remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widget_slice.call( arguments, 1 ),
		inputIndex = 0,
		inputLength = input.length,
		key,
		value;
	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :
						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );
				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = widget_slice.call( arguments, 1 ),
			returnValue = this;

		if ( isMethodCall ) {
			this.each(function() {
				var methodValue,
					instance = $.data( this, fullName );
				if ( options === "instance" ) {
					returnValue = instance;
					return false;
				}
				if ( !instance ) {
					return $.error( "cannot call methods on " + name + " prior to initialization; " +
						"attempted to call method '" + options + "'" );
				}
				if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
					return $.error( "no such method '" + options + "' for " + name + " widget instance" );
				}
				methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue && methodValue.jquery ?
						returnValue.pushStack( methodValue.get() ) :
						methodValue;
					return false;
				}
			});
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat(args) );
			}

			this.each(function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",
	options: {
		disabled: false,

		// callbacks
		create: null
	},
	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widget_uuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			});
			this.document = $( element.style ?
				// element within the document
				element.ownerDocument :
				// element is window or document
				element.document || element );
			this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();
		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},
	_getCreateOptions: $.noop,
	_getCreateEventData: $.noop,
	_create: $.noop,
	_init: $.noop,

	destroy: function() {
		this._destroy();
		// we can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.unbind( this.eventNamespace )
			.removeData( this.widgetFullName )
			// support: jquery <1.6.3
			// http://bugs.jquery.com/ticket/9413
			.removeData( $.camelCase( this.widgetFullName ) );
		this.widget()
			.unbind( this.eventNamespace )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetFullName + "-disabled " +
				"ui-state-disabled" );

		// clean up events and states
		this.bindings.unbind( this.eventNamespace );
		this.hoverable.removeClass( "ui-state-hover" );
		this.focusable.removeClass( "ui-state-focus" );
	},
	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key,
			parts,
			curOption,
			i;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {
			// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				.toggleClass( this.widgetFullName + "-disabled", !!value );

			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
		}

		return this;
	},

	enable: function() {
		return this._setOptions({ disabled: false });
	},
	disable: function() {
		return this._setOptions({ disabled: true });
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement,
			instance = this;

		// no suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// no element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {
				// allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
				eventName = match[1] + instance.eventNamespace,
				selector = match[2];
			if ( selector ) {
				delegateElement.delegate( selector, eventName, handlerProxy );
			} else {
				element.bind( eventName, handlerProxy );
			}
		});
	},

	_off: function( element, eventName ) {
		eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.unbind( eventName ).undelegate( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-hover" );
			},
			mouseleave: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-hover" );
			}
		});
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-focus" );
			},
			focusout: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-focus" );
			}
		});
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}
		var hasOptions,
			effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}
		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;
		if ( options.delay ) {
			element.delay( options.delay );
		}
		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue(function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			});
		}
	};
});

return $.widget;

}));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Core 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
	version: "1.11.4",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	scrollParent: function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
			}).eq( 0 );

		return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
	},

	uniqueId: (function() {
		var uuid = 0;

		return function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			});
		};
	})(),

	removeUniqueId: function() {
		return this.each(function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
		return !!img && visible( img );
	}
	return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
	focus: (function( orig ) {
		return function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				orig.apply( this, arguments );
		};
	})( $.fn.focus ),

	disableSelection: (function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.bind( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
		};
	})(),

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	}
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};

}));


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript === "function")
		execScript(src);
	else
		eval.call(null, src);
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Mouse 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(2),
			__webpack_require__(3)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var mouseHandled = false;
$( document ).mouseup( function() {
	mouseHandled = false;
});

return $.widget("ui.mouse", {
	version: "1.11.4",
	options: {
		cancel: "input,textarea,button,select,option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.bind("mousedown." + this.widgetName, function(event) {
				return that._mouseDown(event);
			})
			.bind("click." + this.widgetName, function(event) {
				if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
					$.removeData(event.target, that.widgetName + ".preventClickEvent");
					event.stopImmediatePropagation();
					return false;
				}
			});

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.unbind("." + this.widgetName);
		if ( this._mouseMoveDelegate ) {
			this.document
				.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
				.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
		}
	},

	_mouseDown: function(event) {
		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// we may have missed mouseup (out of window)
		(this._mouseStarted && this._mouseUp(event));

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = (event.which === 1),
			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
		if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if (!this.mouseDelayMet) {
			this._mouseDelayTimer = setTimeout(function() {
				that.mouseDelayMet = true;
			}, this.options.delay);
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted = (this._mouseStart(event) !== false);
			if (!this._mouseStarted) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
			$.removeData(event.target, this.widgetName + ".preventClickEvent");
		}

		// these delegates are required to keep context
		this._mouseMoveDelegate = function(event) {
			return that._mouseMove(event);
		};
		this._mouseUpDelegate = function(event) {
			return that._mouseUp(event);
		};

		this.document
			.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function(event) {
		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {
			// IE mouseup check - mouseup happened when mouse was out of window
			if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
				return this._mouseUp(event);

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if (this._mouseStarted) {
			this._mouseDrag(event);
			return event.preventDefault();
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted =
				(this._mouseStart(this._mouseDownEvent, event) !== false);
			(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
		}

		return !this._mouseStarted;
	},

	_mouseUp: function(event) {
		this.document
			.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if (this._mouseStarted) {
			this._mouseStarted = false;

			if (event.target === this._mouseDownEvent.target) {
				$.data(event.target, this.widgetName + ".preventClickEvent", true);
			}

			this._mouseStop(event);
		}

		mouseHandled = false;
		return false;
	},

	_mouseDistanceMet: function(event) {
		return (Math.max(
				Math.abs(this._mouseDownEvent.pageX - event.pageX),
				Math.abs(this._mouseDownEvent.pageY - event.pageY)
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function(/* event */) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function(/* event */) {},
	_mouseDrag: function(/* event */) {},
	_mouseStop: function(/* event */) {},
	_mouseCapture: function(/* event */) { return true; }
});

}));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pattern.gif", __webpack_require__.p + "images/pattern.gif");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Dialog 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/dialog/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(2),
			__webpack_require__(4),
			__webpack_require__(3),
			__webpack_require__(61),
			__webpack_require__(62),
			__webpack_require__(6),
			__webpack_require__(63),
			__webpack_require__(64)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.widget( "ui.dialog", {
	version: "1.11.4",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		closeOnEscape: true,
		closeText: "Close",
		dialogClass: "",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",
			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		this.options.title = this.options.title || this.originalTitle;

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.addClass( "ui-dialog-content ui-widget-content" )
			.appendTo( this.uiDialog );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && (element.jquery || element.nodeType) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.removeClass( "ui-dialog-content ui-widget-content" )
			.css( this.originalCss )
			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.stop( true, true ).remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );
		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var activeElement,
			that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).focus().length ) {

			// support: IE9
			// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
			try {
				activeElement = this.document[ 0 ].activeElement;

				// Support: IE9, IE10
				// If the <body> is blurred, IE will switch windows, see #4520
				if ( activeElement && activeElement.nodeName.toLowerCase() !== "body" ) {

					// Hiding a focused element doesn't trigger blur in WebKit
					// so in case we have nothing to focus on, explicitly blur the active element
					// https://bugs.webkit.org/show_bug.cgi?id=47182
					$( activeElement ).blur();
				}
			} catch ( error ) {}
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		});
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map(function() {
				return +$( this ).css( "z-index" );
			}).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( this.document[ 0 ].activeElement );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		});

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {
		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).focus();
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = this.document[0].activeElement,
				isActive = this.uiDialog[0] === activeElement ||
					$.contains( this.uiDialog[0], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );
		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $("<div>")
			.addClass( "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " +
				this.options.dialogClass )
			.hide()
			.attr({
				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			})
			.appendTo( this._appendTo() );

		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[0] || event.target === this.uiDialog[0] ) && !event.shiftKey ) {
					this._delay(function() {
						first.focus();
					});
					event.preventDefault();
				} else if ( ( event.target === first[0] || event.target === this.uiDialog[0] ) && event.shiftKey ) {
					this._delay(function() {
						last.focus();
					});
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		});

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr({
				"aria-describedby": this.element.uniqueId().attr( "id" )
			});
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" )
			.addClass( "ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix" )
			.prependTo( this.uiDialog );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {
				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {
					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.focus();
				}
			}
		});

		// support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button({
				label: this.options.closeText,
				icons: {
					primary: "ui-icon-closethick"
				},
				text: false
			})
			.addClass( "ui-dialog-titlebar-close" )
			.appendTo( this.uiDialogTitlebar );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		});

		uiDialogTitle = $( "<span>" )
			.uniqueId()
			.addClass( "ui-dialog-title" )
			.prependTo( this.uiDialogTitlebar );
		this._title( uiDialogTitle );

		this.uiDialog.attr({
			"aria-labelledby": uiDialogTitle.attr( "id" )
		});
	},

	_title: function( title ) {
		if ( !this.options.title ) {
			title.html( "&#160;" );
		}
		title.text( this.options.title );
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" )
			.addClass( "ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.addClass( "ui-dialog-buttonset" )
			.appendTo( this.uiDialogButtonPane );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// if we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ($.isArray( buttons ) && !buttons.length) ) {
			this.uiDialog.removeClass( "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;
			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );
			// Change the context for the click callback to be the main element
			click = props.click;
			props.click = function() {
				click.apply( that.element[ 0 ], arguments );
			};
			buttonOptions = {
				icons: props.icons,
				text: props.showText
			};
			delete props.icons;
			delete props.showText;
			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet );
		});
		this.uiDialog.addClass( "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable({
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		});
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,
			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css("position"),
			resizeHandles = typeof handles === "string" ?
				handles	:
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable({
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		})
		.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		});
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {
		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		});

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "dialogClass" ) {
			uiDialog
				.removeClass( this.options.dialogClass )
				.addClass( value );
		}

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button({
				// Ensure that we always pass a string
				label: "" + value
			});
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {
			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {
		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css({
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		});

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css({
				height: "auto",
				width: options.width
			})
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css({
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			});
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css({
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				})
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[0];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay(function() {
			isOpening = false;
		});

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			});
		}

		this.overlay = $( "<div>" )
			.addClass( "ui-widget-overlay ui-front" )
			.appendTo( this._appendTo() );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		});
		this.document.data( "ui-dialog-overlays",
			(this.document.data( "ui-dialog-overlays" ) || 0) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this.document
					.unbind( "focusin" )
					.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
});

}));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	__webpack_require__(10)(fox);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(15));

	contexts.push(__webpack_require__(51));

	contexts.push(__webpack_require__(79));

	contexts.push(__webpack_require__(83));

	contexts.push(__webpack_require__(116));


	contexts.forEach(getDeps);
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}


	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(11));

	contexts.push(__webpack_require__(13));


	contexts.forEach(getDeps);
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ga.js": 12
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.widget":[{"value":"#logoutApi","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.event":[{"value":"success","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101025},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.callback":[{"value":function() {
var ga = fox.wom.selectFirst('@root #googleAnalytics');
ga.trackEvent({'eventCategory': 'User', 'eventAction': 'logout'});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101029},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function() {
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var callback = function callback () {
counterCalls++;
var loaded = typeof _gaScriptLoaded !== 'undefined' ?
_gaScriptLoaded :
false
if (!loaded && counterCalls < 5) {
return setTimeout(callback, 2000);
}
self.rwom1('@root #googleAnalytics').trackPageview(currentPage, false);
}();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./mcgoogleanalytics.js": 14
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('mcGoogleAnalytics', {
		/**
		 * Track pageview.
		 * @param {string} page Name of tracked page
		 * @param {boolean} logPage If true, send navigator information to api logger.log
		 * @return {void}
		 */
		trackPageview: function(page, logPage) {
			this.callParent('trackPageview', [page]);

			if (fox.isEmpty(fox.site.member) && (fox.getEnv('affiliateArea') || fox.getEnv('globalSubscription'))) {
				var api = this.getApi('affTrack', {method: 'affiliate.track'});
				var data = {
					page: page
				};

				var foxref = null;

				if (foxref = fox.cookie.get('foxref')) {
					data.refCode = foxref;
				}

				api.send(data, false);
			}

			var permissionManager = fox.wom.selectFirst('~.PermissionManager');

			var isMember = permissionManager
				? !fox.isEmpty(permissionManager.getMemberInfo())
				: !fox.isEmpty(fox.site.member)
			;

			if (isMember && logPage) {
				var page = fox.Navigator.getAll()[0];

				if (!fox.inArray(['scene', 'gallery', 'product'], page)) {
					return;
				}

				var api = this.getApi('loggerLog', {method: 'logger.log'});

				api.send({
					index: 'McUserActivity',
					path: fox.Navigator.getAll()
				}, false);	
			}
		},

		/**
		 * Set default google dimensions for tracker with name "trackerName"
		 * @param {string} trackerName
		 * return {void}
		 */
		_setTrackerDimensions: function(trackerName) {
			this.callParent('_setTrackerDimensions', arguments);

			var foxref = fox.cookie.get('foxref');
			var acode = fox.cookie.get('acode');
			var parsedUrl, getParams;

			if (!acode) {
				parsedUrl = fox.Navigator.parseUrl(document.location);

				if (parsedUrl.search) {
					getParams = fox.Navigator.parseSearch(parsedUrl.search);

					if (getParams['acode']) {
						acode = getParams['acode'];
					}
				}
			}

			ga(trackerName + '.set', 'dimension2', fox.isEmpty(foxref) ? "" : foxref);
			ga(trackerName + '.set', 'dimension3', fox.isEmpty(acode) ? "" : acode);
		}

	}, 'googleAnalytics');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./area-catalog-modelsxxx-css-popup-stylus-compiled.css": 16,
	"./area-catalog-modelsxxx-css-stylus-compiled.css": 19,
	"./icomoon.css": 34,
	"./models.css": 41,
	"./normalize.css": 47,
	"./responsive.css": 49
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(17);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./area-catalog-modelsxxx-css-popup-stylus-compiled.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./area-catalog-modelsxxx-css-popup-stylus-compiled.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".subscription-form-wrapper{margin-top:-15px}.subscription-form-wrapper .btn{background-color:#272e34;display:inline-block;line-height:39px;border-radius:3px;color:#fff;text-align:center;padding:0 15px;text-decoration:none;font-size:12px;font-family:monserat_light;border:1px solid #272e34;transition:background-color .3s}.subscription-form-wrapper .btn>*{display:inline-block;vertical-align:middle}.subscription-form-wrapper .btn i{margin-right:15px}.subscription-form-wrapper .btn:hover{background-color:rgba(39,46,52,.9)}.subscription-form-wrapper .subscription-form .row{margin-bottom:10px}.subscription-form-wrapper .subscription-form .row .inp{width:100%}.subscription-form-wrapper .subscription-form .row.btns{margin-bottom:0;text-align:right}", ""]);

// exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(20);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./area-catalog-modelsxxx-css-stylus-compiled.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./area-catalog-modelsxxx-css-stylus-compiled.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".layout-width{max-width:1200px;margin:0 auto;padding:20px 40px}.layout-width.single-page.ccpa .sp-left{margin-bottom:220px}.sp-right{display:none}.sp-part,.sp-up-time,font-weight normal{font-size:12px}.sp-part-title{font-size:15px;font-weight:700}.marg-left{margin-left:20px}.wrapper-cookie-table{max-width:100%;overflow-x:scroll}.wrapper-cookie-table .cookie-table{border-collapse:collapse;margin-bottom:20px}.wrapper-cookie-table .cookie-table td,.wrapper-cookie-table .cookie-table th{padding:10px;border:1px solid #cecece}.nextlevel.numero{list-style:none;padding-left:20px}.show-popup{font-weight:700;line-height:40px}@media (min-width:768px){.layout-width.single-page.ccpa .wrapper-cookie-table{overflow-x:auto}.layout-width.single-page.ccpa .sp-left{margin-bottom:145px}}@media (min-width:1024px){.sp-main-content-wrapp .wrapper-cookie-table{overflow-x:auto}}@font-face{font-family:mc-xxx;src:url(" + __webpack_require__(21) + ") format(\"woff\"),url(" + __webpack_require__(22) + ") format(\"truetype\"),url(" + __webpack_require__(23) + "#mc-xxx) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:monserat_light;src:url(" + __webpack_require__(24) + ") format(\"woff\"),url(" + __webpack_require__(25) + ") format(\"truetype\"),url(" + __webpack_require__(26) + "#monserat_light) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:monserat_regular;src:url(" + __webpack_require__(27) + ") format(\"woff\"),url(" + __webpack_require__(28) + ") format(\"truetype\"),url(" + __webpack_require__(29) + "#monserat_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:monserat_bold;src:url(" + __webpack_require__(30) + ") format(\"woff\"),url(" + __webpack_require__(31) + ") format(\"truetype\"),url(" + __webpack_require__(32) + "#monserat_bold) format(\"svg\");font-weight:400;font-style:\"normal\"}[class*=\" icn-mc-xxx-\"],[class^=icn-mc-xxx-]{font-family:mc-xxx;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icn-mc-xxx-VR_glasses-1:before{content:\"\\E900\"}.icn-mc-xxx-wishlist_19:before{content:\"\\E905\"}.icn-mc-xxx-male_19:before{content:\"\\E906\"}.icn-mc-xxx-circle_19:before{content:\"\\E907\"}.icn-mc-xxx-female_19:before{content:\"\\E908\"}.icn-mc-xxx-photosets_19:before{content:\"\\E909\"}.icn-mc-xxx-romb_19:before{content:\"\\E90A\"}.icn-mc-xxx-shemale_19:before{content:\"\\E90B\"}.icn-mc-xxx-facebook_18:before{content:\"\\E90C\"}.icn-mc-xxx-instagram_18:before{content:\"\\E90D\"}.icn-mc-xxx-thumblr_18:before{content:\"\\E90E\"}.icn-mc-xxx-twitter_18:before{content:\"\\E90F\"}.icn-mc-xxx-visitSite_15:before{content:\"\\E910\"}.icn-mc-xxx-showsCounter_15:before{content:\"\\E911\"}.icn-mc-xxx-search_20:before{content:\"\\E912\"}.icn-mc-xxx-allUpdates_24:before{content:\"\\E913\"}.icn-mc-xxx-liveShow_24:before{content:\"\\E914\"}.icn-mc-xxx-videos_24:before{content:\"\\E915\"}.icn-mc-xxx-arrLeft_50:before{content:\"\\E916\"}.icn-mc-xxx-arrRight_50:before{content:\"\\E917\"}.icn-mc-xxx-drop_5:before{content:\"\\E918\"}.icn-mc-xxx-emailSubscribe_14:before{content:\"\\E919\"}.icn-mc-xxx-events_26:before{content:\"\\E91A\"}.icn-mc-xxx-models_26:before{content:\"\\E91B\"}.icn-mc-xxx-imagesCounter_13:before{content:\"\\E91C\"}.icn-mc-xxx-videosCounter_13:before{content:\"\\E91D\"}.icn-mc-xxx-menu_23:before{content:\"\\E91E\"}.icn-mc-xxx-MenuHide_23:before{content:\"\\E91F\"}.model-profile-wrapper{font-size:14px}.model-profile-wrapper .model-profile{margin-bottom:40px}.model-profile-wrapper .model-profile .sidebar{width:100%;margin-bottom:25px}.model-profile-wrapper .model-profile .sidebar .profile-foto img{display:block;max-width:100%}.model-profile-wrapper .model-profile .sidebar .block{padding:25px 40px;border-width:0 1px 1px;border-style:solid;border-color:#eeefef;color:#97a5b2;font-family:Georgia;font-style:italic;text-decoration:none}.model-profile-wrapper .model-profile .sidebar .block .row{margin-bottom:20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;line-height:18px}.model-profile-wrapper .model-profile .sidebar .block .row:last-child{margin-bottom:0}.model-profile-wrapper .model-profile .sidebar .block .txt{min-width:105px;font-size:11px}.model-profile-wrapper .model-profile .sidebar .block .val{width:100%}.model-profile-wrapper .model-profile .sidebar .model-name{margin-top:0;margin-bottom:20px}.model-profile-wrapper .model-profile .sidebar .model-name .avatar{width:95px;height:95px;position:relative;margin-top:-50px;padding:5px;float:left}.model-profile-wrapper .model-profile .sidebar .model-name .avatar img{border:5px solid #fff;display:block;width:85px;height:85px;position:relative;z-index:2}.model-profile-wrapper .model-profile .sidebar .model-name .avatar:before{content:\"\";display:block;position:absolute;z-index:1;left:0;right:0;top:0;height:25px;background-color:rgba(151,165,178,.2)}.model-profile-wrapper .model-profile .sidebar .model-name .avatar~.name,.model-profile-wrapper .model-profile .sidebar .model-name .avatar~.online{margin-left:115px}.model-profile-wrapper .model-profile .sidebar .model-name .name{color:#272e34;margin-bottom:5px}.model-profile-wrapper .model-profile .sidebar .model-name .online{color:#97a5b2;font-family:Georgia;font-style:italic;text-decoration:none;font-size:11px}.model-profile-wrapper .model-profile .sidebar .link-to-site{display:block!important}.model-profile-wrapper .model-profile .sidebar .link-to-site a{background-color:#272e34;display:inline-block;line-height:39px;border-radius:3px;color:#fff;text-align:center;padding:0 15px;text-decoration:none;font-size:12px;font-family:monserat_light;border:1px solid #272e34;transition:background-color .3s;display:block}.model-profile-wrapper .model-profile .sidebar .link-to-site a>*{display:inline-block;vertical-align:middle}.model-profile-wrapper .model-profile .sidebar .link-to-site a i{margin-right:15px}.model-profile-wrapper .model-profile .sidebar .link-to-site a:hover{background-color:rgba(39,46,52,.9)}.model-profile-wrapper .model-profile .sidebar .link-to-site a i{font-size:15px}.model-profile-wrapper .model-profile .sidebar .models-content .val{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.model-profile-wrapper .model-profile .sidebar .models-content .icon{margin-right:10px}.model-profile-wrapper .model-profile .sidebar .models-content .icon:last-child{margin-right:0}.model-profile-wrapper .model-profile .sidebar .models-content .icon i{position:relative;top:2px}.model-profile-wrapper .model-profile .sidebar .models-content .num{color:#272e34;margin-left:5px}.model-profile-wrapper .model-profile .sidebar .social-networks .val{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.model-profile-wrapper .model-profile .sidebar .social-networks .val a{margin-right:20px;font-size:18px;color:#97a5b2;font-family:Georgia;font-style:italic;text-decoration:none}.model-profile-wrapper .model-profile .sidebar .social-networks .val a:last-child{margin-right:0}.model-profile-wrapper .model-profile .sidebar .models-wishlist .val a{color:#97a5b2;font-family:Georgia;font-style:italic;text-decoration:none}.model-profile-wrapper .model-profile .sidebar .models-wishlist .val a:hover{text-decoration:underline}.model-profile-wrapper .model-profile .sidebar .models-wishlist .val a i{font-size:18px}.model-profile-wrapper .model-profile .sidebar .models-wishlist a{text-decoration:none}.model-profile-wrapper .model-profile .sidebar .call-me iframe{max-width:100%;width:100px;height:20px}.model-profile-wrapper .model-profile .profile-data{width:100%}.model-profile-wrapper .model-profile .profile-data .subscribe{margin-bottom:5px}.model-profile-wrapper .model-profile .profile-data .subscribe,.model-profile-wrapper .model-profile .profile-data .subscribe a{color:#97a5b2;font-family:Georgia;font-style:italic;text-decoration:none}.model-profile-wrapper .model-profile .profile-data .subscribe a:hover{text-decoration:underline}.model-profile-wrapper .model-profile .profile-data .title{font-size:21px;text-transform:uppercase;letter-spacing:.8px;margin-bottom:25px}.model-profile-wrapper .model-profile .profile-data .introduction{font-size:14px;margin-bottom:50px}.model-profile-wrapper .model-profile .profile-data .introduction .short{margin-bottom:15px}.model-profile-wrapper .model-profile .profile-data .introduction .long{display:none}.model-profile-wrapper .model-profile .profile-data .introduction .show-full a{color:#97a5b2;font-family:Georgia;font-style:italic;text-decoration:none}.model-profile-wrapper .model-profile .profile-data .introduction .show-full a i{font-size:8px}.model-profile-wrapper .model-profile .profile-data .introduction p{margin-top:0;margin-bottom:25px}.model-profile-wrapper .model-profile .profile-data .introduction p:last-child{margin-bottom:0}.model-profile-wrapper .model-profile .profile-data .introduction.full .short,.model-profile-wrapper .model-profile .profile-data .introduction.full .show-full{display:none}.model-profile-wrapper .model-profile .profile-data .introduction.full .long{display:block}.model-profile-wrapper .model-profile .profile-data .stats-table{margin-top:-15px}.model-profile-wrapper .model-profile .profile-data .stats-table .header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;border-bottom:1px solid #eeefef}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item{height:55px;line-height:55px;text-transform:uppercase;color:#97a5b2;font-size:21px;margin:0 25px;position:relative;cursor:pointer}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item .pointer{position:absolute;width:20px;height:10px;left:50%;margin-left:-10px;bottom:-2px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;display:block;transform:translateY(10px);transition:transform .3s,opacity .3s}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item .pointer:after,.model-profile-wrapper .model-profile .profile-data .stats-table .header .item .pointer:before{content:\"\";width:0;height:0;border-style:solid;border-width:0 9.5px 10px;border-color:transparent transparent #eeefef;display:block}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item .pointer:after{position:absolute;left:2px;bottom:0;border-width:0 7.5px 8px;border-color:transparent transparent #fff}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item.active .pointer{-ms-filter:none;filter:none;opacity:1;transform:translateY(0)}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item:first-child{margin-left:0}.model-profile-wrapper .model-profile .profile-data .stats-table .header .item:last-child{margin-right:0}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content{padding-top:25px}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item{display:none}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item .row{line-height:15px;font-size:12px;padding-top:17px;padding-bottom:17px}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item .row strong{font-family:monserat_bold}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item .row:first-child{padding-top:0}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item[data-tab-alias=stats] .row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item[data-tab-alias=stats] .row .name{font-family:monserat_bold;width:120px;min-width:120px}.model-profile-wrapper .model-profile .profile-data .stats-table .stats-content .item.active{display:block}@media (min-width:768px){.model-profile-wrapper .model-profile{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.model-profile-wrapper .model-profile .profile-data,.model-profile-wrapper .model-profile .sidebar{width:50%}.model-profile-wrapper .model-profile .sidebar{margin-bottom:0}.model-profile-wrapper .model-profile .profile-data{padding-left:30px}}@media (min-width:1024px){.model-profile-wrapper .model-profile .sidebar{min-width:360px}.model-profile-wrapper .model-profile .profile-data{width:100%;margin-left:50px;padding-left:0}}.wrapper{min-height:100%;position:relative;z-index:2;transition:filter .4s}.wrapper .models-grid{padding-bottom:160px}.wrapper>.features,.wrapper>.header,.wrapper>.models-sitepage-wrapper{position:relative;z-index:2}.wrapper>.header{z-index:3}.wrapper>.header.slide{position:fixed;left:0;right:0;top:0;background-color:#fff;box-shadow:0 1px 5px 1px rgba(0,0,0,.1)}.wrapper>.header.slide+.models-sitepage-wrapper{margin-top:112px}.wrapper>.header.slide .navigation{top:0}.wrapper.blured{filter:grayscale(100%);overflow:hidden}.models-header{height:75px;padding:20px 0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:row nowrap;flex-direction:row nowrap;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.models-header .title{font-size:14px;line-height:42px;float:left;display:none}.models-header .menu-icon{cursor:pointer;font-size:16px;margin-right:0;margin-left:0;font-weight:700;line-height:42px;vertical-align:middle}.models-header .menu-icon i{font-size:34px;margin-left:10px;transform:rotate(180deg);display:inline-block}.models-header .menu-icon i,.models-header .menu-icon span{vertical-align:middle}.models-header .menu-icon.active{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.models-header .menu-icon.active+.navigation{bottom:0;visibility:visible}.models-header .menu-icon.active+.navigation>section{transform:translateX(-100%)}.models-header .logo{float:right;width:150px}.models-header .logo img{display:block;max-width:100%}.navigation{visibility:hidden;position:fixed;left:100%;right:0;top:107px;bottom:0;z-index:3;width:370px;color:#fff;font-size:14px;line-height:25px;transition-property:bottom;transition-delay:1s}.navigation>section{min-width:240px;margin:0 auto;max-width:370px;padding:0 10px;background-color:#20252a;transition:transform .3s ease-out;height:100%;transform:translateX(100%)}.navigation .has-maxw{max-width:240px;margin:0 auto}.navigation .navi-title{text-transform:uppercase;padding:43px 0 28px;display:-moz-flex;display:-ms-flexbox;display:flex}.navigation .navi-title .icon{font-size:34px;cursor:pointer;transform:rotate(180deg)}.navigation .navi-title span.txt{line-height:34px;vertical-align:middle;margin-left:10px}.navigation li{border-bottom:1px solid hsla(0,0%,100%,.08);display:block;color:#fff;transition:background-color .2s linear}.navigation li a{color:inherit;padding:25px 15px 25px 65px;text-decoration:none;display:block;position:relative}.navigation li a .icon{position:absolute;top:28px;left:30px;font-size:23px}.navigation li a span.descr{display:block}.navigation li a span.descr.label{text-transform:uppercase}.navigation li a span.descr.updates{color:rgba(151,165,178,.5);font-family:Georgia;font-style:italic;line-height:20px;font-size:12px;display:none}.navigation li.active{background-color:hsla(0,0%,100%,.05);color:#fff}.navigation li:first-child.active{border-top:1px solid hsla(0,0%,100%,.08)}.navigation li:not(.active){cursor:default}.navigation li:not(.active):hover{background-color:hsla(0,0%,100%,.02)}.navigation.scrolled{top:0}.models-events-list .event-item.model .event-descr{display:-moz-flex;display:-ms-flexbox;display:flex;padding-top:25px;padding-bottom:20px}.models-events-list .event-item.model .event-descr .model-avatar{width:94px;min-width:94px;border:5px solid hsla(0,0%,100%,.3);margin-right:20px;position:relative;margin-top:-50px}.models-events-list .event-item.model .event-descr .model-avatar span{display:block;border:5px solid #fff}.models-events-list .event-item.model .owner-descr{padding-top:0}.list-wrapper{position:relative;background-color:#ebebeb}.list-wrapper:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;background:url(" + __webpack_require__(7) + ") repeat-x 0 100% #fff;height:540px}.list-wrapper>*{position:relative;z-index:2}.inp+.error-msg{display:none;color:red;font-size:12px;margin-top:5px}.inp.error{border-color:red}.inp.error+.error-msg{display:block}.models-events-list .event-item{transition:transform .2s,opacity .1s}.models-events-list .event-item.masonry-hide{transform:scale(.8);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.models-filter{border-width:1px 0;border-style:solid;border-color:#eeefef;position:relative;padding:20px 0;margin-bottom:30px}.models-filter:after,.models-filter:before{content:\"\";display:none;position:absolute;width:19px;height:9px;background:url(" + __webpack_require__(33) + ") 0 0 no-repeat}.models-filter:after{bottom:-9px;left:-19px}.models-filter:before{top:-9px;right:-19px}.models-filter .form-group{margin-bottom:15px}.models-filter .form-group label{display:none;margin-right:15px;margin-bottom:5px}.models-filter .form-group .inp{display:block}.models-filter .form-group .inp.search{padding-right:80px}.models-filter .form-group .inp.search .autocomplete-list{position:absolute;top:40px;background-color:#fff;border:3px solid #eeefef;left:-3px;right:-3px;max-height:300px;z-index:3;overflow:auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transform:translateY(25px);transition:transform .3s,opacity .3s}.models-filter .form-group .inp.search .autocomplete-list .img{max-width:70px;float:left}.models-filter .form-group .inp.search .autocomplete-list .img img{display:block;max-width:100%}.models-filter .form-group .inp.search .autocomplete-list>div{position:relative}.models-filter .form-group .inp.search .autocomplete-list .name{margin-left:85px;display:block;line-height:70px}.models-filter .form-group .inp.search .autocomplete-list .name .hl{background-color:#ff0}.models-filter .form-group .inp.search .autocomplete-list.show{-ms-filter:none;filter:none;opacity:1;transform:translateY(0)}.models-filter .form-group .inp.search .autocomplete-list .item{overflow:hidden;display:block;text-align:left;padding:10px;border-bottom:1px solid #eeefef}.models-filter .form-group .inp.search .autocomplete-list .item.active,.models-filter .form-group .inp.search .autocomplete-list .item:hover{background-color:#ebebeb}.models-filter .form-group .inp.search .icon.preloader{width:20px;height:20px;margin-top:0;bottom:auto;right:55px;left:auto;top:12px}.models-filter .form-group .inp.search .icon.preloader.spin+.icon.clear{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.models-filter .form-group .inp.search .icon.clear{right:56px;width:auto;cursor:pointer;color:#97a5b2}.models-filter .form-group .inp.search .icon.clear i{font-size:25px;display:block;font-style:normal;transform:rotate(45deg)}.models-filter .form-group:last-child{margin-right:0}.models-filter.models .sorting{min-width:265px}.models-filter.models .gender{min-width:30%}.models-filter.models .search{width:100%}@media (min-width:768px){.models-filter{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.models-filter .form-group{margin-bottom:0;margin-right:20px;width:50%}.models-filter .form-group label{display:block}.models-filter.models .form-group{width:auto}.list-wrapper:before{height:490px}}@media (min-width:1200px){.models-filter .form-group{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.models-filter .form-group label{white-space:nowrap;line-height:46px}.models-filter .form-group .inp{width:100%}.models-filter.models .sorting{min-width:315px}}.nextlevel{padding-left:20px;list-style:none}.mc-xxx-common-popup{position:absolute;background-color:#fff;color:#272e34;padding:35px 45px;z-index:3;max-width:100%;box-shadow:0 14px 24px rgba(0,0,0,.23)}.mc-xxx-common-popup .ui-dialog-titlebar{display:none}.mc-xxx-common-popup.ccpa-form .ui-dialog-titlebar{display:block;font-size:22px;margin-bottom:15px}.mc-xxx-common-popup.ccpa-form .ui-dialog-titlebar .ui-dialog-titlebar-close{position:absolute;right:20px;top:20px;font-size:12px}.mc-xxx-common-popup.ccpa-form .sub-button{text-align:center}.mc-xxx-common-popup.ccpa-form .sub-button #form-submit{padding:7px 15px;border-radius:4px;background-color:#c8cace;white-space:nowrap;width:auto}.mc-xxx-common-popup .popup-content-wrapper{font-size:14px}.mc-xxx-common-popup .popup-content-wrapper .cross{font-size:40px;position:absolute;top:10px;right:5px;display:block;transform:rotate(45deg);text-align:center;width:20px;height:20px;line-height:20px;cursor:pointer}.mc-xxx-common-popup .popup-content-wrapper .title-wrapper{color:#272e34;text-transform:uppercase;font-size:21px;line-height:22px;margin-bottom:25px}.mc-xxx-common-popup .popup-content-wrapper .content-wrapper{padding:0}.mc-xxx-common-popup .popup-content-wrapper .content-wrapper .caption{color:#97a5b2;font-size:11px;margin-bottom:15px;font-family:Georgia}.mc-xxx-common-popup .popup-content-wrapper .footer-wrapper{text-align:right;margin-top:20px}.mc-xxx-common-popup .popup-content-wrapper .footer-wrapper .button{background-color:#272e34;display:inline-block;line-height:39px;border-radius:3px;color:#fff;text-align:center;padding:0 15px;text-decoration:none;font-size:12px;font-family:monserat_light;border:1px solid #272e34;transition:background-color .3s;margin-right:15px}.mc-xxx-common-popup .popup-content-wrapper .footer-wrapper .button>*{display:inline-block;vertical-align:middle}.mc-xxx-common-popup .popup-content-wrapper .footer-wrapper .button i{margin-right:15px}.mc-xxx-common-popup .popup-content-wrapper .footer-wrapper .button:hover{background-color:rgba(39,46,52,.9)}.mc-xxx-common-popup .popup-content-wrapper .footer-wrapper .button:last-child{margin-right:0}.mc-xxx-common-popup~.ui-widget-overlay{position:fixed;top:0;bottom:0;right:0;left:0;background:rgba(0,0,0,.3)}@media (min-width:768px){.mc-xxx-common-popup{position:fixed}}.inp{background-color:#fff}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .title{font-family:monserat_light;font-size:12px;padding-bottom:25px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper{border:4px solid #d4d9de;border-radius:4px;padding:18px 15px 35px;background-color:#fff}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-pic{text-align:center;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-pic img{height:240px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text{font-family:Georgia;font-style:italic;text-align:center;padding:20px 8px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text .bold-text{font-weight:700;font-size:18px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text .text{font-size:12px;color:#97a5b2}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-form .subscription-form{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 auto;flex:1 0 auto;-ms-align-items:center;-ms-flex-align:center;align-items:center}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-form .subscription-form .row{padding:0 0 20px;width:100%}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-form .subscription-form .row .inp{display:-moz-flex;display:-ms-flexbox;display:flex}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-form .subscription-form .subscribe{font-size:14px;color:#fff;background-color:#171b1f;border-color:#171b1f;height:46px;border-radius:6px;min-width:190px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-form .subscription-form .subscribe span{font-family:monserat_regular;padding-left:10px}.models-sitepage-wrapper .models-filter-vr .inp{background-color:#fff;border-color:#d4d9de}.models-sitepage-wrapper .vr-icon{position:absolute;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;-ms-align-items:center;-ms-flex-align:center;align-items:center;font-size:31px;color:#fff;background-color:#171b1f;border-radius:50%;height:50px;width:50px;top:8px;left:8px}@media (min-width:600px){.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper{padding:18px 15px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form{padding:0 40px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-align-items:center;-ms-flex-align:center;align-items:center}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-form{width:470px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-form .subscription-form{-ms-flex-direction:row;flex-direction:row;-ms-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-form .subscription-form .subscribe{margin-left:10px}}@media (min-width:900px){.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .title{font-size:16px;text-align:center}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form{-ms-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-pic img{max-height:240px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-flex:1 0 auto;flex:1 0 auto}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-text{text-align:left}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-text .bold-text{font-size:20px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-text .text{font-size:16px}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-form .subscription-form{-ms-flex-direction:row;flex-direction:row}.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-form .subscription-form .subscribe{margin-left:10px}.models-sitepage-wrapper .vr-icon{top:16px;left:16px}}@media (min-width:1024px){.models-sitepage-wrapper #subscribe-vr .vr-content-wrapper .subscription-vr-wrapper .vr-text-form .vr-form{width:600px}}", ""]);

// exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc-xxx.woff", __webpack_require__.p + "fonts/1blMEwa.woff");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc-xxx.ttf", __webpack_require__.p + "fonts/2iLWa_k.ttf");

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc-xxx.svg", __webpack_require__.p + "fonts/mc-xxx.svg");

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-light-webfont.woff", __webpack_require__.p + "fonts/2cND8CF.woff");

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-light-webfont.ttf", __webpack_require__.p + "fonts/2hEHkVL.ttf");

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-light-webfont.svg", __webpack_require__.p + "fonts/montserrat-light-webfont.svg");

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-regular-webfont.woff", __webpack_require__.p + "fonts/2f5C5kZ.woff");

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-regular-webfont.ttf", __webpack_require__.p + "fonts/T5JUwi_.ttf");

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-regular-webfont.svg", __webpack_require__.p + "fonts/montserrat-regular-webfont.svg");

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-bold-webfont.woff", __webpack_require__.p + "fonts/29XJcM6.woff");

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-bold-webfont.ttf", __webpack_require__.p + "fonts/1M13YJB.ttf");

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-bold-webfont.svg", __webpack_require__.p + "fonts/montserrat-bold-webfont.svg");

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/decor-1.png", __webpack_require__.p + "images/decor-1.png");

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(35);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./icomoon.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./icomoon.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@font-face{font-family:icomoon;src:url(" + __webpack_require__(36) + ");src:url(" + __webpack_require__(37) + "?#iefixirrfou) format(\"embedded-opentype\"),url(" + __webpack_require__(38) + ") format(\"woff\"),url(" + __webpack_require__(39) + ") format(\"truetype\"),url(" + __webpack_require__(40) + "#icomoon) format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:icomoon;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-xxx-20:before{content:\"\\E600\"}.icon-xxx-01:before{content:\"\\E601\"}.icon-xxx-02:before{content:\"\\E602\"}.icon-xxx-03:before{content:\"\\E603\"}.icon-xxx-04:before{content:\"\\E604\"}.icon-xxx-05:before{content:\"\\E605\"}.icon-xxx-06:before{content:\"\\E606\"}.icon-xxx-07:before{content:\"\\E607\"}.icon-xxx-08:before{content:\"\\E608\"}.icon-xxx-09:before{content:\"\\E609\"}.icon-xxx-10:before{content:\"\\E60A\"}.icon-xxx-11:before{content:\"\\E60B\"}.icon-xxx-12:before{content:\"\\E60C\"}.icon-xxx-13:before{content:\"\\E60D\"}.icon-xxx-14:before{content:\"\\E60E\"}.icon-xxx-15:before{content:\"\\E60F\"}.icon-xxx-16:before{content:\"\\E610\"}.icon-event-liveshow:before,.icon-xxx-17:before{content:\"\\E611\"}.icon-event-video:before,.icon-xxx-18:before{content:\"\\E612\"}.icon-event-photoset:before,.icon-xxx-19:before{content:\"\\E613\"}", ""]);

// exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icomoon.eot?irrfou", __webpack_require__.p + "fonts/NGOgU-z.eot");

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icomoon.eot", __webpack_require__.p + "fonts/NGOgU-z.eot");

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icomoon.woff?irrfou", __webpack_require__.p + "fonts/3PgKwQn.woff");

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icomoon.ttf?irrfou", __webpack_require__.p + "fonts/1vExenQ.ttf");

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icomoon.svg?irrfou", __webpack_require__.p + "fonts/icomoon.svg");

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(42);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./models.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./models.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "*{box-sizing:border-box;outline:none}a{cursor:pointer}strong{font-weight:400;font-family:monserat_bold}ul{padding:0;margin:0}body,html{min-height:100%;height:100%;background-color:#fff;font-family:monserat_light;color:#272e34;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.loader,.loader-container{position:relative}.loader{visibility:hidden;opacity:0;width:102px;height:102px;margin:0 auto -102px;background:url(" + __webpack_require__(43) + ") 0 0 no-repeat;transition:filter 1s,opacity 1s,transform 1s;-o-filter:blur(5px);filter:blur(5px)}.loader.show{visibility:visible;opacity:1;margin-bottom:0;-o-filter:blur(0);filter:blur(0)}.loader.rotate{animation-duration:3s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:rotate}@keyframes rotate{0%{transform:rotate(0deg)}50%{transform:rotate(1turn)}to{transform:rotate(2turn)}}.loader.show+.models-events-list{display:block;position:absolute!important;visibility:hidden;top:-99999px}.loader.show~.load-more-events{display:none}.small-loader{content:\"\";display:block;width:19px;height:19px;position:absolute;left:-10px;top:50%;margin-top:-10px;opacity:0;visibility:hidden;background-image:url(" + __webpack_require__(44) + ");background-repeat:no-repeat;background-position:0 0;transition:all .3s ease}.small-loader.spin{visibility:visible;left:20px;opacity:1;animation:play 1s steps(28) infinite}@keyframes play{0%{background-position:0 0}to{background-position:0 -560px}}.btn{border-radius:2px;background-color:#272e34;transition:background-color .2s;color:#fff;line-height:17px;padding:19px 10px;display:inline-block;text-align:center}.btn:hover{opacity:.8}.form-group label{display:none;margin-right:15px}.form-group .inp,.form-group label{vertical-align:middle}.inp{height:46px;border:3px solid #eeefef;border-radius:3px;padding:0 15px;position:relative;display:inline-block}.inp.with-icon{padding-right:56px}.inp.with-icon .icon{width:46px;border:1px solid transparent;height:100%;position:absolute;top:0;bottom:0;text-align:center;line-height:40px;font-size:19px;z-index:2;background-color:#fff}.inp.with-icon.begin{padding-left:46px}.inp.with-icon .icon.begin{left:0}.inp.with-icon .icon.end{right:0;border-left-color:inherit}.inp input,.inp select{border:none;background-color:transparent;height:100%;display:block;width:100%}.inp.select{padding:0;cursor:pointer}.inp.select .txt{position:relative;right:46px;left:15px;line-height:40px;z-index:1}.inp.select.with-icon.begin .txt{left:46px}.inp.select.with-icon.begin{padding-left:0}.inp.select select{opacity:0;padding:0 46px 0 15px;position:relative;z-index:3;cursor:inherit;top:-100%}.inp.select.with-icon.begin select{padding-left:46px}.inp.select .icon.end{font-size:8px}.inp.search .icon{cursor:pointer}.page-width{width:auto;max-width:1194px;margin:0 20px}.pattern{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;background:url(" + __webpack_require__(7) + ") repeat-x left 113% #fff;max-height:1000px;display:none}.features-glider-wrapper{position:relative;max-width:1100px;margin:0 -20px 30px}.features-glider-wrapper>div{position:relative}.features-glider-wrapper .features-glider{z-index:2;position:relative;overflow:hidden;visibility:hidden;margin-bottom:20px}.features-glider-wrapper .features-glider:after,.features-glider-wrapper .features-glider:before{content:\"\";display:none;position:absolute;height:350px;top:0;width:48px;background:url(" + __webpack_require__(45) + ") 0 0 no-repeat;z-index:2}.features-glider-wrapper .features-glider:before{left:0}.features-glider-wrapper .features-glider:after{right:0;transform:rotate(180deg)}.features-glider-wrapper .items{height:inherit;position:relative;overflow:hidden}.features-glider-wrapper .items .item{height:inherit;display:block;float:left;width:100%;position:relative}.features-glider-wrapper .items .item img{display:block;margin:0 auto;max-width:100%}.features-glider-wrapper .bullets{text-align:center;margin-top:0}.features-glider-wrapper .bullets a{display:inline-block;background-color:#272e34;width:13px;height:13px;border:2px solid #fff;border-radius:50%;transition:all .2s;margin:0 15px}.features-glider-wrapper .bullets a.active{width:13px;height:13px;background-color:#fff;border-color:#272e34;border-width:2px}.features-glider-wrapper .arr{text-align:center;position:absolute;margin-top:-23px;top:50%;font-size:25px;background-color:#fff;width:30px;height:46px;line-height:46px;z-index:2}.features-glider-wrapper .arr.lt{left:0;border-radius:0 1px 1px 0}.features-glider-wrapper .arr.rt{right:0;border-radius:1px 0 0 1px}.features-glider-wrapper .decor{display:none;position:absolute;background-color:#000;height:3px;z-index:0;width:168px}.features-glider-wrapper .decor.right{right:-94px;bottom:105px;transform:rotate(-45deg)}.models-events-list{position:relative;margin-left:-1%;margin-right:-1%}.models-events-list .event-item-gutter{width:10px}.models-events-list .event-grid-sizer{width:100%}.models-events-list .event-item{margin:0;border:1px solid #ebebeb;margin-top:5px;margin-bottom:5px}.models-events-list .event-item.no-img{padding-top:40px}.models-events-list .event-item.no-img .primary-thumb{display:none}.models-events-list .no-data{text-align:center;padding:20px 0}.events-feed{min-height:220px}.models-events-list .event-item{float:left;background-color:#fff;border-radius:1px;width:100%;margin-bottom:10px}.models-events-list .event-item img{display:block;max-width:100%;margin:auto}.models-events-list .event-item .primary-thumb{position:relative;display:block}.models-events-list .event-item .primary-thumb .icon{z-index:2;position:absolute;bottom:0;right:0;background-color:rgba(32,37,42,.8);font-size:22px;line-height:70px;width:70px;height:70px;color:#fff;text-align:center}.models-events-list .event-item .primary-thumb.hidden{display:none}.models-events-list .event-item .primary-thumb .slides-container{position:absolute;top:0;right:0;bottom:0;left:0;z-index:2}.models-events-list .event-item .primary-thumb .slide-handler{display:block;height:100%;width:12.5%;position:relative;z-index:3;float:left}.models-events-list .event-item .primary-thumb .slide-image{position:absolute;z-index:1;top:0;right:0;left:0;bottom:0;display:none}.models-events-list .event-item .primary-thumb .slide-handler:hover+.slide-image{display:block}.event-info{padding:0 20px 20px}.models-events-list .event-item .title{font-size:12px;line-height:16px}.models-events-list .event-item .title a{text-decoration:none;color:inherit}.models-events-list .event-item .date{font-size:12px;color:#97a5b2}.models-events-list .event-item .value{font-family:Georgia;font-style:italic;color:#97a5b2}.models-events-list .event-item .event-descr{padding-top:20px;padding-bottom:0}.models-events-list .event-item .event-descr .title{position:relative;text-transform:uppercase;margin-bottom:5px}.models-events-list .event-item .owner-descr{margin-top:15px;border-top:1px solid #eeefef;padding-top:20px;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.models-events-list .event-item .owner-descr .photo{display:none;margin-right:15px;min-width:108px;max-width:108px;height:108px;overflow:hidden;border-radius:1px}.models-events-list .event-item .owner-descr .info{width:100%}.models-events-list .event-item .owner-descr .content{font-family:Georgia;font-style:italic;font-size:12px;line-height:16px;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;justify-content:space-between;margin-top:5px}.models-events-list .event-item .owner-descr .content>span{-ms-flex:1 auto;flex:1 auto}.models-events-list .event-item .owner-descr .content>span>i{font-size:16px;vertical-align:middle}.event-item.join .event-descr{border-bottom:none}.event-item.join .owner-descr{padding-top:0;display:block}.event-item.join .btn.join{display:block}.models-events-list .event-item.liveshow .counter{border-radius:3px;background-color:#3a4147;color:#fff;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;padding:15px 10px;justify-content:space-around;margin-top:15px}.models-events-list .event-item.liveshow .part{-ms-flex:1 auto;flex:1 auto;text-align:center}.models-events-list .event-item.liveshow .part span.digit{font-size:20px;line-height:20px;font-family:Georgia}.models-events-list .event-item.liveshow .part span.label{display:block;font-size:9px;color:#a0a0a0;margin-top:3px;text-align:center}.models-events-list .event-item.liveshow .separator{opacity:.1;font-size:20px}.models-events-list .event-item.liveshow .ls-inprogress{text-align:center;font-size:20px}.load-more-events{padding-top:35px;text-align:center}.load-more-events .load-more{line-height:12px;padding:5px 0;color:#9c9fa1;display:inline-block;border-bottom:2px dashed #9c9fa1;position:relative}.load-more-events .load-more .small-loader.spin{left:-25px}.model-footer{margin-top:65px;padding:40px 0;position:relative;text-align:center;font-size:13px;position:absolute;left:0;right:0;bottom:0;z-index:3;background-color:#ebebeb}.model-footer:after,.model-footer:before{position:absolute;content:\"\";display:block;width:35%;max-width:365px;top:0;height:1px;background-color:rgba(58,65,71,.2)}.model-footer:before{left:0}.model-footer:after{right:0}.model-footer .logo{position:absolute;top:-19px;left:50%;margin-left:-20px}.model-footer .logo img{display:block}.model-footer .cr{display:block;margin-bottom:15px}.model-footer .get-site{color:#3a4147;font-family:monserat_bold;text-decoration:none;border-bottom:2px solid rgba(58,65,71,.2);padding-bottom:3px}.model-footer .footer-links{margin-top:15px}.model-footer .footer-links>span{display:inline-block;padding:5px 0}.model-footer .footer-links a{color:#3a4147;text-decoration:none;padding:0 10px}.model-footer .footer-links a:hover{text-decoration:underline;padding:0 10px}.layout-width{max-width:1200px;margin:0 auto;padding:20px 20px 50px}.sp-right{display:none}.sp-left{margin-bottom:145px}.sp-up-time{font-weight:400}.sp-part,.sp-up-time{font-size:12px}.sp-part table td{padding:7px;vertical-align:top}h2.sp-title{text-align:center}.sp-part-title{font-size:15px;font-weight:700}.marg-left{margin-left:20px}.padd-left{padding-left:55px}.sp-part p{margin:20px}ul.dotted-list{margin:0 0 0 35px}.closest-liveshows{background-color:#272e34;position:relative;z-index:2}.closest-liveshows .closest-liveshows-wrapper{position:relative}.closest-liveshows .pager{position:absolute;left:0;width:8px;z-index:3;top:20px;bottom:0;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;-o-flex-direction:column;flex-direction:column;justify-content:flex-start}.closest-liveshows .models-liveshows,.closest-liveshows .pager{height:160px}.closest-liveshows .pager a{display:block;margin-bottom:4px;width:8px;height:8px;position:relative;border:1px solid #272e34;background-color:#55616b;border-radius:50%}.closest-liveshows .pager a:last-child{margin-bottom:0}.closest-liveshows .pager a.active{border-width:2px;border-color:#fff;background-color:#transparent}.closest-liveshows .item{display:none;padding-top:20px;color:#fff;justify-content:space-between;display:block;transition:opacity .5s,transform .3s;opacity:0;z-index:1;position:absolute;top:0;left:35px;right:0}.closest-liveshows .model{margin-left:0;color:#fff;text-decoration:none;margin-bottom:8px;text-align:center;display:block}.closest-liveshows .model .cam{width:57px;height:67px;background:url(" + __webpack_require__(46) + ") 0 0 no-repeat;float:left;display:none}.closest-liveshows .model .info{margin-left:0;padding-top:0}.closest-liveshows .model .info .next{font-size:25px;font-family:monserat_bold;color:#f0cb66;line-height:25px}.closest-liveshows .model .info .next span{color:#fff}.closest-liveshows .model .info .name{font-size:14px;line-height:18px;font-family:monserat_light}.closest-liveshows .model .info .name strong{font-family:monserat_bold;transition:transform .3s .2s}.closest-liveshows .date-wrapper{text-align:center;position:relative}.closest-liveshows .date-wrapper .starts{font-size:12px;line-height:14px;margin-bottom:10px}.closest-liveshows .date-wrapper .counter{position:absolute;bottom:-28px;left:0;right:0;vertical-align:top;display:none;transition:transform .3s .2s;transform:translateY(-20px)}.closest-liveshows .date-wrapper .counter>*{display:inline-block;vertical-align:top}.closest-liveshows .date-wrapper .counter .part{width:45px;height:59px;border-radius:3px;background-color:#313940;padding:10px 5px;font-family:monserat_regular}.closest-liveshows .date-wrapper .counter .separator{margin:0 5px;color:#55616b;font-size:30px;line-height:36px}.closest-liveshows .date-wrapper span.part6,.closest-liveshows .date-wrapper span.separator5{display:none}.closest-liveshows .date-wrapper span.separator5.show,.closest-liveshows .date-wrapper span.separator5.show+.part6{display:inline-block}.closest-liveshows .date-wrapper .counter .part .digit{font-size:25px;line-height:25px;border-bottom:5px;color:#fff}.closest-liveshows .date-wrapper .counter .part .label{font-size:10px;color:#6e7c89;line-height:12px}.closest-liveshows .join{text-align:center;text-decoration:none;color:#fff}.closest-liveshows .join .img{float:right;width:42px;height:42px;border-radius:50%;overflow:hidden;position:relative;transition:transform .3s .2s}.closest-liveshows .join .img img{display:block;max-width:100%}.closest-liveshows .join .btn-wrapper{margin-right:53px;padding-top:2px}.closest-liveshows .join .btn-wrapper .join-btn{border:3px solid #f0cb66;color:#f0cb66;font-size:12px;font-family:monserat_bold;line-height:12px;padding:10px 25px;margin-bottom:5px;text-transform:uppercase;border-radius:7px;position:relative}.closest-liveshows .join .btn-wrapper .join-btn:after{position:absolute;content:\"\";top:12px;right:-8px;width:0;height:0;border-style:solid;border-width:7px 0 0 7px;border-color:transparent transparent transparent #f0cb66;-webkit-transform:rotate(1turn)}.closest-liveshows .join .btn-wrapper .watch{font-size:12px;display:none}.closest-liveshows .item.active{z-index:2;opacity:1;transform:scale(1)}.closest-liveshows .item.active .date-wrapper .counter{transform:translateY(0)}", ""]);

// exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/star.png", __webpack_require__.p + "images/star.png");

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite-small-preloader-grey.png", __webpack_require__.p + "images/sprite-small-preloader-grey.png");

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/mask.png", __webpack_require__.p + "images/mask.png");

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/cam.png", __webpack_require__.p + "images/cam.png");

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./normalize.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./normalize.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "/*! normalize.css v3.0.2 | MIT License | git.io/normalize */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}", ""]);

// exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(50);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./responsive.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./responsive.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@media (min-width:480px){.models-events-list .event-item-gutter{width:0}.models-events-list .event-grid-sizer{width:22.5%}.models-events-list .event-item{width:48%;margin:5px 1%}}@media (min-width:768px){.page-width{margin:0 30px}.models-header .logo{width:auto;float:left}.models-header .menu-icon{margin-left:30px}.features-glider-wrapper{margin-left:-30px;margin-right:-30px}.features-glider-wrapper .arr{width:50px;height:67px;line-height:67px;margin-top:-33px;font-size:40px}.event-info{padding:0 40px 40px}.models-events-list .event-item .event-descr{padding-top:35px;padding-bottom:0}.models-events-list .event-item .owner-descr{padding-top:30px;margin-top:25px}.models-events-list .event-item .title{font-size:14px;line-height:20px}.models-events-list .event-item .owner-descr .photo{display:block}.models-events-list .event-item .owner-descr .content{margin-top:20px}.models-events-list .event-item.liveshow .counter{margin-top:25px}.models-events-list .event-item.liveshow .part span.digit{font-size:27px;line-height:27px}.model-footer:after,.model-footer:before{width:40%}.model-footer:before{left:0}.model-footer:after{right:0}.model-footer .cr{display:inline;margin-right:25px}.closest-liveshows .item{display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;left:0;padding-top:26px}.closest-liveshows .models-liveshows,.closest-liveshows .pager{height:107px}.closest-liveshows .model{margin-left:25px;text-align:left}.closest-liveshows .model .info .next{margin-bottom:5px}.closest-liveshows .item .date-wrapper .counter{display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.closest-liveshows .join .btn-wrapper .watch{display:block}}@media (min-width:960px){.models-header .title{font-size:17px;display:block}.models-header{height:112px;padding:35px 0}.models-header .menu-icon{margin-left:45px}.features-glider-wrapper{margin-left:auto;margin-right:auto}.models-events-list .event-item-gutter{width:0}.models-events-list .event-grid-sizer{width:32.5%}.models-events-list .event-item{width:31.333%}}@media (min-width:1024px){.side-pad{padding-left:15px;padding-right:15px}.features-glider-wrapper .arr{font-size:50px;background-color:transparent;padding:0;width:auto}.features-glider-wrapper .bullets{margin-top:30px}.features-glider-wrapper .features-glider:after,.features-glider-wrapper .features-glider:before{display:block}.events-feed{min-height:none}}@media (min-width:1115px){.model-footer:before{left:13%}.model-footer:after{right:13%}.closest-liveshows .item{display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;left:0;padding-top:22px}.closest-liveshows .model .cam{display:block}.closest-liveshows .join .img{width:70px;height:70px}.closest-liveshows .date-wrapper .starts{font-size:16px;line-height:22px;margin-bottom:0}.closest-liveshows .model{margin-bottom:0;margin-left:45px}.closest-liveshows .model .info{margin-left:75px;padding-top:10px}.closest-liveshows .model .info .next{font-size:30px;line-height:32px;margin-bottom:0}.closest-liveshows .model .info .name{font-size:16px;line-height:22px}.closest-liveshows .join .btn-wrapper{margin-right:90px}.closest-liveshows .date-wrapper .counter .part{width:60px;height:60px;padding:10px}.closest-liveshows .date-wrapper .counter .separator{font-size:36px;margin:0 2px}.closest-liveshows .pager{justify-content:center;top:0}.closest-liveshows .join .btn-wrapper .join-btn{font-size:16px;line-height:22px}.closest-liveshows .join .btn-wrapper .join-btn:after{top:20px}}@media (min-width:1200px){.page-width{margin:0 auto}.features-glider-wrapper .arr.lt{left:-6%}.features-glider-wrapper .arr.rt{right:-6%}}", ""]);

// exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dependencies.js": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';
	
	__webpack_require__(53);
	__webpack_require__(55);
	__webpack_require__(57);
	__webpack_require__(59);

	__webpack_require__(4);
	__webpack_require__(3);
	__webpack_require__(8);

	__webpack_require__(65)(fox);

	__webpack_require__(66)(fox);
	//require('fox-dynamic-injection!fox-template-loader!../../../model/common/templates/promo/privacyPolicy.tpl')(fox);

	//require('../../../../../common-components/CCPA/templates/mc/doc.a.tpl')(fox);
	__webpack_require__(67)(fox);

	__webpack_require__(68)(fox);
	
	__webpack_require__(72)(fox);

	__webpack_require__(77)(fox);
	__webpack_require__(78)(fox);

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(5)(__webpack_require__(54))

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "/*!\n * imagesLoaded PACKAGED v4.1.4\n * JavaScript is all like \"You images are done yet or what?\"\n * MIT License\n */\n\n/**\n * EvEmitter v1.1.0\n * Lil' event emitter\n * MIT License\n */\n\n/* jshint unused: true, undef: true, strict: true */\n\n( function( global, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, window */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'ev-emitter/ev-emitter',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory();\n  } else {\n    // Browser globals\n    global.EvEmitter = factory();\n  }\n\n}( typeof window != 'undefined' ? window : this, function() {\n\n\n\nfunction EvEmitter() {}\n\nvar proto = EvEmitter.prototype;\n\nproto.on = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // set events hash\n  var events = this._events = this._events || {};\n  // set listeners array\n  var listeners = events[ eventName ] = events[ eventName ] || [];\n  // only add once\n  if ( listeners.indexOf( listener ) == -1 ) {\n    listeners.push( listener );\n  }\n\n  return this;\n};\n\nproto.once = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // add event\n  this.on( eventName, listener );\n  // set once flag\n  // set onceEvents hash\n  var onceEvents = this._onceEvents = this._onceEvents || {};\n  // set onceListeners object\n  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};\n  // set flag\n  onceListeners[ listener ] = true;\n\n  return this;\n};\n\nproto.off = function( eventName, listener ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  var index = listeners.indexOf( listener );\n  if ( index != -1 ) {\n    listeners.splice( index, 1 );\n  }\n\n  return this;\n};\n\nproto.emitEvent = function( eventName, args ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  // copy over to avoid interference if .off() in listener\n  listeners = listeners.slice(0);\n  args = args || [];\n  // once stuff\n  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];\n\n  for ( var i=0; i < listeners.length; i++ ) {\n    var listener = listeners[i]\n    var isOnce = onceListeners && onceListeners[ listener ];\n    if ( isOnce ) {\n      // remove listener\n      // remove before trigger to prevent recursion\n      this.off( eventName, listener );\n      // unset once flag\n      delete onceListeners[ listener ];\n    }\n    // trigger listener\n    listener.apply( this, args );\n  }\n\n  return this;\n};\n\nproto.allOff = function() {\n  delete this._events;\n  delete this._onceEvents;\n};\n\nreturn EvEmitter;\n\n}));\n\n/*!\n * imagesLoaded v4.1.4\n * JavaScript is all like \"You images are done yet or what?\"\n * MIT License\n */\n\n( function( window, factory ) { 'use strict';\n  // universal module definition\n\n  /*global define: false, module: false, require: false */\n\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( [\n      'ev-emitter/ev-emitter'\n    ], function( EvEmitter ) {\n      return factory( window, EvEmitter );\n    });\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      window,\n      require('ev-emitter')\n    );\n  } else {\n    // browser global\n    window.imagesLoaded = factory(\n      window,\n      window.EvEmitter\n    );\n  }\n\n})( typeof window !== 'undefined' ? window : this,\n\n// --------------------------  factory -------------------------- //\n\nfunction factory( window, EvEmitter ) {\n\n\n\nvar $ = window.jQuery;\nvar console = window.console;\n\n// -------------------------- helpers -------------------------- //\n\n// extend objects\nfunction extend( a, b ) {\n  for ( var prop in b ) {\n    a[ prop ] = b[ prop ];\n  }\n  return a;\n}\n\nvar arraySlice = Array.prototype.slice;\n\n// turn element or nodeList into an array\nfunction makeArray( obj ) {\n  if ( Array.isArray( obj ) ) {\n    // use object if already an array\n    return obj;\n  }\n\n  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';\n  if ( isArrayLike ) {\n    // convert nodeList to array\n    return arraySlice.call( obj );\n  }\n\n  // array of single index\n  return [ obj ];\n}\n\n// -------------------------- imagesLoaded -------------------------- //\n\n/**\n * @param {Array, Element, NodeList, String} elem\n * @param {Object or Function} options - if function, use as callback\n * @param {Function} onAlways - callback function\n */\nfunction ImagesLoaded( elem, options, onAlways ) {\n  // coerce ImagesLoaded() without new, to be new ImagesLoaded()\n  if ( !( this instanceof ImagesLoaded ) ) {\n    return new ImagesLoaded( elem, options, onAlways );\n  }\n  // use elem as selector string\n  var queryElem = elem;\n  if ( typeof elem == 'string' ) {\n    queryElem = document.querySelectorAll( elem );\n  }\n  // bail if bad element\n  if ( !queryElem ) {\n    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );\n    return;\n  }\n\n  this.elements = makeArray( queryElem );\n  this.options = extend( {}, this.options );\n  // shift arguments if no options set\n  if ( typeof options == 'function' ) {\n    onAlways = options;\n  } else {\n    extend( this.options, options );\n  }\n\n  if ( onAlways ) {\n    this.on( 'always', onAlways );\n  }\n\n  this.getImages();\n\n  if ( $ ) {\n    // add jQuery Deferred object\n    this.jqDeferred = new $.Deferred();\n  }\n\n  // HACK check async to allow time to bind listeners\n  setTimeout( this.check.bind( this ) );\n}\n\nImagesLoaded.prototype = Object.create( EvEmitter.prototype );\n\nImagesLoaded.prototype.options = {};\n\nImagesLoaded.prototype.getImages = function() {\n  this.images = [];\n\n  // filter & find items if we have an item selector\n  this.elements.forEach( this.addElementImages, this );\n};\n\n/**\n * @param {Node} element\n */\nImagesLoaded.prototype.addElementImages = function( elem ) {\n  // filter siblings\n  if ( elem.nodeName == 'IMG' ) {\n    this.addImage( elem );\n  }\n  // get background image on element\n  if ( this.options.background === true ) {\n    this.addElementBackgroundImages( elem );\n  }\n\n  // find children\n  // no non-element nodes, #143\n  var nodeType = elem.nodeType;\n  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {\n    return;\n  }\n  var childImgs = elem.querySelectorAll('img');\n  // concat childElems to filterFound array\n  for ( var i=0; i < childImgs.length; i++ ) {\n    var img = childImgs[i];\n    this.addImage( img );\n  }\n\n  // get child background images\n  if ( typeof this.options.background == 'string' ) {\n    var children = elem.querySelectorAll( this.options.background );\n    for ( i=0; i < children.length; i++ ) {\n      var child = children[i];\n      this.addElementBackgroundImages( child );\n    }\n  }\n};\n\nvar elementNodeTypes = {\n  1: true,\n  9: true,\n  11: true\n};\n\nImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {\n  var style = getComputedStyle( elem );\n  if ( !style ) {\n    // Firefox returns null if in a hidden iframe https://bugzil.la/548397\n    return;\n  }\n  // get url inside url(\"...\")\n  var reURL = /url\\((['\"])?(.*?)\\1\\)/gi;\n  var matches = reURL.exec( style.backgroundImage );\n  while ( matches !== null ) {\n    var url = matches && matches[2];\n    if ( url ) {\n      this.addBackground( url, elem );\n    }\n    matches = reURL.exec( style.backgroundImage );\n  }\n};\n\n/**\n * @param {Image} img\n */\nImagesLoaded.prototype.addImage = function( img ) {\n  var loadingImage = new LoadingImage( img );\n  this.images.push( loadingImage );\n};\n\nImagesLoaded.prototype.addBackground = function( url, elem ) {\n  var background = new Background( url, elem );\n  this.images.push( background );\n};\n\nImagesLoaded.prototype.check = function() {\n  var _this = this;\n  this.progressedCount = 0;\n  this.hasAnyBroken = false;\n  // complete if no images\n  if ( !this.images.length ) {\n    this.complete();\n    return;\n  }\n\n  function onProgress( image, elem, message ) {\n    // HACK - Chrome triggers event before object properties have changed. #83\n    setTimeout( function() {\n      _this.progress( image, elem, message );\n    });\n  }\n\n  this.images.forEach( function( loadingImage ) {\n    loadingImage.once( 'progress', onProgress );\n    loadingImage.check();\n  });\n};\n\nImagesLoaded.prototype.progress = function( image, elem, message ) {\n  this.progressedCount++;\n  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;\n  // progress event\n  this.emitEvent( 'progress', [ this, image, elem ] );\n  if ( this.jqDeferred && this.jqDeferred.notify ) {\n    this.jqDeferred.notify( this, image );\n  }\n  // check if completed\n  if ( this.progressedCount == this.images.length ) {\n    this.complete();\n  }\n\n  if ( this.options.debug && console ) {\n    console.log( 'progress: ' + message, image, elem );\n  }\n};\n\nImagesLoaded.prototype.complete = function() {\n  var eventName = this.hasAnyBroken ? 'fail' : 'done';\n  this.isComplete = true;\n  this.emitEvent( eventName, [ this ] );\n  this.emitEvent( 'always', [ this ] );\n  if ( this.jqDeferred ) {\n    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';\n    this.jqDeferred[ jqMethod ]( this );\n  }\n};\n\n// --------------------------  -------------------------- //\n\nfunction LoadingImage( img ) {\n  this.img = img;\n}\n\nLoadingImage.prototype = Object.create( EvEmitter.prototype );\n\nLoadingImage.prototype.check = function() {\n  // If complete is true and browser supports natural sizes,\n  // try to check for image status manually.\n  var isComplete = this.getIsImageComplete();\n  if ( isComplete ) {\n    // report based on naturalWidth\n    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );\n    return;\n  }\n\n  // If none of the checks above matched, simulate loading on detached element.\n  this.proxyImage = new Image();\n  this.proxyImage.addEventListener( 'load', this );\n  this.proxyImage.addEventListener( 'error', this );\n  // bind to image as well for Firefox. #191\n  this.img.addEventListener( 'load', this );\n  this.img.addEventListener( 'error', this );\n  this.proxyImage.src = this.img.src;\n};\n\nLoadingImage.prototype.getIsImageComplete = function() {\n  // check for non-zero, non-undefined naturalWidth\n  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671\n  return this.img.complete && this.img.naturalWidth;\n};\n\nLoadingImage.prototype.confirm = function( isLoaded, message ) {\n  this.isLoaded = isLoaded;\n  this.emitEvent( 'progress', [ this, this.img, message ] );\n};\n\n// ----- events ----- //\n\n// trigger specified handler for event type\nLoadingImage.prototype.handleEvent = function( event ) {\n  var method = 'on' + event.type;\n  if ( this[ method ] ) {\n    this[ method ]( event );\n  }\n};\n\nLoadingImage.prototype.onload = function() {\n  this.confirm( true, 'onload' );\n  this.unbindEvents();\n};\n\nLoadingImage.prototype.onerror = function() {\n  this.confirm( false, 'onerror' );\n  this.unbindEvents();\n};\n\nLoadingImage.prototype.unbindEvents = function() {\n  this.proxyImage.removeEventListener( 'load', this );\n  this.proxyImage.removeEventListener( 'error', this );\n  this.img.removeEventListener( 'load', this );\n  this.img.removeEventListener( 'error', this );\n};\n\n// -------------------------- Background -------------------------- //\n\nfunction Background( url, element ) {\n  this.url = url;\n  this.element = element;\n  this.img = new Image();\n}\n\n// inherit LoadingImage prototype\nBackground.prototype = Object.create( LoadingImage.prototype );\n\nBackground.prototype.check = function() {\n  this.img.addEventListener( 'load', this );\n  this.img.addEventListener( 'error', this );\n  this.img.src = this.url;\n  // check if image is already complete\n  var isComplete = this.getIsImageComplete();\n  if ( isComplete ) {\n    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );\n    this.unbindEvents();\n  }\n};\n\nBackground.prototype.unbindEvents = function() {\n  this.img.removeEventListener( 'load', this );\n  this.img.removeEventListener( 'error', this );\n};\n\nBackground.prototype.confirm = function( isLoaded, message ) {\n  this.isLoaded = isLoaded;\n  this.emitEvent( 'progress', [ this, this.element, message ] );\n};\n\n// -------------------------- jQuery -------------------------- //\n\nImagesLoaded.makeJQueryPlugin = function( jQuery ) {\n  jQuery = jQuery || window.jQuery;\n  if ( !jQuery ) {\n    return;\n  }\n  // set local variable\n  $ = jQuery;\n  // $().imagesLoaded()\n  $.fn.imagesLoaded = function( options, callback ) {\n    var instance = new ImagesLoaded( this, options, callback );\n    return instance.jqDeferred.promise( $(this) );\n  };\n};\n// try making plugin\nImagesLoaded.makeJQueryPlugin();\n\n// --------------------------  -------------------------- //\n\nreturn ImagesLoaded;\n\n});\n\n"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(5)(__webpack_require__(56))

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "/*!\n * Swipe 2.2.18\n *\n * Brad Birdsall\n * Copyright 2013, MIT License\n *\n*/\n\n// if the module has no dependencies, the above pattern can be simplified to\n// eslint-disable-next-line no-extra-semi\n;(function (root, factory) {\n  root = root || {};\n  // eslint-disable-next-line no-undef\n  if (typeof define === 'function' && define.amd) {\n    // AMD. Register as an anonymous module.\n    // eslint-disable-next-line no-undef\n    define([], function(){\n      root.Swipe = factory();\n      return root.Swipe;\n    });\n  } else if (typeof module === 'object' && module.exports) {\n    // Node. Does not work with strict CommonJS, but\n    // only CommonJS-like environments that support module.exports,\n    // like Node.\n    module.exports = factory();\n  } else {\n    // Browser globals\n    root.Swipe = factory();\n  }\n}(this, function () {\n  // Establish the root object, `window` (`self`) in the browser, `global`\n  // on the server, or `this` in some virtual machines. We use `self`\n  // instead of `window` for `WebWorker` support.\n  var root = typeof self == 'object' && self.self === self && self ||\n             typeof global == 'object' && global.global === global && global ||\n             this;\n\n  var _document = root.document;\n\n  function Swipe(container, options) {\n\n    'use strict';\n\n    options = options || {};\n\n    // setup initial vars\n    var start = {};\n    var delta = {};\n    var isScrolling;\n\n    // setup auto slideshow\n    var delay = options.auto || 0;\n    var interval;\n\n    var disabled = false;\n\n    // utilities\n    // simple no operation function\n    var noop = function() {};\n    // offload a functions execution\n    var offloadFn = function(fn) { setTimeout(fn || noop, 0); };\n    // Returns a function, that, as long as it continues to be invoked, will not\n    // be triggered.\n    var throttle = function (fn, threshhold) {\n      threshhold = threshhold || 100;\n      var timeout = null;\n\n      function cancel() {\n        if (timeout) clearTimeout(timeout);\n      }\n\n      function throttledFn() {\n        var context = this;\n        var args = arguments;\n        cancel();\n        timeout = setTimeout(function() {\n          timeout = null;\n          fn.apply(context, args);\n        }, threshhold);\n      }\n\n      // allow remove throttled timeout\n      throttledFn.cancel = cancel;\n\n      return throttledFn;\n    };\n\n    // check whether event is cancelable\n    var isCancelable = function (event) {\n      if (!event) return false;\n      return typeof event.cancelable !== 'boolean' || event.cancelable;\n    };\n\n    // polyfill for browsers that do not support Element.matches()\n    if (!Element.prototype.matches) {\n      Element.prototype.matches =\n        Element.prototype.matchesSelector ||\n        Element.prototype.mozMatchesSelector ||\n        Element.prototype.msMatchesSelector ||\n        Element.prototype.oMatchesSelector ||\n        Element.prototype.webkitMatchesSelector ||\n        function (s) {\n          var matches = (this.document || this.ownerDocument).querySelectorAll(s),\n            i = matches.length;\n          while (--i >= 0 && matches.item(i) !== this)\n            ;\n          return i > -1;\n        };\n    }\n\n    // check browser capabilities\n    var browser = {\n      addEventListener: !!root.addEventListener,\n      passiveEvents: (function () {\n        // Test via a getter in the options object to see if the passive property is accessed\n        var supportsPassive = false;\n        try {\n          var opts = Object.defineProperty({}, 'passive', {\n            // eslint-disable-next-line getter-return\n            get: function () {\n              supportsPassive = true;\n            }\n          });\n          root.addEventListener('testEvent', null, opts);\n          root.removeEventListener('testEvent', null, opts);\n        }\n        catch (e) {\n          supportsPassive = false;\n        }\n        return supportsPassive;\n      })(),\n      // eslint-disable-next-line no-undef\n      touch: ('ontouchstart' in root) || root.DocumentTouch && _document instanceof DocumentTouch,\n      transitions: (function(temp) {\n        var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];\n        for ( var i in props ) {\n          if (temp.style[ props[i] ] !== undefined){\n            return true;\n          }\n        }\n        return false;\n      })(_document.createElement('swipe'))\n    };\n\n    // quit if no root element\n    if (!container) return;\n\n    var element = container.children[0];\n    var slides, slidePos, width, length;\n    var index = parseInt(options.startSlide, 10) || 0;\n    var speed = options.speed || 300;\n    options.continuous = options.continuous !== undefined ? options.continuous : true;\n\n    // check text direction\n    var slideDir = (function(el, prop, dir) {\n      if (el.currentStyle) {\n        dir = el.currentStyle[prop];\n      } else if (root.getComputedStyle) {\n        dir = root.getComputedStyle(el, null).getPropertyValue(prop);\n      }\n      return 'rtl' === dir ? 'right' : 'left';\n    })(container, 'direction');\n\n    // AutoRestart option: auto restart slideshow after user's touch event\n    options.autoRestart = options.autoRestart !== undefined ? options.autoRestart : false;\n\n    // throttled setup\n    var throttledSetup = throttle(setup);\n\n    // setup event capturing\n    var events = {\n\n      handleEvent: function(event) {\n        if (disabled) return;\n\n        switch (event.type) {\n          case 'mousedown':\n          case 'touchstart': this.start(event); break;\n          case 'mousemove':\n          case 'touchmove': this.move(event); break;\n          case 'mouseup':\n          case 'mouseleave':\n          case 'touchend': this.end(event); break;\n          case 'webkitTransitionEnd':\n          case 'msTransitionEnd':\n          case 'oTransitionEnd':\n          case 'otransitionend':\n          case 'transitionend': this.transitionEnd(event); break;\n          case 'resize': throttledSetup(); break;\n        }\n\n        if (options.stopPropagation) {\n          event.stopPropagation();\n        }\n      },\n\n      start: function(event) {\n        var touches;\n\n        if (isMouseEvent(event)) {\n          touches = event;\n          event.preventDefault(); // For desktop Safari drag\n        } else {\n          touches = event.touches[0];\n        }\n\n        // check if the user is swiping on an element that the options say to ignore (for example, a scrolling area)\n        if (options.ignore && touches.target.matches(options.ignore)) {\n          return;\n        }\n\n        // measure start values\n        start = {\n\n          // get initial touch coords\n          x: touches.pageX,\n          y: touches.pageY,\n\n          // store time to determine touch duration\n          time: +new Date()\n\n        };\n\n        // used for testing first move event\n        isScrolling = undefined;\n\n        // reset delta and end measurements\n        delta = {};\n\n        // attach touchmove and touchend listeners\n        if (isMouseEvent(event)) {\n          element.addEventListener('mousemove', this, false);\n          element.addEventListener('mouseup', this, false);\n          element.addEventListener('mouseleave', this, false);\n        } else {\n          element.addEventListener('touchmove', this, browser.passiveEvents ? { passive: false } : false);\n          element.addEventListener('touchend', this, false);\n        }\n        runDragStart(getPos(), slides[index]);\n      },\n\n      move: function(event) {\n        var touches;\n\n        if (isMouseEvent(event)) {\n          touches = event;\n        } else {\n          // ensure swiping with one touch and not pinching\n          if ( event.touches.length > 1 || event.scale && event.scale !== 1) {\n            return;\n          }\n\n          // we can disable scrolling unless it is already in progress\n          if (options.disableScroll && isCancelable(event)) {\n            event.preventDefault();\n          }\n\n          touches = event.touches[0];\n        }\n\n        // measure change in x and y\n        delta = {\n          x: touches.pageX - start.x,\n          y: touches.pageY - start.y\n        };\n\n        // determine if scrolling test has run - one time test\n        if ( typeof isScrolling === 'undefined') {\n          isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );\n        }\n\n        // if user is not trying to scroll vertically\n        if (!isScrolling) {\n\n          // if it is not already scrolling\n          if (isCancelable(event)) {\n            // prevent native scrolling\n            event.preventDefault();\n          }\n\n          // stop slideshow\n          stop();\n\n          // increase resistance if first or last slide\n          if (options.continuous) { // we don't add resistance at the end\n\n            translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);\n            translate(index, delta.x + slidePos[index], 0);\n            translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);\n\n          } else {\n\n            delta.x =\n              delta.x /\n              ( (!index && delta.x > 0 ||             // if first slide and sliding left\n                 index === slides.length - 1 &&        // or if last slide and sliding right\n                 delta.x < 0                           // and if sliding at all\n              ) ?\n                ( Math.abs(delta.x) / width + 1 )      // determine resistance level\n                : 1 );                                 // no resistance if false\n\n            // translate 1:1\n            translate(index-1, delta.x + slidePos[index-1], 0);\n            translate(index, delta.x + slidePos[index], 0);\n            translate(index+1, delta.x + slidePos[index+1], 0);\n          }\n        }\n      },\n\n      end: function(event) {\n\n        // measure duration\n        var duration = +new Date() - start.time;\n\n        // determine if slide attempt triggers next/prev slide\n        var isValidSlide =\n            Number(duration) < 250 &&         // if slide duration is less than 250ms\n            Math.abs(delta.x) > 20 ||         // and if slide amt is greater than 20px\n            Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width\n\n        // determine if slide attempt is past start and end\n        var isPastBounds =\n            !index && delta.x > 0 ||                      // if first slide and slide amt is greater than 0\n            index === slides.length - 1 && delta.x < 0;   // or if last slide and slide amt is less than 0\n\n        if (options.continuous) {\n          isPastBounds = false;\n        }\n\n        // OLD determine direction of swipe (true:right, false:left)\n        // determine direction of swipe (1: backward, -1: forward)\n        var direction = Math.abs(delta.x) / delta.x;\n\n        // if not scrolling vertically\n        if (!isScrolling) {\n\n          if (isValidSlide && !isPastBounds) {\n\n            // if we're moving right\n            if (direction < 0) {\n\n              if (options.continuous) { // we need to get the next in this direction in place\n\n                move(circle(index-1), -width, 0);\n                move(circle(index+2), width, 0);\n\n              } else {\n                move(index-1, -width, 0);\n              }\n\n              move(index, slidePos[index]-width, speed);\n              move(circle(index+1), slidePos[circle(index+1)]-width, speed);\n              index = circle(index+1);\n\n            } else {\n              if (options.continuous) { // we need to get the next in this direction in place\n\n                move(circle(index+1), width, 0);\n                move(circle(index-2), -width, 0);\n\n              } else {\n                move(index+1, width, 0);\n              }\n\n              move(index, slidePos[index]+width, speed);\n              move(circle(index-1), slidePos[circle(index-1)]+width, speed);\n              index = circle(index-1);\n            }\n\n            runCallback(getPos(), slides[index], direction);\n\n          } else {\n\n            if (options.continuous) {\n\n              move(circle(index-1), -width, speed);\n              move(index, 0, speed);\n              move(circle(index+1), width, speed);\n\n            } else {\n\n              move(index-1, -width, speed);\n              move(index, 0, speed);\n              move(index+1, width, speed);\n            }\n          }\n        }\n\n        // kill touchmove and touchend event listeners until touchstart called again\n        if (isMouseEvent(event)) {\n          element.removeEventListener('mousemove', events, false);\n          element.removeEventListener('mouseup', events, false);\n          element.removeEventListener('mouseleave', events, false);\n        } else {\n          element.removeEventListener('touchmove', events, browser.passiveEvents ? { passive: false } : false);\n          element.removeEventListener('touchend', events, false);\n        }\n        runDragEnd(getPos(), slides[index]);\n      },\n\n      transitionEnd: function(event) {\n        var currentIndex = parseInt(event.target.getAttribute('data-index'), 10);\n        if (currentIndex === index) {\n          if (delay || options.autoRestart) restart();\n\n          runTransitionEnd(getPos(), slides[index]);\n        }\n      }\n    };\n\n    // trigger setup\n    setup();\n\n    // start auto slideshow if applicable\n    begin();\n\n    // Expose the Swipe API\n    return {\n      // initialize\n      setup: setup,\n\n      // go to slide\n      slide: function(to, speed) {\n        stop();\n        slide(to, speed);\n      },\n\n      // move to previous\n      prev: function() {\n        stop();\n        prev();\n      },\n\n      // move to next\n      next: function() {\n        stop();\n        next();\n      },\n\n      // Restart slideshow\n      restart: restart,\n\n      // cancel slideshow\n      stop: stop,\n\n      // return current index position\n      getPos: getPos,\n\n      // disable slideshow\n      disable: disable,\n\n      // enable slideshow\n      enable: enable,\n\n      // return total number of slides\n      getNumSlides: function() { return length; },\n\n      // completely remove swipe\n      kill: kill\n    };\n\n    // remove all event listeners\n    function detachEvents() {\n      if (browser.addEventListener) {\n        // remove current event listeners\n        element.removeEventListener('touchstart', events, browser.passiveEvents ? { passive: true } : false);\n        element.removeEventListener('mousedown', events, false);\n        element.removeEventListener('webkitTransitionEnd', events, false);\n        element.removeEventListener('msTransitionEnd', events, false);\n        element.removeEventListener('oTransitionEnd', events, false);\n        element.removeEventListener('otransitionend', events, false);\n        element.removeEventListener('transitionend', events, false);\n        root.removeEventListener('resize', events, false);\n      } else {\n        root.onresize = null;\n      }\n    }\n\n    // add event listeners\n    function attachEvents() {\n      if (browser.addEventListener) {\n\n        // set touchstart event on element\n        if (browser.touch) {\n          element.addEventListener('touchstart', events, browser.passiveEvents ? { passive: true } : false);\n        }\n\n        if (options.draggable) {\n          element.addEventListener('mousedown', events, false);\n        }\n\n        if (browser.transitions) {\n          element.addEventListener('webkitTransitionEnd', events, false);\n          element.addEventListener('msTransitionEnd', events, false);\n          element.addEventListener('oTransitionEnd', events, false);\n          element.addEventListener('otransitionend', events, false);\n          element.addEventListener('transitionend', events, false);\n        }\n\n        // set resize event on window\n        root.addEventListener('resize', events, false);\n\n      } else {\n        root.onresize = throttledSetup; // to play nice with old IE\n      }\n    }\n\n    // clone nodes when there is only two slides\n    function cloneNode(el) {\n      var clone = el.cloneNode(true);\n      element.appendChild(clone);\n\n      // tag these slides as clones (to remove them on kill)\n      clone.setAttribute('data-cloned', true);\n\n      // Remove id from element\n      clone.removeAttribute('id');\n    }\n\n    function setup(opts) {\n      // Overwrite options if necessary\n      if (opts != null) {\n        for (var prop in opts) {\n          options[prop] = opts[prop];\n        }\n      }\n\n      // cache slides\n      slides = element.children;\n      length = slides.length;\n\n      // slides length correction, minus cloned slides\n      for (var i = 0; i < slides.length; i++) {\n        if (slides[i].getAttribute('data-cloned')) length--;\n      }\n\n      // set continuous to false if only one slide\n      if (slides.length < 2) {\n        options.continuous = false;\n      }\n\n      // special case if two slides\n      if (browser.transitions && options.continuous && slides.length < 3) {\n        cloneNode(slides[0]);\n        cloneNode(slides[1]);\n\n        slides = element.children;\n      }\n\n      // adjust style on rtl\n      if ('right' === slideDir) {\n        for (var j = 0; j < slides.length; j++) {\n          slides[j].style.float = 'right';\n        }\n      }\n\n      // create an array to store current positions of each slide\n      slidePos = new Array(slides.length);\n\n      // determine width of each slide\n      width = container.getBoundingClientRect().width || container.offsetWidth;\n\n      element.style.width = (slides.length * width * 2) + 'px';\n\n      // stack elements\n      var pos = slides.length;\n      while(pos--) {\n        var slide = slides[pos];\n\n        slide.style.width = width + 'px';\n        slide.setAttribute('data-index', pos);\n\n        if (browser.transitions) {\n          slide.style[slideDir] = (pos * -width) + 'px';\n          move(pos, index > pos ? -width : (index < pos ? width : 0), 0);\n        }\n      }\n\n      // reposition elements before and after index\n      if (options.continuous && browser.transitions) {\n        move(circle(index-1), -width, 0);\n        move(circle(index+1), width, 0);\n      }\n\n      if (!browser.transitions) {\n        element.style[slideDir] = (index * -width) + 'px';\n      }\n\n      container.style.visibility = 'visible';\n\n      // reinitialize events\n      detachEvents();\n      attachEvents();\n    }\n\n    function prev() {\n      if (disabled) return;\n\n      if (options.continuous) {\n        slide(index-1);\n      } else if (index) {\n        slide(index-1);\n      }\n    }\n\n    function next() {\n      if (disabled) return;\n\n      if (options.continuous) {\n        slide(index+1);\n      } else if (index < slides.length - 1) {\n        slide(index+1);\n      }\n    }\n\n    function runCallback(pos, index, dir) {\n      if (options.callback) {\n        options.callback(pos, index, dir);\n      }\n    }\n\n    function runTransitionEnd(pos, index) {\n      if (options.transitionEnd) {\n        options.transitionEnd(pos, index);\n      }\n    }\n\n    function runDragStart(pos, index) {\n      if (options.dragStart) {\n        options.dragStart(pos, index);\n      }\n    }\n\n    function runDragEnd(pos, index) {\n      if (options.dragEnd) {\n        options.dragEnd(pos, index);\n      }\n    }\n\n    function circle(index) {\n\n      // a simple positive modulo using slides.length\n      return (slides.length + (index % slides.length)) % slides.length;\n    }\n\n    function getPos() {\n      // Fix for the clone issue in the event of 2 slides\n      var currentIndex = index;\n\n      if (currentIndex >= length) {\n        currentIndex = currentIndex - length;\n      }\n\n      return currentIndex;\n    }\n\n    function slide(to, slideSpeed) {\n\n      // ensure to is of type 'number'\n      to = typeof to !== 'number' ? parseInt(to, 10) : to;\n\n      // do nothing if already on requested slide\n      if (index === to) return;\n\n      if (browser.transitions) {\n\n        var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward\n\n        // get the actual position of the slide\n        if (options.continuous) {\n          var natural_direction = direction;\n          direction = -slidePos[circle(to)] / width;\n\n          // if going forward but to < index, use to = slides.length + to\n          // if going backward but to > index, use to = -slides.length + to\n          if (direction !== natural_direction) {\n            to = -direction * slides.length + to;\n          }\n\n        }\n\n        var diff = Math.abs(index-to) - 1;\n\n        // move all the slides between index and to in the right direction\n        while (diff--) {\n          move( circle((to > index ? to : index) - diff - 1), width * direction, 0);\n        }\n\n        to = circle(to);\n\n        move(index, width * direction, slideSpeed || speed);\n        move(to, 0, slideSpeed || speed);\n\n        if (options.continuous) { // we need to get the next in place\n          move(circle(to - direction), -(width * direction), 0);\n        }\n\n      } else {\n\n        to = circle(to);\n        animate(index * -width, to * -width, slideSpeed || speed);\n        // no fallback for a circular continuous if the browser does not accept transitions\n      }\n\n      index = to;\n      offloadFn(function() {\n        runCallback(getPos(), slides[index], direction);\n      });\n    }\n\n    function move(index, dist, speed) {\n      translate(index, dist, speed);\n      slidePos[index] = dist;\n    }\n\n    function translate(index, dist, speed) {\n\n      var slide = slides[index];\n      var style = slide && slide.style;\n\n      if (!style) return;\n\n      style.webkitTransitionDuration =\n        style.MozTransitionDuration =\n        style.msTransitionDuration =\n        style.OTransitionDuration =\n        style.transitionDuration = speed + 'ms';\n\n      style.webkitTransform =\n        style.msTransform =\n        style.MozTransform =\n        style.OTransform =\n        style.transform = 'translateX(' + dist + 'px)';\n    }\n\n    function animate(from, to, speed) {\n\n      // if not an animation, just reposition\n      if (!speed) {\n        element.style[slideDir] = to + 'px';\n        return;\n      }\n\n      var start = +new Date();\n\n      var timer = setInterval(function() {\n        var timeElap = +new Date() - start;\n\n        if (timeElap > speed) {\n\n          element.style[slideDir] = to + 'px';\n\n          if (delay || options.autoRestart) restart();\n\n          runTransitionEnd(getPos(), slides[index]);\n\n          clearInterval(timer);\n\n          return;\n        }\n\n        element.style[slideDir] = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';\n      }, 4);\n\n    }\n\n    function begin() {\n      delay = options.auto || 0;\n      if (delay) interval = setTimeout(next, delay);\n    }\n\n    function stop() {\n      delay = 0;\n      clearTimeout(interval);\n    }\n\n    function restart() {\n      stop();\n      begin();\n    }\n\n    function disable() {\n      stop();\n      disabled = true;\n    }\n\n    function enable() {\n      disabled = false;\n      restart();\n    }\n\n    function isMouseEvent(e) {\n      return /^mouse/.test(e.type);\n    }\n\n    function kill() {\n      // cancel slideshow\n      stop();\n\n      // remove inline styles\n      container.style.visibility = '';\n\n      // reset element\n      element.style.width = '';\n      element.style[slideDir] = '';\n\n      // reset slides\n      var pos = slides.length;\n      while (pos--) {\n\n        if (browser.transitions) {\n          translate(pos, 0, 0);\n        }\n\n        var slide = slides[pos];\n\n        // if the slide is tagged as clone, remove it\n        if (slide.getAttribute('data-cloned')) {\n          var _parent = slide.parentElement;\n          _parent.removeChild(slide);\n        }\n\n        // remove styles\n        slide.style.width = '';\n        slide.style[slideDir] = '';\n\n        slide.style.webkitTransitionDuration =\n          slide.style.MozTransitionDuration =\n          slide.style.msTransitionDuration =\n          slide.style.OTransitionDuration =\n          slide.style.transitionDuration = '';\n\n        slide.style.webkitTransform =\n          slide.style.msTransform =\n          slide.style.MozTransform =\n          slide.style.OTransform = '';\n\n        // remove custom attributes (?)\n        // slide.removeAttribute('data-index');\n      }\n\n      // remove all events\n      detachEvents();\n\n      // remove throttled function timeout\n      throttledSetup.cancel();\n    }\n  }\n\n  if ( root.jQuery || root.Zepto ) {\n    (function($) {\n      $.fn.Swipe = function(params) {\n        return this.each(function() {\n          $(this).data('Swipe', new Swipe($(this)[0], params));\n        });\n      };\n    })( root.jQuery || root.Zepto );\n  }\n\n  return Swipe;\n}));\n"

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(5)(__webpack_require__(58))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "/*!\n * Masonry PACKAGED v4.2.2\n * Cascading grid layout library\n * https://masonry.desandro.com\n * MIT License\n * by David DeSandro\n */\n\n/**\n * Bridget makes jQuery widgets\n * v2.0.1\n * MIT license\n */\n\n/* jshint browser: true, strict: true, undef: true, unused: true */\n\n( function( window, factory ) {\n  // universal module definition\n  /*jshint strict: false */ /* globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {\n      return factory( window, jQuery );\n    });\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      window,\n      require('jquery')\n    );\n  } else {\n    // browser global\n    window.jQueryBridget = factory(\n      window,\n      window.jQuery\n    );\n  }\n\n}( window, function factory( window, jQuery ) {\n'use strict';\n\n// ----- utils ----- //\n\nvar arraySlice = Array.prototype.slice;\n\n// helper function for logging errors\n// $.error breaks jQuery chaining\nvar console = window.console;\nvar logError = typeof console == 'undefined' ? function() {} :\n  function( message ) {\n    console.error( message );\n  };\n\n// ----- jQueryBridget ----- //\n\nfunction jQueryBridget( namespace, PluginClass, $ ) {\n  $ = $ || jQuery || window.jQuery;\n  if ( !$ ) {\n    return;\n  }\n\n  // add option method -> $().plugin('option', {...})\n  if ( !PluginClass.prototype.option ) {\n    // option setter\n    PluginClass.prototype.option = function( opts ) {\n      // bail out if not an object\n      if ( !$.isPlainObject( opts ) ){\n        return;\n      }\n      this.options = $.extend( true, this.options, opts );\n    };\n  }\n\n  // make jQuery plugin\n  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {\n    if ( typeof arg0 == 'string' ) {\n      // method call $().plugin( 'methodName', { options } )\n      // shift arguments by 1\n      var args = arraySlice.call( arguments, 1 );\n      return methodCall( this, arg0, args );\n    }\n    // just $().plugin({ options })\n    plainCall( this, arg0 );\n    return this;\n  };\n\n  // $().plugin('methodName')\n  function methodCall( $elems, methodName, args ) {\n    var returnValue;\n    var pluginMethodStr = '$().' + namespace + '(\"' + methodName + '\")';\n\n    $elems.each( function( i, elem ) {\n      // get instance\n      var instance = $.data( elem, namespace );\n      if ( !instance ) {\n        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +\n          pluginMethodStr );\n        return;\n      }\n\n      var method = instance[ methodName ];\n      if ( !method || methodName.charAt(0) == '_' ) {\n        logError( pluginMethodStr + ' is not a valid method' );\n        return;\n      }\n\n      // apply method, get return value\n      var value = method.apply( instance, args );\n      // set return value if value is returned, use only first value\n      returnValue = returnValue === undefined ? value : returnValue;\n    });\n\n    return returnValue !== undefined ? returnValue : $elems;\n  }\n\n  function plainCall( $elems, options ) {\n    $elems.each( function( i, elem ) {\n      var instance = $.data( elem, namespace );\n      if ( instance ) {\n        // set options & init\n        instance.option( options );\n        instance._init();\n      } else {\n        // initialize new instance\n        instance = new PluginClass( elem, options );\n        $.data( elem, namespace, instance );\n      }\n    });\n  }\n\n  updateJQuery( $ );\n\n}\n\n// ----- updateJQuery ----- //\n\n// set $.bridget for v1 backwards compatibility\nfunction updateJQuery( $ ) {\n  if ( !$ || ( $ && $.bridget ) ) {\n    return;\n  }\n  $.bridget = jQueryBridget;\n}\n\nupdateJQuery( jQuery || window.jQuery );\n\n// -----  ----- //\n\nreturn jQueryBridget;\n\n}));\n\n/**\n * EvEmitter v1.1.0\n * Lil' event emitter\n * MIT License\n */\n\n/* jshint unused: true, undef: true, strict: true */\n\n( function( global, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, window */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'ev-emitter/ev-emitter',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory();\n  } else {\n    // Browser globals\n    global.EvEmitter = factory();\n  }\n\n}( typeof window != 'undefined' ? window : this, function() {\n\n\n\nfunction EvEmitter() {}\n\nvar proto = EvEmitter.prototype;\n\nproto.on = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // set events hash\n  var events = this._events = this._events || {};\n  // set listeners array\n  var listeners = events[ eventName ] = events[ eventName ] || [];\n  // only add once\n  if ( listeners.indexOf( listener ) == -1 ) {\n    listeners.push( listener );\n  }\n\n  return this;\n};\n\nproto.once = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // add event\n  this.on( eventName, listener );\n  // set once flag\n  // set onceEvents hash\n  var onceEvents = this._onceEvents = this._onceEvents || {};\n  // set onceListeners object\n  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};\n  // set flag\n  onceListeners[ listener ] = true;\n\n  return this;\n};\n\nproto.off = function( eventName, listener ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  var index = listeners.indexOf( listener );\n  if ( index != -1 ) {\n    listeners.splice( index, 1 );\n  }\n\n  return this;\n};\n\nproto.emitEvent = function( eventName, args ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  // copy over to avoid interference if .off() in listener\n  listeners = listeners.slice(0);\n  args = args || [];\n  // once stuff\n  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];\n\n  for ( var i=0; i < listeners.length; i++ ) {\n    var listener = listeners[i]\n    var isOnce = onceListeners && onceListeners[ listener ];\n    if ( isOnce ) {\n      // remove listener\n      // remove before trigger to prevent recursion\n      this.off( eventName, listener );\n      // unset once flag\n      delete onceListeners[ listener ];\n    }\n    // trigger listener\n    listener.apply( this, args );\n  }\n\n  return this;\n};\n\nproto.allOff = function() {\n  delete this._events;\n  delete this._onceEvents;\n};\n\nreturn EvEmitter;\n\n}));\n\n/*!\n * getSize v2.0.3\n * measure size of elements\n * MIT license\n */\n\n/* jshint browser: true, strict: true, undef: true, unused: true */\n/* globals console: false */\n\n( function( window, factory ) {\n  /* jshint strict: false */ /* globals define, module */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'get-size/get-size',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory();\n  } else {\n    // browser global\n    window.getSize = factory();\n  }\n\n})( window, function factory() {\n'use strict';\n\n// -------------------------- helpers -------------------------- //\n\n// get a number from a string, not a percentage\nfunction getStyleSize( value ) {\n  var num = parseFloat( value );\n  // not a percent like '100%', and a number\n  var isValid = value.indexOf('%') == -1 && !isNaN( num );\n  return isValid && num;\n}\n\nfunction noop() {}\n\nvar logError = typeof console == 'undefined' ? noop :\n  function( message ) {\n    console.error( message );\n  };\n\n// -------------------------- measurements -------------------------- //\n\nvar measurements = [\n  'paddingLeft',\n  'paddingRight',\n  'paddingTop',\n  'paddingBottom',\n  'marginLeft',\n  'marginRight',\n  'marginTop',\n  'marginBottom',\n  'borderLeftWidth',\n  'borderRightWidth',\n  'borderTopWidth',\n  'borderBottomWidth'\n];\n\nvar measurementsLength = measurements.length;\n\nfunction getZeroSize() {\n  var size = {\n    width: 0,\n    height: 0,\n    innerWidth: 0,\n    innerHeight: 0,\n    outerWidth: 0,\n    outerHeight: 0\n  };\n  for ( var i=0; i < measurementsLength; i++ ) {\n    var measurement = measurements[i];\n    size[ measurement ] = 0;\n  }\n  return size;\n}\n\n// -------------------------- getStyle -------------------------- //\n\n/**\n * getStyle, get style of element, check for Firefox bug\n * https://bugzilla.mozilla.org/show_bug.cgi?id=548397\n */\nfunction getStyle( elem ) {\n  var style = getComputedStyle( elem );\n  if ( !style ) {\n    logError( 'Style returned ' + style +\n      '. Are you running this code in a hidden iframe on Firefox? ' +\n      'See https://bit.ly/getsizebug1' );\n  }\n  return style;\n}\n\n// -------------------------- setup -------------------------- //\n\nvar isSetup = false;\n\nvar isBoxSizeOuter;\n\n/**\n * setup\n * check isBoxSizerOuter\n * do on first getSize() rather than on page load for Firefox bug\n */\nfunction setup() {\n  // setup once\n  if ( isSetup ) {\n    return;\n  }\n  isSetup = true;\n\n  // -------------------------- box sizing -------------------------- //\n\n  /**\n   * Chrome & Safari measure the outer-width on style.width on border-box elems\n   * IE11 & Firefox<29 measures the inner-width\n   */\n  var div = document.createElement('div');\n  div.style.width = '200px';\n  div.style.padding = '1px 2px 3px 4px';\n  div.style.borderStyle = 'solid';\n  div.style.borderWidth = '1px 2px 3px 4px';\n  div.style.boxSizing = 'border-box';\n\n  var body = document.body || document.documentElement;\n  body.appendChild( div );\n  var style = getStyle( div );\n  // round value for browser zoom. desandro/masonry#928\n  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;\n  getSize.isBoxSizeOuter = isBoxSizeOuter;\n\n  body.removeChild( div );\n}\n\n// -------------------------- getSize -------------------------- //\n\nfunction getSize( elem ) {\n  setup();\n\n  // use querySeletor if elem is string\n  if ( typeof elem == 'string' ) {\n    elem = document.querySelector( elem );\n  }\n\n  // do not proceed on non-objects\n  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {\n    return;\n  }\n\n  var style = getStyle( elem );\n\n  // if hidden, everything is 0\n  if ( style.display == 'none' ) {\n    return getZeroSize();\n  }\n\n  var size = {};\n  size.width = elem.offsetWidth;\n  size.height = elem.offsetHeight;\n\n  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';\n\n  // get all measurements\n  for ( var i=0; i < measurementsLength; i++ ) {\n    var measurement = measurements[i];\n    var value = style[ measurement ];\n    var num = parseFloat( value );\n    // any 'auto', 'medium' value will be 0\n    size[ measurement ] = !isNaN( num ) ? num : 0;\n  }\n\n  var paddingWidth = size.paddingLeft + size.paddingRight;\n  var paddingHeight = size.paddingTop + size.paddingBottom;\n  var marginWidth = size.marginLeft + size.marginRight;\n  var marginHeight = size.marginTop + size.marginBottom;\n  var borderWidth = size.borderLeftWidth + size.borderRightWidth;\n  var borderHeight = size.borderTopWidth + size.borderBottomWidth;\n\n  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;\n\n  // overwrite width and height if we can get it from style\n  var styleWidth = getStyleSize( style.width );\n  if ( styleWidth !== false ) {\n    size.width = styleWidth +\n      // add padding and border unless it's already including it\n      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );\n  }\n\n  var styleHeight = getStyleSize( style.height );\n  if ( styleHeight !== false ) {\n    size.height = styleHeight +\n      // add padding and border unless it's already including it\n      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );\n  }\n\n  size.innerWidth = size.width - ( paddingWidth + borderWidth );\n  size.innerHeight = size.height - ( paddingHeight + borderHeight );\n\n  size.outerWidth = size.width + marginWidth;\n  size.outerHeight = size.height + marginHeight;\n\n  return size;\n}\n\nreturn getSize;\n\n});\n\n/**\n * matchesSelector v2.0.2\n * matchesSelector( element, '.selector' )\n * MIT license\n */\n\n/*jshint browser: true, strict: true, undef: true, unused: true */\n\n( function( window, factory ) {\n  /*global define: false, module: false */\n  'use strict';\n  // universal module definition\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'desandro-matches-selector/matches-selector',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory();\n  } else {\n    // browser global\n    window.matchesSelector = factory();\n  }\n\n}( window, function factory() {\n  'use strict';\n\n  var matchesMethod = ( function() {\n    var ElemProto = window.Element.prototype;\n    // check for the standard method name first\n    if ( ElemProto.matches ) {\n      return 'matches';\n    }\n    // check un-prefixed\n    if ( ElemProto.matchesSelector ) {\n      return 'matchesSelector';\n    }\n    // check vendor prefixes\n    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];\n\n    for ( var i=0; i < prefixes.length; i++ ) {\n      var prefix = prefixes[i];\n      var method = prefix + 'MatchesSelector';\n      if ( ElemProto[ method ] ) {\n        return method;\n      }\n    }\n  })();\n\n  return function matchesSelector( elem, selector ) {\n    return elem[ matchesMethod ]( selector );\n  };\n\n}));\n\n/**\n * Fizzy UI utils v2.0.7\n * MIT license\n */\n\n/*jshint browser: true, undef: true, unused: true, strict: true */\n\n( function( window, factory ) {\n  // universal module definition\n  /*jshint strict: false */ /*globals define, module, require */\n\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'fizzy-ui-utils/utils',[\n      'desandro-matches-selector/matches-selector'\n    ], function( matchesSelector ) {\n      return factory( window, matchesSelector );\n    });\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      window,\n      require('desandro-matches-selector')\n    );\n  } else {\n    // browser global\n    window.fizzyUIUtils = factory(\n      window,\n      window.matchesSelector\n    );\n  }\n\n}( window, function factory( window, matchesSelector ) {\n\n\n\nvar utils = {};\n\n// ----- extend ----- //\n\n// extends objects\nutils.extend = function( a, b ) {\n  for ( var prop in b ) {\n    a[ prop ] = b[ prop ];\n  }\n  return a;\n};\n\n// ----- modulo ----- //\n\nutils.modulo = function( num, div ) {\n  return ( ( num % div ) + div ) % div;\n};\n\n// ----- makeArray ----- //\n\nvar arraySlice = Array.prototype.slice;\n\n// turn element or nodeList into an array\nutils.makeArray = function( obj ) {\n  if ( Array.isArray( obj ) ) {\n    // use object if already an array\n    return obj;\n  }\n  // return empty array if undefined or null. #6\n  if ( obj === null || obj === undefined ) {\n    return [];\n  }\n\n  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';\n  if ( isArrayLike ) {\n    // convert nodeList to array\n    return arraySlice.call( obj );\n  }\n\n  // array of single index\n  return [ obj ];\n};\n\n// ----- removeFrom ----- //\n\nutils.removeFrom = function( ary, obj ) {\n  var index = ary.indexOf( obj );\n  if ( index != -1 ) {\n    ary.splice( index, 1 );\n  }\n};\n\n// ----- getParent ----- //\n\nutils.getParent = function( elem, selector ) {\n  while ( elem.parentNode && elem != document.body ) {\n    elem = elem.parentNode;\n    if ( matchesSelector( elem, selector ) ) {\n      return elem;\n    }\n  }\n};\n\n// ----- getQueryElement ----- //\n\n// use element as selector string\nutils.getQueryElement = function( elem ) {\n  if ( typeof elem == 'string' ) {\n    return document.querySelector( elem );\n  }\n  return elem;\n};\n\n// ----- handleEvent ----- //\n\n// enable .ontype to trigger from .addEventListener( elem, 'type' )\nutils.handleEvent = function( event ) {\n  var method = 'on' + event.type;\n  if ( this[ method ] ) {\n    this[ method ]( event );\n  }\n};\n\n// ----- filterFindElements ----- //\n\nutils.filterFindElements = function( elems, selector ) {\n  // make array of elems\n  elems = utils.makeArray( elems );\n  var ffElems = [];\n\n  elems.forEach( function( elem ) {\n    // check that elem is an actual element\n    if ( !( elem instanceof HTMLElement ) ) {\n      return;\n    }\n    // add elem if no selector\n    if ( !selector ) {\n      ffElems.push( elem );\n      return;\n    }\n    // filter & find items if we have a selector\n    // filter\n    if ( matchesSelector( elem, selector ) ) {\n      ffElems.push( elem );\n    }\n    // find children\n    var childElems = elem.querySelectorAll( selector );\n    // concat childElems to filterFound array\n    for ( var i=0; i < childElems.length; i++ ) {\n      ffElems.push( childElems[i] );\n    }\n  });\n\n  return ffElems;\n};\n\n// ----- debounceMethod ----- //\n\nutils.debounceMethod = function( _class, methodName, threshold ) {\n  threshold = threshold || 100;\n  // original method\n  var method = _class.prototype[ methodName ];\n  var timeoutName = methodName + 'Timeout';\n\n  _class.prototype[ methodName ] = function() {\n    var timeout = this[ timeoutName ];\n    clearTimeout( timeout );\n\n    var args = arguments;\n    var _this = this;\n    this[ timeoutName ] = setTimeout( function() {\n      method.apply( _this, args );\n      delete _this[ timeoutName ];\n    }, threshold );\n  };\n};\n\n// ----- docReady ----- //\n\nutils.docReady = function( callback ) {\n  var readyState = document.readyState;\n  if ( readyState == 'complete' || readyState == 'interactive' ) {\n    // do async to allow for other scripts to run. metafizzy/flickity#441\n    setTimeout( callback );\n  } else {\n    document.addEventListener( 'DOMContentLoaded', callback );\n  }\n};\n\n// ----- htmlInit ----- //\n\n// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/\nutils.toDashed = function( str ) {\n  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {\n    return $1 + '-' + $2;\n  }).toLowerCase();\n};\n\nvar console = window.console;\n/**\n * allow user to initialize classes via [data-namespace] or .js-namespace class\n * htmlInit( Widget, 'widgetName' )\n * options are parsed from data-namespace-options\n */\nutils.htmlInit = function( WidgetClass, namespace ) {\n  utils.docReady( function() {\n    var dashedNamespace = utils.toDashed( namespace );\n    var dataAttr = 'data-' + dashedNamespace;\n    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );\n    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );\n    var elems = utils.makeArray( dataAttrElems )\n      .concat( utils.makeArray( jsDashElems ) );\n    var dataOptionsAttr = dataAttr + '-options';\n    var jQuery = window.jQuery;\n\n    elems.forEach( function( elem ) {\n      var attr = elem.getAttribute( dataAttr ) ||\n        elem.getAttribute( dataOptionsAttr );\n      var options;\n      try {\n        options = attr && JSON.parse( attr );\n      } catch ( error ) {\n        // log error, do not initialize\n        if ( console ) {\n          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +\n          ': ' + error );\n        }\n        return;\n      }\n      // initialize\n      var instance = new WidgetClass( elem, options );\n      // make available via $().data('namespace')\n      if ( jQuery ) {\n        jQuery.data( elem, namespace, instance );\n      }\n    });\n\n  });\n};\n\n// -----  ----- //\n\nreturn utils;\n\n}));\n\n/**\n * Outlayer Item\n */\n\n( function( window, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'outlayer/item',[\n        'ev-emitter/ev-emitter',\n        'get-size/get-size'\n      ],\n      factory\n    );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory(\n      require('ev-emitter'),\n      require('get-size')\n    );\n  } else {\n    // browser global\n    window.Outlayer = {};\n    window.Outlayer.Item = factory(\n      window.EvEmitter,\n      window.getSize\n    );\n  }\n\n}( window, function factory( EvEmitter, getSize ) {\n'use strict';\n\n// ----- helpers ----- //\n\nfunction isEmptyObj( obj ) {\n  for ( var prop in obj ) {\n    return false;\n  }\n  prop = null;\n  return true;\n}\n\n// -------------------------- CSS3 support -------------------------- //\n\n\nvar docElemStyle = document.documentElement.style;\n\nvar transitionProperty = typeof docElemStyle.transition == 'string' ?\n  'transition' : 'WebkitTransition';\nvar transformProperty = typeof docElemStyle.transform == 'string' ?\n  'transform' : 'WebkitTransform';\n\nvar transitionEndEvent = {\n  WebkitTransition: 'webkitTransitionEnd',\n  transition: 'transitionend'\n}[ transitionProperty ];\n\n// cache all vendor properties that could have vendor prefix\nvar vendorProperties = {\n  transform: transformProperty,\n  transition: transitionProperty,\n  transitionDuration: transitionProperty + 'Duration',\n  transitionProperty: transitionProperty + 'Property',\n  transitionDelay: transitionProperty + 'Delay'\n};\n\n// -------------------------- Item -------------------------- //\n\nfunction Item( element, layout ) {\n  if ( !element ) {\n    return;\n  }\n\n  this.element = element;\n  // parent layout class, i.e. Masonry, Isotope, or Packery\n  this.layout = layout;\n  this.position = {\n    x: 0,\n    y: 0\n  };\n\n  this._create();\n}\n\n// inherit EvEmitter\nvar proto = Item.prototype = Object.create( EvEmitter.prototype );\nproto.constructor = Item;\n\nproto._create = function() {\n  // transition objects\n  this._transn = {\n    ingProperties: {},\n    clean: {},\n    onEnd: {}\n  };\n\n  this.css({\n    position: 'absolute'\n  });\n};\n\n// trigger specified handler for event type\nproto.handleEvent = function( event ) {\n  var method = 'on' + event.type;\n  if ( this[ method ] ) {\n    this[ method ]( event );\n  }\n};\n\nproto.getSize = function() {\n  this.size = getSize( this.element );\n};\n\n/**\n * apply CSS styles to element\n * @param {Object} style\n */\nproto.css = function( style ) {\n  var elemStyle = this.element.style;\n\n  for ( var prop in style ) {\n    // use vendor property if available\n    var supportedProp = vendorProperties[ prop ] || prop;\n    elemStyle[ supportedProp ] = style[ prop ];\n  }\n};\n\n // measure position, and sets it\nproto.getPosition = function() {\n  var style = getComputedStyle( this.element );\n  var isOriginLeft = this.layout._getOption('originLeft');\n  var isOriginTop = this.layout._getOption('originTop');\n  var xValue = style[ isOriginLeft ? 'left' : 'right' ];\n  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];\n  var x = parseFloat( xValue );\n  var y = parseFloat( yValue );\n  // convert percent to pixels\n  var layoutSize = this.layout.size;\n  if ( xValue.indexOf('%') != -1 ) {\n    x = ( x / 100 ) * layoutSize.width;\n  }\n  if ( yValue.indexOf('%') != -1 ) {\n    y = ( y / 100 ) * layoutSize.height;\n  }\n  // clean up 'auto' or other non-integer values\n  x = isNaN( x ) ? 0 : x;\n  y = isNaN( y ) ? 0 : y;\n  // remove padding from measurement\n  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;\n  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;\n\n  this.position.x = x;\n  this.position.y = y;\n};\n\n// set settled position, apply padding\nproto.layoutPosition = function() {\n  var layoutSize = this.layout.size;\n  var style = {};\n  var isOriginLeft = this.layout._getOption('originLeft');\n  var isOriginTop = this.layout._getOption('originTop');\n\n  // x\n  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';\n  var xProperty = isOriginLeft ? 'left' : 'right';\n  var xResetProperty = isOriginLeft ? 'right' : 'left';\n\n  var x = this.position.x + layoutSize[ xPadding ];\n  // set in percentage or pixels\n  style[ xProperty ] = this.getXValue( x );\n  // reset other property\n  style[ xResetProperty ] = '';\n\n  // y\n  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';\n  var yProperty = isOriginTop ? 'top' : 'bottom';\n  var yResetProperty = isOriginTop ? 'bottom' : 'top';\n\n  var y = this.position.y + layoutSize[ yPadding ];\n  // set in percentage or pixels\n  style[ yProperty ] = this.getYValue( y );\n  // reset other property\n  style[ yResetProperty ] = '';\n\n  this.css( style );\n  this.emitEvent( 'layout', [ this ] );\n};\n\nproto.getXValue = function( x ) {\n  var isHorizontal = this.layout._getOption('horizontal');\n  return this.layout.options.percentPosition && !isHorizontal ?\n    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';\n};\n\nproto.getYValue = function( y ) {\n  var isHorizontal = this.layout._getOption('horizontal');\n  return this.layout.options.percentPosition && isHorizontal ?\n    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';\n};\n\nproto._transitionTo = function( x, y ) {\n  this.getPosition();\n  // get current x & y from top/left\n  var curX = this.position.x;\n  var curY = this.position.y;\n\n  var didNotMove = x == this.position.x && y == this.position.y;\n\n  // save end position\n  this.setPosition( x, y );\n\n  // if did not move and not transitioning, just go to layout\n  if ( didNotMove && !this.isTransitioning ) {\n    this.layoutPosition();\n    return;\n  }\n\n  var transX = x - curX;\n  var transY = y - curY;\n  var transitionStyle = {};\n  transitionStyle.transform = this.getTranslate( transX, transY );\n\n  this.transition({\n    to: transitionStyle,\n    onTransitionEnd: {\n      transform: this.layoutPosition\n    },\n    isCleaning: true\n  });\n};\n\nproto.getTranslate = function( x, y ) {\n  // flip cooridinates if origin on right or bottom\n  var isOriginLeft = this.layout._getOption('originLeft');\n  var isOriginTop = this.layout._getOption('originTop');\n  x = isOriginLeft ? x : -x;\n  y = isOriginTop ? y : -y;\n  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';\n};\n\n// non transition + transform support\nproto.goTo = function( x, y ) {\n  this.setPosition( x, y );\n  this.layoutPosition();\n};\n\nproto.moveTo = proto._transitionTo;\n\nproto.setPosition = function( x, y ) {\n  this.position.x = parseFloat( x );\n  this.position.y = parseFloat( y );\n};\n\n// ----- transition ----- //\n\n/**\n * @param {Object} style - CSS\n * @param {Function} onTransitionEnd\n */\n\n// non transition, just trigger callback\nproto._nonTransition = function( args ) {\n  this.css( args.to );\n  if ( args.isCleaning ) {\n    this._removeStyles( args.to );\n  }\n  for ( var prop in args.onTransitionEnd ) {\n    args.onTransitionEnd[ prop ].call( this );\n  }\n};\n\n/**\n * proper transition\n * @param {Object} args - arguments\n *   @param {Object} to - style to transition to\n *   @param {Object} from - style to start transition from\n *   @param {Boolean} isCleaning - removes transition styles after transition\n *   @param {Function} onTransitionEnd - callback\n */\nproto.transition = function( args ) {\n  // redirect to nonTransition if no transition duration\n  if ( !parseFloat( this.layout.options.transitionDuration ) ) {\n    this._nonTransition( args );\n    return;\n  }\n\n  var _transition = this._transn;\n  // keep track of onTransitionEnd callback by css property\n  for ( var prop in args.onTransitionEnd ) {\n    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];\n  }\n  // keep track of properties that are transitioning\n  for ( prop in args.to ) {\n    _transition.ingProperties[ prop ] = true;\n    // keep track of properties to clean up when transition is done\n    if ( args.isCleaning ) {\n      _transition.clean[ prop ] = true;\n    }\n  }\n\n  // set from styles\n  if ( args.from ) {\n    this.css( args.from );\n    // force redraw. http://blog.alexmaccaw.com/css-transitions\n    var h = this.element.offsetHeight;\n    // hack for JSHint to hush about unused var\n    h = null;\n  }\n  // enable transition\n  this.enableTransition( args.to );\n  // set styles that are transitioning\n  this.css( args.to );\n\n  this.isTransitioning = true;\n\n};\n\n// dash before all cap letters, including first for\n// WebkitTransform => -webkit-transform\nfunction toDashedAll( str ) {\n  return str.replace( /([A-Z])/g, function( $1 ) {\n    return '-' + $1.toLowerCase();\n  });\n}\n\nvar transitionProps = 'opacity,' + toDashedAll( transformProperty );\n\nproto.enableTransition = function(/* style */) {\n  // HACK changing transitionProperty during a transition\n  // will cause transition to jump\n  if ( this.isTransitioning ) {\n    return;\n  }\n\n  // make `transition: foo, bar, baz` from style object\n  // HACK un-comment this when enableTransition can work\n  // while a transition is happening\n  // var transitionValues = [];\n  // for ( var prop in style ) {\n  //   // dash-ify camelCased properties like WebkitTransition\n  //   prop = vendorProperties[ prop ] || prop;\n  //   transitionValues.push( toDashedAll( prop ) );\n  // }\n  // munge number to millisecond, to match stagger\n  var duration = this.layout.options.transitionDuration;\n  duration = typeof duration == 'number' ? duration + 'ms' : duration;\n  // enable transition styles\n  this.css({\n    transitionProperty: transitionProps,\n    transitionDuration: duration,\n    transitionDelay: this.staggerDelay || 0\n  });\n  // listen for transition end event\n  this.element.addEventListener( transitionEndEvent, this, false );\n};\n\n// ----- events ----- //\n\nproto.onwebkitTransitionEnd = function( event ) {\n  this.ontransitionend( event );\n};\n\nproto.onotransitionend = function( event ) {\n  this.ontransitionend( event );\n};\n\n// properties that I munge to make my life easier\nvar dashedVendorProperties = {\n  '-webkit-transform': 'transform'\n};\n\nproto.ontransitionend = function( event ) {\n  // disregard bubbled events from children\n  if ( event.target !== this.element ) {\n    return;\n  }\n  var _transition = this._transn;\n  // get property name of transitioned property, convert to prefix-free\n  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;\n\n  // remove property that has completed transitioning\n  delete _transition.ingProperties[ propertyName ];\n  // check if any properties are still transitioning\n  if ( isEmptyObj( _transition.ingProperties ) ) {\n    // all properties have completed transitioning\n    this.disableTransition();\n  }\n  // clean style\n  if ( propertyName in _transition.clean ) {\n    // clean up style\n    this.element.style[ event.propertyName ] = '';\n    delete _transition.clean[ propertyName ];\n  }\n  // trigger onTransitionEnd callback\n  if ( propertyName in _transition.onEnd ) {\n    var onTransitionEnd = _transition.onEnd[ propertyName ];\n    onTransitionEnd.call( this );\n    delete _transition.onEnd[ propertyName ];\n  }\n\n  this.emitEvent( 'transitionEnd', [ this ] );\n};\n\nproto.disableTransition = function() {\n  this.removeTransitionStyles();\n  this.element.removeEventListener( transitionEndEvent, this, false );\n  this.isTransitioning = false;\n};\n\n/**\n * removes style property from element\n * @param {Object} style\n**/\nproto._removeStyles = function( style ) {\n  // clean up transition styles\n  var cleanStyle = {};\n  for ( var prop in style ) {\n    cleanStyle[ prop ] = '';\n  }\n  this.css( cleanStyle );\n};\n\nvar cleanTransitionStyle = {\n  transitionProperty: '',\n  transitionDuration: '',\n  transitionDelay: ''\n};\n\nproto.removeTransitionStyles = function() {\n  // remove transition\n  this.css( cleanTransitionStyle );\n};\n\n// ----- stagger ----- //\n\nproto.stagger = function( delay ) {\n  delay = isNaN( delay ) ? 0 : delay;\n  this.staggerDelay = delay + 'ms';\n};\n\n// ----- show/hide/remove ----- //\n\n// remove element from DOM\nproto.removeElem = function() {\n  this.element.parentNode.removeChild( this.element );\n  // remove display: none\n  this.css({ display: '' });\n  this.emitEvent( 'remove', [ this ] );\n};\n\nproto.remove = function() {\n  // just remove element if no transition support or no transition\n  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {\n    this.removeElem();\n    return;\n  }\n\n  // start transition\n  this.once( 'transitionEnd', function() {\n    this.removeElem();\n  });\n  this.hide();\n};\n\nproto.reveal = function() {\n  delete this.isHidden;\n  // remove display: none\n  this.css({ display: '' });\n\n  var options = this.layout.options;\n\n  var onTransitionEnd = {};\n  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');\n  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;\n\n  this.transition({\n    from: options.hiddenStyle,\n    to: options.visibleStyle,\n    isCleaning: true,\n    onTransitionEnd: onTransitionEnd\n  });\n};\n\nproto.onRevealTransitionEnd = function() {\n  // check if still visible\n  // during transition, item may have been hidden\n  if ( !this.isHidden ) {\n    this.emitEvent('reveal');\n  }\n};\n\n/**\n * get style property use for hide/reveal transition end\n * @param {String} styleProperty - hiddenStyle/visibleStyle\n * @returns {String}\n */\nproto.getHideRevealTransitionEndProperty = function( styleProperty ) {\n  var optionStyle = this.layout.options[ styleProperty ];\n  // use opacity\n  if ( optionStyle.opacity ) {\n    return 'opacity';\n  }\n  // get first property\n  for ( var prop in optionStyle ) {\n    return prop;\n  }\n};\n\nproto.hide = function() {\n  // set flag\n  this.isHidden = true;\n  // remove display: none\n  this.css({ display: '' });\n\n  var options = this.layout.options;\n\n  var onTransitionEnd = {};\n  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');\n  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;\n\n  this.transition({\n    from: options.visibleStyle,\n    to: options.hiddenStyle,\n    // keep hidden stuff hidden\n    isCleaning: true,\n    onTransitionEnd: onTransitionEnd\n  });\n};\n\nproto.onHideTransitionEnd = function() {\n  // check if still hidden\n  // during transition, item may have been un-hidden\n  if ( this.isHidden ) {\n    this.css({ display: 'none' });\n    this.emitEvent('hide');\n  }\n};\n\nproto.destroy = function() {\n  this.css({\n    position: '',\n    left: '',\n    right: '',\n    top: '',\n    bottom: '',\n    transition: '',\n    transform: ''\n  });\n};\n\nreturn Item;\n\n}));\n\n/*!\n * Outlayer v2.1.1\n * the brains and guts of a layout library\n * MIT license\n */\n\n( function( window, factory ) {\n  'use strict';\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'outlayer/outlayer',[\n        'ev-emitter/ev-emitter',\n        'get-size/get-size',\n        'fizzy-ui-utils/utils',\n        './item'\n      ],\n      function( EvEmitter, getSize, utils, Item ) {\n        return factory( window, EvEmitter, getSize, utils, Item);\n      }\n    );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory(\n      window,\n      require('ev-emitter'),\n      require('get-size'),\n      require('fizzy-ui-utils'),\n      require('./item')\n    );\n  } else {\n    // browser global\n    window.Outlayer = factory(\n      window,\n      window.EvEmitter,\n      window.getSize,\n      window.fizzyUIUtils,\n      window.Outlayer.Item\n    );\n  }\n\n}( window, function factory( window, EvEmitter, getSize, utils, Item ) {\n'use strict';\n\n// ----- vars ----- //\n\nvar console = window.console;\nvar jQuery = window.jQuery;\nvar noop = function() {};\n\n// -------------------------- Outlayer -------------------------- //\n\n// globally unique identifiers\nvar GUID = 0;\n// internal store of all Outlayer intances\nvar instances = {};\n\n\n/**\n * @param {Element, String} element\n * @param {Object} options\n * @constructor\n */\nfunction Outlayer( element, options ) {\n  var queryElement = utils.getQueryElement( element );\n  if ( !queryElement ) {\n    if ( console ) {\n      console.error( 'Bad element for ' + this.constructor.namespace +\n        ': ' + ( queryElement || element ) );\n    }\n    return;\n  }\n  this.element = queryElement;\n  // add jQuery\n  if ( jQuery ) {\n    this.$element = jQuery( this.element );\n  }\n\n  // options\n  this.options = utils.extend( {}, this.constructor.defaults );\n  this.option( options );\n\n  // add id for Outlayer.getFromElement\n  var id = ++GUID;\n  this.element.outlayerGUID = id; // expando\n  instances[ id ] = this; // associate via id\n\n  // kick it off\n  this._create();\n\n  var isInitLayout = this._getOption('initLayout');\n  if ( isInitLayout ) {\n    this.layout();\n  }\n}\n\n// settings are for internal use only\nOutlayer.namespace = 'outlayer';\nOutlayer.Item = Item;\n\n// default options\nOutlayer.defaults = {\n  containerStyle: {\n    position: 'relative'\n  },\n  initLayout: true,\n  originLeft: true,\n  originTop: true,\n  resize: true,\n  resizeContainer: true,\n  // item options\n  transitionDuration: '0.4s',\n  hiddenStyle: {\n    opacity: 0,\n    transform: 'scale(0.001)'\n  },\n  visibleStyle: {\n    opacity: 1,\n    transform: 'scale(1)'\n  }\n};\n\nvar proto = Outlayer.prototype;\n// inherit EvEmitter\nutils.extend( proto, EvEmitter.prototype );\n\n/**\n * set options\n * @param {Object} opts\n */\nproto.option = function( opts ) {\n  utils.extend( this.options, opts );\n};\n\n/**\n * get backwards compatible option value, check old name\n */\nproto._getOption = function( option ) {\n  var oldOption = this.constructor.compatOptions[ option ];\n  return oldOption && this.options[ oldOption ] !== undefined ?\n    this.options[ oldOption ] : this.options[ option ];\n};\n\nOutlayer.compatOptions = {\n  // currentName: oldName\n  initLayout: 'isInitLayout',\n  horizontal: 'isHorizontal',\n  layoutInstant: 'isLayoutInstant',\n  originLeft: 'isOriginLeft',\n  originTop: 'isOriginTop',\n  resize: 'isResizeBound',\n  resizeContainer: 'isResizingContainer'\n};\n\nproto._create = function() {\n  // get items from children\n  this.reloadItems();\n  // elements that affect layout, but are not laid out\n  this.stamps = [];\n  this.stamp( this.options.stamp );\n  // set container style\n  utils.extend( this.element.style, this.options.containerStyle );\n\n  // bind resize method\n  var canBindResize = this._getOption('resize');\n  if ( canBindResize ) {\n    this.bindResize();\n  }\n};\n\n// goes through all children again and gets bricks in proper order\nproto.reloadItems = function() {\n  // collection of item elements\n  this.items = this._itemize( this.element.children );\n};\n\n\n/**\n * turn elements into Outlayer.Items to be used in layout\n * @param {Array or NodeList or HTMLElement} elems\n * @returns {Array} items - collection of new Outlayer Items\n */\nproto._itemize = function( elems ) {\n\n  var itemElems = this._filterFindItemElements( elems );\n  var Item = this.constructor.Item;\n\n  // create new Outlayer Items for collection\n  var items = [];\n  for ( var i=0; i < itemElems.length; i++ ) {\n    var elem = itemElems[i];\n    var item = new Item( elem, this );\n    items.push( item );\n  }\n\n  return items;\n};\n\n/**\n * get item elements to be used in layout\n * @param {Array or NodeList or HTMLElement} elems\n * @returns {Array} items - item elements\n */\nproto._filterFindItemElements = function( elems ) {\n  return utils.filterFindElements( elems, this.options.itemSelector );\n};\n\n/**\n * getter method for getting item elements\n * @returns {Array} elems - collection of item elements\n */\nproto.getItemElements = function() {\n  return this.items.map( function( item ) {\n    return item.element;\n  });\n};\n\n// ----- init & layout ----- //\n\n/**\n * lays out all items\n */\nproto.layout = function() {\n  this._resetLayout();\n  this._manageStamps();\n\n  // don't animate first layout\n  var layoutInstant = this._getOption('layoutInstant');\n  var isInstant = layoutInstant !== undefined ?\n    layoutInstant : !this._isLayoutInited;\n  this.layoutItems( this.items, isInstant );\n\n  // flag for initalized\n  this._isLayoutInited = true;\n};\n\n// _init is alias for layout\nproto._init = proto.layout;\n\n/**\n * logic before any new layout\n */\nproto._resetLayout = function() {\n  this.getSize();\n};\n\n\nproto.getSize = function() {\n  this.size = getSize( this.element );\n};\n\n/**\n * get measurement from option, for columnWidth, rowHeight, gutter\n * if option is String -> get element from selector string, & get size of element\n * if option is Element -> get size of element\n * else use option as a number\n *\n * @param {String} measurement\n * @param {String} size - width or height\n * @private\n */\nproto._getMeasurement = function( measurement, size ) {\n  var option = this.options[ measurement ];\n  var elem;\n  if ( !option ) {\n    // default to 0\n    this[ measurement ] = 0;\n  } else {\n    // use option as an element\n    if ( typeof option == 'string' ) {\n      elem = this.element.querySelector( option );\n    } else if ( option instanceof HTMLElement ) {\n      elem = option;\n    }\n    // use size of element, if element\n    this[ measurement ] = elem ? getSize( elem )[ size ] : option;\n  }\n};\n\n/**\n * layout a collection of item elements\n * @api public\n */\nproto.layoutItems = function( items, isInstant ) {\n  items = this._getItemsForLayout( items );\n\n  this._layoutItems( items, isInstant );\n\n  this._postLayout();\n};\n\n/**\n * get the items to be laid out\n * you may want to skip over some items\n * @param {Array} items\n * @returns {Array} items\n */\nproto._getItemsForLayout = function( items ) {\n  return items.filter( function( item ) {\n    return !item.isIgnored;\n  });\n};\n\n/**\n * layout items\n * @param {Array} items\n * @param {Boolean} isInstant\n */\nproto._layoutItems = function( items, isInstant ) {\n  this._emitCompleteOnItems( 'layout', items );\n\n  if ( !items || !items.length ) {\n    // no items, emit event with empty array\n    return;\n  }\n\n  var queue = [];\n\n  items.forEach( function( item ) {\n    // get x/y object from method\n    var position = this._getItemLayoutPosition( item );\n    // enqueue\n    position.item = item;\n    position.isInstant = isInstant || item.isLayoutInstant;\n    queue.push( position );\n  }, this );\n\n  this._processLayoutQueue( queue );\n};\n\n/**\n * get item layout position\n * @param {Outlayer.Item} item\n * @returns {Object} x and y position\n */\nproto._getItemLayoutPosition = function( /* item */ ) {\n  return {\n    x: 0,\n    y: 0\n  };\n};\n\n/**\n * iterate over array and position each item\n * Reason being - separating this logic prevents 'layout invalidation'\n * thx @paul_irish\n * @param {Array} queue\n */\nproto._processLayoutQueue = function( queue ) {\n  this.updateStagger();\n  queue.forEach( function( obj, i ) {\n    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );\n  }, this );\n};\n\n// set stagger from option in milliseconds number\nproto.updateStagger = function() {\n  var stagger = this.options.stagger;\n  if ( stagger === null || stagger === undefined ) {\n    this.stagger = 0;\n    return;\n  }\n  this.stagger = getMilliseconds( stagger );\n  return this.stagger;\n};\n\n/**\n * Sets position of item in DOM\n * @param {Outlayer.Item} item\n * @param {Number} x - horizontal position\n * @param {Number} y - vertical position\n * @param {Boolean} isInstant - disables transitions\n */\nproto._positionItem = function( item, x, y, isInstant, i ) {\n  if ( isInstant ) {\n    // if not transition, just set CSS\n    item.goTo( x, y );\n  } else {\n    item.stagger( i * this.stagger );\n    item.moveTo( x, y );\n  }\n};\n\n/**\n * Any logic you want to do after each layout,\n * i.e. size the container\n */\nproto._postLayout = function() {\n  this.resizeContainer();\n};\n\nproto.resizeContainer = function() {\n  var isResizingContainer = this._getOption('resizeContainer');\n  if ( !isResizingContainer ) {\n    return;\n  }\n  var size = this._getContainerSize();\n  if ( size ) {\n    this._setContainerMeasure( size.width, true );\n    this._setContainerMeasure( size.height, false );\n  }\n};\n\n/**\n * Sets width or height of container if returned\n * @returns {Object} size\n *   @param {Number} width\n *   @param {Number} height\n */\nproto._getContainerSize = noop;\n\n/**\n * @param {Number} measure - size of width or height\n * @param {Boolean} isWidth\n */\nproto._setContainerMeasure = function( measure, isWidth ) {\n  if ( measure === undefined ) {\n    return;\n  }\n\n  var elemSize = this.size;\n  // add padding and border width if border box\n  if ( elemSize.isBorderBox ) {\n    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +\n      elemSize.borderLeftWidth + elemSize.borderRightWidth :\n      elemSize.paddingBottom + elemSize.paddingTop +\n      elemSize.borderTopWidth + elemSize.borderBottomWidth;\n  }\n\n  measure = Math.max( measure, 0 );\n  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';\n};\n\n/**\n * emit eventComplete on a collection of items events\n * @param {String} eventName\n * @param {Array} items - Outlayer.Items\n */\nproto._emitCompleteOnItems = function( eventName, items ) {\n  var _this = this;\n  function onComplete() {\n    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );\n  }\n\n  var count = items.length;\n  if ( !items || !count ) {\n    onComplete();\n    return;\n  }\n\n  var doneCount = 0;\n  function tick() {\n    doneCount++;\n    if ( doneCount == count ) {\n      onComplete();\n    }\n  }\n\n  // bind callback\n  items.forEach( function( item ) {\n    item.once( eventName, tick );\n  });\n};\n\n/**\n * emits events via EvEmitter and jQuery events\n * @param {String} type - name of event\n * @param {Event} event - original event\n * @param {Array} args - extra arguments\n */\nproto.dispatchEvent = function( type, event, args ) {\n  // add original event to arguments\n  var emitArgs = event ? [ event ].concat( args ) : args;\n  this.emitEvent( type, emitArgs );\n\n  if ( jQuery ) {\n    // set this.$element\n    this.$element = this.$element || jQuery( this.element );\n    if ( event ) {\n      // create jQuery event\n      var $event = jQuery.Event( event );\n      $event.type = type;\n      this.$element.trigger( $event, args );\n    } else {\n      // just trigger with type if no event available\n      this.$element.trigger( type, args );\n    }\n  }\n};\n\n// -------------------------- ignore & stamps -------------------------- //\n\n\n/**\n * keep item in collection, but do not lay it out\n * ignored items do not get skipped in layout\n * @param {Element} elem\n */\nproto.ignore = function( elem ) {\n  var item = this.getItem( elem );\n  if ( item ) {\n    item.isIgnored = true;\n  }\n};\n\n/**\n * return item to layout collection\n * @param {Element} elem\n */\nproto.unignore = function( elem ) {\n  var item = this.getItem( elem );\n  if ( item ) {\n    delete item.isIgnored;\n  }\n};\n\n/**\n * adds elements to stamps\n * @param {NodeList, Array, Element, or String} elems\n */\nproto.stamp = function( elems ) {\n  elems = this._find( elems );\n  if ( !elems ) {\n    return;\n  }\n\n  this.stamps = this.stamps.concat( elems );\n  // ignore\n  elems.forEach( this.ignore, this );\n};\n\n/**\n * removes elements to stamps\n * @param {NodeList, Array, or Element} elems\n */\nproto.unstamp = function( elems ) {\n  elems = this._find( elems );\n  if ( !elems ){\n    return;\n  }\n\n  elems.forEach( function( elem ) {\n    // filter out removed stamp elements\n    utils.removeFrom( this.stamps, elem );\n    this.unignore( elem );\n  }, this );\n};\n\n/**\n * finds child elements\n * @param {NodeList, Array, Element, or String} elems\n * @returns {Array} elems\n */\nproto._find = function( elems ) {\n  if ( !elems ) {\n    return;\n  }\n  // if string, use argument as selector string\n  if ( typeof elems == 'string' ) {\n    elems = this.element.querySelectorAll( elems );\n  }\n  elems = utils.makeArray( elems );\n  return elems;\n};\n\nproto._manageStamps = function() {\n  if ( !this.stamps || !this.stamps.length ) {\n    return;\n  }\n\n  this._getBoundingRect();\n\n  this.stamps.forEach( this._manageStamp, this );\n};\n\n// update boundingLeft / Top\nproto._getBoundingRect = function() {\n  // get bounding rect for container element\n  var boundingRect = this.element.getBoundingClientRect();\n  var size = this.size;\n  this._boundingRect = {\n    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,\n    top: boundingRect.top + size.paddingTop + size.borderTopWidth,\n    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),\n    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )\n  };\n};\n\n/**\n * @param {Element} stamp\n**/\nproto._manageStamp = noop;\n\n/**\n * get x/y position of element relative to container element\n * @param {Element} elem\n * @returns {Object} offset - has left, top, right, bottom\n */\nproto._getElementOffset = function( elem ) {\n  var boundingRect = elem.getBoundingClientRect();\n  var thisRect = this._boundingRect;\n  var size = getSize( elem );\n  var offset = {\n    left: boundingRect.left - thisRect.left - size.marginLeft,\n    top: boundingRect.top - thisRect.top - size.marginTop,\n    right: thisRect.right - boundingRect.right - size.marginRight,\n    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom\n  };\n  return offset;\n};\n\n// -------------------------- resize -------------------------- //\n\n// enable event handlers for listeners\n// i.e. resize -> onresize\nproto.handleEvent = utils.handleEvent;\n\n/**\n * Bind layout to window resizing\n */\nproto.bindResize = function() {\n  window.addEventListener( 'resize', this );\n  this.isResizeBound = true;\n};\n\n/**\n * Unbind layout to window resizing\n */\nproto.unbindResize = function() {\n  window.removeEventListener( 'resize', this );\n  this.isResizeBound = false;\n};\n\nproto.onresize = function() {\n  this.resize();\n};\n\nutils.debounceMethod( Outlayer, 'onresize', 100 );\n\nproto.resize = function() {\n  // don't trigger if size did not change\n  // or if resize was unbound. See #9\n  if ( !this.isResizeBound || !this.needsResizeLayout() ) {\n    return;\n  }\n\n  this.layout();\n};\n\n/**\n * check if layout is needed post layout\n * @returns Boolean\n */\nproto.needsResizeLayout = function() {\n  var size = getSize( this.element );\n  // check that this.size and size are there\n  // IE8 triggers resize on body size change, so they might not be\n  var hasSizes = this.size && size;\n  return hasSizes && size.innerWidth !== this.size.innerWidth;\n};\n\n// -------------------------- methods -------------------------- //\n\n/**\n * add items to Outlayer instance\n * @param {Array or NodeList or Element} elems\n * @returns {Array} items - Outlayer.Items\n**/\nproto.addItems = function( elems ) {\n  var items = this._itemize( elems );\n  // add items to collection\n  if ( items.length ) {\n    this.items = this.items.concat( items );\n  }\n  return items;\n};\n\n/**\n * Layout newly-appended item elements\n * @param {Array or NodeList or Element} elems\n */\nproto.appended = function( elems ) {\n  var items = this.addItems( elems );\n  if ( !items.length ) {\n    return;\n  }\n  // layout and reveal just the new items\n  this.layoutItems( items, true );\n  this.reveal( items );\n};\n\n/**\n * Layout prepended elements\n * @param {Array or NodeList or Element} elems\n */\nproto.prepended = function( elems ) {\n  var items = this._itemize( elems );\n  if ( !items.length ) {\n    return;\n  }\n  // add items to beginning of collection\n  var previousItems = this.items.slice(0);\n  this.items = items.concat( previousItems );\n  // start new layout\n  this._resetLayout();\n  this._manageStamps();\n  // layout new stuff without transition\n  this.layoutItems( items, true );\n  this.reveal( items );\n  // layout previous items\n  this.layoutItems( previousItems );\n};\n\n/**\n * reveal a collection of items\n * @param {Array of Outlayer.Items} items\n */\nproto.reveal = function( items ) {\n  this._emitCompleteOnItems( 'reveal', items );\n  if ( !items || !items.length ) {\n    return;\n  }\n  var stagger = this.updateStagger();\n  items.forEach( function( item, i ) {\n    item.stagger( i * stagger );\n    item.reveal();\n  });\n};\n\n/**\n * hide a collection of items\n * @param {Array of Outlayer.Items} items\n */\nproto.hide = function( items ) {\n  this._emitCompleteOnItems( 'hide', items );\n  if ( !items || !items.length ) {\n    return;\n  }\n  var stagger = this.updateStagger();\n  items.forEach( function( item, i ) {\n    item.stagger( i * stagger );\n    item.hide();\n  });\n};\n\n/**\n * reveal item elements\n * @param {Array}, {Element}, {NodeList} items\n */\nproto.revealItemElements = function( elems ) {\n  var items = this.getItems( elems );\n  this.reveal( items );\n};\n\n/**\n * hide item elements\n * @param {Array}, {Element}, {NodeList} items\n */\nproto.hideItemElements = function( elems ) {\n  var items = this.getItems( elems );\n  this.hide( items );\n};\n\n/**\n * get Outlayer.Item, given an Element\n * @param {Element} elem\n * @param {Function} callback\n * @returns {Outlayer.Item} item\n */\nproto.getItem = function( elem ) {\n  // loop through items to get the one that matches\n  for ( var i=0; i < this.items.length; i++ ) {\n    var item = this.items[i];\n    if ( item.element == elem ) {\n      // return item\n      return item;\n    }\n  }\n};\n\n/**\n * get collection of Outlayer.Items, given Elements\n * @param {Array} elems\n * @returns {Array} items - Outlayer.Items\n */\nproto.getItems = function( elems ) {\n  elems = utils.makeArray( elems );\n  var items = [];\n  elems.forEach( function( elem ) {\n    var item = this.getItem( elem );\n    if ( item ) {\n      items.push( item );\n    }\n  }, this );\n\n  return items;\n};\n\n/**\n * remove element(s) from instance and DOM\n * @param {Array or NodeList or Element} elems\n */\nproto.remove = function( elems ) {\n  var removeItems = this.getItems( elems );\n\n  this._emitCompleteOnItems( 'remove', removeItems );\n\n  // bail if no items to remove\n  if ( !removeItems || !removeItems.length ) {\n    return;\n  }\n\n  removeItems.forEach( function( item ) {\n    item.remove();\n    // remove item from collection\n    utils.removeFrom( this.items, item );\n  }, this );\n};\n\n// ----- destroy ----- //\n\n// remove and disable Outlayer instance\nproto.destroy = function() {\n  // clean up dynamic styles\n  var style = this.element.style;\n  style.height = '';\n  style.position = '';\n  style.width = '';\n  // destroy items\n  this.items.forEach( function( item ) {\n    item.destroy();\n  });\n\n  this.unbindResize();\n\n  var id = this.element.outlayerGUID;\n  delete instances[ id ]; // remove reference to instance by id\n  delete this.element.outlayerGUID;\n  // remove data for jQuery\n  if ( jQuery ) {\n    jQuery.removeData( this.element, this.constructor.namespace );\n  }\n\n};\n\n// -------------------------- data -------------------------- //\n\n/**\n * get Outlayer instance from element\n * @param {Element} elem\n * @returns {Outlayer}\n */\nOutlayer.data = function( elem ) {\n  elem = utils.getQueryElement( elem );\n  var id = elem && elem.outlayerGUID;\n  return id && instances[ id ];\n};\n\n\n// -------------------------- create Outlayer class -------------------------- //\n\n/**\n * create a layout class\n * @param {String} namespace\n */\nOutlayer.create = function( namespace, options ) {\n  // sub-class Outlayer\n  var Layout = subclass( Outlayer );\n  // apply new options and compatOptions\n  Layout.defaults = utils.extend( {}, Outlayer.defaults );\n  utils.extend( Layout.defaults, options );\n  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );\n\n  Layout.namespace = namespace;\n\n  Layout.data = Outlayer.data;\n\n  // sub-class Item\n  Layout.Item = subclass( Item );\n\n  // -------------------------- declarative -------------------------- //\n\n  utils.htmlInit( Layout, namespace );\n\n  // -------------------------- jQuery bridge -------------------------- //\n\n  // make into jQuery plugin\n  if ( jQuery && jQuery.bridget ) {\n    jQuery.bridget( namespace, Layout );\n  }\n\n  return Layout;\n};\n\nfunction subclass( Parent ) {\n  function SubClass() {\n    Parent.apply( this, arguments );\n  }\n\n  SubClass.prototype = Object.create( Parent.prototype );\n  SubClass.prototype.constructor = SubClass;\n\n  return SubClass;\n}\n\n// ----- helpers ----- //\n\n// how many milliseconds are in each unit\nvar msUnits = {\n  ms: 1,\n  s: 1000\n};\n\n// munge time-like parameter into millisecond number\n// '0.4s' -> 40\nfunction getMilliseconds( time ) {\n  if ( typeof time == 'number' ) {\n    return time;\n  }\n  var matches = time.match( /(^\\d*\\.?\\d*)(\\w*)/ );\n  var num = matches && matches[1];\n  var unit = matches && matches[2];\n  if ( !num.length ) {\n    return 0;\n  }\n  num = parseFloat( num );\n  var mult = msUnits[ unit ] || 1;\n  return num * mult;\n}\n\n// ----- fin ----- //\n\n// back in global\nOutlayer.Item = Item;\n\nreturn Outlayer;\n\n}));\n\n/*!\n * Masonry v4.2.2\n * Cascading grid layout library\n * https://masonry.desandro.com\n * MIT License\n * by David DeSandro\n */\n\n( function( window, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /*globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( [\n        'outlayer/outlayer',\n        'get-size/get-size'\n      ],\n      factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      require('outlayer'),\n      require('get-size')\n    );\n  } else {\n    // browser global\n    window.Masonry = factory(\n      window.Outlayer,\n      window.getSize\n    );\n  }\n\n}( window, function factory( Outlayer, getSize ) {\n\n\n\n// -------------------------- masonryDefinition -------------------------- //\n\n  // create an Outlayer layout class\n  var Masonry = Outlayer.create('masonry');\n  // isFitWidth -> fitWidth\n  Masonry.compatOptions.fitWidth = 'isFitWidth';\n\n  var proto = Masonry.prototype;\n\n  proto._resetLayout = function() {\n    this.getSize();\n    this._getMeasurement( 'columnWidth', 'outerWidth' );\n    this._getMeasurement( 'gutter', 'outerWidth' );\n    this.measureColumns();\n\n    // reset column Y\n    this.colYs = [];\n    for ( var i=0; i < this.cols; i++ ) {\n      this.colYs.push( 0 );\n    }\n\n    this.maxY = 0;\n    this.horizontalColIndex = 0;\n  };\n\n  proto.measureColumns = function() {\n    this.getContainerWidth();\n    // if columnWidth is 0, default to outerWidth of first item\n    if ( !this.columnWidth ) {\n      var firstItem = this.items[0];\n      var firstItemElem = firstItem && firstItem.element;\n      // columnWidth fall back to item of first element\n      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||\n        // if first elem has no width, default to size of container\n        this.containerWidth;\n    }\n\n    var columnWidth = this.columnWidth += this.gutter;\n\n    // calculate columns\n    var containerWidth = this.containerWidth + this.gutter;\n    var cols = containerWidth / columnWidth;\n    // fix rounding errors, typically with gutters\n    var excess = columnWidth - containerWidth % columnWidth;\n    // if overshoot is less than a pixel, round up, otherwise floor it\n    var mathMethod = excess && excess < 1 ? 'round' : 'floor';\n    cols = Math[ mathMethod ]( cols );\n    this.cols = Math.max( cols, 1 );\n  };\n\n  proto.getContainerWidth = function() {\n    // container is parent if fit width\n    var isFitWidth = this._getOption('fitWidth');\n    var container = isFitWidth ? this.element.parentNode : this.element;\n    // check that this.size and size are there\n    // IE8 triggers resize on body size change, so they might not be\n    var size = getSize( container );\n    this.containerWidth = size && size.innerWidth;\n  };\n\n  proto._getItemLayoutPosition = function( item ) {\n    item.getSize();\n    // how many columns does this brick span\n    var remainder = item.size.outerWidth % this.columnWidth;\n    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';\n    // round if off by 1 pixel, otherwise use ceil\n    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );\n    colSpan = Math.min( colSpan, this.cols );\n    // use horizontal or top column position\n    var colPosMethod = this.options.horizontalOrder ?\n      '_getHorizontalColPosition' : '_getTopColPosition';\n    var colPosition = this[ colPosMethod ]( colSpan, item );\n    // position the brick\n    var position = {\n      x: this.columnWidth * colPosition.col,\n      y: colPosition.y\n    };\n    // apply setHeight to necessary columns\n    var setHeight = colPosition.y + item.size.outerHeight;\n    var setMax = colSpan + colPosition.col;\n    for ( var i = colPosition.col; i < setMax; i++ ) {\n      this.colYs[i] = setHeight;\n    }\n\n    return position;\n  };\n\n  proto._getTopColPosition = function( colSpan ) {\n    var colGroup = this._getTopColGroup( colSpan );\n    // get the minimum Y value from the columns\n    var minimumY = Math.min.apply( Math, colGroup );\n\n    return {\n      col: colGroup.indexOf( minimumY ),\n      y: minimumY,\n    };\n  };\n\n  /**\n   * @param {Number} colSpan - number of columns the element spans\n   * @returns {Array} colGroup\n   */\n  proto._getTopColGroup = function( colSpan ) {\n    if ( colSpan < 2 ) {\n      // if brick spans only one column, use all the column Ys\n      return this.colYs;\n    }\n\n    var colGroup = [];\n    // how many different places could this brick fit horizontally\n    var groupCount = this.cols + 1 - colSpan;\n    // for each group potential horizontal position\n    for ( var i = 0; i < groupCount; i++ ) {\n      colGroup[i] = this._getColGroupY( i, colSpan );\n    }\n    return colGroup;\n  };\n\n  proto._getColGroupY = function( col, colSpan ) {\n    if ( colSpan < 2 ) {\n      return this.colYs[ col ];\n    }\n    // make an array of colY values for that one group\n    var groupColYs = this.colYs.slice( col, col + colSpan );\n    // and get the max value of the array\n    return Math.max.apply( Math, groupColYs );\n  };\n\n  // get column position based on horizontal index. #873\n  proto._getHorizontalColPosition = function( colSpan, item ) {\n    var col = this.horizontalColIndex % this.cols;\n    var isOver = colSpan > 1 && col + colSpan > this.cols;\n    // shift to next row if item can't fit on current row\n    col = isOver ? 0 : col;\n    // don't let zero-size items take up space\n    var hasSize = item.size.outerWidth && item.size.outerHeight;\n    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;\n\n    return {\n      col: col,\n      y: this._getColGroupY( col, colSpan ),\n    };\n  };\n\n  proto._manageStamp = function( stamp ) {\n    var stampSize = getSize( stamp );\n    var offset = this._getElementOffset( stamp );\n    // get the columns that this stamp affects\n    var isOriginLeft = this._getOption('originLeft');\n    var firstX = isOriginLeft ? offset.left : offset.right;\n    var lastX = firstX + stampSize.outerWidth;\n    var firstCol = Math.floor( firstX / this.columnWidth );\n    firstCol = Math.max( 0, firstCol );\n    var lastCol = Math.floor( lastX / this.columnWidth );\n    // lastCol should not go over if multiple of columnWidth #425\n    lastCol -= lastX % this.columnWidth ? 0 : 1;\n    lastCol = Math.min( this.cols - 1, lastCol );\n    // set colYs to bottom of the stamp\n\n    var isOriginTop = this._getOption('originTop');\n    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +\n      stampSize.outerHeight;\n    for ( var i = firstCol; i <= lastCol; i++ ) {\n      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );\n    }\n  };\n\n  proto._getContainerSize = function() {\n    this.maxY = Math.max.apply( Math, this.colYs );\n    var size = {\n      height: this.maxY\n    };\n\n    if ( this._getOption('fitWidth') ) {\n      size.width = this._getContainerFitWidth();\n    }\n\n    return size;\n  };\n\n  proto._getContainerFitWidth = function() {\n    var unusedCols = 0;\n    // count unused columns\n    var i = this.cols;\n    while ( --i ) {\n      if ( this.colYs[i] !== 0 ) {\n        break;\n      }\n      unusedCols++;\n    }\n    // fit container to columns that have been used\n    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;\n  };\n\n  proto.needsResizeLayout = function() {\n    var previousWidth = this.containerWidth;\n    this.getContainerWidth();\n    return previousWidth != this.containerWidth;\n  };\n\n  return Masonry;\n\n}));\n\n"

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(5)(__webpack_require__(60))

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "/*\n * jQuery.counter plugin\n *\n * Copyright (c) 2012 Sophilabs <hi@sophilabs.com>\n * MIT License\n */\n \n!(function (context, definition) {\n  if (typeof define == 'function' && typeof define.amd  == 'object') define(['jquery'], definition);\n  else definition(context['$']);\n}(this, function ($) {\n\n    var checkStop = function(data) {\n        var stop = 0;\n        var current = 0;\n        $.each(data.parts, function(i, part) {\n            stop += (stop * part.limit) + part.stop;\n            current += (current * part.limit) + part.value;\n        });\n        return data.down ? stop >= current : stop <= current;\n    };\n\n    var tick = function() {\n        var e = $(this);\n        var data = e.data('counter');\n        var i = data.parts.length - 1;\n        while(i >= 0) {\n            var part = data.parts[i];\n            part.value += data.down ? -1 : 1;\n            if (data.down && part.value < 0) {\n                part.value = part.limit;\n            } else if (!data.down && part.value > part.limit) {\n                part.value = 0;\n            } else {\n                break;\n            }\n            i--;\n        }\n        refresh(e, i);\n        if (checkStop(data)) {\n            clearInterval(data.intervalId);\n            e.trigger(\"counterStop\");\n        }\n    };\n\n    var refresh = function(e, to) {\n        var data = e.data('counter');\n        var i = data.parts.length - 1;\n        var animateIJ = function(j, digit) {\n            animate(e, i, j, digit);\n        };\n        while (i >= to) {\n            var part = data.parts[i];\n            var digits = part.value + '';\n            while (digits.length < part.padding) {\n                digits = '0' + digits;\n            }\n            $.each(split(digits, ''), animateIJ);\n            i--;\n        }\n    };\n\n    var animate = function(e, ipart, idigit, digit) {\n        var edigit = $($(e.children('span.part').get(ipart)).find('span.digit').get(idigit));\n        edigit.attr('class', 'digit digit' + digit +  ' digit' + edigit.text() + digit).text(digit);\n    };\n\n    //from http://blog.stevenlevithan.com/archives/cross-browser-split\n    var split = function(undef) {\n\n        var nativeSplit = String.prototype.split,\n            compliantExecNpcg = /()??/.exec(\"\")[1] === undef, // NPCG: nonparticipating capturing group\n            self;\n\n        self = function (str, separator, limit) {\n            // If `separator` is not a regex, use `nativeSplit`\n            if (Object.prototype.toString.call(separator) !== \"[object RegExp]\") {\n                return nativeSplit.call(str, separator, limit);\n            }\n            var output = [],\n                flags = (separator.ignoreCase ? \"i\" : \"\") +\n                        (separator.multiline  ? \"m\" : \"\") +\n                        (separator.extended   ? \"x\" : \"\") + // Proposed for ES6\n                        (separator.sticky     ? \"y\" : \"\"), // Firefox 3+\n                lastLastIndex = 0,\n                // Make `global` and avoid `lastIndex` issues by working with a copy\n                separator = new RegExp(separator.source, flags + \"g\"),\n                separator2, match, lastIndex, lastLength;\n            str += \"\"; // Type-convert\n            if (!compliantExecNpcg) {\n                // Doesn't need flags gy, but they don't hurt\n                separator2 = new RegExp(\"^\" + separator.source + \"$(?!\\\\s)\", flags);\n            }\n            /* Values for `limit`, per the spec:\n             * If undefined: 4294967295 // Math.pow(2, 32) - 1\n             * If 0, Infinity, or NaN: 0\n             * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;\n             * If negative number: 4294967296 - Math.floor(Math.abs(limit))\n             * If other: Type-convert, then use the above rules\n             */\n            limit = limit === undef ?\n                -1 >>> 0 : // Math.pow(2, 32) - 1\n                limit >>> 0; // ToUint32(limit)\n            while (match = separator.exec(str)) {\n                // `separator.lastIndex` is not reliable cross-browser\n                lastIndex = match.index + match[0].length;\n                if (lastIndex > lastLastIndex) {\n                    output.push(str.slice(lastLastIndex, match.index));\n                    // Fix browsers whose `exec` methods don't consistently return `undefined` for\n                    // nonparticipating capturing groups\n                    if (!compliantExecNpcg && match.length > 1) {\n                        match[0].replace(separator2, function () {\n                            for (var i = 1; i < arguments.length - 2; i++) {\n                                if (arguments[i] === undef) {\n                                    match[i] = undef;\n                                }\n                            }\n                        });\n                    }\n                    if (match.length > 1 && match.index < str.length) {\n                        Array.prototype.push.apply(output, match.slice(1));\n                    }\n                    lastLength = match[0].length;\n                    lastLastIndex = lastIndex;\n                    if (output.length >= limit) {\n                        break;\n                    }\n                }\n                if (separator.lastIndex === match.index) {\n                    separator.lastIndex++; // Avoid an infinite loop\n                }\n            }\n            if (lastLastIndex === str.length) {\n                if (lastLength || !separator.test(\"\")) {\n                    output.push(\"\");\n                }\n            } else {\n                output.push(str.slice(lastLastIndex));\n            }\n            return output.length > limit ? output.slice(0, limit) : output;\n        };\n        return self;\n    }();\n\n    var methods = {\n        init: function(options) {\n            options = options || {};\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter') || {};\n                data.interval = parseInt(options.interval || e.attr('data-interval') || '1000', 10);\n                data.down = (options.direction || e.attr('data-direction') || 'down') == 'down';\n                data.parts = [];\n                var initial = split(options.initial || e.text(), /([^0-9]+)/);\n                //WARN: Use attr() no data()\n                var format = split(options.format || e.attr('data-format') || \"23:59:59\", /([^0-9]+)/);\n                var stop =  options.stop || e.attr('data-stop');\n                if (stop) {\n                    stop = split(stop, /([^0-9]+)/);\n                }\n                e.html('');\n                $.each(format, function(index, value) {\n                    if (/^\\d+$/.test(value)) {\n                        var part = {};\n                        part.index = index;\n                        part.padding = (value + '').length;\n                        part.limit = parseInt(value, 10);\n                        part.value = parseInt(initial[initial.length - format.length + index] || 0, 10);\n                        part.value = part.value > part.limit ? part.limit : part.value;\n                        part.reset = part.value;\n                        part.stop = parseInt(stop ? stop[stop.length - format.length + index] : (data.down ? 0 : part.limit), 10);\n                        part.stop = part.stop > part.limit ? part.limit : part.stop;\n                        part.stop = part.stop < 0 ? 0 : part.stop;\n                        var epart = $('<span>').addClass('part').addClass('part' + index);\n                        var digits = part.value + '';\n                        while (digits.length < part.padding) {\n                            digits = '0' + digits;\n                        }\n                        $.each(split(digits, ''), function(dindex, dvalue){\n                            epart.append($('<span>').addClass('digit digit' + dvalue).text(dvalue));\n                        });\n                        e.append(epart);\n                        data.parts.push(part);\n                    } else {\n                        e.append($('<span>').addClass('separator').addClass('separator' + index).text(value));\n                    }\n                });\n                if (!checkStop(data)) {\n                    data.intervalId = setInterval($.proxy(tick, this), data.interval);\n                } else {\n                    e.trigger(\"counterStop\");\n                }\n                e.data('counter', data);\n                return this;\n            });\n        },\n        play: function() {\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter');\n                if (!data.intervalId) {\n                    data.intervalId = setInterval($.proxy(tick, this), data.interval);\n                }\n            });\n        },\n        reset: function() {\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter');\n                $.each(data.parts, function(pindex, pvalue){\n                    pvalue.value = pvalue.reset;\n                });\n                refresh($(this), 0);\n                if (data.intervalId) {\n                    clearInterval(data.intervalId);\n                    data.intervalId = setInterval($.proxy(tick, this), data.interval);\n                }\n            });\n        },\n        stop: function() {\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter');\n                clearInterval(data.intervalId);\n                data.intervalId = 0;\n                e.trigger(\"counterStop\");\n            });\n        }\n    };\n\n    $.fn.counter = function(method) {\n        // Method calling logic\n        if (methods[method]) {\n            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));\n        } else if (typeof method === 'object' || ! method) {\n            return methods.init.apply(this, arguments);\n        } else {\n            $.error('Method ' +  method + ' does not exist on jQuery.counter');\n        }\n    };\n\n}));\n"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Button 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/button/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(2),
			__webpack_require__(4),
			__webpack_require__(3)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var lastActive,
	baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
	typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
	formResetHandler = function() {
		var form = $( this );
		setTimeout(function() {
			form.find( ":ui-button" ).button( "refresh" );
		}, 1 );
	},
	radioGroup = function( radio ) {
		var name = radio.name,
			form = radio.form,
			radios = $( [] );
		if ( name ) {
			name = name.replace( /'/g, "\\'" );
			if ( form ) {
				radios = $( form ).find( "[name='" + name + "'][type=radio]" );
			} else {
				radios = $( "[name='" + name + "'][type=radio]", radio.ownerDocument )
					.filter(function() {
						return !this.form;
					});
			}
		}
		return radios;
	};

$.widget( "ui.button", {
	version: "1.11.4",
	defaultElement: "<button>",
	options: {
		disabled: null,
		text: true,
		label: null,
		icons: {
			primary: null,
			secondary: null
		}
	},
	_create: function() {
		this.element.closest( "form" )
			.unbind( "reset" + this.eventNamespace )
			.bind( "reset" + this.eventNamespace, formResetHandler );

		if ( typeof this.options.disabled !== "boolean" ) {
			this.options.disabled = !!this.element.prop( "disabled" );
		} else {
			this.element.prop( "disabled", this.options.disabled );
		}

		this._determineButtonType();
		this.hasTitle = !!this.buttonElement.attr( "title" );

		var that = this,
			options = this.options,
			toggleButton = this.type === "checkbox" || this.type === "radio",
			activeClass = !toggleButton ? "ui-state-active" : "";

		if ( options.label === null ) {
			options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
		}

		this._hoverable( this.buttonElement );

		this.buttonElement
			.addClass( baseClasses )
			.attr( "role", "button" )
			.bind( "mouseenter" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				if ( this === lastActive ) {
					$( this ).addClass( "ui-state-active" );
				}
			})
			.bind( "mouseleave" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( activeClass );
			})
			.bind( "click" + this.eventNamespace, function( event ) {
				if ( options.disabled ) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			});

		// Can't use _focusable() because the element that receives focus
		// and the element that gets the ui-state-focus class are different
		this._on({
			focus: function() {
				this.buttonElement.addClass( "ui-state-focus" );
			},
			blur: function() {
				this.buttonElement.removeClass( "ui-state-focus" );
			}
		});

		if ( toggleButton ) {
			this.element.bind( "change" + this.eventNamespace, function() {
				that.refresh();
			});
		}

		if ( this.type === "checkbox" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
			});
		} else if ( this.type === "radio" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
				$( this ).addClass( "ui-state-active" );
				that.buttonElement.attr( "aria-pressed", "true" );

				var radio = that.element[ 0 ];
				radioGroup( radio )
					.not( radio )
					.map(function() {
						return $( this ).button( "widget" )[ 0 ];
					})
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			});
		} else {
			this.buttonElement
				.bind( "mousedown" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).addClass( "ui-state-active" );
					lastActive = this;
					that.document.one( "mouseup", function() {
						lastActive = null;
					});
				})
				.bind( "mouseup" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).removeClass( "ui-state-active" );
				})
				.bind( "keydown" + this.eventNamespace, function(event) {
					if ( options.disabled ) {
						return false;
					}
					if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
						$( this ).addClass( "ui-state-active" );
					}
				})
				// see #8559, we bind to blur here in case the button element loses
				// focus between keydown and keyup, it would be left in an "active" state
				.bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
					$( this ).removeClass( "ui-state-active" );
				});

			if ( this.buttonElement.is("a") ) {
				this.buttonElement.keyup(function(event) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						// TODO pass through original event correctly (just as 2nd argument doesn't work)
						$( this ).click();
					}
				});
			}
		}

		this._setOption( "disabled", options.disabled );
		this._resetButton();
	},

	_determineButtonType: function() {
		var ancestor, labelSelector, checked;

		if ( this.element.is("[type=checkbox]") ) {
			this.type = "checkbox";
		} else if ( this.element.is("[type=radio]") ) {
			this.type = "radio";
		} else if ( this.element.is("input") ) {
			this.type = "input";
		} else {
			this.type = "button";
		}

		if ( this.type === "checkbox" || this.type === "radio" ) {
			// we don't search against the document in case the element
			// is disconnected from the DOM
			ancestor = this.element.parents().last();
			labelSelector = "label[for='" + this.element.attr("id") + "']";
			this.buttonElement = ancestor.find( labelSelector );
			if ( !this.buttonElement.length ) {
				ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
				this.buttonElement = ancestor.filter( labelSelector );
				if ( !this.buttonElement.length ) {
					this.buttonElement = ancestor.find( labelSelector );
				}
			}
			this.element.addClass( "ui-helper-hidden-accessible" );

			checked = this.element.is( ":checked" );
			if ( checked ) {
				this.buttonElement.addClass( "ui-state-active" );
			}
			this.buttonElement.prop( "aria-pressed", checked );
		} else {
			this.buttonElement = this.element;
		}
	},

	widget: function() {
		return this.buttonElement;
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-helper-hidden-accessible" );
		this.buttonElement
			.removeClass( baseClasses + " ui-state-active " + typeClasses )
			.removeAttr( "role" )
			.removeAttr( "aria-pressed" )
			.html( this.buttonElement.find(".ui-button-text").html() );

		if ( !this.hasTitle ) {
			this.buttonElement.removeAttr( "title" );
		}
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "disabled" ) {
			this.widget().toggleClass( "ui-state-disabled", !!value );
			this.element.prop( "disabled", !!value );
			if ( value ) {
				if ( this.type === "checkbox" || this.type === "radio" ) {
					this.buttonElement.removeClass( "ui-state-focus" );
				} else {
					this.buttonElement.removeClass( "ui-state-focus ui-state-active" );
				}
			}
			return;
		}
		this._resetButton();
	},

	refresh: function() {
		//See #8237 & #8828
		var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOption( "disabled", isDisabled );
		}
		if ( this.type === "radio" ) {
			radioGroup( this.element[0] ).each(function() {
				if ( $( this ).is( ":checked" ) ) {
					$( this ).button( "widget" )
						.addClass( "ui-state-active" )
						.attr( "aria-pressed", "true" );
				} else {
					$( this ).button( "widget" )
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				}
			});
		} else if ( this.type === "checkbox" ) {
			if ( this.element.is( ":checked" ) ) {
				this.buttonElement
					.addClass( "ui-state-active" )
					.attr( "aria-pressed", "true" );
			} else {
				this.buttonElement
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			}
		}
	},

	_resetButton: function() {
		if ( this.type === "input" ) {
			if ( this.options.label ) {
				this.element.val( this.options.label );
			}
			return;
		}
		var buttonElement = this.buttonElement.removeClass( typeClasses ),
			buttonText = $( "<span></span>", this.document[0] )
				.addClass( "ui-button-text" )
				.html( this.options.label )
				.appendTo( buttonElement.empty() )
				.text(),
			icons = this.options.icons,
			multipleIcons = icons.primary && icons.secondary,
			buttonClasses = [];

		if ( icons.primary || icons.secondary ) {
			if ( this.options.text ) {
				buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
			}

			if ( icons.primary ) {
				buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
			}

			if ( icons.secondary ) {
				buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
			}

			if ( !this.options.text ) {
				buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );

				if ( !this.hasTitle ) {
					buttonElement.attr( "title", $.trim( buttonText ) );
				}
			}
		} else {
			buttonClasses.push( "ui-button-text-only" );
		}
		buttonElement.addClass( buttonClasses.join( " " ) );
	}
});

$.widget( "ui.buttonset", {
	version: "1.11.4",
	options: {
		items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
	},

	_create: function() {
		this.element.addClass( "ui-buttonset" );
	},

	_init: function() {
		this.refresh();
	},

	_setOption: function( key, value ) {
		if ( key === "disabled" ) {
			this.buttons.button( "option", key, value );
		}

		this._super( key, value );
	},

	refresh: function() {
		var rtl = this.element.css( "direction" ) === "rtl",
			allButtons = this.element.find( this.options.items ),
			existingButtons = allButtons.filter( ":ui-button" );

		// Initialize new buttons
		allButtons.not( ":ui-button" ).button();

		// Refresh existing buttons
		existingButtons.button( "refresh" );

		this.buttons = allButtons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
				.filter( ":first" )
					.addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
				.end()
				.filter( ":last" )
					.addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
				.end()
			.end();
	},

	_destroy: function() {
		this.element.removeClass( "ui-buttonset" );
		this.buttons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-left ui-corner-right" )
			.end()
			.button( "destroy" );
	}
});

return $.ui.button;

}));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Draggable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(2),
			__webpack_require__(4),
			__webpack_require__(6),
			__webpack_require__(3)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.draggable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if (this.options.addClasses){
			this.element.addClass("ui-draggable");
		}
		if (this.options.disabled){
			this.element.addClass("ui-draggable-disabled");
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function(event) {
		var o = this.options;

		this._blurActiveElement( event );

		// among others, prevent a drag on a resizable-handle
		if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle(event);
		if (!this.handle) {
			return false;
		}

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var document = this.document[ 0 ];

		// Only need to blur if the event occurred on the draggable itself, see #10527
		if ( !this.handleElement.is( event.target ) ) {
			return;
		}

		// support: IE9
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {

			// Support: IE9, IE10
			// If the <body> is blurred, IE will switch windows, see #9520
			if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {

				// Blur any element that currently has focus, see #4261
				$( document.activeElement ).blur();
			}
		} catch ( error ) {}
	},

	_mouseStart: function(event) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		this.helper.addClass("ui-draggable-dragging");

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter(function() {
				return $( this ).css( "position" ) === "fixed";
			}).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if (this._trigger("start", event) === false) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		// Reset helper's right/bottom css if they're set and set explicit width/height instead
		// as this prevents resizing of elements with right/bottom set (see #7772)
		this._normalizeRightBottom();

		this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

		//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart(this, event);
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function(event, noPropagation) {
		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo("absolute");

		//Call plugins and callbacks and use the resulting position if something is returned
		if (!noPropagation) {
			var ui = this._uiHash();
			if (this._trigger("drag", event, ui) === false) {
				this._mouseUp({});
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		return false;
	},

	_mouseStop: function(event) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			dropped = $.ui.ddmanager.drop(this, event);
		}

		//if a drop comes from outside (a sortable)
		if (this.dropped) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
			$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
				if (that._trigger("stop", event) !== false) {
					that._clear();
				}
			});
		} else {
			if (this._trigger("stop", event) !== false) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop(this, event);
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {
			// The interaction is over; whether or not the click resulted in a drag, focus the element
			this.element.focus();
		}

		return $.ui.mouse.prototype._mouseUp.call(this, event);
	},

	cancel: function() {

		if (this.helper.is(".ui-draggable-dragging")) {
			this._mouseUp({});
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function(event) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this.handleElement.addClass( "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this.handleElement.removeClass( "ui-draggable-handle" );
	},

	_createHelper: function(event) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if (!helper.parents("body").length) {
			helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
		}

		// http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
			helper.css("position", "absolute");
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = { left: +obj[0], top: +obj[1] || 0 };
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.element.css("marginLeft"), 10) || 0),
			top: (parseInt(this.element.css("marginTop"), 10) || 0),
			right: (parseInt(this.element.css("marginRight"), 10) || 0),
			bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document") {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function(d, pos) {

		if (!pos) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ){
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if (event.pageX - this.offset.click.left < containment[0]) {
					pageX = containment[0] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top < containment[1]) {
					pageY = containment[1] + this.offset.click.top;
				}
				if (event.pageX - this.offset.click.left > containment[2]) {
					pageX = containment[2] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top > containment[3]) {
					pageY = containment[3] + this.offset.click.top;
				}
			}

			if (o.grid) {
				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
				top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
				pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
				pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (
				pageY -																	// The absolute mouse position
				this.offset.click.top	-												// Click offset (relative to the element)
				this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (
				pageX -																	// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this.helper.removeClass("ui-draggable-dragging");
		if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	_normalizeRightBottom: function() {
		if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
			this.helper.width( this.helper.width() );
			this.helper.css( "right", "auto" );
		}
		if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
			this.helper.height( this.helper.height() );
			this.helper.css( "bottom", "auto" );
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

});

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each(function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// refreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger("activate", event, uiSortable);
			}
		});
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop(event);

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {
				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		});
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {
					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				});
			}

			if ( innermostIntersecting ) {
				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});

					// hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );
					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {
				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});
				}
			}
		});
	}
});

$.ui.plugin.add("draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if (t.css("cursor")) {
			o._cursor = t.css("cursor");
		}
		t.css("cursor", o.cursor);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._cursor) {
			$("body").css("cursor", o._cursor);
		}
	}
});

$.ui.plugin.add("draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if (t.css("opacity")) {
			o._opacity = t.css("opacity");
		}
		t.css("opacity", o.opacity);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._opacity) {
			$(ui.helper).css("opacity", o._opacity);
		}
	}
});

$.ui.plugin.add("draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if (!o.axis || o.axis !== "x") {
				if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
				}
			}

			if (!o.axis || o.axis !== "y") {
				if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
				}
			}

		}

		if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(i, event);
		}

	}
});

$.ui.plugin.add("draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
			var $t = $(this),
				$o = $t.offset();
			if (this !== i.element[0]) {
				i.snapElements.push({
					item: this,
					width: $t.outerWidth(), height: $t.outerHeight(),
					top: $o.top, left: $o.left
				});
			}
		});

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for (i = inst.snapElements.length - 1; i >= 0; i--){

			l = inst.snapElements[i].left - inst.margins.left;
			r = l + inst.snapElements[i].width;
			t = inst.snapElements[i].top - inst.margins.top;
			b = t + inst.snapElements[i].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
				if (inst.snapElements[i].snapping) {
					(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = false;
				continue;
			}

			if (o.snapMode !== "inner") {
				ts = Math.abs(t - y2) <= d;
				bs = Math.abs(b - y1) <= d;
				ls = Math.abs(l - x2) <= d;
				rs = Math.abs(r - x1) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
				}
			}

			first = (ts || bs || ls || rs);

			if (o.snapMode !== "outer") {
				ts = Math.abs(t - y1) <= d;
				bs = Math.abs(b - y2) <= d;
				ls = Math.abs(l - x1) <= d;
				rs = Math.abs(r - x2) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
				}
			}

			if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
				(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
			}
			inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

		}

	}
});

$.ui.plugin.add("draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray($(o.stack)).sort(function(a, b) {
				return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
			});

		if (!group.length) { return; }

		min = parseInt($(group[0]).css("zIndex"), 10) || 0;
		$(group).each(function(i) {
			$(this).css("zIndex", min + i);
		});
		this.css("zIndex", (min + group.length));
	}
});

$.ui.plugin.add("draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if (t.css("zIndex")) {
			o._zIndex = t.css("zIndex");
		}
		t.css("zIndex", o.zIndex);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if (o._zIndex) {
			$(ui.helper).css("zIndex", o._zIndex);
		}
	}
});

return $.ui.draggable;

}));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Position 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {
(function() {

$.ui = $.ui || {};

var cachedScrollbarWidth, supportsOffsetFractions,
	max = Math.max,
	abs = Math.abs,
	round = Math.round,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[0];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[0];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[0].clientWidth;
		}

		div.remove();

		return (cachedScrollbarWidth = w1 - w2);
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[0].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[0] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: withinElement.offset() || { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),

			// support: jQuery 1.6.x
			// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
			width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
			height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[0].preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;
	// clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each(function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		// if the browser doesn't support fractions, then round for consistent results
		if ( !supportsOffsetFractions ) {
			position.left = round( position.left );
			position.top = round( position.top );
		}

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				});
			}
		});

		if ( options.using ) {
			// adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// element is wider than within
			if ( data.collisionWidth > outerWidth ) {
				// element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
					position.left += overLeft - newOverRight;
				// element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;
				// element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}
			// too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;
			// too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;
			// adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// element is taller than within
			if ( data.collisionHeight > outerHeight ) {
				// element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
					position.top += overTop - newOverBottom;
				// element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;
				// element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}
			// too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;
			// too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;
			// adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

// fraction support test
(function() {
	var testElement, testElementParent, testElementStyle, offsetLeft, i,
		body = document.getElementsByTagName( "body" )[ 0 ],
		div = document.createElement( "div" );

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px;";

	offsetLeft = $( div ).offset().left;
	supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );
})();

})();

return $.ui.position;

}));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Resizable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/resizable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(2),
			__webpack_require__(4),
			__webpack_require__(6),
			__webpack_require__(3)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.resizable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,
		// See #7960
		zIndex: 90,

		// callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseInt( value, 10 ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseInt( value, 10 ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden") {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var n, i, handle, axis, hname,
			that = this,
			o = this.options;
		this.element.addClass("ui-resizable");

		$.extend(this, {
			_aspectRatio: !!(o.aspectRatio),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		});

		// Wrap the element if it cannot hold child nodes
		if (this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)) {

			this.element.wrap(
				$("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
					position: this.element.css("position"),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css("top"),
					left: this.element.css("left")
				})
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			this.element.css({
				marginLeft: this.originalElement.css("marginLeft"),
				marginTop: this.originalElement.css("marginTop"),
				marginRight: this.originalElement.css("marginRight"),
				marginBottom: this.originalElement.css("marginBottom")
			});
			this.originalElement.css({
				marginLeft: 0,
				marginTop: 0,
				marginRight: 0,
				marginBottom: 0
			});
			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css("resize");
			this.originalElement.css("resize", "none");

			this._proportionallyResizeElements.push( this.originalElement.css({
				position: "static",
				zoom: 1,
				display: "block"
			}) );

			// support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css({ margin: this.originalElement.css("margin") });

			this._proportionallyResize();
		}

		this.handles = o.handles ||
			( !$(".ui-resizable-handle", this.element).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all") {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split(",");
			this.handles = {};

			for (i = 0; i < n.length; i++) {

				handle = $.trim(n[i]);
				hname = "ui-resizable-" + handle;
				axis = $("<div class='ui-resizable-handle " + hname + "'></div>");

				axis.css({ zIndex: o.zIndex });

				// TODO : What's going on here?
				if ("se" === handle) {
					axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
				}

				this.handles[handle] = ".ui-resizable-" + handle;
				this.element.append(axis);
			}

		}

		this._renderAxis = function(target) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for (i in this.handles) {

				if (this.handles[i].constructor === String) {
					this.handles[i] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown });
				}

				if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)) {

					axis = $(this.handles[i], this.element);

					padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test(i) ? "Top" :
						/se|sw|s/.test(i) ? "Bottom" :
						/^e$/.test(i) ? "Right" : "Left" ].join("");

					target.css(padPos, padWrapper);

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis(this.element);

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.mouseover(function() {
			if (!that.resizing) {
				if (this.className) {
					axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
				}
				that.axis = axis && axis[1] ? axis[1] : "se";
			}
		});

		if (o.autoHide) {
			this._handles.hide();
			$(this.element)
				.addClass("ui-resizable-autohide")
				.mouseenter(function() {
					if (o.disabled) {
						return;
					}
					$(this).removeClass("ui-resizable-autohide");
					that._handles.show();
				})
				.mouseleave(function() {
					if (o.disabled) {
						return;
					}
					if (!that.resizing) {
						$(this).addClass("ui-resizable-autohide");
						that._handles.hide();
					}
				});
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function(exp) {
				$(exp)
					.removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
					.removeData("resizable")
					.removeData("ui-resizable")
					.unbind(".resizable")
					.find(".ui-resizable-handle")
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if (this.elementIsWrapper) {
			_destroy(this.element);
			wrapper = this.element;
			this.originalElement.css({
				position: wrapper.css("position"),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css("top"),
				left: wrapper.css("left")
			}).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css("resize", this.originalResizeStyle);
		_destroy(this.originalElement);

		return this;
	},

	_mouseCapture: function(event) {
		var i, handle,
			capture = false;

		for (i in this.handles) {
			handle = $(this.handles[i])[0];
			if (handle === event.target || $.contains(handle, event.target)) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function(event) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num(this.helper.css("left"));
		curtop = this._num(this.helper.css("top"));

		if (o.containment) {
			curleft += $(o.containment).scrollLeft() || 0;
			curtop += $(o.containment).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = (typeof o.aspectRatio === "number") ?
			o.aspectRatio :
			((this.originalSize.width / this.originalSize.height) || 1);

		cursor = $(".ui-resizable-" + this.axis).css("cursor");
		$("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);

		el.addClass("ui-resizable-resizing");
		this._propagate("start", event);
		return true;
	},

	_mouseDrag: function(event) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = (event.pageX - smp.left) || 0,
			dy = (event.pageY - smp.top) || 0,
			trigger = this._change[a];

		this._updatePrevProperties();

		if (!trigger) {
			return false;
		}

		data = trigger.apply(this, [ event, dx, dy ]);

		this._updateVirtualBoundaries(event.shiftKey);
		if (this._aspectRatio || event.shiftKey) {
			data = this._updateRatio(data, event);
		}

		data = this._respectSize(data, event);

		this._updateCache(data);

		this._propagate("resize", event);

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function(event) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if (this._helper) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && (/textarea/i).test(pr[0].nodeName);
			soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: (that.helper.width()  - soffsetw),
				height: (that.helper.height() - soffseth)
			};
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null;
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

			if (!o.animate) {
				this.element.css($.extend(s, { top: top, left: left }));
			}

			that.helper.height(that.size.height);
			that.helper.width(that.size.width);

			if (this._helper && !o.animate) {
				this._proportionallyResize();
			}
		}

		$("body").css("cursor", "auto");

		this.element.removeClass("ui-resizable-resizing");

		this._propagate("stop", event);

		if (this._helper) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function(forceAspectRatio) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
			maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
			minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
			maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
		};

		if (this._aspectRatio || forceAspectRatio) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if (pMinWidth > b.minWidth) {
				b.minWidth = pMinWidth;
			}
			if (pMinHeight > b.minHeight) {
				b.minHeight = pMinHeight;
			}
			if (pMaxWidth < b.maxWidth) {
				b.maxWidth = pMaxWidth;
			}
			if (pMaxHeight < b.maxHeight) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function(data) {
		this.offset = this.helper.offset();
		if (this._isNumber(data.left)) {
			this.position.left = data.left;
		}
		if (this._isNumber(data.top)) {
			this.position.top = data.top;
		}
		if (this._isNumber(data.height)) {
			this.size.height = data.height;
		}
		if (this._isNumber(data.width)) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if (this._isNumber(data.height)) {
			data.width = (data.height * this.aspectRatio);
		} else if (this._isNumber(data.width)) {
			data.height = (data.width / this.aspectRatio);
		}

		if (a === "sw") {
			data.left = cpos.left + (csize.width - data.width);
			data.top = null;
		}
		if (a === "nw") {
			data.top = cpos.top + (csize.height - data.height);
			data.left = cpos.left + (csize.width - data.width);
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width),
			ismaxh = this._isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
			isminw = this._isNumber(data.width) && o.minWidth && (o.minWidth > data.width),
			isminh = this._isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.position.top + this.size.height,
			cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
		if (isminw) {
			data.width = o.minWidth;
		}
		if (isminh) {
			data.height = o.minHeight;
		}
		if (ismaxw) {
			data.width = o.maxWidth;
		}
		if (ismaxh) {
			data.height = o.maxHeight;
		}

		if (isminw && cw) {
			data.left = dw - o.minWidth;
		}
		if (ismaxw && cw) {
			data.left = dw - o.maxWidth;
		}
		if (isminh && ch) {
			data.top = dh - o.minHeight;
		}
		if (ismaxh && ch) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if (!data.width && !data.height && !data.left && data.top) {
			data.top = null;
		} else if (!data.width && !data.height && !data.top && data.left) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseInt( borders[ i ], 10 ) || 0 );
			widths[ i ] += ( parseInt( paddings[ i ], 10 ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if (!this._proportionallyResizeElements.length) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++) {

			prel = this._proportionallyResizeElements[i];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if (!this.outerDimensions) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css({
				height: (element.height() - this.outerDimensions.height) || 0,
				width: (element.width() - this.outerDimensions.width) || 0
			});

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if (this._helper) {

			this.helper = this.helper || $("<div style='overflow:hidden;'></div>");

			this.helper.addClass(this._helper).css({
				width: this.element.outerWidth() - 1,
				height: this.element.outerHeight() - 1,
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			});

			this.helper
				.appendTo("body")
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function(event, dx) {
			return { width: this.originalSize.width + dx };
		},
		w: function(event, dx) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function(event, dx, dy) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function(event, dx, dy) {
			return { height: this.originalSize.height + dy };
		},
		se: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		sw: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		},
		ne: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		nw: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		}
	},

	_propagate: function(n, event) {
		$.ui.plugin.call(this, n, [ event, this.ui() ]);
		(n !== "resize" && this._trigger(n, event, this.ui()));
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

});

/*
 * Resizable Extensions
 */

$.ui.plugin.add("resizable", "animate", {

	stop: function( event ) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && (/textarea/i).test(pr[0].nodeName),
			soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null,
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

		that.element.animate(
			$.extend(style, top && left ? { top: top, left: left } : {}), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseInt(that.element.css("width"), 10),
						height: parseInt(that.element.css("height"), 10),
						top: parseInt(that.element.css("top"), 10),
						left: parseInt(that.element.css("left"), 10)
					};

					if (pr && pr.length) {
						$(pr[0]).css({ width: data.width, height: data.height });
					}

					// propagating resize, and updating values for each animation step
					that._updateCache(data);
					that._propagate("resize", event);

				}
			}
		);
	}

});

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ? oc.get( 0 ) : ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$([ "Top", "Right", "Left", "Bottom" ]).each(function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			});

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			(that._helper ?
				that.offset.left - cop.left :
				(that.offset.left - co.left)) );

		hoset = Math.abs( that.sizeDiff.height +
			(that._helper ?
				that.offset.top - cop.top :
				(that.offset.top - co.top)) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}
	}
});

$.ui.plugin.add("resizable", "alsoResize", {

	start: function() {
		var that = $(this).resizable( "instance" ),
			o = that.options;

		$(o.alsoResize).each(function() {
			var el = $(this);
			el.data("ui-resizable-alsoresize", {
				width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
				left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
			});
		});
	},

	resize: function(event, ui) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: (that.size.height - os.height) || 0,
				width: (that.size.width - os.width) || 0,
				top: (that.position.top - op.top) || 0,
				left: (that.position.left - op.left) || 0
			};

			$(o.alsoResize).each(function() {
				var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
					css = el.parents(ui.originalElement[0]).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each(css, function(i, prop) {
					var sum = (start[prop] || 0) + (delta[prop] || 0);
					if (sum && sum >= 0) {
						style[prop] = sum || null;
					}
				});

				el.css(style);
			});
	},

	stop: function() {
		$(this).removeData("resizable-alsoresize");
	}
});

$.ui.plugin.add("resizable", "ghost", {

	start: function() {

		var that = $(this).resizable( "instance" ), o = that.options, cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost
			.css({
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			})
			.addClass("ui-resizable-ghost")
			.addClass(typeof o.ghost === "string" ? o.ghost : "");

		that.ghost.appendTo(that.helper);

	},

	resize: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost) {
			that.ghost.css({
				position: "relative",
				height: that.size.height,
				width: that.size.width
			});
		}
	},

	stop: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost && that.helper) {
			that.helper.get(0).removeChild(that.ghost.get(0));
		}
	}

});

$.ui.plugin.add("resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $(this).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = (grid[0] || 1),
			gridY = (grid[1] || 1),
			ox = Math.round((cs.width - os.width) / gridX) * gridX,
			oy = Math.round((cs.height - os.height) / gridY) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
			isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
			isMinWidth = o.minWidth && (o.minWidth > newWidth),
			isMinHeight = o.minHeight && (o.minHeight > newHeight);

		o.grid = grid;

		if (isMinWidth) {
			newWidth += gridX;
		}
		if (isMinHeight) {
			newHeight += gridY;
		}
		if (isMaxWidth) {
			newWidth -= gridX;
		}
		if (isMaxHeight) {
			newHeight -= gridY;
		}

		if (/^(se|s|e)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if (/^(ne)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if (/^(sw)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

});

return $.ui.resizable;

}));


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('Autocomplete2', {

		configure: function (argument) {
			this.searchStr = '';
			this.responseData = [];
			this.inputTimer = null;
			this.filteredData = null;

			this.registerOptions('', {
				//useCache: false,
				searchParam: 'name',
				hightlightSelector: '.name',
				loadAll: false,
				staticFilter: false,
				filterParam: 'alias',

				widgets: {
					api: {
						widget: 'Api',
						method: 'Portal.searchModels'
					},

					input: {
						widget: 'Widget',
						autoRender: true,
						container: '.form-group.search',
						template: 'catalog_search_input'
					},

					list: {
						widget: 'List',
						autoRender: false,
						embed: {
							widget: '@parent #input',
							container: '[fox-autocomplete-result-list]'
						},
						'tpl.row': 'catalog_search_item',
						'hooks.onAddedToDom': fox.bind(function () {
							this._listAdded();
						}, this)
					}
				},

				handleWom: {
					handleApiStateChange: {
						widget: '#api',
						event: ['prepare', 'success', 'failure', 'loading', 'loaded', 'loadError'],
						callback: '_handleApiStateChange'
					},
					searchFailure: {
						widget: '@this',
						event: ['search_failure'],
						callback: '_handleSearchFailure'
					},
					searchSuccess: {
						widget: '@this',
						event: ['search_success'],
						callback: '_handleSearchSuccess'
					},
					itemSelected: {
						widget: '@this',
						event: ['item_selected'],
						callback: '_handleItemSelect'
					},
					inputEmptyState: {
						widget: '@this',
						event: ['inputEmpty', 'inputNotEmpty'],
						callback: '_handleInputEmptyState'
					}
				},

				handleDom: {
					selectFromList: {
						targetWidget: '#list',
						target: '[fox-autocomplete-result-item]',
						event: 'click',
						callback: '_handleSelectClick'
					},
					searchFormSubmit: {
						targetWidget: '#input',
						target: 'form[fox-autocomplete-form]',
						event: 'submit',
						callback: '_onFormSubmit'
					},
					searchFormSubmit2: {
						targetWidget: '#input',
						target: '.icon.search-start',
						event: 'click',
						callback: '_onFormSubmit'
					},
					inputChange: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'input',
						callback: '_handleInputChange'
					},
					clear: {
						targetWidget: '#input',
						target: '.icon.clear',
						event: 'click',
						callback: 'clear'
					},
					_bindKeyboardEvents: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'focus',
						callback: '_bindKeyboardEvents'
					},
					// _bindKeyboardEvents2: {
					// 	targetWidget: '#input',
					// 	target: '[fox-autocomplete-input]',
					// 	click: 'click',
					// 	callback: function (el, alias, w, e) {
					// 		fox.dom.event.stop(e);

					// 		return false;
					// 	}
					// },
					_unbindKeyboardEvents: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'blur',
						callback: '_unbindKeyboardEvents'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.api = this.rwom1('#api');
			this.input = this.rwom1('#input');
			this.resultList = this.rwom1('#list');
			this.hightlightSelector = this.getOption('hightlightSelector');
			this.useCache = false;
			this.isOpened = false;

			this.isFirstLoad = true;

			/*if (this.getOption('useCache')) {
				this.enableCache();
			}*/

			if (this.getOption('loadAll')) {
				this.loadAll();
			}

			//this._bindWindowEvents();

			this.callParent('running', arguments);
		},

		activate: function (argument) {
			//this._bindWindowEvents();

			this.callParent('activate', arguments);
			
			if (this.getOption('loadAll')) {
				this.loadAll();
			}
		},

		deactivate: function (argument) {
			//this._unbindWindowEvents();
			this.reset();
			this._hideList();
			this.callParent('deactivate', arguments);
		},

		reset: function (argument) {
			this.fillInput('');
			this.resultList.setCollection(this.responseData);

			this.searchStr = '';
			this.cachedData = {};

			this.isFirstLoad = true;

			if (!this.getOption('staticFilter')) {
				this.responseData = {};
				this.resultList.setCollection([]);
			}
		},

		enableCache: function () {
			this.clearCache();
			this.useCache = true;
		},

		disableCache: function () {
			delete this.cachedData;

			this.useCache = false;
		},

		clearCache: function () {
			this.cachedData = {};
		},

		getCachedData: function () {
			return this.cachedData;
		},

		prepareSearchParams: function (value) {
			var params = {};
			
			if (this.apiIsDl()) {
				//set params for datalayer

				return {};
			}

			params[this.getOption('searchParam')] = value;

			return params;
		},

		loadData: function (value) {
			var params = this.prepareSearchParams(value);

			if (this.apiIsDl()) {
				this.prepareSearchParams(value);
				this.api.load();

				return;
			}

			this.api.send(params);
		},

		_loadAll: function () {
			this.hookWrapper('loadAll');
		},

		loadAll: function () {
			this.loadData('');
			//this.waitEvent(this, ['search_success'], this._handleLoadAll)
		},

		search: function (value) {
			//this.searchStr = value;

			if (this.useCache && this.isInCache(value)) {
				this.getFromCache(value);

				return;
			}

			this.loadData(value);
		},

		clear: function () {
			this.fillInput('');
			this.clickedNode = null;
			this._hideList();
			this.dispatchEvent('search_form_submit');

			this.isFirstLoad = true;

			if (this.getOption('loadAll')) {
				this.loadAll();
			}
		},

		_onFormSubmit: function (el, w, alias, e) {
			fox.dom.event.stop(e);

			if (this.listPointer < 0) {
				this.dispatchEvent('search_form_submit');
				this.hideList();
			}

			return false;
		},

		getSearchString: function (argument) {
			return this.searchStr;
		},

		isInCache: function (value) {
			return this.cachedData[value] || false;
		},

		getFromCache: function (value) {
			////console.log('from cache', this.cachedData[value]);
			this.responseData = this.cachedData[value];

			this.dispatchEvent('search_success', this.responseData);
		},

		_handleApiStateChange: function (response, api, e) {
			if (fox.inArray(['prepare', 'loading'], e)) {
				this._showLoader();
				this.apiInProgress = true;

				return;
			}

			this._hideLoader();
			this.apiInProgress = false;

			var answer = response.answer;

			if (fox.inArray(['failure', 'error', 'loadError'], e)) {
				this.dispatchEvent('search_failure', answer);

				return;
			}

			if (this.useCache) {
				this.cachedData[this.searchStr] = answer.response;
			}

			this.responseData = this.apiIsDl() ? api.getCollection() : answer.response;

			this.isFirstLoad = false;

			this.hookWrapper('prepareResponse');

			if (!fox.isArray(this.responseData)) {
				this.responseData = fox.toArray(this.responseData);
			}

			if (!this.getOption('staticFilter')) {
				this.dispatchEvent('search_success', this.responseData);

				return;
			}

			this.filteredData = fox.clone(this.responseData);
			this.dispatchEvent('search_success', this.filteredData);
		},

		_showLoader: function () {
			this.dispatchEvent('loader_show');
			this.hookWrapper('toggleLoader', true);
		},

		_hideLoader: function () {
			this.dispatchEvent('loader_hide');
			this.hookWrapper('toggleLoader', false);
		},

		toggleLoader: function (state) {
			var loader = this.input.dom1('.preloader');

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', loader);
		},

		_showList: function () {
			if (!this.responseData.length) {
				return;
			}

			if (this.getOption('staticFilter') && !this.filteredData.length) {
				return;
			}

			this._bindWindowEvents();
			this.hookWrapper('showList');
			this.isOpened = true;
		},

		showList: function () {
			////console.warn('show list');
			fox.dom.addClass('show', this.input.dom1('.autocomplete-list'));
		},

		_hideList: function () {
			this.hookWrapper('hideList');
			this.isOpened = false;
			this._unbindWindowEvents();
		},

		hideList: function () {
			////console.warn('hide list');
			fox.dom.removeClass('show', this.input.dom1('.autocomplete-list'));
		},

		_handleSearchFailure: function (answer) {
			////console.warn(arguments);
		},

		_handleSearchSuccess: function (data) {
			this.renderResultList(data);
		},

		renderResultList: function (data) {
			this.resultList.setCollection(data, true);
		},

		_handleSelectClick: function (elm, alias, w, e) {
			fox.dom.event.stop(e);

			this.clickedNode = elm;
			this.dispatchEvent('item_selected', elm);

			if (this.getOption('staticFilter')) {
				return;
			}

			this._hideList();
		},

		_handleItemSelect: function (node) {
			this.hookWrapper('select', node);
		},

		_listAdded: function () {
			this.listPointer = -1;

			if (this.getOption('staticFilter')) {
				this._staticListAdded();

				return;
			}

			if (this.responseData && this.responseData.length) {
				this.resultItems = this.resultList.dom('[fox-autocomplete-result-item]');

				if (this.getOption('loadAll') && this.isFirstLoad === true) {
					return;
				}

				if (this.isFocus) {
					this._showList();
				}
				
				this.hightlightResult();

				return;
			}

			this._hideList();
			this.resultItems = [];
		},

		_staticListAdded: function () {
			this.resultItems = [];

			if (!!this.filteredData && this.filteredData.length) {
				this.resultItems = this.resultList.dom('[fox-autocomplete-result-item]');

				return;
			}

			this._hideList();
		},

		select: function (node) {
			this.dispatchEvent('search_form_submit');

			this.fillInput($(this.clickedNode).attr('fox-autocomplete-search-result'));
			this.hideList();
		},

		fillInput: function (str) {
			var elm = this.input.dom1('[fox-autocomplete-input]');
			elm[elm.tagName.toLocaleLowerCase() === 'input' ? 'value' : 'innerText'] = str;
			this.searchStr = str;

			this.dispatchEvent(str.length > 0 ? 'inputNotEmpty' : 'inputEmpty');
		},

		_handleInputChange: function (el) {
			var str = el.tagName.toLocaleLowerCase() === 'input' ? fox.trim(el.value) : fox.trim(el.innerText);

			if (this.apiInProgress) {

				this.waitEvent(this.wom1('#api'), ['success', 'loaded'], fox.bind(function (argument) {
					this._handleInputChange(el);
				}, this));
				
				return;
			}

			this.dispatchEvent(str.length > 0 ? 'inputNotEmpty' : 'inputEmpty');

			this.searchStr = str;

			if (this.getOption('staticFilter')) {
				this.filterData();
				
				return;
			}

			if (!str.length) {
				this._hideList();

				if (this.getOption('loadAll')) {
					this.loadAll();
				}
				
				return;
			}

			if (this.inputTimer) {
				window.clearInterval(this.inputTimer);
			}

			this.inputTimer = window.setTimeout(fox.bind(function (argument) {
				this.search(this.searchStr);
			}, this), 500);
		},

		hightlightResult: function () {
			if (!this.hightlightSelector) {
				return;
			}

			fox.each(this.resultItems, function (elt) {
				var $target = $(elt).find(this.hightlightSelector);
				var txt = $target.text();
				var matches = txt.match(new RegExp(this.searchStr, 'gi'));
				var split = txt.split(new RegExp(this.searchStr, 'gi'));
				var result = '';

				fox.each(matches, function (part, i) {
					result += split[i] + '<span class="hl hl-' + i + '">' + part + '</span>';
				}, this);

				if (matches) {
					result += split[matches.length];	
				}

				$target.html(result);
			}, this);
		},

		_close: function (e) {
			console.log('_close');
			var container = $(e.data.el);

			if (e.type === 'keyup') {
				if (e.keyCode && e.keyCode === 27) {
					e.data.widget._hideList();
				}

				return;
			}

			if (!container.length) {
				e.data.widget._hideList();

				return;
			}

			if (!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				e.data.widget.isOpened) {
					e.data.widget._hideList();
			}

		},

		_bindWindowEvents: function (argument) {
			var data = {widget: this};
			var elm = this.wom1('#input').dom1('form');

			if (elm) {
				data.el = elm;
			}

			$(window).on('click', data, this._close);
			$(window).on('keyup', data, this._close);
		},

		_unbindWindowEvents: function (argument) {
			$(window).off('click', this._close);
			$(window).off('keyup', this._close);
		},

		_bindKeyboardEvents: function () {
			$(window).on('keyup', {widget: this}, this._onKeyup);

			if (this.getOption('staticFilter') && this.filteredData.length) {
				this._showList();
			}

			this.isFocus = true;
		},

		_unbindKeyboardEvents: function (argument) {
			$(window).off('keyup', this._onKeyup);

			this.isFocus = false;
		},

		_onKeyup: function (e) {
			var _this = e.data.widget;
			e.preventDefault();

			if (e.keyCode === 38) {
				_this._kbPrev();
			}

			if (e.keyCode === 40) {
				//down
				_this._kbNext();
			}

			if (e.keyCode === 13) {
				_this._kbSelect();
			}

			return false;
		},

		_kbNext: function () {
			var pointer = ++this.listPointer;

			if (pointer >= this.responseData.length) {
				pointer = 0;
			}

			this._hightlight(pointer);

		},

		_kbPrev: function () {
			var pointer = --this.listPointer;

			if (pointer < 0) {
				pointer = this.responseData.length - 1;
			}

			this._hightlight(pointer);
		},

		_kbSelect: function () {
			if (this.listPointer < 0) {
				return;
			}

			this._handleSelectClick(this.resultItems[this.listPointer]);
		},

		_hightlight: function (ind) {
			this.listPointer = ind;
			this.hookWrapper('hightlight', ind);
		},

		hightlight: function (ind) {

			fox.each(this.resultItems, function (node, i) {
				fox.dom.removeClass('active', node);

				if (i === ind) {
					fox.dom.addClass('active', node);
					this._scrollList(node);
				}
			}, this);
		},

		_scrollList: function (node) {
			var top = $(node).position().top;

			$(this.resultList.element[0].parentNode).scrollTop(top);
		},

		getInputValue: function () {
			return this.wom1('#input').dom1('[fox-autocomplete-input]').value;
		},

		getValue: function () {
			return this.getInputValue();
		},

		apiIsDl: function () {
			return fox.oop.instanceOf(this.api, 'Datalayer');
		},

		filterData: function () {
			if (!this.searchStr.length) {
				this.filteredData = fox.clone(this.responseData);
			} else {
				var param = this.getOption('filterParam');
				this.filteredData = this.responseData.filter(function (obj) {
					if (obj[param] && obj[param].toLocaleLowerCase().match(this.searchStr)) {
						return true;
					}

					return false;
				}.bind(this));
			}

			this.renderResultList(this.filteredData);
		},

		prepareResponse: function () {
			fox.each(this.responseData, function (item) {
				if (fox.isString(item.id) && fox.isNumeric(item.id)) {
					item.id = window.parseInt(item.id);
				}
			});
		},

		_handleInputEmptyState: function (obj, w, e) {
			var cross = this.wom1('#input').dom1('.clear-field');

			if (!cross) {
				return;
			}

			fox.dom[(e === 'inputEmpty' ? 'removeClass' : 'addClass')]('show', cross);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_copyright_policy", [["div",{"class":"layout-width single-page"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"Centro Publisher Limited"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Copyright Policy"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: May 15, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part-1"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Reporting Claims of Copyright Infringement "}]]],["p",{},[["textNode",{"text":"We take claims of copyright infringement seriously. We will respond to notices of alleged copyright infringement that comply with applicable law. If you believe any materials accessible on or from the websites located at "}],["a",{"href":"https://www.modelcentro.com","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.modelcentro.com"}]]],["textNode",{"text":", "}],["a",{"href":"https://models.xxx","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.models.xxx"}]]],["textNode",{"text":", or "}],["a",{"href":"https://fancentro.com/","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.fancentro.com"}]]],["textNode",{"text":" (collectively, the "}],["strong",{},[["textNode",{"text":"“Websites”"}]]],["textNode",{"text":") infringe your copyright, you may request removal of those materials (or access to them) from the applicable Website by submitting written notification to our Copyright Agent (designated below). In accordance with the Online Copyright Infringement Liability Limitation Act of the Digital Millennium Copyright Act ("}],["a",{"href":"www.copyright.gov/title17/92chap5.html#512","target":"_blank","rel":"nofollow"}],["textNode",{"text":"17 U.S.C. § 512) (the "}],["strong",{},[["textNode",{"text":"“DMCA”"}]]],["textNode",{"text":"), the written notice (the "}],["strong",{},[["textNode",{"text":"“DMCA Notice”"}]]],["textNode",{"text":") must include substantially the following:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Your physical or electronic signature."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Identification of the copyright work you believe to have been infringed or, if the claim involves multiple works on the applicable Website, a representative list of the works."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Identification of the material you believe to be infringing in a sufficiently precise manner to allow us to locate that material."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Adequate information by which we can contact you (including your name, postal address, telephone number, and, if available, email address)."}]]]]],["li",{},[["p",{},[["textNode",{"text":"A statement that you have a good faith belief that use of the copyrighted material is not authorized by the copyright owner, its agent, or the law."}]]]]],["li",{},[["p",{},[["textNode",{"text":"A statement that the information in the written notice is accurate."}]]]]],["li",{},[["p",{},[["textNode",{"text":"A statement, under penalty of perjury, that you are authorized to act on behalf of the copyright owner."}]]]]]]]]],["p",{},[["textNode",{"text":"Our designated Copyright Agent to receive DMCA notices is:"}]]],["p",{},[["textNode",{"text":"Corey D. Silverstein, Esq."}],["br"],["textNode",{"text":" 30150 Telegraph Road, Suite 444"}],["br"],["textNode",{"text":" Bingham Farms, Michigan 48025"}],["br"],["textNode",{"text":" (248) 645-1222 (fax)"}],["br"],["textNode",{"text":" "}],["a",{"data-name":"dmca","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"}]]],["p",{},[["textNode",{"text":"If you fail to comply with all the requirements of section 512(c)(3) of the DMCA, your DMCA Notice may not be effective."}]]],["p",{},[["textNode",{"text":"Please be aware that if you knowingly materially misrepresent that material or activity on the applicable Website is infringing your copyright, you may be held liable for damages (including costs and attorneys’ fees) under section 512(f) of the DMCA."}]]]]],["div",{"class":"sp-part","id":"part-2"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Counter-Notification Procedures"}]]],["p",{},[["textNode",{"text":"If you believe that material you posted on or through the applicable Website was removed or access to it was disabled by mistake or misidentification, you may file a counter-notification with us (a "}],["strong",{},[["textNode",{"text":"“Counter-Notice”"}]]],["textNode",{"text":") by submitting written notification to our Copyright Agent (identified below). In accordance with the DMCA, the Counter-Notice must include substantially the following:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Your physical or electronic signature."}]]]]],["li",{},[["p",{},[["textNode",{"text":"An identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access disabled."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Adequate information by which we can contact you (including your name, postal address, telephone number and, if available, email address)."}]]]]],["li",{},[["p",{},[["textNode",{"text":"A statement under penalty of perjury by you that you have a good faith belief that the material identified above was removed or disabled as a result of a mistake or misidentification of the material to be removed or disabled."}]]]]],["li",{},[["p",{},[["textNode",{"text":"A statement that you will consent to the jurisdiction of the Federal District Court for the judicial district in which your address is located (or if you reside outside the United States, the United States District Court for the Eastern District of Michigan) and that you will accept service from the person (or an agent of that person) who provided us with the complaint at issue."}]]]]]]]]],["p",{},[["textNode",{"text":"Completed Counter-Notices should be sent to:"}]]],["p",{},[["textNode",{"text":"Corey D. Silverstein, Esq."}],["br"],["textNode",{"text":"30150 Telegraph Road, Suite 444"}],["br"],["textNode",{"text":"Bingham Farms, Michigan 48025"}],["br"],["textNode",{"text":"(248) 645-1222 (fax)"}],["br"],["a",{"data-name":"dmca","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"}]]],["p",{},[["textNode",{"text":"The DMCA allows us to restore the removed content if the party filing the original DMCA Notice does not file a court action against you within ten business days of receiving the copy of your Counter-Notice."}]]],["p",{},[["textNode",{"text":"Please be aware that if you knowingly materially misrepresent that material or activity on the applicable Website was removed or disabled by mistake or misidentification, you may be held liable for damages (including costs and attorneys’ fees) under section 512(f) of the DMCA."}]]]]],["div",{"class":"sp-part","id":"part-3"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Repeat Infringers"}]]],["p",{},[["textNode",{"text":"It is our policy in appropriate circumstances to disable or terminate the accounts of users who are repeat infringers in accordance with our repeat infringer policy."}]]]]]]],["div",{"class":"col sp-right"},[["ul",{"class":"part-navigator"},[["li",{"data-target":"part-1"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Reporting Claims of Copyright Infringement "}]]],["li",{"data-target":"part-2"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Counter-Notification Procedures "}]]],["li",{"data-target":"part-3"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Repeat Infringers "}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("page_ccpa", [["div",{"class":"layout-width single-page"},[["import",{"name":"promo_ccpa_header"}],["div",{"class":"sp-main-content-wrapp"},[["import",{"name":"promo_ccpa_body"}],["div",{"class":"col sp-right"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	__webpack_require__(69);
	__webpack_require__(8);
	__webpack_require__(71);
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_dialog.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_dialog.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".ui-dialog.dlg-amc{position:fixed;z-index:1000;max-width:96%;min-width:310px}.ui-dialog.dlg-amc.dlg-pos-abs{position:absolute}.ui-dialog.dlg-amc .p-t{padding-top:30px}.ui-dialog.dlg-amc .p-b{padding-bottom:30px}.ui-dialog.dlg-amc .p-l{padding-left:30px}.ui-dialog.dlg-amc .p-r{padding-right:30px}.ui-dialog.dlg-amc .ui-dialog-titlebar{background-color:#5d7bd0;color:#fff;padding:20px 60px 20px 30px;border-radius:5px 5px 0 0;line-height:normal;cursor:move}.ui-dialog.dlg-amc .ui-dialog-titlebar .ui-dialog-title{font-size:20px}.ui-dialog.dlg-amc .ui-dialog-titlebar-close{cursor:pointer;display:inline-block;width:45px;height:40px;margin:0;border:none;position:absolute;right:5px;top:14px}.ui-dialog.dlg-amc .ui-dialog-content{background-color:#fff;border-radius:0 0 5px 5px}.ui-dialog.dlg-amc .ui-dialog-content .ui-dialog-buttonpane{margin-top:0!important}.ui-dialog.dlg-amc .ui-dialog-buttonpane{text-align:center;padding:19px;background:#fbfbfb;border-top:1px solid #d4d4d4;border-radius:0 0 5px 5px;margin-top:-4px}.ui-dialog.dlg-amc .ui-dialog-buttonpane .ui-button{margin:0 5px;padding:0 15px;height:31px}.ui-dialog.dlg-amc~.ui-widget-overlay{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.75);z-index:999}.ui-dialog.dlg-amc .gui-notice-item{position:relative;animation:none;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;display:none;transition:opacity .2s;border-radius:0}.ui-dialog.dlg-amc .gui-notice-item.open{display:block;-ms-filter:none;filter:none;opacity:1}.ui-dialog.dlg-amc.dlg-amc-success .ui-dialog-titlebar{background-color:#5aac23}.ui-dialog.dlg-amc.dlg-amc-error .ui-dialog-titlebar{background-color:#ed5758}.ui-dialog.dlg-amc .separator{border-color:#ddd;border-style:solid}.ui-dialog.dlg-amc .separator.bottom{border-width:0 0 1px}.ui-dialog.dlg-amc .separator.top{border-width:1px 0 0}.dlg-content{padding:20px}.dlg-footer{border-color:#d4d4d4;background-color:#fbfbfb;border-radius:0 0 5px 5px}.dlg-footer,.dlg-footer .inner{border-width:1px 0 0;border-style:solid}.dlg-footer .inner{border-color:#fff;padding:19px}.dlg-footer .inner:after{content:\"\";display:table;width:100%}.dlg-footer .guiButton{margin-left:5px}.ui-dialog-form .row{margin-bottom:10px}.ui-dialog-form .row .ml{margin-left:10px}.ui-dialog-form .row.pt{padding-top:10px}.ui-dialog-form>.row:last-child{margin-bottom:0}.ui-dialog-form label{margin-bottom:5px;display:block}.ui-dialog-form .block{display:block;width:100%}.ui-dialog-form .code-wrapper{font-size:10px}.ui-dialog-form.inline .row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.ui-dialog-form.inline .row label{margin-bottom:0;min-width:130px;line-height:31px}.ui-dialog-form.inline .row .field-wrapper{-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto}.ui-dialog-form.inline .row .field-wrapper .block{width:100%}@media (max-width:767px){.ui-dialog.dlg-amc{width:96%!important}}@media (min-width:768px){.ui-dialog.dlg-amc:not(.no-max-width){max-width:700px}}.ui-dialog.dlg-amc.custom-popup-title .ui-widget-header{display:none}.ui-dialog.dlg-amc.custom-popup-title .cancel-close{position:absolute;cursor:pointer;top:23px;right:22px;padding:10px}.ui-dialog.dlg-amc.custom-popup-title .ui-dialog-content{border-radius:5px}.ui-dialog.dlg-amc.custom-popup-title .i_check_16{font-size:16px;color:#a2a2a2}.ui-dialog.dlg-amc.custom-popup-title .done .i_check_16{color:#6cb758}", ""]);

// exports


/***/ }),
/* 71 */
/***/ (function(module, exports) {

(function (fox, $){
    'use strict';
    fox.registerWidget('PopupWidget', {
        configure: function (options){
            this.registerOptions('', {
                template: '',
                additionalClass: '',
                autoReposition: true,
                repositionTopSpace: 0,
                dialog: {
                    autoOpen: options.autoOpen || false,
                    dialogClass: 'dlg-amc dark-overlay',
                    title: options.title,
                    closeText: '',
                    width: 'auto'
                },
                handleWom: {
                    dOnShow: {
                        event: 'show',
                        widget: '@this',
                        'params.prefix': 'uniqPopEvent',
                        callback: function () {
                            $(fox.dom.selectFirst('.wrapper')).addClass('blured');

                            if (this.getOption('autoReposition') === true) {
                                setTimeout(fox.bind(function (){
                                    this._switchChangeEvents(true);
                                    this.switchPositionPopupClass(true);
                                }, this), 50);
                            }
                        }
                    },
                    dOnHide: {
                        event: 'hide',
                        widget: '@this',
                        'params.prefix': 'uniqPopEvent',
                        callback: function () {
                            $(fox.dom.selectFirst('.wrapper')).removeClass('blured');
                          
                            if (this.getOption('autoReposition') === true) {
                                this._switchChangeEvents(false);
                                this.switchPositionPopupClass(false);
                            }
                        }
                    },
                    centering1: {
                        event: 'addedToDom',
                        widget: '@this ~.Widget',
                        callback: function () {
                            this._center();
                        },
                        'params.prefix': 'centering_popup'
                    },
                    centering2: {
                        event: 'playerRunning',
                        widget: '@this ~.Html5Player',
                        callback: function () {
                            this._center();
                        },
                        'params.prefix': 'centering_popup'
                    }
                }
            });
            
            this.callParent('configure', arguments);
        },

        init: function () {
            this
                .setOption('dialog.dialogClass', this.getOption('dialog.dialogClass') + ' ' + this.getOption('additionalClass'));

            if (this.getOption('autoReposition') === true) {
                var that = this;

                this._callReposition = function(event) {
                    if (that.timerId) {
                        window.clearTimeout(that.timerId);
                        that.timerId = false;
                    }

                    that.timerId = window.setTimeout(function() {
                        that.reposition(event.type);
                    }.bind(that), 300);
                };
            }

            this.callParent('init', arguments);
        },

        embed: function() {
            this.callParent('embed', arguments);

            this.toggleHidden(true);

            if (fox.utils.isTouchDevice()) {
                this.addTouchEvents();
            }
        },

        addTouchEvents: function() {
            this.dialogMethod('widget')
                .find('.ui-dialog-titlebar-close')
                .on('touchend', function(e) {
                    e.preventDefault();
                    this.click();
                });
        },

        setButtonsId: function () {
            if (this.getOption('dialog.buttons')) {
                fox.each(this.getOption('dialog.buttons'), function (val, key) {
                    val.id = val.id ? val.id + '_' + this.getId() : val.text.toLowerCase() + '_' + this.getId();
                }, this);

            } else return;
        },

        dialogDestroy: function () {
            this.dialogMethod('destroy');
           
            return this;
        },

        _switchChangeEvents: function(type) {
            var nameListener = type ? 'addEventListener' : 'removeEventListener';
            var nameEvent = fox.utils.isTouchDevice() ? 'orientationchange' : 'resize';

            window[nameListener](nameEvent, this._callReposition);
        },

        switchPositionPopupClass: function(state) {
            if (state) {
                var isBig = this.popupIsBig();
                fox.dom[isBig ? 'addClass' : 'removeClass']('dlg-pos-abs', this.element);
                this._reposition(isBig);
            } else {
                fox.dom.removeClass('dlg-pos-abs', this.element);
            }
        },

        popupIsBig: function() {
            return (window.innerHeight - 100) < this.element[0].offsetHeight;
        },

        _reposition: function(state) {
            if (!state) {
                this.toggleHidden(true);
                this._center();
                return;
            }

            this.toggleHidden();

            var top = parseInt(this.getOption('repositionTopSpace'));

            this.element[0].style.top = top + 'px';
            window.scrollTo(0, top);
        },

        reposition: function(eventName) {
            if (this.popupIsBig()) {
                this.switchPositionPopupClass(true);
            } else {
                this._center();
            }
        },

        hide: function() {
			this.callParent('hide', arguments);
            this.toggleHidden();
            
			return this;
        },
        
        toggleHidden: function(state) {
            document.querySelector('html').classList[!!state ? 'add' : 'remove']('hidden-scroll');
        }
        
    }, 'Dialog');
})(fox, fox.jQuery);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	__webpack_require__(73);

	var require__template = __webpack_require__(75);

	require__template.keys().forEach(function (module) {
		require__template(module)(fox);
	});

	// var require__js = require.context('./widget', true, /\.js$/);

	// require__js.keys().forEach(function (module) {
	// 	require__js(module)(fox);
	// });
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".cookie-consent.ccpa-form .title{border-top:1px solid hsla(0,0%,85%,.4);font-size:14px;line-height:20px;font-weight:700;padding-top:20px;text-align:left;margin-bottom:15px}.cookie-consent.ccpa-form .row{margin-bottom:20px;line-height:24px;font-size:12px;line-height:20px;color:#111}.cookie-consent.ccpa-form .row *{line-height:inherit}.cookie-consent.ccpa-form .row .radio-btn-wrap{height:17px;width:17px;margin-right:12px;padding:12px}.cookie-consent.ccpa-form .row .radio-btn-wrap .radio-btn-dot{top:2px;left:2px;bottom:2px;right:2px}.cookie-consent.ccpa-form ._row{margin-bottom:25px}.cookie-consent.ccpa-form ._row .row-label{font-size:16px;line-height:30px;color:#111}.cookie-consent.ccpa-form ._row .row-label.textsuccess{text-align:center}.cookie-consent.ccpa-form ._row .mc-form-field{width:100%;min-height:50px;background-color:#fbfafa;font-size:16px;padding-left:20px;padding-right:20px}.cookie-consent.ccpa-form ._row textarea.mc-form-field{line-height:19px}.cookie-consent.ccpa-form ._row ._error-text{margin-top:5px;color:#d35855}.cookie-consent.ccpa-form .sub-button{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin-bottom:0}.cookie-consent.ccpa-form .sub-button .mc-btn{width:170px}#ccpa-form .mc-radiobutton.row{padding:10px 0;margin-bottom:0;display:-ms-flexbox;display:flex;text-align:left}#ccpa-form .mc-radiobutton.row.lastrow{margin-bottom:15px}#ccpa-form ._row textarea.mc-form-field{font:400 16px system-ui}.ui-dialog.dlg-amc.ccpa-form .ui-dialog-titlebar{padding:20px 30px}.cookie-consent.ccpa-form ._row ._error-text{height:8px}@media (min-width:768px){#ccpa-form .mc-radiobutton.row{-ms-flex-align:center;-moz-align-items:center;align-items:center}}@media (max-width:768px){.ccpa-form{max-width:320px}}", ""]);

// exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ccpa-form.a.tpl": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("ccpa_form_mc", [["form",{"id":"ccpa-form","class":"ccpa-form"},[["div",{"class":"ui-dialog-content cookie-consent ccpa-form p-l p-r p-b"},[["div",{"class":"row-label title"},[["textNode",{"text":"I would like"}]]],["label",{"for":"knowInformation","class":"mc-radiobutton row"},[["input",{"type":"radio","name":"optionAlias","value":"knowInformation","checked":""}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"radio-caption"},[["textNode",{"text":"to know what information is collected about me by ModelCentro. "}]]]]],["label",{"for":"transferData","class":"mc-radiobutton row"},[["input",{"type":"radio","name":"optionAlias","value":"transferData"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"radio-caption"},[["textNode",{"text":"to receive a copy of the information collected about me by ModelCentro. "}]]]]],["label",{"for":"deleteInformation","class":"mc-radiobutton row"},[["input",{"type":"radio","name":"optionAlias","value":"deleteInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"radio-caption"},[["textNode",{"text":"ModelCentro to delete the information collected about me. "}]]]]],["label",{"for":"prohibitInformation","class":"mc-radiobutton row lastrow"},[["input",{"type":"radio","name":"optionAlias","value":"prohibitInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"radio-caption"},[["textNode",{"text":"to prohibit ModelCentro to share information collected about me with third parties. "}]]]]],["if",{"empty":""},[["div",{"class":"_row email"},[["label",{"class":"row-label"},[["textNode",{"text":"Email:"}]]],["div",{"class":"_base-input-wrapper"},[["input",{"type":"text","class":"_base-input mc-form-field","name":"email","placeholder":"Your email"}],["p",{"class":"_error-text"}]]]]]],[["member","empty",true]]],["div",{"class":"_row"},[["label",{"class":"row-label"},[["span",{},[["textNode",{"text":"Text message:"}]]]]],["div",{"class":"_base-input-wrapper"},[["input",{"type":"text","class":"_base-input mc-form-field","name":"comment","placeholder":"Your message"}],["p",{"class":"_error-text"}]]]]],["div",{"class":"_row _flex _r-h-justify sub-button"},[["button",{"type":"submit","id":"form-submit","class":"fright mc-btn button-with-spinner white-spin with-loader"},[["textNode",{"text":"Submit Request"}]]]]]]]]]]);
fox.registerTemplate("ccpa_success_mc", [["div",{"class":"ui-dialog-content cookie-consent ccpa-form  p-l p-r p-b"},[["if",{"notempty":""},[["div",{"class":"row-label textsuccess"},[["textNode",{"text":"Thank you! "}],["br"],["textNode",{"text":" Your request has been submitted."}],["br"],["textNode",{"text":" An account manager will contact you to confirm and finalize it."}]]],["else",{},[["div",{"class":"row-label textsuccess"},[["textNode",{"text":"Thank you!"}],["br"],["textNode",{"text":" Your request has been submitted."}],["br"],["textNode",{"text":" The response will be sent to your email."}]]]]]],[["deleteInformation","notempty",true]]],["div",{"class":"_row _flex _r-h-justify sub-button"},[["button",{"type":"button","id":"success","class":"successccpa fright mc-btn"},[["textNode",{"text":"Okay"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function (fox, $) {
	// const UA_PARSER = require('ua-parser-js');

	// var _ = {
	// 	getTranslation: function(alias) {
	// 		var translation = {
	// 			'emailNotValid': function() {return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');},
	// 			'fieldIsRequired': function() {return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');}
	// 		};

	// 		return translation[alias] || '';
	// 	}
	// };

	fox.registerWidget('CCPR_Form', {
		configure: function configure() {

			this.registerOptions('', {
				template: 'page_ccpa_login_form',
				widgets: {
					snManager: {
						widget: 'Widget',
						autoRender: false,
						active: false
					},
					authApi: {
						widget: 'Api',
						method: 'ccpa.request',
						httpMethod: 'post'

					},
					form: {
						widget: 'DomForm',
						formSelector: '#ccpa-form'

					}
				},
				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					}
				},
				handleDom: {
					onFocus: {
						target: '[name="email"]',
						event: 'focus',
						callback: '_clearErrors'
					},

					formButtonSubmit: {
						target: '#ccpa-form',
						event: 'submit',
						callback: '_submit'
					},
					closePopup: {
						event: 'click',
						target: '.cancel-close',
						callback: 'closePopup'
					}
				}
			});

			this.callParent('configure', arguments);
		},
		running: function running() {
			this.callParent('running', arguments);

			this.notices = fox.wom.selectFirst('~#throughNotifications');
		},
		activate: function activate() {
			this.form = this.rwom1('#form');

			this.checkMember();
			this.callParent('activate', arguments);
		},
		rendering: function rendering() {
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},
		checkMember: function checkMember() {
			if (fox.isEmpty(fox.site.member)) {
				this.form.setOption('elements.email', {
					//validateOnFly: true,
					// type: 'input',
					validators: [{ validator: 'mandatory', message: this.getTextMessage('fieldIsRequired') }, { validator: 'regexp', options: { type: 'email' }, message: this.getTextMessage('emailNotValid') }]
				});
				this.setTemplateOptions('member', false);
				this.isMember = false;

				return;
			}

			this.setTemplateOptions('member', true);
			this.isMember = true;
		},
		formSubmitError: function formSubmitError(err) {
			//this.showErrorMessage(err.answer.reason);
			//this.togglePreloader(false);

			this.notices.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: 'Oops! There is no such user in our system',
				//noticeAlias: 'loginError',
				delayClose: 3000
			});

			this.togglePreloader(false);
		},
		getTextMessage: function getTextMessage(alias) {
			var msg = '';

			switch (alias) {
				case 'emailNotValid':
					msg = 'Email is not valid';
					break;
				case 'fieldIsRequired':
					msg = 'This field is required';
					break;
			}

			return msg;
		},
		showErrorMessage: function showErrorMessage(msg, fieldName) {
			//console.log(msg, fieldName)
			var $elm = $(this.dom1('[name="' + fieldName + '"]'));

			$elm.addClass('error');
			$elm.parent().find('._error-text').text(msg);
		},
		_submit: function _submit(el, w, alias, e) {
			var _this = this;

			fox.jQuery.Event(e).preventDefault();

			this.wom1('#form').submit().then(function (result) {
				if (result === false) {
					return;
				}

				_this.togglePreloader(true);

				_this.submit().then(function (resp) {
					var response = resp.params.answer.response;

					_this.togglePreloader(false);

					_this.onSuccessSubmit();
				}).catch(function (err) {
					var answer = err.params.answer;

					switch (answer.code) {
						default:
							_this.showErrorMessage('Oops! There is no such user in our system', 'email');
					}
					_this.togglePreloader(false);
				});
			});
		},
		submit: function submit() {
			var data = this.wom1('#form').getValues();

			Object.keys(data).forEach(function (key) {
				data[key] = window.encodeURIComponent(data[key]);
			});

			return this.wom1('#authApi').psend(data);
		},
		togglePreloader: function togglePreloader(state) {
			var btn = this.dom1('#form-submit');

			if (!btn) {
				return;
			}

			fox.dom[state ? 'addClass' : 'removeClass']('spin', btn);
		},
		_handleFormValidation: function _handleFormValidation(formData, form) {
			var _this2 = this;

			var msg = '';

			formData.forEach(function (resp) {
				var $elm = $(_this2.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					_this2.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');

					return;
				}

				$elm.removeClass('error');
			});
		},
		onSuccessSubmit: function onSuccessSubmit() {
			var values = _extends({}, this.form.getValues());

			var w = this.wom1('@parent @parent #popupSuccess #content');
			values.optionAlias === 'deleteInformation' ? w.setTemplateOptions('deleteInformation', true) : w.setTemplateOptions('deleteInformation', false);
			w.render();
			this.resetForm();
			this.dispatchEvent('form_submit_success', values);
		},
		_clearErrors: function _clearErrors(elm) {
			var $elm = $(elm);
			var $p = $elm.parent();

			$elm.removeClass('error');
			$p.removeClass('error');

			$p.find('._error-text').text('');
		},
		resetForm: function resetForm() {
			var values = {
				optionAlias: 'knowInformation',
				comment: ''
			};

			if (!this.member) {
				values.email = '';
			}

			this.form.setValues(values);
		},
		getSuccessMessage: function getSuccessMessage(values) {
			if (values.optionAlias === 'deleteInformation') {
				return 'Thank you! Your request has been submitted. An account manager will contact you to confirm and finalize it.';
			}
			return 'Thank you! Your request has been submitted. The response will be sent to your email.';
		},
		closePopup: function closePopup() {
			this.getParent().hide();
		}
	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    fox.registerWidget('Page_CCPA', {
        configure: function configure() {
            this.registerOptions('', {
                template: 'page_ccpa',
                autoRender: true,
                handleDom: {
                    showPopup: {
                        event: 'click',
                        target: '[show-popup]',
                        callback: 'showPopup'
                    }
                }
            });

            this.callParent('configure', arguments);
        },
        showPopup: function showPopup() {
            // 
        }
    });
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dialog.js": 80,
	"./ga.js": 81,
	"./maps/guest.js": 82
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Dialog":{"dialog.dialogClass":[{"value":"mc-xxx-common-popup","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102003},"path":"~.Dialog","_fox_":1}],"widgets.content.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102006},"path":"~.Dialog","_fox_":1}],"widgets.content.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102007},"path":"~.Dialog","_fox_":1}],"widgets.content.template":[{"value":"popup_example","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102008},"path":"~.Dialog","_fox_":1}],"widgets.content.embed.container":[{"value":".contents","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102010},"path":"~.Dialog","_fox_":1}],"widgets.content.handleDom.commonClosePopup.target":[{"value":".close, .close-popup","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102013},"path":"~.Dialog","_fox_":1}],"widgets.content.handleDom.commonClosePopup.event":[{"value":"click","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102014},"path":"~.Dialog","_fox_":1}],"widgets.content.handleDom.commonClosePopup.callback":[{"value":"@parent:hide","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102015},"path":"~.Dialog","_fox_":1}],"handleWom.dOnShow.event":[{"value":"show","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102018},"path":"~.Dialog","_fox_":1}],"handleWom.dOnShow.widget":[{"value":"@this","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102019},"path":"~.Dialog","_fox_":1}],"handleWom.dOnShow.params.prefix":[{"value":"uniqPopEvent","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102020},"path":"~.Dialog","_fox_":1}],"handleWom.dOnShow.callback":[{"value":function () {
$(fox.dom.selectFirst('.wrapper')).addClass('blured');
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102023},"path":"~.Dialog","_fox_":1}],"handleWom.dOnHide.event":[{"value":"hide","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102025},"path":"~.Dialog","_fox_":1}],"handleWom.dOnHide.widget":[{"value":"@this","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102026},"path":"~.Dialog","_fox_":1}],"handleWom.dOnHide.params.prefix":[{"value":"uniqPopEvent","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102027},"path":"~.Dialog","_fox_":1}],"handleWom.dOnHide.callback":[{"value":function () {
$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102030},"path":"~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102004},"path":"@root","_fox_":1}],"widgets.apiAddReferer.widget":[{"value":"Api","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102006},"path":"@root","_fox_":1}],"widgets.apiAddReferer.method":[{"value":"site.addReferer","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102007},"path":"@root","_fox_":1}],"widgets.apiAddReferer.domain":[{"value":"https:\u002F\u002Fmodelcentro.com","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102008},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function() {
if (!fox.isEmpty(document.referrer)) {
this.rwom1('@parent #apiAddReferer').send({'referer': document.referrer});
}
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var callback = function() {
counterCalls++;
if (!_gaScriptLoaded && counterCalls < 5) {
setTimeout(arguments.callee, 2000);
return;
}
self.rwom1('@root #googleAnalytics').trackPageview(currentPage, false);
}();
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102027},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root .Site_Layout":{"group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102003},"path":"@root .Site_Layout","_fox_":1}],"active":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102004},"path":"@root .Site_Layout","_fox_":1}]},"@root .Site_Layout .Site_Page":{"visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102006},"path":"@root .Site_Layout .Site_Page","_fox_":1}],"group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102007},"path":"@root .Site_Layout .Site_Page","_fox_":1}]},"@root .Site_Layout .Site_Page .Widget":{"autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102009},"path":"@root .Site_Layout .Site_Page .Widget","_fox_":1}]},"@root":{"widgets.menu.widget":[{"value":"Menu2","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102012},"path":"@root","_fox_":1}],"mapGuest.routes.home":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.home\u002F(*foxref)":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.@miss":[{"value":"#catalog #404","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.@":[{"value":"#catalog #models","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.models":[{"value":"#catalog #models","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.updates":[{"value":"#catalog #latest","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.@\u002F(*foxref)":[{"value":"#catalog #models","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.models\u002F(*foxref)":[{"value":"#catalog #models","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.profile\u002F:id":[{"value":"#catalog #profile","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.profile\u002F:id\u002F(*foxref)":[{"value":"#catalog #profile","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.vr":[{"value":"#catalog #vr","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.privacy-policy":[{"value":"#catalog #privacyPolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.copyright-policy":[{"value":"#catalog #copyrightPolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.cookie-table":[{"value":"#catalog #cookieTable","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.cookie-policy":[{"value":"#catalog #cookiePolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.routes.california-privacy-rights":[{"value":"#catalog #californiaPR","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102032},"path":"@root","_fox_":1}],"mapGuest.widgets.intercom.widget":[{"value":"Intercom","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102035},"path":"@root","_fox_":1}],"mapGuest.widgets.intercom.listenWidgets":[{"value":"@root .Site_Layout .Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102036},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widget":[{"value":"Layout_Catalog","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102038},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.template":[{"value":"Layout_Catalog","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102039},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.latest.widget":[{"value":"Catalog3X_Latest","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102042},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.latest.title":[{"value":"Models XXX","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102043},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.models.widget":[{"value":"Catalog3X_Models","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102045},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.models.title":[{"value":"Models XXX","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102046},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.profile.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102048},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.profile.title":[{"value":"Models XXX","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.profile.widgets.profile.widget":[{"value":"Catalog_Model_Profile","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102052},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.profile.widgets.profile.template":[{"value":"catalog_home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102053},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.profile.widgets.profile.container":[{"value":".models-sitepage-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102054},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.vr.widget":[{"value":"Catalog3X_VR","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102056},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.vr.title":[{"value":"Models XXX","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102057},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.vr.widgets.events.widget":[{"value":"Catalog_List_VR","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102060},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.vr.widgets.events.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102061},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.vr.widgets.events.container":[{"value":".list-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102063},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.privacyPolicy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102065},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.privacyPolicy.title":[{"value":"Privacy Policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102066},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.privacyPolicy.widgets.privacyPolicy.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102069},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.privacyPolicy.widgets.privacyPolicy.template":[{"value":"promo_privacyPolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102070},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.privacyPolicy.widgets.privacyPolicy.container":[{"value":".models-sitepage-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102072},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.californiaPR.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102074},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.californiaPR.title":[{"value":"California Consumer Privacy Act","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102075},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.californiaPR.widgets.californiaPolicy.widget":[{"value":"Page_CCPA_MC","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102078},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.californiaPR.widgets.californiaPolicy.container":[{"value":".models-sitepage-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102080},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.copyrightPolicy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102082},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.copyrightPolicy.title":[{"value":"Copyright Policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102083},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.copyrightPolicy.widgets.copyrightPolicy.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102086},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.copyrightPolicy.widgets.copyrightPolicy.template":[{"value":"promo_copyright_policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102087},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.copyrightPolicy.widgets.copyrightPolicy.container":[{"value":".models-sitepage-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102088},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookieTable.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102090},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookieTable.title":[{"value":"Cookie Table","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102091},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookieTable.widgets.cookieTable.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102094},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookieTable.widgets.cookieTable.template":[{"value":"promo_cookie_table","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102095},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookieTable.widgets.cookieTable.container":[{"value":".models-sitepage-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102096},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookiePolicy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102098},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookiePolicy.title":[{"value":"Cookie Policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102099},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookiePolicy.widgets.cookieTable.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102102},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookiePolicy.widgets.cookieTable.template":[{"value":"promo_cookie_policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102103},"path":"@root","_fox_":1}],"mapGuest.widgets.catalog.widgets.cookiePolicy.widgets.cookieTable.container":[{"value":".models-sitepage-wrapper","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102104},"path":"@root","_fox_":1}],"menu.home.home":[{"value":["home","models"],"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102107},"path":"@root","_fox_":1}],"menu.home.updates":[{"value":["updates"],"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102108},"path":"@root","_fox_":1}],"menu.vr.vr":[{"value":["vr"],"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102111},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./catalog/events.tpl": 84,
	"./catalog/filter.tpl": 85,
	"./catalog/glider.tpl": 86,
	"./catalog/header.tpl": 96,
	"./catalog/liveshows.tpl": 98,
	"./catalog/search/search.tpl": 99,
	"./home/home.tpl": 100,
	"./layout/catalog.tpl": 101,
	"./legaldoc/ccpa.tpl": 103,
	"./legaldoc/complaintsPolicy.tpl": 104,
	"./legaldoc/cookie_policy.tpl": 105,
	"./legaldoc/cookie_table.tpl": 106,
	"./legaldoc/privacyPolicy.tpl": 107,
	"./menu/sidebar.tpl": 108,
	"./model/profile.tpl": 109,
	"./popup/example.tpl": 111,
	"./popup/model/subscription.tpl": 112,
	"./popup/model/vrsubscription.tpl": 113,
	"./site.tpl": 115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_events", [["div",{"class":"loader show rotate"}],["section",{"id":"events-list","class":"models-events-list"}],["section",{"class":"load-more-events"},[["a",{"class":"load-more"},[["textNode",{"text":" Load next 14 items "}],["span",{"class":"small-loader"}]]]]]]);
fox.registerTemplate("catalog_events_item_empty", [["div",{"class":"no-data"},[["textNode",{"text":"It looks like we don't have "}],["strong",{},[["span",{},[],[["searchKeyword","__text",true]]]]],["textNode",{"text":" in our listings yet."}]]]]);
fox.registerTemplate("catalog_events_item", [["div",{"class":"event-item &&0&&","data-event-id":""},[["a",{"href":"","class":"primary-thumb","target":"_blank"},[["if",{"notempty":""},[["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["image","src",true]]],["else",{"addclass":"hidden"}]],[["image","notempty",true]]],["else",{},[["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["_typedParams.metaValues.primary.url","src",true]]],["div",{"class":"slides-container"},[["foreach",{"from":"","item":"item"},[["span",{"class":"slide-handler"}],["div",{"class":"slide-image"},[["img",{"src":"","alt":""},[],[["item.url","src",true]]]]]],[["_typedParams.metaValues.baseBig","from",true]]]]],["else",{},[["img",{"src":"","alt":""},[],[["_typedParams.metaValues.primary.url","src",true]]]]]],[["useSlideShow","notempty",true]]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]],["span",{"class":"icon"},[["i",{"class":"icon-event-&&0&&"},[],[["eventAlias","class"]]]]]],[["link","href",true]]],["div",{"class":"event-info"},[["div",{"class":"event-descr"},[["if",{"notempty":"","addclass":"no-date"},[["div",{"class":"title"},[["a",{"href":"","target":"_blank"},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["else",{"addclass":"empty-title"},[["textNode",{"text":" Free members show "}]]]],[["title","notempty",true]]]],[["link","href",true]]]]],["div",{"class":"date"},[["span",{"class":"value"},[["textNode",{"text":" Live Show | "}],["span",{},[],[["startDate","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]],["else",{},[["div",{"class":"title"},[["a",{"href":"","target":"_blank"},[["span",{},[],[["title","__text",true]]]],[["link","href",true]]]]],["div",{"class":"date"},[["if",{"notempty":""},[["if",{"notempty":""},[["span",{"class":"value"},[["span",{},[],[["_typedParams.length","__text",true]]],["textNode",{"text":" photos"}]]],["else",{},[["span",{"class":"value"},[["span",{},[],[["_typedParams.length","__text",true,[{"name":"timeLength","params":[]}]]]]]]]]],[["type","notempty",true,[{"name":"eq","params":["6"]}]]]],["textNode",{"text":" | "}]],[["_typedParams.length","notempty",true,[{"name":"gt","params":["0"]}]]]],["span",{"class":"value"},[["textNode",{"text":" "}],["span",{},[],[["startDate","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]]]],["if",{"notempty":""},[["if",{"notempty":"","addclass":"scheduled"},[["if",{"empty":""},[["div",{"class":"counter scheduled","data-liveshow-startdate":""},[],[["startDate","data-liveshow-startdate",true]]]],[["liveshowSkiped","empty",true]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"notempty":"","addclass":""},[["div",{"class":"counter ls-inprogress"},[["textNode",{"text":"Online now!"}]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["2"]}]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]],["div",{"class":"owner-descr"},[["if",{"notempty":""},[["a",{"href":"/profile/&&0&&-&&1&&","class":"photo"},[["img",{"src":"","alt":""},[],[["_model.avatar","src",true]]]],[["_model.name","href"],["_model.clientId","href"]]]],[["_model.avatar","notempty",true]]],["div",{"class":"info"},[["div",{"class":"title"},[["a",{"href":"/profile/&&0&&-&&1&&"},[["span",{},[],[["_model.name","__text",true]]]],[["_model.name","href"],["_model.clientId","href"]]]]],["div",{"class":"content"},[["if",{"notempty":""},[["span",{"class":"ls"},[["i",{"class":"icon-xxx-17 date"}],["textNode",{"text":" "}],["span",{},[],[["_model.totalLiveshows","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalLiveshows","notempty",true,[{"name":"gt","params":["0"]}]]]],["if",{"notempty":""},[["span",{"class":"sc"},[["i",{"class":"icon-xxx-18 date"}],["textNode",{"text":" "}],["span",{},[],[["_model.totalVideos","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalVideos","notempty",true,[{"name":"gt","params":["0"]}]]]],["if",{"notempty":""},[["span",{"class":"ph"},[["i",{"class":"icon-xxx-19 date"}],["textNode",{"text":" "}],["span",{},[],[["_model.totalPhotosets","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalPhotosets","notempty",true,[{"name":"gt","params":["0"]}]]]]]]]]]]]]],[["eventAlias","class"],["eventId","data-event-id",true]]]]);
fox.registerTemplate("catalog_events_item_model", [["div",{"class":"event-item model &&0&&","data-event-id":""},[["if",{"notempty":""},[["a",{"href":"/profile/&&0&&-&&1&&","class":"primary-thumb"},[["img",{"src":"","alt":""},[],[["_typedParams.metaValues.primary.url","src",true]]]],[["title","href"],["clientId","href"]]],["else",{"addclass":"no-img"}]],[["_typedParams.metaValues.primary.url","notempty",true]]],["div",{"class":"event-info"},[["div",{"class":"event-descr"},[["if",{"notempty":""},[["div",{"class":"model-avatar"},[["span",{"class":"photo"},[["img",{"src":"","alt":""},[],[["_model.avatar","src",true]]]]]]]],[["_model.avatar","notempty",true]]],["div",{"class":"descr-wrapper"},[["div",{"class":"title"},[["a",{"href":"/profile/&&0&&-&&1&&"},[["span",{},[],[["title","__text",true]]]],[["title","href"],["clientId","href"]]]]],["if",{"notempty":""},[["div",{"class":"date"},[["span",{"class":"value"},[["textNode",{"text":" Was online at "}],["span",{},[],[["lastOnline","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]]],[["lastOnline","notempty",true]]]]]]],["if",{"notempty":""},[["if",{"notempty":"","addclass":"scheduled"},[["if",{"empty":""},[["div",{"class":"counter scheduled","data-liveshow-startdate":""},[],[["startDate","data-liveshow-startdate",true]]]],[["liveshowSkiped","empty",true]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"notempty":"","addclass":""},[["div",{"class":"counter ls-inprogress"},[["textNode",{"text":"Online now!"}]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["2"]}]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]],["div",{"class":"owner-descr"},[["div",{"class":"info"},[["div",{"class":"content"},[["span",{"class":"value"},[["textNode",{"text":"Model's content:"}]]],["if",{"notempty":""},[["span",{"class":"ls"},[["i",{"class":"icon-xxx-17 date"}],["textNode",{"text":" &nbsp;"}],["span",{},[],[["_model.totalLiveshows","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalLiveshows","notempty",true,[{"name":"gt","params":["0"]}]]]],["if",{"notempty":""},[["span",{"class":"sc"},[["i",{"class":"icon-xxx-18 date"}],["textNode",{"text":" &nbsp;"}],["span",{},[],[["_model.totalVideos","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalVideos","notempty",true,[{"name":"gt","params":["0"]}]]]],["if",{"notempty":""},[["span",{"class":"ph"},[["i",{"class":"icon-xxx-19 date"}],["textNode",{"text":" &nbsp;"}],["span",{},[],[["_model.totalPhotosets","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalPhotosets","notempty",true,[{"name":"gt","params":["0"]}]]]]]]]]]]]]],[["eventAlias","class"],["eventId","data-event-id",true]]]]);
fox.registerTemplate("catalog_events_item_model_profile", [["div",{"class":"event-item &&0&&","data-event-id":""},[["a",{"href":"","class":"primary-thumb","target":"_blank"},[["if",{"notempty":""},[["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["image","src",true]]],["else",{"addclass":"hidden"}]],[["image","notempty",true]]],["else",{},[["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["_typedParams.metaValues.primary.url","src",true]]],["div",{"class":"slides-container"},[["foreach",{"from":"","item":"item"},[["span",{"class":"slide-handler"}],["div",{"class":"slide-image"},[["img",{"src":"","alt":""},[],[["item.url","src",true]]]]]],[["_typedParams.metaValues.baseBig","from",true]]]]],["else",{},[["if",{"empty":""},[["img",{"src":"","alt":""},[],[["_typedParams.metaValues.primary.url","src",true]]],["else",{},[["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["_typedParams.contents.content","src",true]]]],[["_typedParams.contents.type","notempty",true,[{"name":"eq","params":["3"]}]]]]]]],[["eventAlias","empty",true,[{"name":"eq","params":["post"]}]]]]]]],[["useSlideShow","notempty",true]]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]],["if",{"empty":""},[["span",{"class":"icon"},[["i",{"class":"icon-event-&&0&&"},[],[["eventAlias","class"]]]]]],[["eventAlias","empty",true,[{"name":"eq","params":["post"]}]]]]],[["link","href",true]]],["div",{"class":"event-info"},[["div",{"class":"event-descr"},[["if",{"notempty":"","addclass":"no-date"},[["div",{"class":"title"},[["a",{"href":"","target":"_blank"},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["else",{"addclass":"empty-title"},[["textNode",{"text":" Free members show "}]]]],[["title","notempty",true]]]],[["link","href",true]]]]],["div",{"class":"date"},[["span",{"class":"value"},[["textNode",{"text":" Live Show | "}],["span",{},[],[["startDate","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]],["else",{},[["div",{"class":"title"},[["a",{"href":"","target":"_blank"},[["span",{},[],[["title","__text",true]]]],[["link","href",true]]]]],["div",{"class":"date"},[["if",{"notempty":""},[["if",{"notempty":""},[["span",{"class":"value"},[["span",{},[],[["_typedParams.length","__text",true]]],["textNode",{"text":" photos"}]]],["else",{},[["span",{"class":"value"},[["span",{},[],[["_typedParams.length","__text",true,[{"name":"timeLength","params":[]}]]]]]]]]],[["type","notempty",true,[{"name":"eq","params":["6"]}]]]],["textNode",{"text":" | "}]],[["_typedParams.length","notempty",true,[{"name":"gt","params":["0"]}]]]],["span",{"class":"value"},[["textNode",{"text":" "}],["span",{},[],[["startDate","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]]]],["if",{"notempty":""},[["if",{"notempty":"","addclass":"scheduled"},[["if",{"empty":""},[["div",{"class":"counter scheduled","data-liveshow-startdate":""},[],[["startDate","data-liveshow-startdate",true]]]],[["liveshowSkiped","empty",true]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"notempty":"","addclass":""},[["div",{"class":"counter ls-inprogress"},[["textNode",{"text":"Online now!"}]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["2"]}]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]]]]],[["eventAlias","class"],["eventId","data-event-id",true]]]]);
fox.registerTemplate("catalog_events_item_vr_model", [["div",{"class":"event-item model &&0&&","data-event-id":""},[["if",{"notempty":""},[["a",{"href":"/profile/&&0&&-&&1&&","class":"primary-thumb"},[["span",{"class":"vr-icon"},[["i",{"class":"icn-mc-xxx-VR_glasses-1"}]]],["textNode",{"text":" "}],["img",{"src":"","alt":""},[],[["_typedParams.metaValues.primary.url","src",true]]]],[["title","href"],["clientId","href"]]],["else",{"addclass":"no-img"}]],[["_typedParams.metaValues.primary.url","notempty",true]]],["div",{"class":"event-info"},[["div",{"class":"event-descr"},[["if",{"notempty":""},[["div",{"class":"model-avatar"},[["span",{"class":"photo"},[["img",{"src":"","alt":""},[],[["_model.avatar","src",true]]]]]]]],[["_model.avatar","notempty",true]]],["div",{"class":"descr-wrapper"},[["div",{"class":"title"},[["a",{"href":"/profile/&&0&&-&&1&&"},[["span",{},[],[["title","__text",true]]]],[["title","href"],["clientId","href"]]]]],["if",{"notempty":""},[["div",{"class":"date"},[["span",{"class":"value"},[["textNode",{"text":" Was online at "}],["span",{},[],[["lastOnline","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]]],[["lastOnline","notempty",true]]]]]]],["if",{"notempty":""},[["if",{"notempty":"","addclass":"scheduled"},[["if",{"empty":""},[["div",{"class":"counter scheduled","data-liveshow-startdate":""},[],[["startDate","data-liveshow-startdate",true]]]],[["liveshowSkiped","empty",true]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"notempty":"","addclass":""},[["div",{"class":"counter ls-inprogress"},[["textNode",{"text":"Online now!"}]]]],[["_typedParams.status","notempty",true,[{"name":"eq","params":["2"]}]]]]],[["eventAlias","notempty",true,[{"name":"eq","params":["liveshow"]}]]]],["div",{"class":"owner-descr"},[["div",{"class":"info"},[["div",{"class":"content"},[["span",{"class":"value"},[["textNode",{"text":"Model's content:"}]]],["if",{"notempty":""},[["span",{"class":"ls"},[["i",{"class":"icon-xxx-17 date"}],["textNode",{"text":" &nbsp;"}],["span",{},[],[["_model.totalLiveshows","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalLiveshows","notempty",true,[{"name":"gt","params":["0"]}]]]],["if",{"notempty":""},[["span",{"class":"sc"},[["i",{"class":"icon-xxx-18 date"}],["textNode",{"text":" &nbsp;"}],["span",{},[],[["_model.totalVideos","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalVideos","notempty",true,[{"name":"gt","params":["0"]}]]]],["if",{"notempty":""},[["span",{"class":"ph"},[["i",{"class":"icon-xxx-19 date"}],["textNode",{"text":" &nbsp;"}],["span",{},[],[["_model.totalPhotosets","__text",true]]],["textNode",{"text":" "}]]]],[["_model.totalPhotosets","notempty",true,[{"name":"gt","params":["0"]}]]]]]]]]]]]]],[["eventAlias","class"],["eventId","data-event-id",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_filter_latest", [["div",{"class":"form-group gender"},[["label",{"for":"gender"},[["textNode",{"text":"Gender:"}]]],["div",{"class":"inp with-icon select begin"},[["span",{"class":"txt"},[["textNode",{"text":"All"}]]],["textNode",{"text":" "}],["select",{"id":"gender","name":"gender"},[["option",{"value":"-1","data-icon":"icon-xxx-20"},[["textNode",{"text":"All"}]]],["option",{"value":"2","data-icon":"icon-xxx-10"},[["textNode",{"text":"Female"}]]],["option",{"value":"1","data-icon":"icon-xxx-11"},[["textNode",{"text":"Male"}]]],["option",{"value":"3","data-icon":"icon-xxx-12"},[["textNode",{"text":"Transgender"}]]]]],["textNode",{"text":" "}],["span",{"class":"icon begin"},[["i",{"class":"icon-xxx-20"}]]],["textNode",{"text":" "}],["span",{"class":"icon end"},[["i",{"class":"icon-xxx-09"}]]]]]]],["div",{"class":"form-group search"}]]);
fox.registerTemplate("catalog_filter_models", [["div",{"class":"form-group sorting"},[["label",{"for":"sorting"},[["textNode",{"text":"Sort:"}]]],["div",{"class":"inp with-icon select"},[["span",{"class":"txt"},[["textNode",{"text":"Most popular this week"}]]],["textNode",{"text":" "}],["select",{"id":"sorting","name":"sorting"},[["option",{"value":"3"},[["textNode",{"text":"Most active recently"}]]],["option",{"value":"4"},[["textNode",{"text":"A - Z"}]]]]],["textNode",{"text":" "}],["span",{"class":"icon end"},[["i",{"class":"icon-xxx-09"}]]]]]]],["div",{"class":"form-group gender"},[["label",{"for":"gender"},[["textNode",{"text":"Gender:"}]]],["div",{"class":"inp with-icon select begin"},[["span",{"class":"txt"},[["textNode",{"text":"All"}]]],["textNode",{"text":" "}],["select",{"id":"gender","name":"gender"},[["option",{"value":"-1","data-icon":"icon-xxx-20"},[["textNode",{"text":"All"}]]],["option",{"value":"2","data-icon":"icon-xxx-10"},[["textNode",{"text":"Female"}]]],["option",{"value":"1","data-icon":"icon-xxx-11"},[["textNode",{"text":"Male"}]]],["option",{"value":"3","data-icon":"icon-xxx-12"},[["textNode",{"text":"Transgender"}]]]]],["textNode",{"text":" "}],["span",{"class":"icon begin"},[["i",{"class":"icon-xxx-20"}]]],["textNode",{"text":" "}],["span",{"class":"icon end"},[["i",{"class":"icon-xxx-09"}]]]]]]],["div",{"class":"form-group search"}]]);
fox.registerTemplate("catalog_filter_content", [["div",{"class":"form-group sorting"},[["label",{"for":"sorting"},[["textNode",{"text":"Sort:"}]]],["div",{"class":"inp with-icon select"},[["span",{"class":"txt"},[["textNode",{"text":"Last Added"}]]],["textNode",{"text":" "}],["select",{"id":"sorting","name":"sortContent"},[["option",{"value":"-1"},[["textNode",{"text":"Last Added"}]]],["option",{"value":"1"},[["textNode",{"text":"A - Z"}]]]]],["textNode",{"text":" "}],["span",{"class":"icon end"},[["i",{"class":"icon-xxx-09"}]]]]]]],["div",{"class":"form-group gender"},[["label",{"for":"gender"},[["textNode",{"text":"Type:"}]]],["div",{"class":"inp with-icon select"},[["span",{"class":"txt"},[["textNode",{"text":"All"}]]],["textNode",{"text":" "}],["select",{"id":"type","name":"type"},[["option",{"value":"-1","data-icon":"icon-xxx-20"},[["textNode",{"text":"All"}]]],["option",{"value":"1","data-icon":"icon-xxx-10"},[["textNode",{"text":"Liveshow"}]]],["option",{"value":"2","data-icon":"icon-xxx-11"},[["textNode",{"text":"Post"}]]],["option",{"value":"3","data-icon":"icon-xxx-12"},[["textNode",{"text":"Photoset"}]]],["option",{"value":"4","data-icon":"icon-xxx-12"},[["textNode",{"text":"Video"}]]]]],["textNode",{"text":" "}],["span",{"class":"icon end"},[["i",{"class":"icon-xxx-09"}]]]]]]],["div",{"class":"form-group search"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_glider", [["div",{},[["div",{"id":"features-glider","class":"features-glider"},[["div",{"class":"items"},[["a",{"href":"http://dominika-c.com/&&0&&","class":"item i-1","target":"_blank"},[["img",{"src":"" + __webpack_require__(87) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://sabraspage.com/&&0&&","class":"item i-2","target":"_blank"},[["img",{"src":"" + __webpack_require__(88) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://sweetsophie.com/&&0&&","class":"item i-3","target":"_blank"},[["img",{"src":"" + __webpack_require__(89) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://littleredbunny.xxx/&&0&&","class":"item i-4","target":"_blank"},[["img",{"src":"" + __webpack_require__(90) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://librarygirl.xxx/&&0&&","class":"item i-5","target":"_blank"},[["img",{"src":"" + __webpack_require__(91) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://sophialocke.xxx/&&0&&","class":"item i-6","target":"_blank"},[["img",{"src":"" + __webpack_require__(92) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://tanyatate.com/&&0&&","class":"item i-7","target":"_blank"},[["img",{"src":"" + __webpack_require__(93) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://kyliecupcake.com/&&0&&","class":"item i-8","target":"_blank"},[["img",{"src":"" + __webpack_require__(94) + "","alt":""}]],[["foxref","href",false,[],"env"]]],["textNode",{"text":" "}],["a",{"href":"http://officialelizabethmarxs.com/&&0&&","class":"item i-9","target":"_blank"},[["img",{"src":"" + __webpack_require__(95) + "","alt":""}]],[["foxref","href",false,[],"env"]]]]]]],["a",{"class":"arr lt"},[["i",{"class":"icon-xxx-15"}]]],["textNode",{"text":" "}],["a",{"class":"arr rt"},[["i",{"class":"icon-xxx-16"}]]],["div",{"class":"decor left"}],["div",{"class":"decor right"}]]],["div",{"class":"bullets"},[["a",{"class":"active","data-number":"0"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"1"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"2"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"3"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"4"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"5"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"6"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"7"},[["span"]]],["textNode",{"text":" "}],["a",{"class":"","data-number":"8"},[["span"]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/01.png", __webpack_require__.p + "images/glider/01.png");

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/02.png", __webpack_require__.p + "images/glider/02.png");

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/04.png", __webpack_require__.p + "images/glider/04.png");

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/05.png", __webpack_require__.p + "images/glider/05.png");

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/06.png", __webpack_require__.p + "images/glider/06.png");

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/07.png", __webpack_require__.p + "images/glider/07.png");

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/08.png", __webpack_require__.p + "images/glider/08.png");

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/09.png", __webpack_require__.p + "images/glider/09.png");

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/glider/10.png", __webpack_require__.p + "images/glider/10.png");

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_header", [["a",{"href":"/","class":"logo"},[["img",{"src":"" + __webpack_require__(97) + "","alt":""}]]],["div",{"class":"title"},[["textNode",{"text":"Home Of "}],["strong",{},[["textNode",{"text":"Authentic Model"}]]],["textNode",{"text":" Operated Websites"}]]],["span",{"class":"menu-icon"},[["span",{},[["textNode",{"text":"Menu"}]]],["textNode",{"text":" "}],["i",{"class":"icon-xxx-08"}]]],["nav",{"id":"navigation","class":"navigation"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/models-xxx-logo.png", __webpack_require__.p + "images/models-xxx-logo.png");

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_closest_liveshows", [["div",{"class":"page-width"},[["section",{"class":"models-liveshows"},[["div",{"class":"closest-liveshows-wrapper"},[["div",{"class":"closest-liveshows-pager pager"}],["div",{"class":"closest-liveshows-list"}]]]]]]]]);
fox.registerTemplate("catalog_closest_liveshows_row", [["div",{"class":"closest-livewshows-row item"},[["a",{"class":"item-part model","href":"/profile/&&0&&-&&1&&"},[["div",{"class":"cam"}],["div",{"class":"info"},[["div",{"class":"next"},[["span",{},[["textNode",{"text":"Next"}]]],["textNode",{"text":" live show "}]]],["div",{"class":"name"},[["textNode",{"text":"by "}],["strong",{},[["span",{},[],[["name","__text",true]]]]]]]]]],[["name","href"],["clientId","href"]]],["div",{"class":"item-part date-wrapper"},[["div",{"class":"starts"},[["span",{},[],[["startDate","__text",true,[{"name":"dateFormat","params":["%d %b, %y at %l","%M %p"]}]]]],["textNode",{"text":" (EST). Starts in:"}]]],["div",{"class":"counter","data-liveshow-counter":""}]]],["a",{"class":"item-part join","href":"&&0&&/&&1&&/join","target":"_blank"},[["if",{"notempty":""},[["div",{"class":"img"},[["img",{"src":"","title":""},[],[["avatar","src",true],["name","title",true]]]]]],[["avatar","notempty",true]]],["div",{"class":"btn-wrapper"},[["div",{"class":"join-btn"},[["textNode",{"text":"join my fan club"}]]],["div",{"class":"watch"},[["textNode",{"text":"and watch me live for free!"}]]]]]],[["siteUrl","href"],["foxref","href",false,[],"env"]]]]]]);
fox.registerTemplate("catalog_closest_liveshows_pager", [["a",{"class":"slide","slide-index":""},[],[["_index","slide-index",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_search_input", [["label",{"for":"search-by-name"},[["textNode",{"text":"Search by name:"}]]],["form",{"class":"inp with-icon search","fox-autocomplete-form":""},[["input",{"type":"text","fox-autocomplete-input":"","name":"search-by-name","id":"search-by-name","placeholder":"Type name here","autocomplete":"off"}],["textNode",{"text":" "}],["span",{"class":"icon preloader small-loader"}],["textNode",{"text":" "}],["span",{"class":"icon clear"},[["i",{},[["textNode",{"text":"+"}]]]]],["textNode",{"text":" "}],["span",{"class":"icon end search-start"},[["i",{"class":"icon-xxx-13"}]]],["section",{"class":"autocomplete-list"},[["div",{"fox-autocomplete-result-list":""}]]]]]]);
fox.registerTemplate("catalog_search_item", [["a",{"class":"item","fox-autocomplete-result-item":"","fox-autocomplete-search-result":""},[["span",{"class":"img"},[["img",{"src":"","title":""},[],[["avatar","src",true],["name","title",true]]]]],["textNode",{"text":" "}],["span",{"class":"name"},[["span",{},[],[["name","__text",true]]]]]],[["name","fox-autocomplete-search-result",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("catalog_home", [["section",{"class":"list-wrapper"}]]);
fox.registerTemplate("catalog_home_grid", [["section",{"id":"models-grid","class":"models-grid side-pad"},[["div",{"class":"page-width"},[["section",{"id":"models-filter","class":"models-filter"}],["section",{"id":"events-feed","class":"events-feed"}]]]]]]);
fox.registerTemplate("catalog_home_models_grid", [["section",{"id":"models-grid","class":"models-grid side-pad"},[["div",{"class":"page-width"},[["section",{"id":"models-filter","class":"models-filter models"}],["section",{"id":"events-feed","class":"events-feed"}]]]]]]);
fox.registerTemplate("catalog_home_vrlist_grid", [["section",{"id":"models-grid","class":"models-grid side-pad"},[["div",{"class":"page-width"},[["section",{"id":"subscribe-vr"}],["section",{"id":"models-filter","class":"models-filter models-filter-vr models"}],["section",{"id":"events-feed","class":"events-feed"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_catalog", [["section",{"id":"closest-liveshows","class":"closest-liveshows"}],["header",{"id":"models-header","class":"header"},[["div",{"class":"page-width"},[["section",{"class":"models-header"}]]]]],["section",{"class":"models-sitepage-wrapper"}],["section",{"id":"model-footer","class":"model-footer clearfix"},[["div",{"class":"page-width"},[["span",{"class":"logo"},[["img",{"src":"" + __webpack_require__(102) + "","alt":""}]]],["textNode",{"text":" "}],["span",{"class":"cr"},[["textNode",{"text":"&copy; 2013 - 2017 All rights reserved"}]]],["textNode",{"text":" "}],["a",{"href":"http://modelcentro.com/?acode=mPQDIo4n","class":"get-site","target":"_blank"},[["textNode",{"text":"Get Your Site Free!"}]]],["div",{"class":"footer-links"},[["span",{},[["a",{"href":"/cookie-policy","class":"footer-link","target":"_blank"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":" "}],["a",{"href":"/cookie-table","class":"footer-link","target":"_blank"},[["textNode",{"text":"Cookie Table"}]]]]],["span",{},[["a",{"href":"/privacy-policy","class":"footer-link","target":"_blank"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" "}],["a",{"href":"/california-privacy-rights","class":"footer-link","target":"_blank"},[["textNode",{"text":"California Privacy Rights"}]]]]],["textNode",{"text":" "}],["span",{},[["a",{"href":"/copyright-policy","class":"footer-link","target":"_blank"},[["textNode",{"text":"Copyright Policy"}]]]]]]]]]]],["div",{"class":"pattern"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/small-logo.png", __webpack_require__.p + "images/small-logo.png");

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_ccpa_body", [["div",{"class":"layout-width single-page ccpa"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro.com"}]]],["div",{"class":"title-text"},[["textNode",{"text":"Privacy Notice for California Residents"}]]],["div",{"class":"sp-up-time title"},[["textNode",{"text":"Effective Date: January 1, 2020"}]]],["div",{"class":"sp-up-time title"},[["textNode",{"text":"Last Revised: December 6, 2019"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part_0"},[["div",{"class":"padd-left"},[["p",{},[["textNode",{"text":"This privacy notice for California residents supplements the information contained in ModelCentro's "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"privacy policy"}]]],["textNode",{"text":" and applies solely to all visitors, users, and others who reside in California (“consumers” or “you”). We adopt this notice to comply with the California Consumer Privacy Act of 2018 (CCPA) and any terms defined in the CCPA have the same meaning when used in this Notice. "}]]]]]]],["div",{"class":"sp-part","id":"part_1"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Information We Collect"}]]],["p",{},[["textNode",{"text":"Our Website collects information that identifies, relates to, describes, references, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer, household, or device (“personal information”). Personal information does not include: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Publicly available information from government records. "}]]],["li",{},[["textNode",{"text":" Deidentified or aggregated consumer information. "}]]],["li",{},[["textNode",{"text":" Information excluded from the CCPA’s scope, like: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["textNode",{"text":" health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data; "}]]],["li",{},[["textNode",{"text":" personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver’s Privacy Protection Act of 1994. "}]]]]],["p"]]]]],["p",{},[["textNode",{"text":"In particular, our Website has collected the following categories of personal information from its consumers within the last 12 months: "}]]],["div",{"class":"wrapper-cookie-table"},[["table",{"border":"1","cellpadding":"7","cellspacing":"0"},[["tr",{},[["th",{},[["textNode",{"text":"Category"}]]],["th",{},[["textNode",{"text":"Examples"}]]],["th",{},[["textNode",{"text":"Collected"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"A. Identifiers."}]]],["td",{},[["textNode",{"text":" A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver’s license number, passport number, or other similar identifiers. "}]]],["td",{},[["textNode",{"text":"YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)). "}]]],["td",{},[["textNode",{"text":" A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information.Some personal information included in this category may overlap with other categories. "}]]],["td",{},[["textNode",{"text":" YES"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" C. Protected classification characteristics under California or federal law. "}]]],["td",{},[["textNode",{"text":" Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information). "}]]],["td",{},[["textNode",{"text":" YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" D. Commercial information. "}]]],["td",{},[["textNode",{"text":" Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies. "}]]],["td",{},[["textNode",{"text":"YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" E. Biometric information. "}]]],["td",{},[["textNode",{"text":" Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" F. Internet or other similar network activity. "}]]],["td",{},[["textNode",{"text":" Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement. "}]]],["td",{},[["textNode",{"text":" YES"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" G. Geolocation data. "}]]],["td",{},[["textNode",{"text":" Physical location or movements. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" H. Sensory data. "}]]],["td",{},[["textNode",{"text":" Audio, electronic, visual, thermal, olfactory, or similar information. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" I. Professional or employment-related information. "}]]],["td",{},[["textNode",{"text":" Current or past job history or performance evaluations. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)). "}]]],["td",{},[["textNode",{"text":" Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" K. Inferences drawn from other personal information. "}]]],["td",{},[["textNode",{"text":" Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]]]]]],["p",{},[["textNode",{"text":"Our Website obtains the categories of personal information listed above from the following categories of sources: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Directly from you. For example, from forms you complete or products and services you purchase. "}]]],["li",{},[["textNode",{"text":" Indirectly from you. For example, from observing your actions on our Website. "}]]],["li",{},[["textNode",{"text":" From third parties, for example, our business partners. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Use of Personal Information "}]]]]],["p",{},[["textNode",{"text":"We may use or disclose the personal information we collect for one or more of the following purposes: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to ask a question about our products or services, we will use that personal information to respond to your inquiry. If you provide your personal information to purchase a product or service, we will use that information to process your payment. We may also save your information to facilitate new product orders. "}]]],["li",{},[["textNode",{"text":" To provide, support, personalize, and develop our Website, products, and services. "}]]],["li",{},[["textNode",{"text":" To create, maintain, customize, and secure your account with us. "}]]],["li",{},[["textNode",{"text":" To process your requests, purchases, transactions, and payments and prevent transactional fraud. "}]]],["li",{},[["textNode",{"text":" To provide you with support and to respond to your inquiries, including to investigate and address your concerns and monitor and improve our responses. "}]]],["li",{},[["textNode",{"text":" To personalize your Website experience and to deliver content and product and service offerings relevant to your interests, including targeted offers and ads through our Website, third-party sites, and via email or text message (with your consent, where required by law). "}]]],["li",{},[["textNode",{"text":" To help maintain the safety, security, and integrity of our Website, products and services, databases and other technology assets, and business. "}]]],["li",{},[["textNode",{"text":" For testing, research, analysis, and product development, including to develop and improve our Website, products, and services. "}]]],["li",{},[["textNode",{"text":"To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations. "}]]],["li",{},[["textNode",{"text":" As described to you when collecting your personal information or as otherwise stated in the CCPA. "}]]],["li",{},[["textNode",{"text":" To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by us about our Website users is among the assets transferred. "}]]]]],["p",{},[["textNode",{"text":"We will not collect additional categories of personal information or use the personal information we collected for materially different, unrelated, or incompatible purposes without providing you notice. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Sharing Personal Information "}]]]]],["p",{},[["textNode",{"text":"We may disclose your personal information to a third party for a business purpose. When we disclose personal information for a business purpose, we enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the contract."}]]],["p",{},[["textNode",{"text":"We share your personal information with the following categories of third parties:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Service providers. "}]]],["li",{},[["textNode",{"text":" Internet cookie data recipients, like Google Analytics. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Disclosures of Personal Information for a Business Purpose "}]]]]],["p",{},[["textNode",{"text":"In the preceding 12 months, Company has disclosed the following categories of personal information for a business purpose: "}]]],["p",{"class":"pl-20"}],["p",{},[["textNode",{"text":" Category A: Identifiers."}]]],["p",{},[["textNode",{"text":" Category B: California Customer Records personal information categories. "}]]],["p",{},[["textNode",{"text":" Category F: Internet or other similar network activity. "}]]],["p"],["p",{},[["textNode",{"text":"We disclose your personal information for a business purpose to the following categories of third parties: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Service providers. "}]]],["li",{},[["textNode",{"text":" Internet cookie data recipients, like Google Analytics. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Sales of Personal Information "}]]]]],["p",{},[["textNode",{"text":"In the preceding 12 months, Company had not sold personal information. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Rights and Choices "}]]]]],["p",{},[["textNode",{"text":"The CCPA provides consumers (California residents) with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Access to Specific Information and Data Portability Rights "}]]]]],["p",{},[["textNode",{"text":"You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will disclose to you: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" The categories of personal information we collected about you. "}]]],["li",{},[["textNode",{"text":" The categories of sources for the personal information we collected about you. "}]]],["li",{},[["textNode",{"text":" Our business or commercial purpose for collecting or selling that personal information. "}]]],["li",{},[["textNode",{"text":" The categories of third parties with whom we share that personal information. "}]]],["li",{},[["textNode",{"text":" The specific pieces of personal information we collected about you (also called a data portability request). "}]]],["li",{},[["textNode",{"text":" If we sold or disclosed your personal information for a business purpose, two separate lists disclosing: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["textNode",{"text":" sales, identifying the personal information categories that each category of recipient purchased; "}]]],["li",{},[["textNode",{"text":" disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained. "}]]]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Deletion Request Rights "}]]]]],["p",{},[["textNode",{"text":"You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies. "}]]],["p",{},[["textNode",{"text":"We may deny your deletion request if retaining the information is necessary for us or our service providers to: "}]]],["ul",{"class":"nextlevel"},[["li",{},[["textNode",{"text":" 1. Complete the transaction for which we collected the personal information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or otherwise perform our contract with you. "}]]],["li",{},[["textNode",{"text":" 2 Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities. "}]]],["li",{},[["textNode",{"text":" 3. Debug products to identify and repair errors that impair existing intended functionality. "}]]],["li",{},[["textNode",{"text":" 4. Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law. "}]]],["li",{},[["textNode",{"text":" 5. Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.). "}]]],["li",{},[["textNode",{"text":" 6. Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information’s deletion may likely render impossible or seriously impair the research’s achievement, if you previously provided informed consent. "}]]],["li",{},[["textNode",{"text":" 7. Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us. "}]]],["li",{},[["textNode",{"text":" 8. Comply with a legal obligation. "}]]],["li",{},[["textNode",{"text":" 9. Make other internal and lawful uses of that information that are compatible with the context in which you provided it. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Exercising Access, Data Portability, and Deletion Rights"}]]]]],["p",{},[["textNode",{"text":"To exercise the access, data portability, and deletion rights described above, please submit a verifiable consumer request to us by either: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]]]],["li",{},[["textNode",{"text":" Visiting "}],["a",{"show-popup":"","class":"show-popup"},[["textNode",{"text":"CCPA"}]]]]]]],["p",{},[["textNode",{"text":"Only you, or someone legally authorized to act on your behalf, may make a verifiable consumer request related to your personal information. You may also make a verifiable consumer request on behalf of your minor child. "}]]],["p",{},[["textNode",{"text":"You may only make a verifiable consumer request for access or data portability twice within a 12-month period. The verifiable consumer request must: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative. "}]]],["li",{},[["textNode",{"text":" Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it. "}]]]]],["p",{},[["textNode",{"text":"We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you. "}]]],["p",{},[["textNode",{"text":"Making a verifiable consumer request does not require you to create an account with us. "}]]],["p",{},[["textNode",{"text":"We will only use personal information provided in a verifiable consumer request to verify the requestor’s identity or authority to make the request. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Response Timing and Format "}]]]]],["p",{},[["textNode",{"text":"We endeavor to respond to a verifiable consumer request within 45 days of its receipt. If we require more time (up to 45 days), we will inform you of the reason and extension period in writing."}]]],["p",{},[["textNode",{"text":"If you have an account with us, we will deliver our written response to that account. If you do not have an account with us, we will deliver our written response by mail or electronically, at your option."}]]],["p",{},[["textNode",{"text":"Any disclosures we provide will only cover the 12-month period preceding the verifiable consumer request’s receipt. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance."}]]],["p",{},[["textNode",{"text":"We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request."}]]],["p",{},[["strong",{},[["textNode",{"text":"Non-Discrimination "}]]]]],["p",{},[["textNode",{"text":"We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Deny you goods or services. "}]]],["li",{},[["textNode",{"text":" Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties. "}]]],["li",{},[["textNode",{"text":" Provide you a different level or quality of goods or services. "}]]],["li",{},[["textNode",{"text":" Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services. "}]]]]],["p",{},[["textNode",{"text":"However, we may offer you certain financial incentives permitted by the CCPA that can result in different prices, rates, or quality levels. Any CCPA-permitted financial incentive we offer will reasonably relate to your personal information’s value and contain written terms that describe the program’s material aspects. Participation in a financial incentive program requires your prior opt in consent, which you may revoke at any time. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Other California Privacy Rights"}]]]]],["p",{},[["textNode",{"text":"California’s “Shine the Light” law (Civil Code Section § 1798.83) permits users of our Website that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make that request, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to Our Privacy Notice"}]]]]],["p",{},[["textNode",{"text":"We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will post the updated notice on the Website and update the notice’s effective date. "}],["strong",{},[["textNode",{"text":"Your continued use of our Website following the posting of changes constitutes your acceptance of such changes"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Information "}]]]]],["p",{},[["textNode",{"text":"If you have any questions or comments about this notice, the ways in which Centro Publisher Limited collects and uses your information described below and in the "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", your choices and rights regarding that use, or wish to exercise your rights under California law, please do not hesitate to contact us at: "}]]],["p",{"class":"pl-20"}],["p",{},[["strong",{},[["textNode",{"text":"Website:"}]]],["textNode",{"text":" "}],["a",{"target":"_blank","href":"https://support.modelcentro.com/hc/en-us/requests/new"},[["textNode",{"text":" support.modelcentro.com "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Email:"}]]],["textNode",{"text":" "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]]]],["p"]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_complaintspolicy", [["div",{"class":"layout-width single-page ccpa"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro.com"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Complaints Policy"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: December 6, 2019 "}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part_0"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Introduction"}]]],["p",{},[["textNode",{"text":"Welcome to Centro Publisher Limited’s privacy policy."}]]],["p",{},[["textNode",{"text":"Centro Publisher Limited respects your privacy and is committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you."}]]],["p",{},[["textNode",{"text":"This privacy policy is provided in a layered format, so you can click through to the specific areas set out below. Please also use the Glossary to understand the meaning of some of the terms used in this privacy policy."}]]],["ol",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Important Information and Who We Are"}]]]]],["li",{},[["p",{},[["textNode",{"text":"The Data We Collect About You"}]]]]],["li",{},[["p",{},[["textNode",{"text":"How Is Your Personal Data Collected"}]]]]],["li",{},[["p",{},[["textNode",{"text":"How We Use Your Personal Data"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Disclosures of Your Personal Data"}]]]]],["li",{},[["p",{},[["textNode",{"text":"International Transfers"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Data Security"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Data Retention"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Do Not Track Policy"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Your Nevada Privacy Rights"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Your Canadian Privacy Rights"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Your GDPR Legal Rights"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Glossary"}]]]]]]]]]]],["div",{"class":"sp-part","id":"part_1"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 1. Important Information and Who We Are"}]]],["p",{},[["strong",{},[["textNode",{"text":"Purpose of this Privacy policy"}]]]]],["p",{},[["textNode",{"text":"This privacy policy aims to give you information on how Centro Publisher Limited collects and processes your personal data through your use of this website, including any data you may provide through this website when you sign up to our website."}]]],["p",{},[["textNode",{"text":"This website is not intended for children and we do not knowingly collect data relating to children."}]]],["p",{},[["textNode",{"text":"It is important that you read this privacy policy together with any other privacy policy or fair processing policy we may provide on specific occasions when we are collecting or processing personal data about you so that you are fully aware of how and why we are using your data. This privacy policy supplements other notices and privacy policies and is not intended to override them. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Controller"}]]]]],["p",{},[["textNode",{"text":"Centro Publisher Limited is the controller and responsible for your personal data (collectively referred to as “ModelCentro”, “we”, “us”, or “our” in this privacy policy)."}]]],["p",{},[["textNode",{"text":"We have appointed a data privacy manager who is responsible for overseeing questions in relation to this privacy policy. If you have any questions about this privacy policy, including any requests to exercise your GDPR legal rights, please contact the data privacy manager using the details set out below."}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Details"}]]]]],["p",{},[["textNode",{"text":"If you have any questions about this privacy policy or our privacy practices, please contact our data privacy manager in the following ways: "}],["br"],["textNode",{"text":" Full name of legal entity: Centro Publisher Limited"}],["br"],["textNode",{"text":" Name or title of data privacy manager: Chief Privacy Officer"}],["br"],["textNode",{"text":" Email address: "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["br"],["textNode",{"text":" Postal address: Ajeltaki Road, Ajeltaki Island, Majuro, Marshal Islands MH96960."}]]],["p",{},[["textNode",{"text":"If you reside in the UK, you have the right to make a complaint at any time to the Information Commissioner’s Office (ICO), the UK supervisory authority for data protection issues ("}],["a",{"href":"https://ico.org.uk/","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.ico.org.uk"}]]],["textNode",{"text":"). "}]]],["p",{},[["textNode",{"text":"If you reside within the EEA, you have the right to make a complaint at any time to the appropriate supervisory authority for your country of residence. See "}],["a",{"href":"https://ec.europa.eu","target":"_blank","rel":"nofollow"},[["textNode",{"text":"ec.europa.eu"}]]],["textNode",{"text":" for these details. "}]]],["p",{},[["textNode",{"text":"If you reside outside the EEA or the UK, we will apply your legal rights as applicable to the data laws in the jurisdiction you are in."}]]],["p",{},[["textNode",{"text":"We would, however, appreciate the chance to deal with your concerns before you approach your supervisory authority so please contact us in the first instance."}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the Privacy policy and Your Duty to Inform Us of Changes"}]]]]],["p",{},[["textNode",{"text":"We keep our privacy policy under regular review. This version was last updated on December 6, 2019. Historic versions can be obtained by contacting us at "}],["a",{"data-name":"privacy","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"},[["textNode",{"text":"privacy "}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"The data protection law in the European Union changes on May 25, 2018. Although this privacy policy states most of your rights under the new laws, we may not yet be able to respond to some of your requests (for example, a request for erasure) until May 2018 as we are still working towards getting our systems ready for some of these changes."}]]],["p",{},[["textNode",{"text":"It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-Party Links"}]]]]],["p",{},[["textNode",{"text":"This website may include links to third-party websites, plug-ins, and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit."}]]]]]]],["div",{"class":"sp-part","id":"part_2"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 2. The Data We Collect About You "}]]],["p",{},[["textNode",{"text":"Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data)."}]]],["p",{},[["textNode",{"text":"We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Identity Data"}]]],["textNode",{"text":" includes first name, last name, stage name, username or similar identifier, third-party social media account login information, tax or national identification number, government-issued identification number, date of birth, and gender."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Contact Data"}]]],["textNode",{"text":" includes mailing address, email address, and telephone numbers."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Financial Data"}]]],["textNode",{"text":" includes bank account details."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Transaction Data"}]]],["textNode",{"text":" includes details about payments to you and other details of ModelCentro products and services you use."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Technical Data"}]]],["textNode",{"text":" includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Content Data"}]]],["textNode",{"text":" includes photos, videos, or other digital content uploaded to our platform (please remember that Content Data that you post may reveal personal data about yourself as well)."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Profile Data"}]]],["textNode",{"text":" includes your username and password, your interests, preferences, feedback, and survey responses."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Usage Data"}]]],["textNode",{"text":" includes information about how you use our website, products, and services."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Facebook® and Twitter® Login Data"}]]],["textNode",{"text":" includes your email address and password if you choose to link your Facebook® or Twitter® account with us to facilitate account creation and logon process."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Marketing and Communications Data"}]]],["textNode",{"text":" includes your preferences in receiving marketing from us and our third parties and your communication preferences."}]]]]]]],["p",{},[["textNode",{"text":"We also collect, use, and share "}],["strong",{},[["textNode",{"text":"Aggregated Data"}]]],["textNode",{"text":" such as statistical or demographic data for any purpose. Aggregated Data could be derived from your personal data but is not considered personal data in law as this data will not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific website feature. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy."}]]],["p",{},[["textNode",{"text":"We do not collect any "}],["strong",{},[["textNode",{"text":"Special Categories of Personal Data "}]]],["textNode",{"text":" about you (this includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health, and genetic and biometric data) unless you voluntarily provide it. Nor do we collect any information about criminal convictions and offenses."}]]],["p",{},[["strong",{},[["textNode",{"text":"If You Fail to Provide Personal Data"}]]]]],["p",{},[["textNode",{"text":"Where we need to collect personal data by law, or under the terms of a contract we have with you and you fail to provide that data when requested, we may not be able to perform the contract we have or are trying to enter into with you (for example, to provide you with goods or services). In this case, we may have to cancel a service you have with us, but we will notify you if this is the case at the time."}]]]]]]],["div",{"class":"sp-part","id":"part_3"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"3. How Is Your Personal Data Collected? "}]]],["p",{},[["textNode",{"text":"We use different methods to collect data from and about you, including through:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["strong",{},[["textNode",{"text":"Direct interactions"}]]],["textNode",{"text":". You may give us your Identity, Contact, and Financial Data by filling in forms or by corresponding with us by post, email, or otherwise. This includes personal data you provide when you: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["p",{},[["textNode",{"text":"apply for our products or services;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"create an account on our website;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"create a website on our platform;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"request marketing to be sent to you;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"enter a competition, promotion, or survey;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"give us feedback or contact us."}]]]]]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Automated technologies or interactions."}]]],["textNode",{"text":" As you interact with our website, we will automatically collect Technical and Usage Data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, server logs, and other similar technologies. We may also receive Technical and Usage Data about you if you visit other websites employing our cookies. Please see our "}],["a",{"href":"https://models.xxx/cookie-policy"},[["textNode",{"text":"cookie policy"}]]],["textNode",{"text":" for further details. "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Third parties or publicly available sources."}]]],["textNode",{"text":" We will receive personal data about you from various third parties as set out below: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["p",{},[["textNode",{"text":"Technical Data from the following parties:"}]]],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["p",{},[["textNode",{"text":"analytics providers such as Google based outside the EU;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"payment processors such as CentroBill based inside and outside the EU;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"affiliates based inside and outside the EU; and"}]]]]],["li",{},[["p",{},[["textNode",{"text":"search information providers such as Google based outside the EU."}]]]]]]]]],["li",{},[["p",{},[["textNode",{"text":"Contact, Financial, and Transaction Data from providers of technical, payment, and delivery services such as CentroBill based inside and outside the EU."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Contact, Technical, and Profile Data from third-party social media platforms such as Facebook® and Twitter® based outside the EU if you choose to register and login using your Facebook® or Twitter® account. "}]]]]]]]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"User Contributions."}]]],["textNode",{"text":" You also may provide Content Data for us to publish or display "}],["strong",{},[["textNode",{"text":"(“post”)"}]]],["textNode",{"text":" on public website areas or transmit to other website users or third parties. You submit Content Data for posting and transmission to others at your own risk. Although you may set certain privacy settings for Content Data by logging into your account profile, please be aware that no security measures are perfect or impenetrable. Additionally, we cannot control the actions of any website users with whom you choose to share your Content Data. Therefore, we cannot and do not guarantee that unauthorized persons will not view your Content Data. "}]]]]]]]]]]],["div",{"class":"sp-part","id":"part_4"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 4. How We Use Your Personal Data "}]]],["p",{},[["textNode",{"text":"We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Where we need to perform the contract we are about to enter into or have entered into with you."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Where we need to comply with a legal obligation."}]]]]]]],["p",{},[["textNode",{"text":"Visit the Glossary to find out more about the types of lawful basis that we will rely on to process your personal data."}]]],["p",{},[["textNode",{"text":"Generally, we do not rely on consent as a legal basis for processing your personal data although we will get your consent before sending third-party direct marketing communications to you via email. You have the right to withdraw consent to marketing at any time by contacting us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Purposes for Which We Will Use Your Personal Data"}]]]]],["p",{},[["textNode",{"text":"We have set out below, in a table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate."}]]],["p",{},[["textNode",{"text":"Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data. Please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":" if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below."}]]],["table",{"border":"1","cellpadding":"7","cellspacing":"0"},[["tr",{},[["th",{},[["textNode",{"text":"Purpose/Activity"}]]],["th",{},[["textNode",{"text":"Type of data"}]]],["th",{},[["textNode",{"text":"Lawful basis for processing including basis of legitimate interest"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"To register you as a new customer"}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact "}]]],["td",{},[["textNode",{"text":"Performance of a contract with you"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To process and manage your account including:"}],["br"],["br"],["textNode",{"text":" (a) Manage your website or store "}],["br"],["br"],["textNode",{"text":" (b) Verify your age and identity"}],["br"],["br"],["textNode",{"text":" (c) Collect and pay money owed to you "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Financial"}],["br"],["br"],["textNode",{"text":" (d) Transaction"}],["br"],["br"],["textNode",{"text":" (e) Content"}],["br"],["br"],["textNode",{"text":" (f) Profile"}],["br"],["br"],["textNode",{"text":" (g) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary for our legitimate interests (to verify your age and identity) (c) Necessary to comply with a legal obligation "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To manage our relationship with you which will include:"}],["br"],["br"],["textNode",{"text":" (a) Notifying you about changes to our terms or privacy policy"}],["br"],["br"],["textNode",{"text":" (b) Communicate with you about your account"}],["br"],["br"],["textNode",{"text":" (c) Asking you to leave a review or take a survey "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Profile"}],["br"],["br"],["textNode",{"text":" (d) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation"}],["br"],["br"],["textNode",{"text":" (c) Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To enable you to partake in a prize draw, competition, or complete a survey "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Profile"}],["br"],["br"],["textNode",{"text":" (d) Usage"}],["br"],["br"],["textNode",{"text":" (e) Marketing and Communications "}]]],["td",{},[["textNode",{"text":"(a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary for our legitimate interests (to study how customers use our products/services, to develop them and grow our business) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To administer and protect our business and this website and conduct internal operations(including for security, fraud, troubleshooting/technical support, data analysis, testing, system maintenance, support, reporting, and hosting of data) "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Technical "}]]],["td",{},[["textNode",{"text":" (a) Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud, and in the context of a business reorganization or group restructuring exercise)"}],["br"],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To deliver content to you and to measure or understand the effectiveness of the content we serve to you "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (c) Technical "}],["br"],["br"],["textNode",{"text":" (d) Content"}],["br"],["br"],["textNode",{"text":" (e) Profile"}],["br"],["br"],["textNode",{"text":" (f) Usage"}],["br"],["br"],["textNode",{"text":" (g) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary for our legitimate interests (to provide you content that you have requested, to study how customers use our services, to develop them, to grow our business, and to inform our marketing strategy) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To use data analytics to improve our website, products/services, marketing, customer relationships, and experiences "}]]],["td",{},[["textNode",{"text":" (a) Technical"}],["br"],["br"],["textNode",{"text":" (b) Usage "}]]],["td",{},[["textNode",{"text":" Necessary for our legitimate interests (to define types of customers for our products and services, to keep our website updated and relevant, to develop our business, and to inform our marketing strategy)"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To make suggestions and recommendations to you about goods or services that may be of interest to you "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Technical"}],["br"],["br"],["textNode",{"text":" (d) Usage"}],["br"],["br"],["textNode",{"text":" (e) Profile"}],["br"],["br"],["textNode",{"text":" (f) Marketing and Communications "}]]],["td",{},[["textNode",{"text":"Necessary for our legitimate interests (to develop our products/services and grow our business)"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To allow you to sign up or log in using your Facebook® or Twitter® account "}]]],["td",{},[["textNode",{"text":" Facebook® and Twitter® Login Data "}]]],["td",{},[["textNode",{"text":"Your consent"}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Marketing"}]]]]],["p",{},[["textNode",{"text":"We strive to provide you with choices regarding certain personal data uses, particularly around marketing and advertising. We have established the following personal data control mechanisms:"}]]],["p",{},[["strong",{},[["textNode",{"text":"Promotional Offers from Us"}]]]]],["p",{},[["textNode",{"text":"We may use your Identity, Contact, Technical, Usage, and Profile Data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services, and offers may be relevant for you (we call this marketing)."}]]],["p",{},[["textNode",{"text":"You will receive marketing communications from us if you have requested information from us or purchased services from us or if you provided us with your details when you entered a competition or registered for a promotion and, in each case, you have not opted out of receiving that marketing."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-Party Marketing"}]]]]],["p",{},[["textNode",{"text":"We will get your express opt-in consent before we share your personal data with any third party for marketing purposes."}]]],["p",{},[["strong",{},[["textNode",{"text":"Opting Out"}]]]]],["p",{},[["textNode",{"text":"You can ask us or third parties to stop sending you marketing messages at any time by following the opt-out links on any marketing messages sent to you or by contacting us at any time at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of a service purchase or registration, service experience, or other transactions. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies"}]]]]],["p",{},[["textNode",{"text":"You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly. For more information about the cookies we use, please see our "}],["a",{"href":"https://models.xxx/cookie-policy"},[["textNode",{"text":"cookie policy"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Change of Purpose"}]]]]],["p",{},[["textNode",{"text":"We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so."}]]],["p",{},[["textNode",{"text":"Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law."}]]]]]]],["div",{"class":"sp-part","id":"part_5"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 5. Disclosures of Your Personal Data "}]]],["p",{},[["textNode",{"text":"We may share your personal data with the parties set out below for the purposes stated in the table (Purposes for which we will use your personal data) above. "}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"External Third Parties as set out in the Glossary."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Specific third parties such as VikingHost B.V., CentroBill, Facebook, and Twitter."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy."}]]]]]]],["p",{},[["textNode",{"text":"We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions."}]]]]]]],["div",{"class":"sp-part","id":"part_6"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 6. International Transfers "}]]],["p",{},[["textNode",{"text":"We are based in the Marshal Islands, but our servers are located in the Netherlands. We may process, store, and transfer personal data we collect, in and to a country outside your own, with different privacy laws that may or may not be comprehensive as your own. Where we do so, and where we are required to under local law, we will put in place appropriate mechanisms to ensure that your personal data receives an adequate level of protection where it is processed."}]]],["p",{},[["textNode",{"text":"Unless you are located in the EEA or the UK, by submitting your personal data or engaging with the website or our application, you consent to this transfer, storing, or processing."}]]],["p",{},[["textNode",{"text":"If you reside in the European Economic Area (EEA) or the United Kingdom (UK), your personal data may be processed outside of the EEA or UK, including, for example, in the United States, so processing of your personal data will involve a transfer of data outside the EEA or UK. "}]]],["p",{},[["textNode",{"text":"Whenever we transfer your personal data out of the EEA, we ensure a similar degree of protection is afforded to it by ensuring that the recipient third party agrees to contractual clauses."}]]],["p",{},[["textNode",{"text":"Please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":" if you want further information on the specific mechanism used by us when transferring your personal data out of the EEA or UK."}]]]]]]],["div",{"class":"sp-part","id":"part_7"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 7. Data Security "}]]],["p",{},[["textNode",{"text":"We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality."}]]],["p",{},[["textNode",{"text":"We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so."}]]]]]]],["div",{"class":"sp-part","id":"part_8"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 8. Data Retention "}]]],["p",{},[["strong",{},[["textNode",{"text":"How Long Will You Use My Personal Data For?"}]]]]],["p",{},[["textNode",{"text":"We will only retain your personal data for as long as reasonably necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting, or reporting requirements. We may retain your personal data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with you. "}]]],["p",{},[["textNode",{"text":"To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting, or other requirements. "}]]],["p",{},[["textNode",{"text":"By law we have to keep basic information about certain customers (including Contact, Identity, Financial, and Transaction Data) for seven years after they stop being customers for tax purposes or to comply with applicable law, including 18 U.S.C. § 2257. "}]]],["p",{},[["textNode",{"text":"In some circumstances (depending on where you reside) you can ask us to delete your data: see Request erasure below for further information. "}]]],["p",{},[["textNode",{"text":"In some circumstances we will anonymize your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you."}]]]]]]],["div",{"class":"sp-part","id":"part_9"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 9. Do Not Track Policy"}]]],["p",{},[["textNode",{"text":"Do Not Track (“DNT”) is a privacy preference that you can set in your browser. DNT is a way for you to inform websites and services that you do not want certain information about your webpage visits collected over time and across websites or online services. We are committed to providing you with meaningful choices about the information we collect and that is why we provide you the ability to opt out. But we do not recognize or respond to any DNT signals as the Internet industry works toward defining exactly what DNT means, what it means to comply with DNT, and a common approach to responding to DNT. For more information, visit "}],["a",{"href":"https://www.allaboutdnt.com","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.allaboutdnt.com"}]]],["textNode",{"text":"."}]]]]]]],["div",{"class":"sp-part","id":"part_10"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 10. Your California Privacy Rights "}]]],["p",{},[["textNode",{"text":"If you are a California resident, California law may provide you with additional rights regarding our use of your personal data. To learn more about your California privacy rights., visit "}],["a",{"href":"/california-privacy-rights"},[["textNode",{"text":" https://models.xxx/california-privacy-rights"}]]]]],["p",{},[["textNode",{"text":"California’s “Shine the Light” law (Civil Code Section 1798.83) permits our users who are California residents to request certain information regarding our disclosure of personal data to third parties for their direct marketing purposes. To make that request, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]]]],["p",{},[["textNode",{"text":" Further, if you are a California resident and would like to opt out from the disclosure of your personal data to any third party for direct marketing purposes, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". If you opt out from permitting your personal data to be shared, you may still receive selected offers directly from us in accordance with California law. "}]]]]]]],["div",{"class":"sp-part","id":"part_11"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 11. Your Nevada Privacy Rights "}]]],["p",{},[["textNode",{"text":"Nevada residents who wish to exercise their sale opt-out rights under Nevada Revised Statutes Chapter 603A may submit a request to this designated address: "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". However, please know we do not currently sell data triggering that statute’s opt-out requirements. "}]]]]]]],["div",{"class":"sp-part","id":"part_12"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 12. Your Canadian Privacy Rights "}]]],["p",{},[["textNode",{"text":"We comply with Canadian Federal and Provincial privacy laws and regulations, including the Personal Information Protection and Electronic Documents Act. "}]]],["p",{},[["textNode",{"text":"We will only use your personal information for the purposes intended and as detailed in this policy unless we have obtained your consent to use it for other purposes. "}]]],["p",{},[["textNode",{"text":"Residents of Canada are notified that the personal data they provide to us is stored in our databases outside of Canada, including in the Netherlands, and may be subject to disclosure to authorized law enforcement or government agencies in response to lawful demand under the laws of that country."}]]],["p",{},[["textNode",{"text":"You may withdraw your consent to our personal data collection, use, or disclosure, subject to legal and contractual restrictions."}]]],["p",{},[["textNode",{"text":"You have the right to complain about our personal data handling practices."}]]],["p",{},[["textNode",{"text":"If you need to contact us about your personal data or believe that we have violated your privacy rights, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". You may visit "}],["a",{"target":"_blank","href":"https://www.priv.gc.ca/"},[["textNode",{"text":" www.priv.gc.ca"}]]],["textNode",{"text":" for more information about your privacy rights. "}]]]]]]],["div",{"class":"sp-part","id":"part_13"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 13. Your GDPR Legal Rights "}]]],["p",{},[["textNode",{"text":"If you reside in the EEA or UK, under certain circumstances, you have rights under data protection laws in relation to your personal data. Please click on the links below to find out more about these rights: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Request access to your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request correction of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request erasure of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Object to processing of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request restriction of processing your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request transfer of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Right to withdraw consent."}]]]]]]],["p",{},[["textNode",{"text":"If you wish to exercise any of the rights set out above, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"No Fee Usually Required"}]]]]],["p",{},[["textNode",{"text":"You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive, or excessive. Alternatively, we could refuse to comply with your request in these circumstances."}]]],["p",{},[["strong",{},[["textNode",{"text":"What We May Need from You"}]]]]],["p",{},[["textNode",{"text":"We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response."}]]],["p",{},[["strong",{},[["textNode",{"text":"Time Limit to Respond"}]]]]],["p",{},[["textNode",{"text":"We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated. "}]]]]]]],["div",{"class":"sp-part","id":"part_14"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 14. Glossary "}]]],["p",{},[["strong",{},[["textNode",{"text":"Lawful Basis"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Consent "}]]],["textNode",{"text":" means processing your personal data where you have signified your agreement by a statement or clear opt-in to processing for a specific purpose. Consent will only be valid if it is a freely given, specific, informed, and unambiguous indication of what you want. You can withdraw your consent at any time by contacting us. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Legitimate Interest"}]]],["textNode",{"text":" means the interest of our business in conducting and managing our business to enable us to give you the best service/product and the best and most secure experience. We make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process your personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities by contacting us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Performance of Contract"}]]],["textNode",{"text":" means processing your data where it is necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract."}]]],["p",{},[["strong",{},[["textNode",{"text":"Comply with a legal obligation "}]]],["textNode",{"text":" means processing your personal data where it is necessary for compliance with a legal obligation that we are subject to."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third Parties"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"External Third Parties"}]]]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Compliance with Laws"}]]],["textNode",{"text":". We may disclose your information where we are legally required to do so to comply with applicable law, government requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements). "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Vital Interests and Legal Rights"}]]],["textNode",{"text":". We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved. "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Vendors, Consultants, and Other Third-Party Service Providers"}]]],["textNode",{"text":". We may share your data with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf and require access to that information to do that work. Examples include payment processing, data analysis, email delivery, hosting services, customer service, and marketing efforts. We may allow selected third parties to use tracking technology on the website, which will enable them to collect data about how you interact with the website over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content and better understand online activity. For example, we use Google Analytics to help us understand how our customers use the website (you can read more about how Google uses your personal data here: "}],["a",{"target":"_blank","rel":"nofollow","href":"https://www.google.com/intl/en/policies/privacy/"},[["textNode",{"text":" https://www.google.com/intl/en/policies/privacy/)"}]]],["textNode",{"text":". You can also optout of Google Analytics here: "}],["a",{"target":"_blank","rel":"nofollow","href":"https://tools.google.com/dlpage/gaoptout"},[["textNode",{"text":" https://tools.google.com/dlpage/gaoptout"}]]],["textNode",{"text":". "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Your Legal Rights"}]]]]],["p",{},[["textNode",{"text":"Depending on the country you reside in, you may have the right to:"}]]],["p",{},[["strong",{},[["textNode",{"text":"Request access"}]]],["textNode",{"text":" to your personal data (commonly known as a “data subject access request”). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request correction"}]]],["textNode",{"text":" of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request erasure"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully, or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request."}]]],["p",{},[["strong",{},[["textNode",{"text":"Object to processing"}]]],["textNode",{"text":" of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request restriction of processing"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: (a) if you want us to establish the data’s accuracy; (b) where our use of the data is unlawful but you do not want us to erase it; (c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise, or defend legal claims; or (d) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request the transfer"}]]],["textNode",{"text":" of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you."}]]],["p",{},[["strong",{},[["textNode",{"text":"Withdraw consent at any time"}]]],["textNode",{"text":" where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent."}]]]]]]]]],["div",{"class":"col sp-right"},[["ul",{"class":"part-navigator"},[["li",{"data-target":"part_0"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Introduction "}]]],["li",{"data-target":"part_1"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Important Information and Who We Are "}]]],["li",{"data-target":"part_2"},[["span",{"class":"sp-dot"}],["textNode",{"text":" The Data We Collect About You "}]]],["li",{"data-target":"part_3"},[["span",{"class":"sp-dot"}],["textNode",{"text":" How Is Your Personal Data Collected? "}]]],["li",{"data-target":"part_4"},[["span",{"class":"sp-dot"}],["textNode",{"text":" How We Use Your Personal Data "}]]],["li",{"data-target":"part_5"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Disclosures of Your Personal Data "}]]],["li",{"data-target":"part_6"},[["span",{"class":"sp-dot"}],["textNode",{"text":" International Transfers "}]]],["li",{"data-target":"part_7"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Data Security "}]]],["li",{"data-target":"part_8"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Data Retention "}]]],["li",{"data-target":"part_9"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Do Not Track Policy "}]]],["li",{"data-target":"part_10"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your California Privacy Rights "}]]],["li",{"data-target":"part_11"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your Nevada Privacy Rights "}]]],["li",{"data-target":"part_12"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your Canadian Privacy Rights"}]]],["li",{"data-target":"part_13"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your Legal Rights "}]]],["li",{"data-target":"part_14"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Glossary "}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_cookie_policy", [["div",{"class":"layout-width single-page ccpa"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"Models.xxx"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Cookie Use Policy"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Modified: July 9, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part-0"},[["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"Cookies are small files of letters and numbers stored on your browser or device that enable the cookie owner to recognize the device when it visits websites or uses online services. The website you visit may set cookies directly, known as first-party cookies, or may trigger cookies set by other domain names, known as third-party cookies. While we may automatically use some cookies that are strictly necessary to provide the services you request or enable communications, we request your consent for all our other cookie uses. "}]]]]]]],["div",{"class":"sp-part","id":"part-1"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Types of Cookies We Use"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"We may use the following types of cookies:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":" Strictly necessary cookies"}]]],["textNode",{"text":" Our website requires the use of these cookies to properly operate or provide necessary functions relating to the services you request. They include, for example, cookies enabling page navigation. You can set your browser to block or alert you about these cookies, but some parts of our website may not work then."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Analytical/performance cookies. "}]]],["textNode",{"text":" These cookies allow us and our third-party service providers to recognize and count the number of visitors and to see how visitors move around our website when they are using it. This helps us improve how our website works by, for example, ensuring that users can easily find what they need on our website. These cookies generate aggregate statistics that are not associated with an individualized profile. If you do not allow these cookies, we will not know when you have visited our website."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Functionality cookies. "}]]],["textNode",{"text":" These cookies enable helpful but non-essential website functions that improve your website experience. By recognizing you when you return to our website, they may, for example, allow us to personalize our content for you, greet you by name, or remember your preferences (for example, your choice of language or region). These cookies may enable visitor identification over time, but not across different websites. If you do not allow these cookies, some or all our website’s functionalities may not function properly."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Advertising, tracking, or targeting cookies. "}]]],["textNode",{"text":" These cookies enable different advertising related functions. They may allow us to record information about your visit to our website, such as pages visited, links followed, and videos viewed so we can make our website and the advertising displayed on it more relevant to your interests. These cookies may enable visitor identification over time, but not across different websites."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Third-party cookies. "}]]],["textNode",{"text":" Our website may contain helpful but non-essential features or plug-ins enabling third-party services that use cookies, such as social network connectors, advertising networks, or web traffic analysis services. These cookies may enable visitor identification across websites and over time. We do not control the third party’s use of those cookies. Please review each party’s cookie disclosure before consenting to this use category."}]]]]]]]]],["p",{},[["textNode",{"text":" Our "}],["a",{"href":"/privacy-policy","target":"_blank"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" describes our practices for any personal data that our first-party cookies collect, store, or use. "}]]],["p",{},[["textNode",{"text":" Except for strictly necessary cookies, all first-party cookies set by this site will expire no later than two years after your last website visit. Third-party cookie expiration periods are set by their respective owners. "}]]],["p",{},[["textNode",{"text":" Please see our "}],["a",{"href":"/cookie-table","target":"_blank"},[["textNode",{"text":" Cookie Table"}]]],["textNode",{"text":" for a list of the individual first-party and third-party cookies potentially used on this site and their specific purposes. "}]]]]]]],["div",{"class":"sp-part","id":"part-2"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Cross-Border Data Transfers"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" The cookies we use may process, store, or transfer personal data in and to a country outside your own, with privacy laws that provide different, possibly lower, protections. You consent to this transfer, storing, or processing when you consent to our cookie use. Our servers are located in the Netherlands. Please review the third-party cookie provider’s policy to learn more about its location. "}]]]]]]],["div",{"class":"sp-part","id":"part-3"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Your Cookie Choices"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"You consent to our use of cookies when you continue using our site."}]]],["p",{},[["textNode",{"text":" You may withdraw your consent for our cookie uses that are not strictly necessary at any time by engaging the consent manager tool "}],["a",{"href":"/cookie-table"},[["textNode",{"text":" Cookie Table"}]]],["textNode",{"text":". "}]]],["p",{},[["textNode",{"text":" Most web browsers allow you to directly block all cookies, or just third-party cookies, through your browser settings. Using your browser settings to block all cookies, including strictly necessary ones, may interfere with proper site operation. "}]]],["p"]]]]],["div",{"class":"sp-part","id":"part-4"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Changes to Our Cookie Uses "}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"We will post any changes to the way we use cookies on this page and indicate on our website that we updated this cookie notice. If the changes materially alter how we use cookies, we will post a notice on our website and request your consent for the materially different use. Please check back frequently to see any updates or changes to our cookie use notice."}]]]]]]],["div",{"class":"sp-part","id":"part-5"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Contact Information"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" Please submit any questions, comments, or requests regarding this cookie use notice using the process described in our Privacy Policy, located at "}],["a",{"href":"https://models.xxx/privacy-policy"},[["textNode",{"text":" https://models.xxx/privacy-policy"}]]],["textNode",{"text":". "}]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_cookie_table", [["div",{"class":"layout-width single-page"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"Models.xxx"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Cookie Table"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Modified: July 9, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Cookies Used on Models.xxx"}]]],["div",{"class":"sp-part","id":"part-0"},[["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"The following table lists all cookies potentially in use on the Models.xxx website. We will update this table as our website changes and evolves, so please check back frequently to review any new cookie uses. Visit our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":" Cookie Policy"}]]],["textNode",{"text":" for more information and choices about our cookie use, including our contact information and complaint procedures. "}]]]]]]],["div",{"class":"wrapper-cookie-table"},[["table",{"class":"cookie-table"},[["thead",{},[["tr",{},[["th",{},[["textNode",{"text":"Cookie Category"}]]],["th",{},[["textNode",{"text":"Cookie Name and Owner"}]]],["th",{},[["textNode",{"text":"Purpose"}]]],["th",{},[["textNode",{"text":"Expiry"}]]],["th",{},[["textNode",{"text":"Type"}]]]]]]],["tbody",{},[["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":" io "}],["br"],["textNode",{"text":" Models.xxx"}]]],["td",{},[["textNode",{"text":" Preserves user session state across page requests."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":" __ax "}],["br"],["textNode",{"text":" videos.models.xxx"}]]],["td",{},[["textNode",{"text":"Security cookie used to prevent unauthorized access or disclosure of the user account. In all cases, these cookies do not store any information that makes you personally identifiable to us."}]]],["td",{},[["textNode",{"text":" 1 year"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":" exo_uid "}],["br"],["textNode",{"text":" videos.models.xxx"}]]],["td",{},[["textNode",{"text":"Security cookie used to prevent unauthorized access or disclosure of the user account. In all cases, these cookies do not store any information that makes you personally identifiable to us."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":" io "}],["br"],["textNode",{"text":" videos.models.xxx"}]]],["td",{},[["textNode",{"text":"Preserves user session state across page requests."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" referers "}],["br"],["textNode",{"text":" Models.xxx"}]]],["td",{},[["textNode",{"text":"Used to store information, such as what time your current visit occurred, whether you have been to the website before, and what website referred you to the web page."}]]],["td",{},[["textNode",{"text":" 1 year"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" RNLBSERVERID "}],["br"],["textNode",{"text":" Models.xxx"}]]],["td",{},[["textNode",{"text":"Used to make sure visitor page requests are routed to the same server."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" RNLBSERVERID "}],["br"],["textNode",{"text":" videos.models.xxx"}]]],["td",{},[["textNode",{"text":"Used to make sure visitor page requests are routed to the same server."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" RNLBSERVERID "}],["br"],["textNode",{"text":" ec-small.centrofiles.com "}],["br"],["textNode",{"text":" ec-large.centrofiles.com "}],["br"],["textNode",{"text":" ec-st.centrofiles.com"}]]],["td",{},[["textNode",{"text":"Used to make sure visitor page requests are routed to the same server."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":" _ga "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Registers a unique ID that is used to generate statistical data on how the visitor uses the website."}]]],["td",{},[["textNode",{"text":" 2 years"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":" _gat "}],["br"],["textNode",{"text":" _gat_tracker0 "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Used by Google Analytics to throttle request rate."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":" _gid "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Registers a unique ID that is used to generate statistical data on how the visitor uses the website."}]]],["td",{},[["textNode",{"text":" 1 day"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]]]]]]]],["div",{"class":"sp-part","id":"part-0"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_privacypolicy", [["div",{"class":"layout-width single-page ccpa"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro.com"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Privacy Policy"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: December 6, 2019 "}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part_0"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Introduction"}]]],["p",{},[["textNode",{"text":"Welcome to Centro Publisher Limited’s privacy policy."}]]],["p",{},[["textNode",{"text":"Centro Publisher Limited respects your privacy and is committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you."}]]],["p",{},[["textNode",{"text":"This privacy policy is provided in a layered format, so you can click through to the specific areas set out below. Please also use the Glossary to understand the meaning of some of the terms used in this privacy policy."}]]],["ol",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Important Information and Who We Are"}]]]]],["li",{},[["p",{},[["textNode",{"text":"The Data We Collect About You"}]]]]],["li",{},[["p",{},[["textNode",{"text":"How Is Your Personal Data Collected"}]]]]],["li",{},[["p",{},[["textNode",{"text":"How We Use Your Personal Data"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Disclosures of Your Personal Data"}]]]]],["li",{},[["p",{},[["textNode",{"text":"International Transfers"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Data Security"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Data Retention"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Do Not Track Policy"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Your Nevada Privacy Rights"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Your Canadian Privacy Rights"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Your GDPR Legal Rights"}]]]]],["li",{},[["p",{},[["textNode",{"text":"Glossary"}]]]]]]]]]]],["div",{"class":"sp-part","id":"part_1"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 1. Important Information and Who We Are"}]]],["p",{},[["strong",{},[["textNode",{"text":"Purpose of this Privacy policy"}]]]]],["p",{},[["textNode",{"text":"This privacy policy aims to give you information on how Centro Publisher Limited collects and processes your personal data through your use of this website, including any data you may provide through this website when you sign up to our website."}]]],["p",{},[["textNode",{"text":"This website is not intended for children and we do not knowingly collect data relating to children."}]]],["p",{},[["textNode",{"text":"It is important that you read this privacy policy together with any other privacy policy or fair processing policy we may provide on specific occasions when we are collecting or processing personal data about you so that you are fully aware of how and why we are using your data. This privacy policy supplements other notices and privacy policies and is not intended to override them. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Controller"}]]]]],["p",{},[["textNode",{"text":"Centro Publisher Limited is the controller and responsible for your personal data (collectively referred to as “ModelCentro”, “we”, “us”, or “our” in this privacy policy)."}]]],["p",{},[["textNode",{"text":"We have appointed a data privacy manager who is responsible for overseeing questions in relation to this privacy policy. If you have any questions about this privacy policy, including any requests to exercise your GDPR legal rights, please contact the data privacy manager using the details set out below."}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Details"}]]]]],["p",{},[["textNode",{"text":"If you have any questions about this privacy policy or our privacy practices, please contact our data privacy manager in the following ways: "}],["br"],["textNode",{"text":" Full name of legal entity: Centro Publisher Limited"}],["br"],["textNode",{"text":" Name or title of data privacy manager: Chief Privacy Officer"}],["br"],["textNode",{"text":" Email address: "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["br"],["textNode",{"text":" Postal address: Ajeltaki Road, Ajeltaki Island, Majuro, Marshal Islands MH96960."}]]],["p",{},[["textNode",{"text":"If you reside in the UK, you have the right to make a complaint at any time to the Information Commissioner’s Office (ICO), the UK supervisory authority for data protection issues ("}],["a",{"href":"https://ico.org.uk/","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.ico.org.uk"}]]],["textNode",{"text":"). "}]]],["p",{},[["textNode",{"text":"If you reside within the EEA, you have the right to make a complaint at any time to the appropriate supervisory authority for your country of residence. See "}],["a",{"href":"https://ec.europa.eu","target":"_blank","rel":"nofollow"},[["textNode",{"text":"ec.europa.eu"}]]],["textNode",{"text":" for these details. "}]]],["p",{},[["textNode",{"text":"If you reside outside the EEA or the UK, we will apply your legal rights as applicable to the data laws in the jurisdiction you are in."}]]],["p",{},[["textNode",{"text":"We would, however, appreciate the chance to deal with your concerns before you approach your supervisory authority so please contact us in the first instance."}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the Privacy policy and Your Duty to Inform Us of Changes"}]]]]],["p",{},[["textNode",{"text":"We keep our privacy policy under regular review. This version was last updated on December 6, 2019. Historic versions can be obtained by contacting us at "}],["a",{"data-name":"privacy","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"},[["textNode",{"text":"privacy "}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"The data protection law in the European Union changes on May 25, 2018. Although this privacy policy states most of your rights under the new laws, we may not yet be able to respond to some of your requests (for example, a request for erasure) until May 2018 as we are still working towards getting our systems ready for some of these changes."}]]],["p",{},[["textNode",{"text":"It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-Party Links"}]]]]],["p",{},[["textNode",{"text":"This website may include links to third-party websites, plug-ins, and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit."}]]]]]]],["div",{"class":"sp-part","id":"part_2"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 2. The Data We Collect About You "}]]],["p",{},[["textNode",{"text":"Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data)."}]]],["p",{},[["textNode",{"text":"We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Identity Data"}]]],["textNode",{"text":" includes first name, last name, stage name, username or similar identifier, third-party social media account login information, tax or national identification number, government-issued identification number, date of birth, and gender."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Contact Data"}]]],["textNode",{"text":" includes mailing address, email address, and telephone numbers."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Financial Data"}]]],["textNode",{"text":" includes bank account details."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Transaction Data"}]]],["textNode",{"text":" includes details about payments to you and other details of ModelCentro products and services you use."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Technical Data"}]]],["textNode",{"text":" includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Content Data"}]]],["textNode",{"text":" includes photos, videos, or other digital content uploaded to our platform (please remember that Content Data that you post may reveal personal data about yourself as well)."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Profile Data"}]]],["textNode",{"text":" includes your username and password, your interests, preferences, feedback, and survey responses."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Usage Data"}]]],["textNode",{"text":" includes information about how you use our website, products, and services."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Facebook® and Twitter® Login Data"}]]],["textNode",{"text":" includes your email address and password if you choose to link your Facebook® or Twitter® account with us to facilitate account creation and logon process."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Marketing and Communications Data"}]]],["textNode",{"text":" includes your preferences in receiving marketing from us and our third parties and your communication preferences."}]]]]]]],["p",{},[["textNode",{"text":"We also collect, use, and share "}],["strong",{},[["textNode",{"text":"Aggregated Data"}]]],["textNode",{"text":" such as statistical or demographic data for any purpose. Aggregated Data could be derived from your personal data but is not considered personal data in law as this data will not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific website feature. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy."}]]],["p",{},[["textNode",{"text":"We do not collect any "}],["strong",{},[["textNode",{"text":"Special Categories of Personal Data "}]]],["textNode",{"text":" about you (this includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health, and genetic and biometric data) unless you voluntarily provide it. Nor do we collect any information about criminal convictions and offenses."}]]],["p",{},[["strong",{},[["textNode",{"text":"If You Fail to Provide Personal Data"}]]]]],["p",{},[["textNode",{"text":"Where we need to collect personal data by law, or under the terms of a contract we have with you and you fail to provide that data when requested, we may not be able to perform the contract we have or are trying to enter into with you (for example, to provide you with goods or services). In this case, we may have to cancel a service you have with us, but we will notify you if this is the case at the time."}]]]]]]],["div",{"class":"sp-part","id":"part_3"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"3. How Is Your Personal Data Collected? "}]]],["p",{},[["textNode",{"text":"We use different methods to collect data from and about you, including through:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["strong",{},[["textNode",{"text":"Direct interactions"}]]],["textNode",{"text":". You may give us your Identity, Contact, and Financial Data by filling in forms or by corresponding with us by post, email, or otherwise. This includes personal data you provide when you: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["p",{},[["textNode",{"text":"apply for our products or services;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"create an account on our website;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"create a website on our platform;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"request marketing to be sent to you;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"enter a competition, promotion, or survey;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"give us feedback or contact us."}]]]]]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Automated technologies or interactions."}]]],["textNode",{"text":" As you interact with our website, we will automatically collect Technical and Usage Data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, server logs, and other similar technologies. We may also receive Technical and Usage Data about you if you visit other websites employing our cookies. Please see our "}],["a",{"href":"https://models.xxx/cookie-policy"},[["textNode",{"text":"cookie policy"}]]],["textNode",{"text":" for further details."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Third parties or publicly available sources."}]]],["textNode",{"text":" We will receive personal data about you from various third parties as set out below: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["p",{},[["textNode",{"text":"Technical Data from the following parties:"}]]],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["p",{},[["textNode",{"text":"analytics providers such as Google based outside the EU;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"payment processors such as CentroBill based inside and outside the EU;"}]]]]],["li",{},[["p",{},[["textNode",{"text":"affiliates based inside and outside the EU; and"}]]]]],["li",{},[["p",{},[["textNode",{"text":"search information providers such as Google based outside the EU."}]]]]]]]]],["li",{},[["p",{},[["textNode",{"text":"Contact, Financial, and Transaction Data from providers of technical, payment, and delivery services such as CentroBill based inside and outside the EU."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Contact, Technical, and Profile Data from third-party social media platforms such as Facebook® and Twitter® based outside the EU if you choose to register and login using your Facebook® or Twitter® account. "}]]]]]]]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"User Contributions."}]]],["textNode",{"text":" You also may provide Content Data for us to publish or display "}],["strong",{},[["textNode",{"text":"(“post”)"}]]],["textNode",{"text":" on public website areas or transmit to other website users or third parties. You submit Content Data for posting and transmission to others at your own risk. Although you may set certain privacy settings for Content Data by logging into your account profile, please be aware that no security measures are perfect or impenetrable. Additionally, we cannot control the actions of any website users with whom you choose to share your Content Data. Therefore, we cannot and do not guarantee that unauthorized persons will not view your Content Data."}]]]]]]]]]]],["div",{"class":"sp-part","id":"part_4"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 4. How We Use Your Personal Data "}]]],["p",{},[["textNode",{"text":"We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Where we need to perform the contract we are about to enter into or have entered into with you."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Where we need to comply with a legal obligation."}]]]]]]],["p",{},[["textNode",{"text":"Visit the Glossary to find out more about the types of lawful basis that we will rely on to process your personal data."}]]],["p",{},[["textNode",{"text":"Generally, we do not rely on consent as a legal basis for processing your personal data although we will get your consent before sending third-party direct marketing communications to you via email. You have the right to withdraw consent to marketing at any time by contacting us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Purposes for Which We Will Use Your Personal Data"}]]]]],["p",{},[["textNode",{"text":"We have set out below, in a table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate."}]]],["p",{},[["textNode",{"text":"Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data. Please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":" if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below."}]]],["table",{"border":"1","cellpadding":"7","cellspacing":"0"},[["tr",{},[["th",{},[["textNode",{"text":"Purpose/Activity"}]]],["th",{},[["textNode",{"text":"Type of data"}]]],["th",{},[["textNode",{"text":"Lawful basis for processing including basis of legitimate interest"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"To register you as a new customer"}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact "}]]],["td",{},[["textNode",{"text":"Performance of a contract with you"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To process and manage your account including:"}],["br"],["br"],["textNode",{"text":" (a) Manage your website or store "}],["br"],["br"],["textNode",{"text":" (b) Verify your age and identity"}],["br"],["br"],["textNode",{"text":" (c) Collect and pay money owed to you "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Financial"}],["br"],["br"],["textNode",{"text":" (d) Transaction"}],["br"],["br"],["textNode",{"text":" (e) Content"}],["br"],["br"],["textNode",{"text":" (f) Profile"}],["br"],["br"],["textNode",{"text":" (g) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary for our legitimate interests (to verify your age and identity) (c) Necessary to comply with a legal obligation "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To manage our relationship with you which will include:"}],["br"],["br"],["textNode",{"text":" (a) Notifying you about changes to our terms or privacy policy"}],["br"],["br"],["textNode",{"text":" (b) Communicate with you about your account"}],["br"],["br"],["textNode",{"text":" (c) Asking you to leave a review or take a survey "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Profile"}],["br"],["br"],["textNode",{"text":" (d) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation"}],["br"],["br"],["textNode",{"text":" (c) Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To enable you to partake in a prize draw, competition, or complete a survey "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Profile"}],["br"],["br"],["textNode",{"text":" (d) Usage"}],["br"],["br"],["textNode",{"text":" (e) Marketing and Communications "}]]],["td",{},[["textNode",{"text":"(a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary for our legitimate interests (to study how customers use our products/services, to develop them and grow our business) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To administer and protect our business and this website and conduct internal operations(including for security, fraud, troubleshooting/technical support, data analysis, testing, system maintenance, support, reporting, and hosting of data) "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Technical "}]]],["td",{},[["textNode",{"text":" (a) Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud, and in the context of a business reorganization or group restructuring exercise)"}],["br"],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To deliver content to you and to measure or understand the effectiveness of the content we serve to you "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (c) Technical "}],["br"],["br"],["textNode",{"text":" (d) Content"}],["br"],["br"],["textNode",{"text":" (e) Profile"}],["br"],["br"],["textNode",{"text":" (f) Usage"}],["br"],["br"],["textNode",{"text":" (g) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["br"],["textNode",{"text":" (b) Necessary for our legitimate interests (to provide you content that you have requested, to study how customers use our services, to develop them, to grow our business, and to inform our marketing strategy) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To use data analytics to improve our website, products/services, marketing, customer relationships, and experiences "}]]],["td",{},[["textNode",{"text":" (a) Technical"}],["br"],["br"],["textNode",{"text":" (b) Usage "}]]],["td",{},[["textNode",{"text":" Necessary for our legitimate interests (to define types of customers for our products and services, to keep our website updated and relevant, to develop our business, and to inform our marketing strategy)"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To make suggestions and recommendations to you about goods or services that may be of interest to you "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["br"],["textNode",{"text":" (b) Contact"}],["br"],["br"],["textNode",{"text":" (c) Technical"}],["br"],["br"],["textNode",{"text":" (d) Usage"}],["br"],["br"],["textNode",{"text":" (e) Profile"}],["br"],["br"],["textNode",{"text":" (f) Marketing and Communications "}]]],["td",{},[["textNode",{"text":"Necessary for our legitimate interests (to develop our products/services and grow our business)"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To allow you to sign up or log in using your Facebook® or Twitter® account "}]]],["td",{},[["textNode",{"text":" Facebook® and Twitter® Login Data "}]]],["td",{},[["textNode",{"text":"Your consent"}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Marketing"}]]]]],["p",{},[["textNode",{"text":"We strive to provide you with choices regarding certain personal data uses, particularly around marketing and advertising. We have established the following personal data control mechanisms:"}]]],["p",{},[["strong",{},[["textNode",{"text":"Promotional Offers from Us"}]]]]],["p",{},[["textNode",{"text":"We may use your Identity, Contact, Technical, Usage, and Profile Data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services, and offers may be relevant for you (we call this marketing)."}]]],["p",{},[["textNode",{"text":"You will receive marketing communications from us if you have requested information from us or purchased services from us or if you provided us with your details when you entered a competition or registered for a promotion and, in each case, you have not opted out of receiving that marketing."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-Party Marketing"}]]]]],["p",{},[["textNode",{"text":"We will get your express opt-in consent before we share your personal data with any third party for marketing purposes."}]]],["p",{},[["strong",{},[["textNode",{"text":"Opting Out"}]]]]],["p",{},[["textNode",{"text":"You can ask us or third parties to stop sending you marketing messages at any time by following the opt-out links on any marketing messages sent to you or by contacting us at any time at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of a service purchase or registration, service experience, or other transactions. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies"}]]]]],["p",{},[["textNode",{"text":"You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly. For more information about the cookies we use, please see our "}],["a",{"href":"https://models.xxx/cookie-policy"},[["textNode",{"text":"cookie policy"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Change of Purpose"}]]]]],["p",{},[["textNode",{"text":"We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so."}]]],["p",{},[["textNode",{"text":"Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law."}]]]]]]],["div",{"class":"sp-part","id":"part_5"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 5. Disclosures of Your Personal Data "}]]],["p",{},[["textNode",{"text":"We may share your personal data with the parties set out below for the purposes stated in the table (Purposes for which we will use your personal data) above. "}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"External Third Parties as set out in the Glossary."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Specific third parties such as VikingHost B.V., CentroBill, Facebook, and Twitter."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy."}]]]]]]],["p",{},[["textNode",{"text":"We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions."}]]]]]]],["div",{"class":"sp-part","id":"part_6"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 6. International Transfers "}]]],["p",{},[["textNode",{"text":"We are based in the Marshal Islands, but our servers are located in the Netherlands. We may process, store, and transfer personal data we collect, in and to a country outside your own, with different privacy laws that may or may not be comprehensive as your own. Where we do so, and where we are required to under local law, we will put in place appropriate mechanisms to ensure that your personal data receives an adequate level of protection where it is processed."}]]],["p",{},[["textNode",{"text":"Unless you are located in the EEA or the UK, by submitting your personal data or engaging with the website or our application, you consent to this transfer, storing, or processing."}]]],["p",{},[["textNode",{"text":"If you reside in the European Economic Area (EEA) or the United Kingdom (UK), your personal data may be processed outside of the EEA or UK, including, for example, in the United States, so processing of your personal data will involve a transfer of data outside the EEA or UK. "}]]],["p",{},[["textNode",{"text":"Whenever we transfer your personal data out of the EEA, we ensure a similar degree of protection is afforded to it by ensuring that the recipient third party agrees to contractual clauses."}]]],["p",{},[["textNode",{"text":"Please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":" if you want further information on the specific mechanism used by us when transferring your personal data out of the EEA or UK."}]]]]]]],["div",{"class":"sp-part","id":"part_7"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 7. Data Security "}]]],["p",{},[["textNode",{"text":"We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality."}]]],["p",{},[["textNode",{"text":"We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so."}]]]]]]],["div",{"class":"sp-part","id":"part_8"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 8. Data Retention "}]]],["p",{},[["strong",{},[["textNode",{"text":"How Long Will You Use My Personal Data For?"}]]]]],["p",{},[["textNode",{"text":"We will only retain your personal data for as long as reasonably necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting, or reporting requirements. We may retain your personal data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with you. "}]]],["p",{},[["textNode",{"text":"To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting, or other requirements. "}]]],["p",{},[["textNode",{"text":"By law we have to keep basic information about certain customers (including Contact, Identity, Financial, and Transaction Data) for seven years after they stop being customers for tax purposes or to comply with applicable law, including 18 U.S.C. § 2257. "}]]],["p",{},[["textNode",{"text":"In some circumstances (depending on where you reside) you can ask us to delete your data: see Request erasure below for further information. "}]]],["p",{},[["textNode",{"text":"In some circumstances we will anonymize your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you."}]]]]]]],["div",{"class":"sp-part","id":"part_9"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 9. Do Not Track Policy"}]]],["p",{},[["textNode",{"text":"Do Not Track (“DNT”) is a privacy preference that you can set in your browser. DNT is a way for you to inform websites and services that you do not want certain information about your webpage visits collected over time and across websites or online services. We are committed to providing you with meaningful choices about the information we collect and that is why we provide you the ability to opt out. But we do not recognize or respond to any DNT signals as the Internet industry works toward defining exactly what DNT means, what it means to comply with DNT, and a common approach to responding to DNT. For more information, visit "}],["a",{"href":"https://www.allaboutdnt.com","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.allaboutdnt.com"}]]],["textNode",{"text":"."}]]]]]]],["div",{"class":"sp-part","id":"part_10"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 10. Your California Privacy Rights "}]]],["p",{},[["textNode",{"text":"If you are a California resident, California law may provide you with additional rights regarding our use of your personal data. To learn more about your California privacy rights., visit "}],["a",{"href":"/california-privacy-rights"},[["textNode",{"text":" https://models.xxx/california-privacy-rights"}]]]]],["p",{},[["textNode",{"text":"California’s “Shine the Light” law (Civil Code Section 1798.83) permits our users who are California residents to request certain information regarding our disclosure of personal data to third parties for their direct marketing purposes. To make that request, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]]]],["p",{},[["textNode",{"text":" Further, if you are a California resident and would like to opt out from the disclosure of your personal data to any third party for direct marketing purposes, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". If you opt out from permitting your personal data to be shared, you may still receive selected offers directly from us in accordance with California law. "}]]]]]]],["div",{"class":"sp-part","id":"part_11"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 11. Your Nevada Privacy Rights "}]]],["p",{},[["textNode",{"text":"Nevada residents who wish to exercise their sale opt-out rights under Nevada Revised Statutes Chapter 603A may submit a request to this designated address: "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". However, please know we do not currently sell data triggering that statute’s opt-out requirements. "}]]]]]]],["div",{"class":"sp-part","id":"part_12"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 12. Your Canadian Privacy Rights "}]]],["p",{},[["textNode",{"text":"We comply with Canadian Federal and Provincial privacy laws and regulations, including the Personal Information Protection and Electronic Documents Act. "}]]],["p",{},[["textNode",{"text":"We will only use your personal information for the purposes intended and as detailed in this policy unless we have obtained your consent to use it for other purposes. "}]]],["p",{},[["textNode",{"text":"Residents of Canada are notified that the personal data they provide to us is stored in our databases outside of Canada, including in the Netherlands, and may be subject to disclosure to authorized law enforcement or government agencies in response to lawful demand under the laws of that country."}]]],["p",{},[["textNode",{"text":"You may withdraw your consent to our personal data collection, use, or disclosure, subject to legal and contractual restrictions."}]]],["p",{},[["textNode",{"text":"You have the right to complain about our personal data handling practices."}]]],["p",{},[["textNode",{"text":"If you need to contact us about your personal data or believe that we have violated your privacy rights, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". You may visit "}],["a",{"target":"_blank","href":"https://www.priv.gc.ca/"},[["textNode",{"text":" www.priv.gc.ca"}]]],["textNode",{"text":" for more information about your privacy rights. "}]]]]]]],["div",{"class":"sp-part","id":"part_13"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 13. Your GDPR Legal Rights "}]]],["p",{},[["textNode",{"text":"If you reside in the EEA or UK, under certain circumstances, you have rights under data protection laws in relation to your personal data. Please click on the links below to find out more about these rights: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Request access to your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request correction of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request erasure of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Object to processing of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request restriction of processing your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Request transfer of your personal data."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Right to withdraw consent."}]]]]]]],["p",{},[["textNode",{"text":"If you wish to exercise any of the rights set out above, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"No Fee Usually Required"}]]]]],["p",{},[["textNode",{"text":"You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive, or excessive. Alternatively, we could refuse to comply with your request in these circumstances."}]]],["p",{},[["strong",{},[["textNode",{"text":"What We May Need from You"}]]]]],["p",{},[["textNode",{"text":"We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response."}]]],["p",{},[["strong",{},[["textNode",{"text":"Time Limit to Respond"}]]]]],["p",{},[["textNode",{"text":"We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated. "}]]]]]]],["div",{"class":"sp-part","id":"part_14"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 14. Glossary "}]]],["p",{},[["strong",{},[["textNode",{"text":"Lawful Basis"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Consent "}]]],["textNode",{"text":" means processing your personal data where you have signified your agreement by a statement or clear opt-in to processing for a specific purpose. Consent will only be valid if it is a freely given, specific, informed, and unambiguous indication of what you want. You can withdraw your consent at any time by contacting us. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Legitimate Interest"}]]],["textNode",{"text":" means the interest of our business in conducting and managing our business to enable us to give you the best service/product and the best and most secure experience. We make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process your personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities by contacting us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Performance of Contract"}]]],["textNode",{"text":" means processing your data where it is necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract."}]]],["p",{},[["strong",{},[["textNode",{"text":"Comply with a legal obligation "}]]],["textNode",{"text":" means processing your personal data where it is necessary for compliance with a legal obligation that we are subject to."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third Parties"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"External Third Parties"}]]]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Compliance with Laws"}]]],["textNode",{"text":". We may disclose your information where we are legally required to do so to comply with applicable law, government requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements). "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Vital Interests and Legal Rights"}]]],["textNode",{"text":". We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved. "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Vendors, Consultants, and Other Third-Party Service Providers"}]]],["textNode",{"text":". We may share your data with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf and require access to that information to do that work. Examples include payment processing, data analysis, email delivery, hosting services, customer service, and marketing efforts. We may allow selected third parties to use tracking technology on the website, which will enable them to collect data about how you interact with the website over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content and better understand online activity. For example, we use Google Analytics to help us understand how our customers use the website (you can read more about how Google uses your personal data here: "}],["a",{"target":"_blank","rel":"nofollow","href":"https://www.google.com/intl/en/policies/privacy/"},[["textNode",{"text":" https://www.google.com/intl/en/policies/privacy/)"}]]],["textNode",{"text":". You can also optout of Google Analytics here: "}],["a",{"target":"_blank","rel":"nofollow","href":"https://tools.google.com/dlpage/gaoptout"},[["textNode",{"text":" https://tools.google.com/dlpage/gaoptout"}]]],["textNode",{"text":". "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Your Legal Rights"}]]]]],["p",{},[["textNode",{"text":"Depending on the country you reside in, you may have the right to:"}]]],["p",{},[["strong",{},[["textNode",{"text":"Request access"}]]],["textNode",{"text":" to your personal data (commonly known as a “data subject access request”). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request correction"}]]],["textNode",{"text":" of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request erasure"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully, or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request."}]]],["p",{},[["strong",{},[["textNode",{"text":"Object to processing"}]]],["textNode",{"text":" of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request restriction of processing"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: (a) if you want us to establish the data’s accuracy; (b) where our use of the data is unlawful but you do not want us to erase it; (c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise, or defend legal claims; or (d) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it."}]]],["p",{},[["strong",{},[["textNode",{"text":"Request the transfer"}]]],["textNode",{"text":" of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you."}]]],["p",{},[["strong",{},[["textNode",{"text":"Withdraw consent at any time"}]]],["textNode",{"text":" where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent."}]]]]]]]]],["div",{"class":"col sp-right"},[["ul",{"class":"part-navigator"},[["li",{"data-target":"part_0"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Introduction "}]]],["li",{"data-target":"part_1"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Important Information and Who We Are "}]]],["li",{"data-target":"part_2"},[["span",{"class":"sp-dot"}],["textNode",{"text":" The Data We Collect About You "}]]],["li",{"data-target":"part_3"},[["span",{"class":"sp-dot"}],["textNode",{"text":" How Is Your Personal Data Collected? "}]]],["li",{"data-target":"part_4"},[["span",{"class":"sp-dot"}],["textNode",{"text":" How We Use Your Personal Data "}]]],["li",{"data-target":"part_5"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Disclosures of Your Personal Data "}]]],["li",{"data-target":"part_6"},[["span",{"class":"sp-dot"}],["textNode",{"text":" International Transfers "}]]],["li",{"data-target":"part_7"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Data Security "}]]],["li",{"data-target":"part_8"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Data Retention "}]]],["li",{"data-target":"part_9"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Do Not Track Policy "}]]],["li",{"data-target":"part_10"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your California Privacy Rights "}]]],["li",{"data-target":"part_11"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your Nevada Privacy Rights "}]]],["li",{"data-target":"part_12"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your Canadian Privacy Rights"}]]],["li",{"data-target":"part_13"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Your Legal Rights "}]]],["li",{"data-target":"part_14"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Glossary "}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("menu_sidebar", [["section",{},[["div",{"class":"has-maxw navi-title"},[["span",{"class":"icon hide-menu"},[["i",{"class":"icon-xxx-07"}]]],["textNode",{"text":" "}],["span",{"class":"txt"},[["textNode",{"text":"hide menu"}]]]]],["ul",{"class":"has-maxw"},[["li",{},[["a",{"href":"/"},[["i",{"class":"icon icon-xxx-05"}],["textNode",{"text":" "}],["span",{"class":"descr label"},[["textNode",{"text":"Models"}]]],["textNode",{"text":" "}],["span",{"class":"descr updates"},[["textNode",{"text":"256 hottest updates"}]]]]]]],["li",{},[["a",{"href":"/updates"},[["i",{"class":"icon icon-xxx-01"}],["textNode",{"text":" "}],["span",{"class":"descr label"},[["textNode",{"text":"Latest updates"}]]],["textNode",{"text":" "}],["span",{"class":"descr updates"},[["textNode",{"text":"256 hottest updates"}]]]]]]],["li",{},[["a",{"href":"http://videos.models.xxx"},[["i",{"class":"icon icon-xxx-18"}],["span",{"class":"descr label"},[["textNode",{"text":"Free Videos"}]]],["span",{"class":"descr updates"},[["textNode",{"text":"256 hottest updates"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("model_profile", [["div",{"class":"model-profile-wrapper"},[["div",{"class":"model-profile page-width"},[["div",{"class":"sidebar"},[["if",{"notempty":""},[["div",{"class":"profile-foto"},[["img",{"src":"","alt":""},[],[["image.url","src",true],["stats.name","alt",true]]]]]],[["image.name","notempty",true]]],["div",{"class":"block"},[["div",{"class":"model-name"},[["if",{"notempty":""},[["div",{"class":"avatar"},[["img",{"src":"","alt":""},[],[["avatar","src",true],["stats.name","alt",true]]]]]],[["avatar","notempty",true]]],["div",{"class":"name"},[["textNode",{"text":" "}],["span",{},[],[["stats.name","__text",true]]],["textNode",{"text":" "}]]],["div",{"class":"online"},[["textNode",{"text":" Was online at "}],["span",{},[],[["lastOnline","__text",true,[{"name":"dateFormat","params":["%d %b, %Y"]}]]]],["textNode",{"text":" "}]]]]],["div",{"class":"link-to-site row"},[["a",{"href":"http://&&0&&/&&1&&","target":"_blank"},[["i",{"class":"icn-mc-xxx-visitSite_15"}],["textNode",{"text":" Official website "}]],[["siteUrl","href"],["foxref","href",false,[],"env"]]]]],["div",{"class":"models-content row"},[["div",{"class":"txt"},[["textNode",{"text":"Model's content:"}]]],["div",{"class":"val"},[["span",{"class":"icon"},[["i",{"class":"icn-mc-xxx-liveShow_24"}],["textNode",{"text":" "}],["span",{"class":"num"},[["span",{},[],[["counters.totalLiveshows","__text",true]]]]]]],["span",{"class":"icon"},[["i",{"class":"icn-mc-xxx-videosCounter_13"}],["textNode",{"text":" "}],["span",{"class":"num"},[["span",{},[],[["counters.totalVideos","__text",true]]]]]]],["textNode",{"text":" "}],["span",{"class":"icon"},[["i",{"class":"icn-mc-xxx-photosets_19"}],["textNode",{"text":" "}],["span",{"class":"num"},[["span",{},[],[["counters.totalPhotosets","__text",true]]]]]]]]]]]]],["div",{"class":"block socials"},[["div",{"class":"social-networks row"},[["div",{"class":"txt"},[["textNode",{"text":"Social networks:"}]]],["div",{"class":"val"},[["foreach",{"from":"","item":"item"},[["a",{"href":"","target":"_blank"},[["i",{"class":"icn-mc-xxx-&&0&&_18"},[],[["item.alias","class"]]]],[["item.pageUrl","href",true]]]],[["socialList","from",true]]]]]]],["if",{"notempty":""},[["div",{"class":"models-wishlist row"},[["div",{"class":"txt"},[["textNode",{"text":"My wishlist:"}]]],["div",{"class":"val"},[["i",{"class":"icn-mc-xxx-wishlist_19"}],["a",{"href":"","target":"_blank"},[["textNode",{"text":" Open wish list "}]],[["amazonwishListUrl.listUrl","href",true]]]]]]]],[["amazonwishListUrl.listUrl","notempty",true]]]]],["div",{"class":"block external-apps"},[["if",{"notempty":""},[["div",{"class":"skyprivate row"},[["div",{"class":"txt"},[["textNode",{"text":"Skype me:"}]]],["div",{"class":"val"},[["a",{"href":"","target":"_blank","class":""},[["img",{"src":"" + __webpack_require__(110) + "","alt":""}]],[["amazonwishListUrl.listUrl","href",true]]]]]]]],[["skyprivate.connected","notempty",true]]],["if",{"notempty":""},[["div",{"class":"call-me row"},[["div",{"class":"txt"},[["textNode",{"text":"Call me:"}]]],["div",{"class":"val"},[["iframe",{"src":"https://verifiedcall.com/module/?talent=&&0&&&style=k&aff=modelcentro","frameborder":"0"},[],[["varifyCall.profile","src"]]]]]]]],[["varifyCall.link","notempty",true]]]]]]],["div",{"class":"profile-data"},[["div",{"class":"subscribe"},[["i",{"class":"icn-mc-xxx-emailSubscribe_14"}],["textNode",{"text":" "}],["a",{"class":"show-subscribe-popup"},[["textNode",{"text":"Subscribe to model's updates"}]]]]],["div",{"class":"title"},[["textNode",{"text":" About "}],["span",{},[],[["stats.name","__text",true]]],["textNode",{"text":" "}]]],["if",{"notempty":""},[["if",{"notempty":""},[["div",{"class":"introduction"},[["div",{"class":"short"},[["textNode",{"text":" "}],["span",{},[],[["stats.introduction","__text",true,[{"name":"truncate","params":["150","..."]}]]]],["textNode",{"text":" "}]]],["div",{"class":"long"},[["textNode",{"text":" "}],["span",{},[],[["stats.introduction","__text",true]]],["textNode",{"text":" "}]]],["div",{"class":"show-full"},[["a",{"class":"show-more"},[["textNode",{"text":" Show full text "}],["i",{"class":"icn-xxx-09"}]]]]]]],["else",{},[["div",{"class":"introduction"},[["textNode",{"text":" "}],["span",{},[],[["stats.introduction","__text",true]]],["textNode",{"text":" "}]]]]]],[["stats.introduction","notempty",true,[{"name":"length","params":["gt","150"]}]]]]],[["stats.introduction","notempty",true]]],["div",{"class":"stats-table"},[["div",{"class":"header"},[["div",{"class":"item active","data-tab-alias":"stats"},[["textNode",{"text":" stats "}],["span",{"class":"pointer"}]]],["if",{"empty":""},[["div",{"class":"item","data-tab-alias":"filmography"},[["textNode",{"text":" filmography "}],["span",{"class":"pointer"}]]]],[["publicActivity.movie","empty",true,[{"name":"empty","params":[]}]]]],["if",{"empty":""},[["div",{"class":"item","data-tab-alias":"awards"},[["textNode",{"text":" awards "}],["span",{"class":"pointer"}]]]],[["publicActivity.award","empty",true,[{"name":"empty","params":[]}]]]]]],["div",{"class":"stats-content"},[["div",{"class":"item active","data-tab-alias":"stats"},[["foreach",{"from":"","item":"item"},[["if",{"notempty":""},[["div",{"class":"row"},[["div",{"class":"name"},[["span",{},[],[["item.title","__text",true]]]]],["div",{"class":"value"},[["span",{},[],[["item.value","__text",true]]]]]]]],[["item.value","notempty",true,[{"name":"notEmpty","params":[]}]]]]],[["stats.data","from",true]]]]],["if",{"empty":""},[["if",{"empty":""},[["div",{"class":"item","data-tab-alias":"filmography"},[["foreach",{"from":"","item":"item2"},[["div",{"class":"row"},[["strong",{},[["span",{},[],[["item2.yearMovie","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"- "}],["span",{},[],[["item2.titleMovie","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"- "}],["span",{},[],[["item2.director","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"- "}],["span",{},[],[["item2.studio","__text",true]]]]]]]],[["publicActivity.movie","from",true]]]]]],[["publicActivity.movie","empty",true,[{"name":"empty","params":[]}]]]],["if",{"empty":""},[["div",{"class":"item","data-tab-alias":"awards"},[["foreach",{"from":"","item":"item3"},[["div",{"class":"row"},[["strong",{},[["span",{},[],[["item3.yearAward","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"- "}],["span",{},[],[["item3.category","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"- "}],["span",{},[],[["item3.titleAward","__text",true]]]]]]]],[["publicActivity.award","from",true]]]]]],[["publicActivity.award","empty",true,[{"name":"empty","params":[]}]]]]],[["publicActivity","empty",true,[{"name":"empty","params":[]}]]]]]]]]]]]],["div",{"class":"list-wrapper"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/profile-skyprivate-icon.png", __webpack_require__.p + "images/profile-skyprivate-icon.png");

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_example", [["div",{"class":"popup-content-wrapper"},[["span",{"class":"cross close-popup"},[["textNode",{"text":"+"}]]],["div",{"class":"title-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"Example popup"}]]]]],["div",{"class":"content-wrapper"},[["p",{"class":"caption"},[["textNode",{"text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."}]]],["p",{},[["textNode",{"text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."}]]],["p",{},[["textNode",{"text":"Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."}]]]]],["div",{"class":"footer-wrapper"},[["button",{"class":"button"},[["textNode",{"text":"Ok"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_model_subscription", [["div",{"class":"popup-content-wrapper"},[["span",{"class":"cross close-popup"},[["textNode",{"text":"+"}]]],["div",{"class":"title-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"Email subscription"}]]]]],["div",{"class":"content-wrapper"},[["div",{"class":"subscription-form-wrapper"},[["p",{"class":"caption"},[["textNode",{"text":"Subscribe to "}],["span",{},[],[["modelName","__text",true]]],["textNode",{"text":" updates"}]]],["form",{"class":"subscription-form"},[["div",{"class":"row"},[["div",{"class":"inp name"},[["input",{"type":"text","name":"name","placeholder":"Type name here","autocomplete":"off"}]]],["div",{"class":"error-msg"}]]],["div",{"class":"row"},[["div",{"class":"inp email"},[["input",{"type":"text","name":"email","placeholder":"Type email here","autocomplete":"off"}]]],["div",{"class":"error-msg"}]]]]]]]]],["div",{"class":"footer-wrapper"},[["button",{"class":"button subscribe"},[["textNode",{"text":"Subscribe"}]]]]]]]]);
fox.registerTemplate("popup_model_subscription_success", [["div",{"class":"popup-content-wrapper"},[["span",{"class":"cross close-popup"},[["textNode",{"text":"+"}]]],["div",{"class":"title-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"Subscription success!"}]]]]],["div",{"class":"content-wrapper"},[["div",{"class":"subscription-form-wrapper"},[["p",{},[["textNode",{"text":"You're now subscribed to "}],["strong",{},[["span",{},[],[["modelName","__text",true]]]]],["textNode",{"text":" updates!"}]]],["p",{},[["textNode",{"text":"Thank you for your subscription!"}]]]]]]]]]]);
fox.registerTemplate("popup_model_subscription_error", [["div",{"class":"popup-content-wrapper"},[["span",{"class":"cross close-popup"},[["textNode",{"text":"+"}]]],["div",{"class":"title-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"Subscription error!"}]]]]],["div",{"class":"content-wrapper"},[["div",{"class":"subscription-form-wrapper"},[["if",{"empty":""},[["p",{},[["textNode",{"text":"Subscription error!"}]]],["else",{},[["p",{},[["span",{},[],[["message","__text",true]]]]]]]],[["message","empty",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("vr_model_subscription", [["div",{"class":"vr-content-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"This page showcases the full list of websites powered by ModelCentro that offer VR content."}]]],["div",{"class":"subscription-vr-wrapper"},[["div",{"class":"vr-pic"},[["img",{"src":"" + __webpack_require__(114) + ""}]]],["div",{"class":"vr-text-form"},[["div",{"class":"vr-text"},[["p",{"class":"bold-text"},[["textNode",{"text":" We are currently working on adding new gorgeous websites, so please stay tuned! "}]]],["p",{"class":"text"},[["textNode",{"text":" If you would like to receive updates to your email address, simply subscribe to this newsletter and be the first to see the beautiful VR content produced by ModelCentro models! "}]]]]],["div",{"class":"vr-form"},[["form",{"class":"subscription-form"},[["div",{"class":"row"},[["div",{"class":"inp email"},[["input",{"type":"text","name":"email","placeholder":"Type email here","autocomplete":"off"}]]],["div",{"class":"error-msg"}]]],["button",{"class":"button subscribe"},[["i",{"class":"icn-mc-xxx-emailSubscribe_14"},[["span",{},[["textNode",{"text":"Subscribe"}]]]]]]]]]]]]]]]]]]);
fox.registerTemplate("popup_model_subscription_success", [["div",{"class":"popup-content-wrapper"},[["span",{"class":"cross close-popup"},[["textNode",{"text":"+"}]]],["div",{"class":"title-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"Subscription success!"}]]]]],["div",{"class":"content-wrapper"},[["div",{"class":"subscription-form-wrapper"},[["p",{},[["textNode",{"text":"You're now subscribed to "}],["strong",{},[["span",{},[],[["modelName","__text",true]]]]],["textNode",{"text":" updates!"}]]],["p",{},[["textNode",{"text":"Thank you for your subscription!"}]]]]]]]]]]);
fox.registerTemplate("popup_model_subscription_error", [["div",{"class":"popup-content-wrapper"},[["span",{"class":"cross close-popup"},[["textNode",{"text":"+"}]]],["div",{"class":"title-wrapper"},[["div",{"class":"title"},[["textNode",{"text":"Subscription error!"}]]]]],["div",{"class":"content-wrapper"},[["div",{"class":"subscription-form-wrapper"},[["if",{"empty":""},[["p",{},[["textNode",{"text":"Subscription error!"}]]],["else",{},[["p",{},[["span",{},[],[["message","__text",true]]]]]]]],[["message","empty",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/vr-subscribe.png", __webpack_require__.p + "images/vr-subscribe.png");

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("site", [["html",{"lang":"en"},[["head",{},[["meta",{"charset":"UTF-8"}],["title",{},[["textNode",{"text":"Models xxx"}]]],["meta",{"name":"viewport","content":"width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"}],["meta",{"property":"og:title","content":""},[],[["ogTitle","content",true,[],"env"]]],["meta",{"property":"og:url","content":""},[],[["ogUrl","content",true,[],"env"]]],["meta",{"property":"og:image","content":""},[],[["ogImage","content",true,[],"env"]]],["meta",{"property":"og:description","content":""},[],[["ogDescription","content",true,[],"env"]]],["link",{"rel":"icon","href":"require('../images/favicon.ico?skip-fox')","type":"image/x-icon"}],["meta",{"name":"google-site-verification","content":"2GDwvlpvftzEpsHo0GWfz7AUrLklnAhLcBXUWDGjqWA"}]]],["body"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./catalog/catalog3x/catalog3x.js": 117,
	"./catalog/catalog3x/latest.js": 118,
	"./catalog/catalog3x/list/content.js": 119,
	"./catalog/catalog3x/list/latest.js": 120,
	"./catalog/catalog3x/list/list.js": 121,
	"./catalog/catalog3x/list/models.js": 122,
	"./catalog/catalog3x/list/vrlist.js": 123,
	"./catalog/catalog3x/models.js": 124,
	"./catalog/catalog3x/vllist.js": 125,
	"./catalog/model/profile.js": 126,
	"./ccpa.es.js": 127,
	"./layout/catalog.js": 128,
	"./menu/sidebar.js": 129,
	"./models/closestLiveshows.js": 130,
	"./popup/model/subscription.js": 131,
	"./popup/model/subscriptionvr.js": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {	
	fox.registerWidget('Catalog3X', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'catalog_home',
				container: '.models-sitepage-wrapper',
				'!visual': true,
				'widgets.events.widgets.eventsList.widgets.list.manualRender': true
			});

			this.callParent('configure', arguments);
		}

	}, 'Site_Page');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	
	fox.registerWidget('Catalog3X_Latest', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					events: {
						widget: 'Catalog_List_Latest'
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Catalog3X');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Catalog_List_Content', {

		configure: function () {
			this.moreEventsAvailable = true;
			this.masonryApplied = false;
			this.searchKeyword = false;

			this.eventsAliases = {
				1: 'liveshow',
				2: 'post',
				3: 'message',
				4: 'trip',
				5: 'custom',
				6: 'photoset',
				7: 'video',
				8: 'join'
			};

			this.contentTypes = {
				1: 'Liveshow',
				2: 'Post',
				3: 'Photoset',
				4: 'Video',
				'Liveshow': 1,
				'Post': 2,
				'Photoset': 3,
				'Video': 4
			};/*[1, 2, 6, 7];*/
			
			this.registerOptions('', {
				'!scrollHandlerPath': '@parent @parent @parent #scrollHandler',
				template: 'catalog_home_models_grid',
				widgets: {
					eventsFilter: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-filter',
						template: 'catalog_filter_content',
						widgets: {
							search: {
								widget: 'Widget',
								autoRender: true,
								container: '.form-group.search',
								template: 'catalog_search_input'
							}
						},

						handleDom: {
							selectChange: {
								target: 'select',
								event: 'change',
								callback: '@parent:_handleSelectChange'
							},
							clearSearch: {
								targetWidget: '#search',
								target: '.icon.clear',
								event: 'click',
								callback: '@parent:_clearSearch'
							},
							search: {
								targetWidget: '#search',
								target: '.search-start',
								event: 'click',
								callback: '@parent:_searchByName'	
							}
						},

						handleWom: {
							searchFormSubmit: {
								widget: '#search',
								event: 'search_form_submit',
								callback: '@parent:_searchByName'
							}
						},

						'hooks.onAddedToDom': fox.bind(function () {
							var sortContent = fox.Navigator.get('sortContent');
							var type = fox.Navigator.get('type');
							var name = fox.Navigator.get('contentName');

							if (sortContent) {
								this.updateFilterOnLoad('sortContent', sortContent, true);
							}

							if (type) {
								this.updateFilterOnLoad('type', type, true);
							}

							if (name) {
								this.updateFilterOnLoad('contentName', name);
							}
						}, this)
					},
					eventsList: {
						'widgets.list.tpl.row': 'catalog_events_item_model_profile'
					}
				},
				handleWom: {
					'!_handleScrolling.widget': '@parent @parent @parent #scrollHandler'
				}
				
			});

			this.callParent('configure', arguments);

			this.searchParams = ['type', 'contentName', 'sortContent'];
			this.sortingTypes = {
				'-1': 'Last Added',
				1: 'A-Z',
				'Last Added': -1,
				'A-Z': 1
			};
		},

		activate: function (argument) {
			this.callParent('activate', arguments);
			
			this.resetPager();
		},

		_handleSelectChange: function (el, skipEvent) {
			var opt = el.options[el.selectedIndex];
			var parent = el.parentNode;
			$('.txt', parent).text(opt.innerHTML);


			if (skipEvent === true) {
				return;
			}

			this.dispatchEvent('select_changed', {name: el.name, value: opt.value});
		},

		_handleFilterChange: function (data) {
			this.masonryApplied = false;

			switch (data.name) {
				case 'type':
				case 'sortContent':
					if (data.value < 0) {
						this.setFilterParams(data.name, false);
						this.loadEvents();

						return;
					}

					this.setFilterParams(data.name, data.value);
				break;
			}

			this.loadEvents();
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('contentName', false);
			this.wom1('#eventsFilter #search').dom1('#search-by-name').value = '';

			this.loadEvents();
		},

		updateFilterOnLoad: function (alias, value, skipEvent) {
			switch (alias) {
				case 'contentName':
					this.updateNameInput(value);
				break;

				case 'sortContent':
					this.updateSelect('sortContent', value, skipEvent);
				break;

				case 'type':
					this.updateSelect('type', this.contentTypes[value], skipEvent);
				break;
			}
		},

		updateSelect: function (name, value, skipEvent) {
			var el = this.wom1('#eventsFilter').dom1('[name="' + name + '"]');

			if (!el) {
				return;
			}
			
			$(el).find('option').each(function (i, opt) {
				opt.selected = false;

				if (opt.value == value) {
					opt.selected = true;
				}
			});

			this._handleSelectChange(el, skipEvent);

		},

		updateNameInput: function (value) {
			this.rwom1('#eventsFilter #search').dom1('#search-by-name').value = window.decodeURI(value);
		},

		prepareResponse: function (response, alias) {
			var collection = response.collection;

			fox.each(collection, function (data) {
				data.eventAlias = this.eventsAliases[data.type];

				if (data.type == 2) {
					data.link  = [data.link, 'post', data._typedParams.id].join('/');
				}

				if (data.type == 1 || data.type == 7) {
					data.useSlideShow = true;
				}

				if (data.type == 1 && data._typedParams.status == 0 && new Date(data.startDate) < new Date()) {
					data.liveshowSkiped = true
					//data._typedParams.status = 1
				}

				if (fox.inArray(fox.getObjectKeys(this.contentTypes), data.type) && data.title) {
					data.link = [data.link, fox.utils.toNavigatorAlias(data.title)].join('/');
				}
			}, this);

			//console.log(response)
			this.wom1('#' + alias)._apiResponse = response.dataLayer || response;
		},

		_searchByName: function (obj, w, e) {
			var value = this.wom1('#eventsFilter #search').dom1('#search-by-name').value;
			//console.log('_searchByName', value);

			this.searchKeyword = value;

			if (!fox.trim(value).length) {
				this._clearSearch();

				return;
			};

			this.searchByName(value);

			return false;
		},

		searchByName: function (str) {
			this.masonryApplied = false;
			this.searchKeyword = str;

			this.setFilterParams('contentName', str);

			this.loadEvents();
		},

		/*prepareSearchParams: function (id) {
			this.callParent('prepareSearchParams', arguments);

			if (id) {
				this.eventsDl._transitParameters['clientId'] = id;
				this.moreEventsDl._transitParameters['clientId'] = id;
			}
		},*/

		prepareSearchParams: function (id) {
			this._resetDls();
			//this.eventsDl._transitParameters = {};
			//this.moreEventsDl._transitParameters = {};


			fox.each(this.searchParams, function (param) {
				var val = fox.Navigator.get(param);

				if (param === 'type') {
					val = this.contentTypes[val];
				}

				if (param === 'sortContent') {
					val = this.sortingTypes[val];
				}

				if (val) {
					this.setTransitParameter(param, val);
				}
			}, this);

			if (id) {
				this.eventsDl._transitParameters.clientId = id;
				this.moreEventsDl._transitParameters.clientId = id;
			}
		},

	}, 'Catalog_List');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_List_Latest', {

		configure: function () {
			this.moreEventsAvailable = true;
			this.masonryApplied = false;
			this.searchKeyword = false;

			this.eventsAliases = {
				1: 'liveshow',
				2: 'post',
				3: 'message',
				4: 'trip',
				5: 'custom',
				6: 'photoset',
				7: 'video',
				8: 'join'
			}

			this.contentTypes = [1, 2, 6, 7];

			this.registerOptions('', {
				widgets: {
					eventsFilter: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-filter',
						template: 'catalog_filter_latest',
						widgets: {
							search: {
								widget: 'Autocomplete2'
							}
						},

						handleDom: {
							selectChange: {
								target: 'select',
								event: 'change',
								callback: '@parent:_handleSelectChange'
							},
							clearSearch: {
								target: '.icon.clear',
								event: 'click',
								callback: '@parent:_clearSearch'
							}
						},

						handleWom: {
							searchFormSubmit: {
								widget: '#search',
								event: 'search_form_submit',
								callback: '@parent:_searchByName'
							}
						},

						'hooks.onAddedToDom': fox.bind(function () {
							var gender = fox.Navigator.get('gender');
							var name = fox.Navigator.get('name');

							if (gender) {
								this.updateFilterOnLoad('gender', this.genders[gender], true);
								//this.updateGenderSelect(this.genders[gender]);
							}
							if (name) {
								this.updateFilterOnLoad('name', name);
								this.setFilterParams('name', name);
								this.loadEvents();
							}
						}, this)
					}
				}
				
			});

			this.callParent('configure', arguments);
		},

		_handleSelectChange: function (el, skipEvent) {
			var opt = el.options[el.selectedIndex];
			var parent = el.parentNode;
			$('.txt', parent).text(opt.innerHTML);

			if (el.name == 'gender') {
				$('.icon.begin', parent).html('<i class="' + $(opt).attr('data-icon') + '"></i>');
			}

			if (skipEvent === true) {
				return;
			};

			this.dispatchEvent('select_changed', {name: el.name, value: opt.value})
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('name', false);
			this.loadEvents();
		},

		updateFilterOnLoad: function (alias, value, skipEvent) {
			switch (alias) {
				case 'name':
					this.updateNameInput(value);
				break;

				case 'gender':
					this.updateGenderSelect(value, skipEvent)
				break;
			}
		},

		updateGenderSelect: function (value, skipEvent) {
			var el = this.wom1('#eventsFilter').dom1('[name="gender"]');

			if (!el) {
				return;
			}
			
			$(el).find('option').each(function (i, opt) {
				opt.selected = false;

				if (opt.value == value) {
					opt.selected = true;
				};
			});

			this._handleSelectChange(el, skipEvent);

		},

		updateNameInput: function (value) {
			this.rwom1('#eventsFilter #search').fillInput(window.decodeURI(value));
		},

		prepareResponse: function (response, alias) {
			var collection = response.collection;

			fox.each(collection, function (data) {
				data.eventAlias = this.eventsAliases[data.type];

				if (data.type == 1 || data.type == 7) {
					data.useSlideShow = true;
				}

				if (data.type == 1 && data._typedParams.status == 0 && new Date(data.startDate) < new Date()) {
					data.liveshowSkiped = true
					//data._typedParams.status = 1
				}

				if (fox.inArray(this.contentTypes, data.type) && data.title) {
					data.link = [data.link, fox.utils.toNavigatorAlias(data.title)].join('/');
				}
			}, this);

			//console.log(response)
			this.wom1('#' + alias)._apiResponse = response.dataLayer || response;
		},

		_searchByName: function (obj, w, e) {
			var value = w.getSearchString();
			console.log('_searchByName', value);

			this.searchKeyword = value;

			if (!fox.trim(value).length) {
				this._clearSearch();

				return;
			};

			this.searchByName(value);

			return false;
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('name', false);
			this.loadEvents();
		},

		searchByName: function (str) {
			this.masonryApplied = false;
			this.searchKeyword = str;

			this.setFilterParams('name', str)

			this.loadEvents();
		},

	}, 'Catalog_List');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	var SAFE_THUMB_PARAMS = {
		v1: 'uDrXbF6zst',
		v2: 'uDrXbF6zst'
	};

	fox.registerWidget('Catalog_List', {
		configure: function () {
			this.eventsLimit = 14;
			this.genders = {
				'All': '-1',
				'Male': 1,
				'Female': 2,
				'Transgender': 3,
				'-1': 'All',
				1: 'Male',
				2: 'Female',
				3: 'Transgender'
			};

			this.searchParams = ['gender', 'name', 'sorting'];

			this.sortingTypes = {
				'-1': 'Last Added',
				1: 'A-Z',
				'Last Added': -1,
				'A-Z': 1
			};

			this.registerOptions('', {
				template: 'catalog_home_grid',
				autoRender: true,
				container: '.list-wrapper',
				scrollHandlerPath: '@parent @parent #scrollHandler',
				widgets: {
					eventsDl: {
						widget: 'Datalayer',
						method: 'Portal.getEvents',
						limit: this.eventsLimit,
						sendTimezone: true,
						cacheChannel: 'catalog',
						transitParameters : SAFE_THUMB_PARAMS,

						'hooks.onPrepareResponse': fox.bind(function (response) {
							this.moreEventsDl._pager.next = 2;
							this.prepareResponse(response, 'eventsDl');
						}, this)
					},

					moreEventsDl: {
						widget: 'Datalayer',
						method: 'Portal.getEvents',
						limit: this.eventsLimit,
						offset: this.eventsLimit,
						cacheChannel: 'catalog',
						sendTimezone: true,
						transitParameters : {
							v1: 'uDrXbF6zst',
							v2: 'uDrXbF6zst'
						},

						'hooks.onPrepareResponse': fox.bind(function (response) {
							this.prepareResponse(response, 'moreEventsDl');
						}, this)
					},
					eventsList: {
						widget: 'Widget',
						container: '.events-feed',
						template: 'catalog_events',
						autoRender: true,
						widgets: {
							list: {
								widget: 'AdvancedList',
								container: '.models-events-list',
								active: true,
								group: 'events',
								tpl: {
									row: 'catalog_events_item',
									emptyRow: 'catalog_events_item_empty'
								},
								hooks: {
									onStopRendering: function () {
										this._handleListRendering();
									}.bind(this),
									onStopEmbedding: function () {
										this.applyMasonry();
										this.insertCounters();
										this.buildSliders();
										this.rwom1(this.getOption('scrollHandlerPath')).enable();
									}.bind(this)
								}
							}
						},
						handleDom: {
							loadMoreEvents: {
								target: '.load-more',
								event: 'click',
								callback: '@parent:loadMoreEvents'
							}
						}
					}
				},

				handleWom: {
					loadStart: {
						widget: '#eventsDl',
						event: 'loading',
						callback: 'showLoader'
					},
					loadEnd: {
						widget: '#eventsDl',
						event: 'loaded',
						callback: '_handleDlLoad'
					},
					showSmallLoader: {
						widget: '#moreEventsDl',
						event: 'loading',
						callback: 'showSmallLoader'
					},
					renderMoreEvents: {
						widget: '#moreEventsDl',
						event: 'loaded',
						callback: '_renderMoreEvents'
					},
					selectChanged: {
						widget: '@this',
						event: 'select_changed',
						callback: '_handleFilterChange'
					},
					_handleScrolling: {
						widget: '@parent @parent #scrollHandler',
						event: 'bottomPointReached',
						callback: '_handleScrolling'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.eventsDl = this.wom1('#eventsDl');
			this.moreEventsDl = this.rwom1('#moreEventsDl');
			this.eventsList = this.wom1('#eventsList #list');

			this.eventsDl.initPagerMode();

			if (!this.getOption('customLoad')) {
				this.loadEvents();
			}

			this.moreEventsDl.initPagerMode();
			this.moreEventsDl._pager.next = 2;


			this.handleEvent(fox.Navigator, 'modified', fox.bind(this._handleNaviModifications, this));
		},

		activate: function (argument) {
			if (!this.getOption('customLoad')) {
				this.resetPager();
				this.prepareSearchParams();
				this.loadEvents();
			}

			this.callParent('activate', arguments);
		},

		deactivate: function (argument) {
			this.reset();
			this.rwom1(this.getOption('scrollHandlerPath')).disable();

			this.callParent('deactivate', arguments);
		},

		reset: function () {
			this._resetDls();
			this._resetCollection();
			this.masonryApplied = false;

			this.masonry('destroy');
		},

		_resetDls: function () {
			this.eventsDl.setCollection([]);
			this.eventsDl._transitParameters = fox.clone(SAFE_THUMB_PARAMS);
			this.moreEventsDl.setCollection([]);
			this.moreEventsDl._transitParameters = fox.clone(SAFE_THUMB_PARAMS);
		},

		_resetCollection: function () {
			this.eventsList.resetCollection();
		},

		prepareSearchParams: function (argument) {
			this._resetDls();

			fox.each(this.searchParams, function (param) {
				var val = fox.Navigator.get(param);

				if (val) {
					this.setTransitParameter(param, val);
				}
			}, this);
		},

		setTransitParameter: function (param, val) {
			this.eventsDl.setTransitParameter(param, val);
			this.moreEventsDl.setTransitParameter(param, val);
		},

		unSetTransitParameter: function (param) {
			delete this.eventsDl._transitParameters[param];
			delete this.moreEventsDl._transitParameters[param];
		},

		resetPager: function (argument) {
			this.eventsDl._pager.next = 1;
			this.moreEventsDl._pager.next = 2;
		},

		loadEvents: function () {
			this.rwom1(this.getOption('scrollHandlerPath')).disable();
			this.eventsDl.load();
		},

		loadMoreEvents: function () {
			this.rwom1(this.getOption('scrollHandlerPath')).disable();
			this.moreEventsDl.nextPage();
		},

		prepareResponse: function (response, alias) {},

		showLoader: function () {
			//console.warn('loader show!');
			var loader = this.wom1('#eventsList').dom1('.loader');

			fox.dom.addClass('show', loader);

			window.setTimeout(fox.bind(function () {
				fox.dom.addClass('rotate', loader);
			}, this), 800);

			this.toggleLoadMoreLink(false);
		},

		hideLoader: function () {
			var loader = this.rwom1('#eventsList').dom1('.loader');

			fox.dom.removeClass('show', loader);

			window.setTimeout(fox.bind(function () {
				fox.dom.removeClass('rotate', loader);
			}, this), 1000);

		},

		toggleLoadMoreLink: function (state) {
			var link = this.wom1('#eventsList').dom1('.load-more-events');

			if (link) {
				link.style.display = state ? 'block' : 'none';
			}

			this.moreEventsAvailable = state;
		},

		destoryMassonry: function () {
			var $container = this.getListContainer();
			$container.css('height', 'auto')
		},

		applyMasonry2: function () {
			if (this.masonryApplied) {
				if (!this.moreEventsDl.getCollection().length) {
					this.hideSmallLoader();
				}

				this.rebuildMasonry();

				return;
			}

			if (!this.eventsDl.getCollection().length) {
				this.destoryMassonry();
				this.hideLoader();
				
				return;
			}

			this.buildMasonry();
			
		},

		applyMasonry: function () {
			this.masonry((!this.masonryApplied ? 'build' : 'rebuild'));
		},

		masonry: function (action) {
			switch(action) {
				case 'build':
					this._buildMasonry();
				break;

				case 'rebuild':
					this._reBuildMasonry();
				break;

				case 'destroy':
					this._destroyMasonry();
				break;
			}

		},

		_buildMasonry: function () {
			var $container = this.getListContainer();
			var imgLoad = imagesLoaded($container);

			imgLoad.on('always', fox.bind(function(instance) {
				//console.log('DONE  - all images have been successfully loaded');
				this.hideLoader();

				$container.masonry({
					itemSelector: '.event-item',
					transitionDuration: 0
				});

				this.masonryApplied = true;
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					};

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));
		},

		_reBuildMasonry: function () {
			var $container = this.getListContainer();
			var imgLoad = imagesLoaded($container);
			var elems = [];

			if (!$container.data('masonry')) {
				console.warn('_reBuildMasonry', 'masonry not applied');
				this.masonry('build');
				return;
			}

			fox.each(this.eventsList.dataModelLastUpdate, function (data) {
				elems.push(data._domNode[0]);
				$(data._domNode[0]).addClass('masonry-hide');
			});

			$container.masonry('once', 'layoutComplete', fox.bind(function (items) {
				fox.each(items, function (item) {
					$(item.element).removeClass('masonry-hide');
				});
			}, this));

			imgLoad.on('always', fox.bind(function(instance) {
				$container.masonry('reloadItems');
				$container.masonry({
					itemSelector: '.event-item',
					transitionDuration: 0
				});

				this.hideSmallLoader();
			}, this));

			/*var elems = [];

			fox.each(this.eventsList.dataModelLastUpdate, function (data) {
				elems.push(data._domNode[0]);
				$(data._domNode[0]).css('opacity', 0);
			});

			var imgLoad = imagesLoaded(elems);

			$container.masonry();

			imgLoad.on('always', fox.bind(function(instance) {
				fox.each(elems, function (elt) {
					$container.masonry('appended', $(elt));
				});

				this.hideSmallLoader();
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					};

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));*/
		},

		_destroyMasonry: function () {
			var $container = this.getListContainer();
			$container.css('height', 'auto');
			$container.masonry();
			$container.masonry('destroy');
			this.masonryApplied = false;
		},

		buildMasonry: function () {
			var $container = this.getListContainer();
			var imgLoad = imagesLoaded($container);

			this.destoryMassonry();

			$container.masonry({
				itemSelector: '.event-item'
			});

			imgLoad.on('always', fox.bind(function(instance) {
				//console.log('DONE  - all images have been successfully loaded');
				this.hideLoader();
				$container.masonry();
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					}

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));

			this.masonryApplied = true;
		},

		rebuildMasonry: function () {
			var $container = this.getListContainer();
			var elems = [];

			fox.each(this.eventsList.dataModelLastUpdate, function (data) {
				elems.push(data._domNode[0]);
				$(data._domNode[0]).css('opacity', 0);
			});

			var imgLoad = imagesLoaded(elems);

			$container.masonry();

			imgLoad.on('always', fox.bind(function(instance) {
				fox.each(elems, function (elt) {
					$container.masonry('appended', $(elt));
				});

				this.hideSmallLoader();
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					}

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));
		},

		_handleDlLoad: function (obj, dl, alias) {
			var collection = dl.getCollection();

			this.renderList(collection);

			if (collection.length && collection.length == this.eventsLimit) {
				this.toggleLoadMoreLink(true);
				return;
			}

			this.toggleLoadMoreLink(false);
		},

		_handleListRendering: function () {
			if (fox._isNewfe) {
				if (!this.eventsDl.getCollection().length) {
					if (!this.emptyRow) {
						this.emptyRow = this.prepareTemplateProcessor('catalog_events_item_empty');
					}
					this.eventsList.fragment = this.emptyRow.setData({searchKeyword: this.searchKeyword}).compile();
					this.toggleLoadMoreLink(false);

					return;
				}
			} else {
				if (!this.eventsList._readyToRender) {
					this.toggleLoadMoreLink(true);
					return;
				}
			}


			this.toggleLoadMoreLink(true);
		},

		insertCounters: function () {
			var selector = 'data-liveshow-startDate';
			var events = this.getListContainer().find('[' + selector + '].scheduled');
			var parts = ['Days', 'Hours', 'Mins', 'Secs'];

			$.each(events, function (i, el) {
				var $el = $(el);
				var date = $el.attr(selector);

				$el.counter({
					initial: fox.utils.getRemainingTime(date),
					direction: 'down',
					format: "99:23:59:59",
					stop: "00:00:00:00",
				});

				$el.removeClass('scheduled');

				$el.find('.part').each(function (n, part) {
					$(part).append($('<span class="label">' + parts[n] + '</span>'));
				});
			});
		},

		buildSliders: function () {
			$('.slides-container').not('.builded').each(function (i, el) {
				var slides = $(el).find('.slide-image');
				var n = 1;
				var intId;

				$(el).on('mouseenter', function () {
					slides.hide().eq(0).show();

					intId = window.setInterval(function () {
						if (n >= slides.length) {
							n = 0;
						}
						slides.hide().eq(n).show();
						n++;
					}, 1000);
				});

				$(el).on('mouseleave', function () {
					slides.hide().eq(0).show();
					window.clearInterval(intId);
				});

				$(el).addClass('builded');
			});
		},

		_renderMoreEvents: function (obj, dl, e) {
			var collection = dl.getCollection();

			if (!collection.length) {
				this.toggleLoadMoreLink(false);

				return;
			}

			//console.log('_renderMoreEvents', collection.length)

			this.eventsList.appendItem(collection);
			
			if (collection.length < this.eventsLimit) {
				this.toggleLoadMoreLink(false);
			} else {
				this.toggleLoadMoreLink(true);
			}
		},

		showSmallLoader: function () {
			var el = this.rwom1('#eventsList').dom1('.small-loader');

			if (!el) {
				return;
			}

			fox.dom.addClass('spin', el);
		},

		hideSmallLoader: function () {
			var el = this.rwom1('#eventsList').dom1('.small-loader');

			if (!el) {
				return;
			}

			fox.dom.removeClass('spin', el);
		},

		setFilterParams: function (name, value) {
			var val;
			var naviVal;
			var objHash = fox.clone(fox.Navigator.objHash, true);

			if (!value) {
				delete objHash[name];

				this.moreEventsDl.clearTransitParameters(name);
				this.eventsDl.clearTransitParameters(name);
				fox.Navigator.update(objHash);

				return;
			}

			switch (name) {
				default:
				case 'name':
					val = value;
					naviVal = value;
					this.searchKeyword = window.decodeURI(value);
				break;

				case 'gender':
					if (fox.isNumeric(value)) {
						val = value;
						naviVal = this.genders[value];
					} else {
						val = this.genders[value];
						naviVal = value;
					}
				break;

				case 'type':
					if (fox.isNumeric(value)) {
						val = value;
						naviVal = this.contentTypes[value];
					} else {
						val = this.contentTypes[value];
						naviVal = value;
					}
				break;

				case 'sortContent':
					if (fox.isNumeric(value)) {
						val = value;
						naviVal = this.sortingTypes[value];
					} else {
						val = this.sortingTypes[value];
						naviVal = value;
					}
				break; 
			}

			//console.log(name, val, naviVal);

			this.moreEventsDl.setTransitParameter(name, val);
			this.eventsDl.setTransitParameter(name, val);
			fox.Navigator.set(name, naviVal);
		},

		_handleFilterChange: function (data) {
			this.masonryApplied = false;

			switch (data.name) {
				case 'gender':
					if (data.value < 0) {
						this.setFilterParams(data.name, false);
						this.loadEvents();						

						return;
					}

					this.setFilterParams(data.name, data.value);
				break;
				case 'sorting':
					if (data.value >= 0) {
						this.setFilterParams(data.name, data.value);
					}
				break;
			}

			this.loadEvents();
		},

		_handleScrolling2: function (data) {
			if (data.direction > 0 && this.moreEventsAvailable) {
				this.loadMoreEvents();
			}
		},

		_handleScrolling: function (data) {
			if (data.direction > 0 && this.moreEventsAvailable) {
				this.loadMoreEvents();
			}
		},

		_handleNaviModifications: function (data, navi, ev) {
			var params = fox.getObjectKeys(data);
			var action = 'deleted';
			var reload = false;

			fox.each(data, function (val, param) {
				if (val == 'deleted') {
					this.unSetTransitParameter(param);
					reload = true;
				}
			}, this);

			if (!reload) {
				return;
			}

			if (!this.getOption('customLoad')) {
				this.masonryApplied = false;
				this.resetPager();
				this.prepareSearchParams();

			
				this.loadEvents();
			}
		},

		renderList: function (collection) {
			this.eventsList.resetCollection(collection);

			//console.log('collection', collection.length);
		},

		setEmbedReadyState: function (state) {
			//this.eventsList._readyToEmbed = state;

			//console.log('_readyToEmbed', state);
		},

		getListContainer: function () {
			return $('#events-list')
		}

	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_List_Models', {

		configure: function () {
			this.registerOptions('', {
				template: 'catalog_home_models_grid',
				widgets: {
					eventsFilter: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-filter',
						template: 'catalog_filter_models',
						widgets: {
							search: {
								widget: 'Autocomplete2'
							}
						},

						handleDom: {
							selectChange: {
								target: 'select',
								event: 'change',
								callback: '@parent:_handleSelectChange'
							},
							clearSearch: {
								target: '.icon.clear',
								event: 'click',
								callback: '@parent:_clearSearch'
							}
						},

						handleWom: {
							searchFormSubmit: {
								widget: '#search',
								event: 'search_form_submit',
								callback: '@parent:_searchByName'
							}
						},

						'hooks.onAddedToDom': fox.bind(function () {
							var gender = fox.Navigator.get('gender');
							var name = fox.Navigator.get('name');
							if (gender) {
								this.updateFilterOnLoad('gender', this.genders[gender], true);
								//this.updateGenderSelect(this.genders[gender]);
							}
							if (name) {
								this.updateFilterOnLoad('name', name);
								this.setFilterParams('name', name);
								this.loadEvents();
							}
						}, this)
					},

					eventsList: {
						'widgets.list.tpl.row': 'catalog_events_item_model'
					}
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function () {
			this.registerOptions('#eventsDl', {
				method: 'Portal.getModelsFeed'
			});
			this.registerOptions('#moreEventsDl', {
				method: 'Portal.getModelsFeed'
			});
			
			this.callParent('init', arguments);
		},

		_handleSelectChange: function (el, skipEvent) {
			var opt = el.options[el.selectedIndex];
			var parent = el.parentNode;
			$('.txt', parent).text(opt.innerHTML);

			if (el.name == 'gender') {
				$('.icon.begin', parent).html('<i class="' + $(opt).attr('data-icon') + '"></i>');
			}

			if (skipEvent === true) {
				return;
			}

			this.dispatchEvent('select_changed', {name: el.name, value: opt.value});
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('name', false);
			this.loadEvents();
		},

		updateFilterOnLoad: function (alias, value, skipEvent) {
			switch (alias) {
				case 'name':
					this.updateNameInput(value);
				break;

				case 'gender':
					this.updateGenderSelect(value, skipEvent);
				break;
			}
		},

		updateGenderSelect: function (value, skipEvent) {
			var el = this.wom1('#eventsFilter').dom1('[name="gender"]');

			if (!el) {
				return;
			}
			
			$(el).find('option').each(function (i, opt) {
				opt.selected = false;

				if (opt.value == value) {
					opt.selected = true;
				}
			});

			this._handleSelectChange(el, skipEvent);

		},

		updateNameInput: function (value) {
			this.rwom1('#eventsFilter #search').fillInput(window.decodeURI(value));
		},

		_searchByName: function (obj, w, e) {
			var value = w.getSearchString();
			console.log('_searchByName', value);

			this.searchKeyword = value;

			if (!fox.trim(value).length) {
				this._clearSearch();

				return;
			}

			this.searchByName(value);

			return false;
		},

		searchByName: function (str) {
			this.masonryApplied = false;
			this.searchKeyword = str;

			this.setFilterParams('name', str);

			this.loadEvents();
		},

		prepareResponse: function (response, alias) {
			var collection = response.collection;

			fox.each(collection, function (data) {
				data.customLink = '/profile/' + data.clientId;
			}, this);

			this.wom1('#' + alias)._apiResponse = response.dataLayer || response;
		},
	}, 'Catalog_List');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_List_VR', {

		configure: function () {
			this.registerOptions('', {
				template: 'catalog_home_vrlist_grid',
				'widgets.eventsList': {
					'widgets.list.tpl.row': 'catalog_events_item_vr_model'
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function () {
			this.registerOptions('#eventsDl', {
				method: 'Portal.getModelsFeed',
				transitParameters: {withVrContent: 1}
				
			});
			this.registerOptions('#moreEventsDl', {
				method: 'Portal.getModelsFeed',
				transitParameters: {withVrContent: 1}
			});
			this.callParent('init', arguments);
		}
	}, 'Catalog_List_Models');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	
	fox.registerWidget('Catalog3X_Models', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					events: {
						widget: 'Catalog_List_Models',
						autoRender: true,
						container: '.list-wrapper'
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Catalog3X');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	
	fox.registerWidget('Catalog3X_VR', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					events: {
						widget: 'Catalog_List_VR'
					},
					subscribeVR: {
						widget: 'Model_VR_Subscription'
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Catalog3X_Latest');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_Model_Profile', {

		configure: function () {

			this.registerOptions('', {
				
				widgets: {
					profileApi: {
						widget: 'Api',
						method: 'Portal_Model.getData'
					},

					modelProfile: {
						widget: 'Widget',
						template: 'model_profile',
						manualRender: true,
						autoRender: false,
						embed: {
							widget: '@parent @parent',
							container: '.models-sitepage-wrapper'
						}
					},

					modelContentList: {
						widget: 'Catalog_List_Content',
						customLoad: true,
						embed: {
							widget: '@parent #modelProfile',
							container: '.list-wrapper'	
						}
						
					},

					subscribePopup: {
						widget: 'Dialog',
						useUiPosition: true,
						'dialog.width': 370,
						'!widgets.content.widget': 'Popup_Model_Subscription',
						//'!widgets.content.embed.container': '.ui-widget-content',
					},

					successPopup: {
						widget: 'Dialog',
						useUiPosition: true,
						'dialog.width': 370,
						'!widgets.content.template': 'popup_model_subscription_success'
					},

					errorPopup: {
						widget: 'Dialog',
						useUiPosition: true,
						'dialog.width': 370,
						'!widgets.content.template': 'popup_model_subscription_error'
					}
				},

				handleWom: {
					handleApiResponse: {
						widget: '#profileApi',
						event: ['success', 'error', 'failure'],
						callback: '_handleApiResponse'
					},
					modelProfileLoaded: {
						widget: '@this',
						event: 'modelProfileLoaded',
						callback: '_modelProfileLoaded'
					},
					profileChange: {
						widget: '@root #navi',
						event: 'modified_1',
						callback: '_handleNavi'
					}
				},

				handleDom: {
					toggleIntroductionText: {
						targetWidget: '#modelProfile',
						event: 'click',
						target: '.show-full .show-more',
						callback: 'toggleIntroductionText'
					},
					switchTab: {
						targetWidget: '#modelProfile',
						event: 'click',
						target: '.stats-table .header .item',
						callback: '_switchTab'
					},
					showSubscriptionPopup: {
						targetWidget: '#modelProfile',
						target: '.show-subscribe-popup',
						event: 'click',
						callback: 'showSubscriptionPopup'
					}
				}

			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.api = this.wom1('#profileApi');
			this.contentList = this.wom1('#modelContentList');
			this.modelProfile = this.wom1('#modelProfile');

			this.modelData = {};

			this.getProfileData(this.prepareId(fox.Navigator.get(1)));

			this.callParent('running', arguments);
		},

		activating: function (param) {
			this.getProfileData(param.id);

			this.callParent('activating', arguments);
		},

		_handleNavi: function (param, navi, e) {
			//console.log('_handleNavi', arguments);

			if (fox.isString(param) && !fox.isEmpty(param)) {
				this.getProfileData(param);
				this.contentList.reset();
				this.contentList.resetPager();
			}
		},

		getProfileData: function (id) {
			//console.log('getProfileData', id)
			this.contentList.eventsList._readyToEmbed = false;
			var id = this.prepareId(id);
			this.api.send({id: id});

			this.contentList.prepareSearchParams(id);
			//this.contentList.setTransitParameter('clientId', id);
			this.contentList.masonry('destroy');
			this.contentList.loadEvents();

			this.modelData['id'] = id;
		},

		_handleApiResponse: function (resp, w, e) {

			if (e == 'failure' || e == 'error') {
				console.error('something gone wrong', w.getAlias(), resp);

				return;
			}

			this.modelData['data'] = resp.answer.response;

			this.dispatchEvent('modelProfileLoaded')
		},

		_modelProfileLoaded: function () {
			//console.log('_modelProfileLoaded')
			this.contentList.eventsList._readyToEmbed = true;

			this.modelProfile.setTemplateOptions(this.modelData.data.success)
			this.modelProfile.render();



			this.wom1('#subscribePopup #content').setModelData(this.modelData);
			//this.contentList.setTransitParameter('name', fox.objectGet(this.modelData.success, 'stats.name'));
			//this.contentList.setTransitParameter('clientId', fox.Navigator.get(1));
			//this.contentList.loadEvents();
		},

		toggleIntroductionText: function () {
			fox.dom.addClass('full', this.modelProfile.dom1('.introduction'));
		},

		_switchTab: function (el) {
			this.switchTab($(el).attr('data-tab-alias'));
		},

		switchTab: function (alias) {
			var w = this.modelProfile;

			fox.each(w.dom('.stats-table .item'), function (el) {
				var el = $(el);
				var elAlias = el.attr('data-tab-alias')

				el.removeClass('active')

				if (alias == elAlias) {
					el.addClass('active');
				}
			}, this);
		},

		showSubscriptionPopup: function () {
			this.wom1('#subscribePopup').show();
		},

		prepareId: function (str) {
			var regExp = /\d+$/;

			return str.match(regExp)[0];
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	fox.registerWidget('Page_CCPA_MC', {
		configure: function configure() {
			this.registerOptions('', {
				widgets: {
					popup: {
						widget: 'Dialog',
						useUiPosition: true,
						dialog: {
							title: 'California Consumer Privacy form',
							width: '550px',
							closeText: 'X',
							'!dialogClass': 'ccpa-form mc-xxx-common-popup'
						},
						widgets: {
							content: {
								widget: 'CCPR_Form',
								template: 'ccpa_form_mc'
							}
						}
					},
					popupSuccess: {
						widget: 'Dialog',
						useUiPosition: true,
						dialog: {
							title: 'Success',
							width: '340px',
							'!dialogClass': 'ccpa-form mc-xxx-common-popup'
						},
						widgets: {
							content: {
								widget: 'Widget',
								template: 'ccpa_success_mc',
								handleDom: {
									closePopup: {
										target: '#success',
										event: 'click',
										callback: '@parent @parent:successHide'

									}
								}
							}
						}
					}
				},
				handleWom: {
					success: {
						widget: '#popup #content',
						event: 'form_submit_success',
						callback: 'hidePopup'
					}
				}
			});
			this.callParent('configure', arguments);
		},
		successHide: function successHide() {
			this.wom1('#popupSuccess').hide();
		},
		showPopup: function showPopup() {
			this.wom1('#popup').show();
		},
		hidePopup: function hidePopup() {
			this.wom1('#popup').hide();
			this.wom1('#popupSuccess').show();
		}
	}, 'Page_CCPA');
};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {

	fox.registerWidget('Layout_Catalog', {

		configure: function(options) {
			this.sidebarIsVisible = false;

			this.registerOptions('', {
				pageContainer: '.models-sitepage-wrapper',
				widgets: {
					scrollHandler: {
						widget: 'WindowScrollHandler',
						bottomOffset: $(window).height(),
						customEnabling: true
					},
					closestLiveshows: {
						widget: 'Models_ClosestLiveshows'
					},
					header: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-header',
						template: 'catalog_header',
						handleDom: {
							showSidebar: {
								target: '.menu-icon',
								event: 'click',
								callback: '@parent:_showSidebar'
							}
						},

						widgets: {
							sidebar: {
								widget: 'Menu_Sidebar',
								'widgets.menu.hooks.onAddedToDom': fox.bind(function (argument) {
									this.naviElm = this.wom1('#header #sidebar #menu').element[0];
								}, this)
							}
						}
					}
				},

				handleWom: {
					scrolling: {
						widget: '#scrollHandler',
						event: 'scrolling',
						callback: '_handleScrolling'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		addedToDom: function (argument) {
			this.headerElm = this.dom1('#models-header');
		},

		running: function (argument) {
			fox.dom.on('click', window, fox.bind(function () {
				this.hideSidebar();
			}, this));

			this.callParent('running', arguments);
		},

		_showSidebar: function (el, alias, w, e) {
			fox.dom.event.stop(e);
			this.showSidebar();
		},

		showSidebar: function () {
			if (this.sidebarIsVisible) {
				return;
			}

			fox.dom.addClass('active', this.wom1('#header').dom1('.menu-icon'));
			this.sidebarIsVisible = true;
		},

		hideSidebar: function () {
			if (!this.sidebarIsVisible) {
				return;
			}

			fox.dom.removeClass('active', this.wom1('#header').dom1('.menu-icon'));
			this.sidebarIsVisible = false;
		},

		_handleScrolling: function (offset) {
			var lshowHeight = 107;
			var t = offset.top;

			if (t >= lshowHeight && !this.freeze) {
				this.freeze = true;
				//this.naviElm.style.top = 112 + 'px';
				fox.dom.addClass('slide', this.headerElm);
			}

			if (t < lshowHeight) {
				this.freeze = false;
				//this.naviElm.style.top = (lshowHeight - t) + 'px';
				fox.dom.removeClass('slide', this.headerElm);
			}
		}

	}, 'Site_Layout');
	
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Menu_Sidebar', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					menu: {
						widget: 'Widget',
						autoRender: true,
						template: 'menu_sidebar',
						embed: {
							widget: '@parent @parent',
							container: 'nav.navigation#navigation'
						}
					}
				},

				handleWom: {
					highlight: {
						widget: '@this',
						event: 'pageChanged',
						callback: '_handlePageChange'
					}
				}
				
			})

			this.callParent('configure', arguments);
		},

		running: function () {
			this.menu = this.wom1('#menu');
			this.layout = this.wom1('@parent @parent @parent');

			this.callParent('running', arguments);
		},

		_handlePageChange: function (pageData) {
			if (this.menu._indom) {
				this.highlight(pageData.page);

				return;
			}

			this.handleEvent(this.menu, 'addedToDom', fox.bind(function () {
				this.highlight(pageData.page);
			}, this), {once: true, prefix: 'sectionMenu'});
		},

		highlight: function (page) {
			fox.each(this.menu.dom('[href]'), function (link) {
				fox.dom.removeClass('active', link.parentNode);
			}, this)

			fox.dom.addClass('active', this.menu.dom1('[href="/' + page + '"]').parentNode);
		}

	}, 'Menu2');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SidebarSlider Widget

(function (fox, $) {
	
	fox.registerWidget('Models_ClosestLiveshows', {

		configure: function (argument) {
			this.currentSlide = 0;

			this.registerOptions('', {
				slidePeriod: 12000,

				widgets: {
					api: {
						widget: 'Api',
						method: 'Portal.GetPublicLiveshowEvents',
						limit: 5,
						sendTimezone: true	
					},

					grid: {
						widget: 'Widget',
						autoRender: false,
						container: '.closest-liveshows',
						template: 'catalog_closest_liveshows',

						widgets: {
							list: {
								widget: 'List',
								autoRender: false,
								'tpl.row': 'catalog_closest_liveshows_row',
								container: '.closest-liveshows-list',

								'hooks.onAddedToDom': fox.bind(function () {
									this.insertCounters();
									this.initSlider();
									this.renderPager();
									this.showSlide(this.currentSlide);
								}, this)
							},
							pager: {
								widget: 'List',
								autoRender: false,
								'tpl.row': 'catalog_closest_liveshows_pager',
								container: '.closest-liveshows-pager'
							}
						}
					}
				},

				handleWom: {
					apiSuccess: {
						widget: '#api',
						event: ['success', 'error', 'failure'],
						callback: '_handleApiResponse'
					},

					slideShown: {
						widget: '@this',
						event: 'slide_shown',
						callback: 'markSlide'
					}
				},

				handleDom: {
					pagerClick: {
						targetWidget: '#grid #pager',
						target: '.slide',
						event: 'click',
						callback: '_changeSlide'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);
		},

		running: function () {
			this.api = this.rwom1('#api');
			this.grid = this.rwom1('#grid');
			this.list = this.grid.rwom1('#list');

			this.getClosestLiveshows();

			this.callParent('running', arguments);
		},

		getClosestLiveshows: function () {
			this.api.send({limit: this.wom1('#api').getOption('limit')});
		},

		_handleApiResponse: function (response, w, alias) {
			if (alias != 'success') {
				this.setListData(null);
				return;
			}

			fox.each(response.answer.response, function (item, i) {
				item._index = i;
			});

			this.setListData(response.answer.response);

			this.renderList();
		},

		setListData: function (data) {
			this.listData = data;
		},

		getListData: function (argument) {
			return this.listData;	
		},

		getListDataLength: function () {
			return fox.count(this.listData);
		},

		renderList: function () {
			var list = this.getListData();

			if (list) {
				this.list.setCollection(list, true);
				this.grid.render();

				return;
			};

			this.grid.removeFromDom();
		},

		insertCounters: function () {
			var blocks = this.list.dom('[data-liveshow-counter]');

			fox.each(blocks, function (elm, i) {
				var $elm = $(elm);
				var date = this.listData[i].startDate;
				var remTime = this._getRemainingtime(date);
				var format = "99:23:59:59";
				var interval = 1000 * 60;
				var obj = {
					0: 'Days',
					2: 'Hours',
					4: 'Minutes',
					6: 'Secs'
				};

				//console.log(remTime)

				if (remTime.split(':')[0] == 0) {
					format = '23:59:59';
					interval = 1000;
					obj = {
						0: 'hours',
						2: 'minutes',
						4: 'seconds'
					};
				}

				$elm.counter({
					initial: remTime,
			        direction: 'down',
			        format: format,
			        interval: interval,
			        stop: "00:00:00:00",
				});

				fox.each(obj, function (val, key) {
					$elm.find('.part' + key).append('<span class="label"> ' + val + '</span>');

					if (key == 6 && interval == 1000) {
						$elm.find('.separator5').addClass('show')
					}
				});

			}, this);
		},

		_getRemainingtime: function (date) {
			return fox.utils.getRemainingTime(date);
		},

		initSlider: function (argument) {
			this.stopSlide();
			this.startSlide();
		},

		startSlide: function (argument) {
			this.slidingId = window.setInterval(fox.bind(this._slide, this), this.getOption('slidePeriod'));
		},

		stopSlide: function () {
			if (this.slidingId) {
				window.clearInterval(this.slidingId);
			};
		},

		_slide: function () {
			// this.currentSlide++;
			this.setCurrentSlide(this.currentSlide + 1);

			if (this.currentSlide == this.getListDataLength()) {
				this.currentSlide = 0;
			};

			this.showSlide(this.currentSlide);
		},

		setCurrentSlide: function (num) {
			this.currentSlide = num;
		},

		showSlide: function (ind) {
			var items = this.grid.dom('.closest-liveshows-list .item');

			fox.each(items, function (item, i) {
				fox.dom.removeClass('active', item);

				if (ind == i) {
					window.setTimeout(fox.bind(function () {
						fox.dom.addClass('active', item);
						this.dispatchEvent('slide_shown', {ind: ind});	
					}, this), 500)
				};
			}, this);

			//$(block).css('transform', ['translateY', '(', -ind*47 , 'px',')'].join(''));
		},

		renderPager: function() {
			this.wom1('#grid #pager').setCollection(this.getListData(), true);
		},

		markSlide: function (data) {
			fox.each(this.wom1('#grid #pager').dom('.slide'), function (item, i) {
				fox.dom[(i == data.ind ? 'addClass' : 'removeClass')]('active', item);
			}, this);
		},

		_changeSlide: function (el) {
			var ind = window.parseInt(fox.dom.wrap(el).attr('slide-index'));
			this.stopSlide();
			this.setCurrentSlide(ind)
			this.showSlide(ind);
			this.startSlide();
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Popup_Model_Subscription', {

		configure: function () {
			this.registerOptions('', {
				'!template': 'popup_model_subscription',
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: false,
						formElements: {
							name: {
								element: '[name="name"]',
								autoApply: true,
								defaultValue: fox.utils.localStorage('getItem', 'localName')
							},
							email: {
								element: '[name="email"]',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}],
								defaultValue: fox.utils.localStorage('getItem', 'localEmail')
							},
						},
						'methods.send': 'Portal_Model.subscribe',
						submit: {
							target: '.subscribe',
							event: 'click'
						},
						'hooks.onSubmit': fox.bind(function (values) {
							this.handleSubmit(values);
						}, this),
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['name', 'email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Cannot be empty'
							}]
						}
					},

					// successPopup: {
					// 	widget: 'Dialog',
					// 	'dialog.width': 370,
					// 	'!widgets.content.template': 'popup_model_subscription_success'
					// },

					// errorPopup: {
					// 	widget: 'Dialog',
					// 	'dialog.width': 370,
					// 	'!widgets.content.template': 'popup_model_subscription_error'
					// }
				},

				handleDom: {
					focus: {
						target: 'input',
						event: 'focus',
						callback: '_handleFocus'
					}
				},

				handleWom: {
					_handleFormValidation: {
						widget: '#form #validator',
						event: 'formNotValid',
						callback: '_handleFormValidation'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		deactivate: function () {
			this.data = {};

			fox.each(['#successPopup', '#errorPopup'], function (path){
				var cont = this.wom1(['@parent', '@parent', path, '#content'].join(' '));

				cont.setTemplateOptions({});
			}, this);

			this.callParent('deactivate', arguments);
		},

		addedToDom: function () {
			this.wom1('#form').loadValues();
		},

		toggleError: function (name, state, msg) {
			var elm = this.dom1('[name="' + name + '"]');
			var msgElm = fox.dom.selectFirst('.error-msg', elm.parentNode.parentNode);
			
			msg = msg || '';

			fox.dom[state ? 'addClass' : 'removeClass']('error', elm.parentNode);

			if (!fox.isEmpty(msg)) {
				msgElm.innerHTML = msg;
			}

			if (!state) {
				msgElm.innerHTML = '';
			}
		},

		_handleFormValidation: function (err, w) {
			fox.each(err.errorStack, function(arr, alias) {
				this.toggleError(alias, true, arr[0].message);
			}, this);
		},

		_handleFocus: function (el) {
			this.toggleError(el.name, false);
		},

		handleSubmit: function (values) {
			var api = this.wom1('#form')._getFormSendApi();

			values.id = this.data.id;

			api.psend(values)
				.then(fox.bind(this.onSubscribeResponse, this))
				.catch(fox.bind(function (res, performer, e) {
					console.error('subscribe api ' + e, res);
					
					if (res && res.params.answer.reason) {
						this.showErrorPopup(res.params.answer.reason);

						return;
					}

					this.showErrorPopup();

				}, this));

			this.dispatchEvent('submit', values);
		},

		onSubscribeResponse: function () {
			var name = this.dom1('[name="name"]').value;
			var email = this.dom1('[name="email"]').value;

			if (name) {
				fox.utils.localStorage('setItem', 'localName', name);
			}

			if (email) {
				fox.utils.localStorage('setItem', 'localEmail', email);
			}

			this.showSuccessPopup();
		},

		setModelData: function (data) {
			this.data = data;

			var name = fox.objectGet(this.data.data.success, 'stats.name');

			this.setTemplateOptions('modelName', name);
			this.render();

			fox.each(['#successPopup', '#errorPopup'], function (path){
				var cont = this.wom1(['@parent', '@parent', path, '#content'].join(' '));

				cont.setTemplateOptions('modelName', name);
				cont.render();
			}, this);

		},

		showErrorPopup: function (msg) {
			var popup = this.wom1('@parent @parent #errorPopup');

			if (msg) {
				popup.wom1('#content').setTemplateOptions('message', msg);
				popup.wom1('#content').render();
			}

			popup.show();
		},

		showSuccessPopup: function () {
			this.wom1('@parent @parent #successPopup').show();
		}
	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Model_VR_Subscription', {

		configure: function () {
			this.registerOptions('', {
				'template': 'vr_model_subscription',
				'embed.container': '#subscribe-vr',
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: false,
						formElements: {
							email: {
								element: '[name="email"]',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}],
								defaultValue: fox.utils.localStorage('getItem', 'localEmail')
							},
						},
						'methods.send': 'Subscription.subscribe',
						submit: {
							target: '.subscribe',
							event: 'click'
						},
						'hooks.onSubmit': fox.bind(function (values) {
							this.handleSubmit(values)
						}, this),
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Cannot be empty'
							}]
						}
					}
				},

				handleDom: {
					focus: {
						target: 'input',
						event: 'focus',
						callback: '_handleFocus'
					}
				},

				handleWom: {
					_handleFormValidation: {
						widget: '#form #validator',
						event: 'formNotValid',
						callback: '_handleFormValidation'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		addedToDom: function () {
			if(!fox.utils.localStorage('getItem', 'localEmail')){
				this.wom1('#form').loadValues();
			} else {
				$('.subscription-vr-wrapper').hide();
			}
		},

		toggleError: function (name, state, msg) {
			var elm = this.dom1('[name="' + name + '"]');
			var msgElm = fox.dom.selectFirst('.error-msg', elm.parentNode.parentNode);
			var msg = msg || '';

			fox.dom[state ? 'addClass' : 'removeClass']('error', elm.parentNode);

			if (!fox.isEmpty(msg)) {
				msgElm.innerHTML = msg;
			};

			if (!state) {
				msgElm.innerHTML = '';
			}
		},

		_handleFormValidation: function (err, w) {
			fox.each(err.errorStack, function(arr, alias) {
				this.toggleError(alias, true, arr[0].message)
			}, this)
		},

		_handleFocus: function (el) {
			this.toggleError(el.name, false);
		},

		handleSubmit: function (values) {
			var api = this.wom1('#form')._getFormSendApi();
			values.type = 'modelsxxx-vr-subscriber';

			api.psend(values)
				.then(fox.bind(this.onSubscribeResponse, this))
				.catch(fox.bind(function (res, performer, e) {
					console.error('subscribe api ' + e, res)
					
					if (res && res.params.answer.reason) {
						this.showError(res.params.answer.reason);

						return;
					};

					this.showError();

				}, this));

			this.dispatchEvent('submit', values);
		},

		onSubscribeResponse: function () {
			var email = this.dom1('[name="email"]').value;

			if (email) {
				fox.utils.localStorage('setItem', 'localEmail', email);
			}

			this.showSuccess();
		},

		showError: function (msg) {
			$('.error-msg').html('<div>' + msg +'</div>')
		},

		showSuccess: function () {
			$('.subscription-form').html('<div>Subscription success!</div>')
		}
	});
})(fox, jQuery);

 /* fox-dynamic-injection */ 
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// pk.0.js